/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431d2ac0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_431d2ac0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"c5a4c266-a2bb-4c8e-b829-24c22461c6df","title":"Научете повече за принтера","link":"finding-information-about-printer-topic.html","desc":"Откриване на информация за принтера","descFull":"Откриване на информация за принтера Ресурси и къде да ги намерите Какво търсите? Намерете го тук Начални инструкции за конфигуриране Вижте документацията за конфигуриране, доставена с принтера. Софтуер на принтера Драйвер за отпечатване или факс Фърмуер на принтера Помощна програма Отидете на  www.lexmark.com/downloads , потърсете Вашия модел на принтер, след което в менюто Type (Тип) изберете нужния Ви драйвер, фърмуер или помощна програма. Избиране и съхраняване на хартия и специални носители Зареждане на хартия Конфигуриране на настройките на принтера Преглеждане и отпечатване на документи и снимки Конфигуриране на принтера в мрежа Грижи за принтера и поддръжка Отстраняване на неизправности и решаване на проблеми Информационен център – отидете на  https://infoserve.lexmark.com . Видеоклипове с инструкции – отидете на  https://infoserve.lexmark.com/idv/ . Помощна информация за използване на софтуера на принтера. Помощ за операционни системи Microsoft Windows или Macintosh – отворете софтуерна програма на принтера или приложение и след това щракнете върху  Help  (Помощ). Кликнете върху  , за да видите информация, свързана с контекста. Help (Помощ) се инсталира автоматично със софтуера на принтера. В зависимост от операционната система софтуерът на принтера е в папката на програмата за принтера или на работния плот. Документация Поддръжка чрез чат на живо Поддръжка по имейл Гласова поддръжка Отидете на  https://support.lexmark.com . Изберете вашата държава или регион и след това изберете вашия продукт, за да видите подходящата страница за поддръжка. Информацията за връзка с отдела за поддръжка за Вашата държава или регион можете да намерите на уебсайта или в отпечатаната гаранция, доставена с принтера. Когато се свържете с поддръжката на клиенти, имайте подръка следната информация: Място и дата на закупуване Тип и сериен номер на машината За повече информация вижте  . Информация за безопасност Нормативна информация Информация за гаранцията Информация за околната среда Информацията за гаранцията варира според държавата или региона: В САЩ  – вижте декларацията за ограничена отговорност, включена към този принтер, или отидете на адрес  https://support.lexmark.com . В други държави или региони  – вижте отпечатаната гаранция, доставена с принтера. Информационно ръководство за продукта – вижте документацията, доставена с принтера, или отидете на адрес  https://support.lexmark.com . Информация в цифровия паспорт на Lexmark Отидете на  https://csr.lexmark.com/digital-passport.php . намиране на информация за принтера"},{"UUID":"f1ab7d36-f731-438e-b8c4-562b956cbf26","title":"Научете повече за принтера","link":"finding-printer-serial-number-topic.html","desc":"Намиране на серийния номер на","descFull":"Намиране на серийния номер на принтера Отворете вратичка А. Открийте серийния номер. сериен номер на принтер намиране сериен номер, принтер намиране"},{"UUID":"4314a778-49bd-45a7-b371-53c8adadc7f5","title":"Научете повече за принтера","link":"printer-configurations-topic.html","desc":"Конфигурации на принтера Монтирането на","descFull":"Конфигурации на принтера Монтирането на един или повече допълнителни компоненти във вашия принтер или многофункционално устройство може да изисква наличието на основа на колелца, мебели или друга характеристика, за да се предотврати нестабилност, която може да причини нараняване. За повече информация относно поддържаните конфигурации вижте  www.lexmark.com/multifunctionprinters . Монтирането на един или повече допълнителни компоненти във вашия принтер или многофункционално устройство може да изисква наличието на основа на колелца, мебели или друга характеристика, за да се предотврати нестабилност, която може да причини нараняване. За повече информация относно поддържаните конфигурации се свържете с мястото, откъдето сте закупили принтера. За да намалите риска от нестабилност в оборудването, заредете отделно всяка тава. Дръжте всички останали тави затворени, докато не стане необходимо да се използват. Можете да конфигурирате принтера си, като добавите до три допълнителни тави за 250 или 550 листа. За повече информация вижте  . Части на принтера 1 Автоматично подаващо устройство (АПУ) 2 Тава на АПУ 3 Изходна тава на АПУ 4 Контролен панел 5 Стандартна изходна тава 6 Многоцелево подаващо устройство 7 Стандарта тава за 550 листа 8 Допълнителна тава за 250 или 550 листа конфигурации на принтера"},{"UUID":"34e6d91e-4e69-4ad4-a080-b076a7281702","title":"Научете повече за принтера","link":"using-control-panel-topic.html","desc":"Използване на контролния панел Части","descFull":"Използване на контролния панел Части на контролния панел и техните функции Част на контролен панел Функция 1 Бутон за захранване Включете или изключете принтера. За изключване на принтера натиснете и задръжте бутона за захранване за пет секунди. Задава принтера на режим Sleep (Заспиване). Събудете принтера от режим Sleep (Заспиване) или режим Hibernate (Хибернация). 2 Дисплея Преглеждате съобщенията на принтера и статуса на консумативите. Конфигурирате и извършвате задания с принтера. 3 Светлинния индикатор Проверите състоянието на принтера. контролен панел използване използване на контролния панел"},{"UUID":"f325eeac-2e8c-4be0-9f2f-10f38c3dfcc4","title":"Научете повече за принтера","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Запознаване със състоянията на индикаторната","descFull":"Запознаване със състоянията на индикаторната светлина Цвят на светлинния индикатор и отговарящото на него състояние на принтера Светлинния индикатор Съст.принтер Off (Изкл.) Принтерът е изключен. Постоянно син Принтерът е в състояние на готовност. Мигащ в синьо Принтерът е отпечатва или обработва данни. Мигащ в червено Принтерът изисква намеса на потребителя. Свети в кехлибарен цвят Принтерът е изключен в режим „Заспиване“. Мигащ в кехлибарен цвят Принтерът е в режим Deep Sleep (Дълбок сън) или в режим Hibernate (Хибернация). светлинен индикатор запознаване със състоянието състояние на принтера"},{"UUID":"b0e7ca62-7ca6-44ef-8ef9-25db9f885c53","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Указания за хартия Използвайте подходяща","descFull":"Указания за хартия Използвайте подходяща хартия, за да предотвратите задръстванията и да спомогнете за безпроблемен печат. Винаги използвайте нова, неповредена хартия. Преди зареждане на хартията се запознайте с препоръчителната страна за печат на хартията. Тази информация обикновено е посочена на опаковката на хартията. Не използвайте хартия, която е срязана или подрязана на ръка. Не смесвайте хартия от различен размер, вид или тегло в една и съща тава. Смесването води до задръствания. Не използвайте хартия с покритие, освен ако не е специално предназначена за електрофотаграфски печат. За повече информация вижте  Указания за хартия и специални носители . хартия избор указания за хартия"},{"UUID":"057566f5-2d08-4fbc-ad0f-32e1ea91e0a3","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Характеристики на хартията Следните характеристики","descFull":"Характеристики на хартията Следните характеристики на хартията влияят върху качеството на печат и надеждността. Вземете под внимание следните фактори, преди да отпечатвате върху тях. Тегло Тавите могат да подават хартия с различни тегла. Хартия, по-лека от 60 г/м 2  (16 lb), може да не е достатъчно твърда, за да се подава правилно, което може да причини засядания. За повече информация вижте темата \"Поддържани тегла на хартията\". Набръчкване Набръчкването е тенденцията хартията да се набръчква в краищата си. Ако се набръчка прекалено много, това може да доведе до проблеми с подаването на хартия. Набръчкване може да се появи, след като хартията премине през принтера, където е изложена на високи температури. Ако съхранявате хартията разопакована в горещи, влажни, студени или сухи условия, това може да доведе до набръчкване на хартията преди печат и може да създаде проблеми с подаването. Гладкост Гладкостта на хартията влияе директно върху качеството на печат. Ако хартията е прекалено груба, тонерът не може да отпечатва правилно. Ако хартията е прекалено гладка, това може да доведе до проблеми с подаването на хартия или качеството на печат. Препоръчваме да се използва хартия с 50 точки по Шефилд. Съдържание на влага Количеството влага в хартията влияе както на качеството на печат, така и на способността на принтера да подава хартията правилно. Оставете хартията в оригиналната опаковка, докато не я използвате. Излагането на хартията на промени във влагата, може да понижи качеството й. Преди печата оставете хартията в нейната оригинална опаковка в продължение на 24 до 48 часа. Средата, в която се съхранява хартията, трябва да бъде същата, като тази на принтера. Удължете времето няколко дни, ако условията на съхранение или транспортиране се различават много от експлоатационните условия на принтера. Дебелата хартия може да изисква по-продължителен период на кондициониране. Посока на влакното Влакното се отнася до подравняването на влакната на хартията в един лист хартия. Влакната са или  дълги , които се простират по дължината на хартията, или  къси , които се простират по ширината на хартията. За препоръчваната посока на влакната вижте темата \"Поддържани тегла на хартията\". Съдържание на влакната Най-висококачествената ксерографска хартия е направена от 100 процентово химическо обработено пулпово дърво. Това съдържание осигурява на хартията висока степен на стабилност, което води до по-малко проблеми с подаването и по-добро качество на печат. Хартията, която съдържа влакна като памук, може да повлияе неблагоприятно на работата с хартия. характеристики на хартията"},{"UUID":"2af1ca2e-580e-4519-ba6d-4c257a9c77b1","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Неприемлива хартия Следните видове хартия","descFull":"Неприемлива хартия Следните видове хартия не се препоръчват за употреба с принтера: Химически обработени хартии, които се използват за правене на копия без пигментен слой за копиране. Те са известни и като хартии без пигментен слой за копиране, копирна хартия без пигмент (CCP) или хартия, която не изисква пигмент (NCR). Предварително отпечатани хартии с химикали, които може да замърсят принтера. Предварително отпечатани хартии, които могат да се влияят от температурата във фиксиращия модул на принтера. Предварително отпечатани хартии, които изискват регистрация (точното място на отпечатване върху страницата), по-голяма от ±2,3 мм (±0,09 in). Например форми за оптично разпознаване на знаци (OCR). В някои случаи регистрацията може да се регулира със софтуерно приложение за успешно отпечатване на тези формуляри. Хартии с покритие (гумирани), синтетични хартии или термични хартии. Хартии с необработени страни, грапави или сериозно текстурирана повърхност или набръчкани хартии. Хартии, които не съответстват на EN12281:2002 (Европа). Хартия, която тежи по-малко от 60 г/м 2  (16 lb). Формуляри или документи с няколко слоя. неприемлива хартия"},{"UUID":"bd9bd978-0a25-46f7-9411-be4da1007c85","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Съхраняване на хартия Използвайте тези","descFull":"Съхраняване на хартия Използвайте тези указания за съхраняване на хартия, което ще Ви помогне за избягването на засядане на хартията и неравномерно качество на печат: Съхранявайте хартията в оригиналната опаковка в същата среда, в която съхранявате и принтера, в продължение на 24 до 48 часа преди печат. Удължете времето няколко дни, ако условията на съхранение или транспортиране се различават много от експлоатационните условия на принтера. Дебелата хартия може да изисква по-продължителен период на кондициониране. За най-добри резултати съхранявайте хартията на места, където температурата е 21 °C (70 °F), а относителната влажност е 40 процента. Повечето производители на етикети препоръчват отпечатване в температурен диапазон 18 – 24 °C (65 – 75 °F) с относителна влажност между 40 и 60 процента. Съхранявайте хартията в кутии, на палет или рафт, а не на пода. Съхранявайте отделните пакети върху хоризонтална повърхност. Не съхранявайте нищо върху отделните опаковки хартия. Изваждайте хартията от кутията или опаковката само когато сте готови да я заредите в принтера. Кутията и опаковката помагат за запазване на хартията чиста, суха и гладка. съхраняване на хартия"},{"UUID":"0a548346-0499-478a-8d68-8794d706da93","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Избор на предварително отпечатани формуляри","descFull":"Избор на предварително отпечатани формуляри и бланка Използвайте хартия с влакна по дължината на хартията. Използвайте само формуляри и бланки, които са отпечатани чрез офсетов литографски или гравиран процес на печат. Избягвайте хартия с груба или силно текстурирана повърхност. Използвайте мастила, които не са засегнати от смолата в тонера. Мастила, които са устойчиви на окисление или с маслена основа, обикновено отговарят на тези изисквания; латексовите мастила не отговарят. Преди да закупите големи количества, отпечатайте проби върху предварително отпечатани формуляри и бланки, който смятате да използвате. Така ще прецените дали мастилото на предварително отпечатания формуляр или бланка ще повлияе на качеството на печат. В случай на съмнение се свържете с доставчика си на хартия. Когато отпечатвате върху бланки, заредете хартията в правилната за Вашия принтер ориентация. За повече информация вижте  Указания за хартия и специални носители . Когато отпечатвате върху бланки, заредете хартията в правилната за Вашия принтер ориентация. хартия предварително отпечатани формуляри предварително отпечатани формуляри избор хартия бланка бланка избор"},{"UUID":"f5053f01-1a51-475d-9677-2f332f6e2148","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Поддържани размери хартия Поддържани размери","descFull":"Поддържани размери хартия Поддържани размери хартия Размер на хартията Стандарта тава за 550 листа Допълнителна тава за 250 или 550 листа Многоцелево подаващо устройство Двустранен печат Стъкло на скенера Устройство за автоматично подаване на документи 1  Поддръжката по подразбиране е подаване по ширината на листа. 2  Когато е избран Universal (Универсален размер), страницата се форматира за 215,90 x 355,60 мм (8,5 x 14 in), освен ако не е посочено от приложението. 3  Хартията трябва да бъде поне 210 мм (8,27 in) широка и 279,4 мм (11 in) дълга за двустранно отпечатване. A4 210 x 297 мм (8,27 x 11,7 in) Портрет А5 (SEF) 148 x 210 мм (5,83 x 8,27 in) X Пейзаж А5 (LEF) 1 210 x 148 мм (8,27 x 5,83 in) X X A6 105 x 148 мм (4,13 x 5,83 in) X X JIS B5 182 x 257 мм (7,17 x 10,1 in) X Размер Oficio (Мексико) 216 x 340 мм (8,5 x 13,4 in) Hagaki 100 x 148 мм (3,93 x 5,83 in) X X X X Заявление 139,7 x 215,9 мм (5,5 x 8,5 in) X Executive 184,2 x 266,7 мм (7,25 x 10,5 in) X Letter 215,9 x 279,4 мм (8,5 x 11 in) Legal 215,9 x 355,6 мм (8,5 x 14 in) Фолио 215,9 x 330,2 мм (8,5 x 13 in) Универсален размер 2 от 105 x 148 мм до 215,9 x 359,92 мм (от 4,3 x 5,83 in до 8,5 x 14,17 in) X 3 X Универсален размер 2 от 76,2 x 127 мм до 215,9 x 359,92 мм (от 3 x 5,83 in до 8,5 x 14,17 in) X X X X X Универсален размер 2 от 25,4 x 25,4 мм до 215,9 x 355,6 мм (от 1 x 1 in до 8,5 x 14 in) X X X X X 7 3/4 Envelope (Плик 7 3/4) 98,4 x 190,5 мм (3,875 x 7,5 in) X X X X Плик 9 98,4 x 225,4 мм (3,875 x 8,9 in) X X X X Плик 10 104,8 x 241,3 мм (4,12 x 9,5 in) X X X X Плик DL 110 x 220 мм (4,33 x 8,66 in) X X X X Плик C5 162 x 229 мм (6,38 x 9,01 in) X X X X Плик B5 176 x 250 мм (6,93 x 9,84 in) X X X X Др.плик. от 76,2 x 127 мм до 215,9 x 359,92 мм (от 3 x 5,83 in до 8,5 x 14,17 in) X X X X поддържани размери хартия размери на хартия, поддържани"},{"UUID":"87524d35-9ae4-4f3c-8f67-bfa1a2147dba","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Поддържани типове хартия Поддържани типове","descFull":"Поддържани типове хартия Поддържани типове хартия Тип хартия Стандарта тава за 550 листа Допълнителна тава за 250 или 550 листа Многоцелево подаващо устройство Двустранен печат Устройство за автоматично подаване на документи * Едностранните етикети за хартия се поддържат за спорадична употреба за по-малко от 20 страници на месец. Не се поддържат винилни, фармацевтични или двустранни етикети. Обикновена хартия Картон за картички X X X X Рецикл. хартия Хартиени етикети * X X Ленена хартия Бланка Пред.отп. Цветна хартия Лека хартия Тежка хартия Груба/памук Плик X X X X Груби пликове X X X X поддържани типове хартия типове хартия, поддържани"},{"UUID":"b637110c-9815-4a96-924b-42d2ec3a5a2d","title":"Избор на хартия","link":"selecting-paper-group.html","desc":"Поддържано тегло на хартията Поддържано","descFull":"Поддържано тегло на хартията Поддържано тегло на хартията Поддържано тегло на хартията Стандарта тава за 550 листа Допълнителна тава за 250 или 550 листа Многоцелево подаващо устройство Двустранен печат* Устройство за автоматично подаване на документи * Не поддържа картон за картички, етикети или пликове. 60 – 120 г/м 2 (16–32 lb документна) 60 – 120 г/м 2 (16–32 lb документна) 60 – 216 г/м 2 (16–58 lb документна) 60 – 120 г/м 2 (16–32 lb документна) 52 – 120 г/м 2 (14–32 lb документна) поддържани тегла на хартията тегло на хартия, поддържано"},{"UUID":"95a99a38-1526-40e8-b16d-8600fc2240fb","title":"Настройване, инсталиране и конфигуриране","link":"selecting-location-printer-topic.html","desc":"Избор на място за принтера","descFull":"Избор на място за принтера Оставете достатъчно място за отваряне на тавите, капаците и вратичките и за инсталиране на хардуерни опции. Поставете принтера близо до електрически контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. За да избегнете риска от токов удар, не поставяйте и не използвайте този продукт в близост до вода или мокри места. Уверете се, че въздушният поток в помещението отговаря на най-новите изисквания на стандарта 62 на ASHRAE или стандарт 156 на Техническия комитет на Европейския комитет за стандартизация. Осигурите равна, здрава и стабилна повърхност. Дръжте принтера: чист, сух и непрашен. далеч от отделни скоби от телбод или кламери. далеч от пряко излагане на въздушния поток на климатици, отоплителни уреди или вентилатори. при условия, които не включват директна слънчева светлина или силно количество влага. Спазвайте препоръчителните температури и избягвайте резки промени: Препоръчителни температури Околна температура Температура на съхранение За добра вентилация е необходимо да осигурите следното препоръчително свободно пространство около принтера: Препоръчително пространство около принтера 1 Отгоре 2 Задна страна 3 Дясна страна 4 Предна страна 5 Лява страна принтер избор на място за избор на място за принтера принтер минимални свободни пространства преместване на принтера"},{"UUID":"e1c65277-8c86-4d6a-acf4-ef41000d7452","title":"Настройване, инсталиране и конфигуриране","link":"attaching-cables-topic.html","desc":"Свързване на кабели За да","descFull":"Свързване на кабели За да избегнете риска от токов удар, по време на гръмотевична буря не задавайте настройки на продукта и не го свързвайте с електрически или кабелни връзки, като например със захранващия кабел, функцията за факс или телефона. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. За да избегнете риска от пожар или токов удар, използвайте само захранващия кабел, предоставен с този продукт, или предложения за замяна от производителя разрешен кабел. За да намалите риска от пожар, използвайте само 26 AWG или по-голям телекомуникационен (RJ-11) кабел, когато свързвате този продукт към обществената комутируема телефонна мрежа. За потребители в Австралия кабелът трябва да бъде одобрен от Службата за комуникации и медии на Австралия. За да избегнете загуба на данни или повреда на принтера, не докосвайте USB кабела, безжични мрежови адаптери или принтера в показаните зони по време на печат. Портове на принтера и техните функции Порт на принтера Функция 1 Гнездо за захранващия кабел Свържете принтера към правилно заземен електрически контакт. 2 Ethernet порт Свържете принтера към мрежа. 3 портът Свържете клавиатура или друга съвместима опция. 4 USB порт на принтера Свържете принтера към компютър. 5 EXT порт Свържете повече устройства (телефон или телефонен секретар) към принтера и телефонната линия. Използвайте този порт, ако нямате отделна факс линия за принтера и ако този начин на свързване се поддържа във Вашата страна или регион. 6 LINE порт Свържете принтера към активна телефонна линия през стандартна стенна розетка (RJ‑11), DSL филтър, VoIP адаптер или друг адаптер, който Ви позволява достъп до телефонната линия за изпращане и получаване на факсове. свързване на кабели USB порт на принтера Ethernet порт LINE порт EXT порт гнездо за захранващия кабел"},{"UUID":"c794054b-3eed-4296-9c9b-9bff6deaaea8","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Използване на началния екран Вашият","descFull":"Използване на началния екран Вашият начален екран може да варира в зависимост от настройките за персонализиране на началния екран, администраторската конфигурация, както и активните Embedded Solutions. Икони от началния екран и техните описания № Икона Функция 1 бутон за стоп или отмяна Спрете текущото задание. 2 Копиране Прави копия. 3 Смяна на език Сменете езика на дисплея на принтера. 4 Имейл Изпраща имейли. 5 Настройки Получите достъп до менютата на принтера. 6 Факс Изпраща факс. 7 Адресен указател Достъп до, създаване и организиране на контакти. 8 Състояние/Консумативи Покажете предупреждение или съобщение за грешка от принтера всеки път, когато е необходима намеса на потребителя за продължаване на работата. Видите повече информация относно предупреждението или съобщението от принтера и как да ги изчистите. Можете също да имате достъп до тази настройка, като докоснете горната част на началния екран. 9 Задържани задания Показва всички настоящи задържани задания за печат 10 Опашка на заданията Показва всички настоящи задания за печат. Можете също да имате достъп до тази настройка, като докоснете горната част на началния екран. 11 USB у-во Преглеждате, избирате или отпечатвате снимки и документи от флаш устройство. 12 Scan Profiles (Профили на сканиране) Сканира и запазва документите директно на компютъра. 13 FTP Сканира и запазва документите директно на FTP сървър. 14 Маркери Организира всички маркери. 15 Твърд диск Преглед, избор и управление на документи от твърд диск или интелигентно запаметяващо устройство. 16 Мрежова папка Сканиране към мрежова папка или към място в мрежата. 17 Бутона „Старт“ Стартирате задание в зависимост от избрания режим. 18 Екранна клавиатура За въвеждане на числа или символи в поле за въвеждане. използване на началния екран начален екран използване"},{"UUID":"10ebf198-a3d2-4f34-8235-8c4a4b86ea11","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Персонализиране на началния екран Отворете","descFull":"Персонализиране на началния екран Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Device (Устройство) Home Screen Customization (Персонализиране на началния екран) . Извършете едно или повече от следните действия: За да добавите икона към началния екран, кликнете върху  , изберете името на приложението, след което кликнете върху  Add (Добавяне) . За да отстраните икона от началния екран, изберете името на приложението, след което кликнете върху  Remove (Отстраняване) . За да персонализирате име на приложение, изберете името на приложението, кликнете върху  Edit (Редактиране) , след което назначете име. За да възстановите името на приложение, изберете името на приложението, кликнете върху  Edit (Редактиране) , след което изберете  Restore app label (Възстановяване на етикета на приложение) . За да добавите интервал между приложения, кликнете върху  , изберете  BLANK SPACE (ИНТЕРВАЛ) , след което кликнете върху  Add (Добавяне) . За да подредите приложенията, плъзнете имената на приложенията в желаната от Вас последователност. За да възстановите началния екран по подразбиране, кликнете върху  Restore home screen (Възстановяване на началния екран) . Приложете промените. икони на началния екран показване икони на началния екран показване начален екран персонализиране показване на приложения на началния екран добавяне на приложения на началния екран"},{"UUID":"1991e506-fd57-4168-b1f0-dcaf38dc680d","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Поддържани приложения Приложения и техните","descFull":"Поддържани приложения Приложения и техните поддържани модели на принтери Приложение Модели на принтер Scan Center (Център за сканиране) MX532, MX632, XM3350 Център за бързи команди MX532, MX632, XM3350 Копиране на карти MX532, MX632, XM3350 Персонализиране на дисплея MX532, MX632, XM3350 Customer Support (Поддръжка на клиенти) XM3350 Device Quotas (Квоти на устройството) XM3350 поддържани приложения приложения на принтера"},{"UUID":"c94f9f0e-1b3f-444e-a0af-175078afac9c","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Настройване на центъра за сканиране","descFull":"Настройване на центъра за сканиране От началния екран докоснете  Scan Center (Център за сканиране) . Изберете и създайте местоназначение, а след това конфигурирайте настройките. При създаване на мрежово местоназначение се уверете, че сте валидирали и коригирали настройките, докато не възникват никакви грешки. Запаметяват се само местоназначения, създадени от вградения уебсървър. За повече информация вижте документацията на решението. Приложете промените. Scan Center (Център за сканиране) настройване"},{"UUID":"daf97255-949d-490f-a378-98929ed5e86a","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Създаване на бърза команда От","descFull":"Създаване на бърза команда От началния екран докоснете  Shortcut Center (Център за бързи команди) . Иконата и името може да са променени. За повече информация се свържете с Вашия администратор. Изберете функция на принтера, след което докоснете  Create Shortcut (Създаване на бърза команда) . Функцията за сигурен имейл не се поддържа. Конфигурирайте настройките, след което докоснете  Save (Записване) . Въведете уникално име на бързата команда. За да избегнете показването на отрязани имена върху началния екран, въведете само до 25 символа. Докоснете  ОК . Приложението автоматично генерира уникален номер на бързата команда. За да стартирате бързата команда, докоснете  , докоснете  # (№) , след което въведете номера на бързата команда. създаване на бързи команди бързи команди създаване бърза команда Копиране бърза команда Имейл бърза команда Факс бърза команда FTP"},{"UUID":"698defc1-dd79-429f-84a2-3083890544af","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Настройване на Копиране на карти","descFull":"Настройване на Копиране на карти Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Apps (Приложения) Card Copy (Копиране на карти) Configure (Конфигуриране) . Уверете се, че  Показването на икони  е активирано. Уверете се, че  Настройките за имейл  и  Настройките за мрежов дял  са конфигурирани. Когато сканирате карта, се уверете, че разделителната способност на сканиране не превишава 200 dpi за цветно и 400 dpi за черно-бяло сканиране. Когато сканирате множество карти, се уверете, че разделителната способност на сканиране не превишава 150 dpi за цветно и 300 dpi за черно-бяло сканиране. Приложете промените. На принтера се нуждаете от твърд диск или интелигентно запаметяващо устройство, за да сканирате множество карти. Копиране на карти настройване"},{"UUID":"be9e43fb-5949-4bd5-be7e-d7df6b8481d1","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Използване на Персонализиране на дисплея","descFull":"Използване на Персонализиране на дисплея Преди да използвате приложението, не забравяйте да разрешите и да конфигурирате настройките на скрийнсейвъра, слайдшоуто и тапета от Embedded Web Server (Вграден уебсървър). Управление на изображенията за скрийнсейвър и слайдшоу От Embedded Web Server (Вграден уебсървър) щракнете върху  Apps (Приложения) Display Customization (Персонализиране на дисплея) Configure (Конфигуриране) . В раздела за изображения за Screen Saver (Скрийнсейвър) и Slideshow (Слайдшоу) добавете, редактирайте или изтрийте изображение. Можете да добавите до 10 изображения. Когато са активирани, иконите за състоянието се появяват върху скрийнсейвъра само когато има грешки, предупреждения или облачно базирани известия. Приложете промените. Смяна на изображението на тапета От началния екран докоснете  Change Wallpaper (Смяна на тапета) . Изберете изображение, което да използвате. Приложете промените. Показване на слайдшоу от флаш устройство Поставете флаш устройство в предния USB порт. От началния екран докоснете  Slideshow (Слайдшоу) . Можете да извадите флаш устройството, след като започне слайдшоуто, но изображенията няма да бъдат съхранени в принтера. Ако слайдшоуто спре, поставете отново флаш устройството, за да прегледате изображенията. Персонализиране на дисплея използване използване на Персонализиране на дисплея персонализиране на дисплея смяна на тапета показване на слайдшоу управление на скрийнсейвър"},{"UUID":"5ffc8bcc-9747-4f77-a401-de43d8861988","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Използване на Поддръжка на клиенти","descFull":"Използване на Поддръжка на клиенти Това приложение се поддържа само при някои модели на принтер. За повече информация вижте  . Това приложение се поддържа само при някои модели на принтер. За информация относно начина на конфигуриране на настройките на приложението вижте  Ръководството за администратора за поддръжка на клиенти. От началния екран докоснете  Customer Support (Поддръжка на клиенти) . Отпечатайте или изпратете информацията по имейл. Customer Support (Поддръжка на клиенти) използване използване на  Поддръжка на клиенти"},{"UUID":"11367d94-739b-4a8b-87f7-2fb71b23db87","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Настройка на Device Quotas (Квоти","descFull":"Настройка на Device Quotas (Квоти на устройството) Това приложение се поддържа само при някои модели на принтер. За повече информация вижте  . Това приложение се поддържа само при някои модели на принтер. За информация относно начина на конфигуриране на настройките на приложението вижте  Ръководството за администратора за квоти на устройството . Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Apps (Приложения) Device Quotas (Квоти на устройството) Configure (Конфигуриране) . От раздела  Потребителски профили  добавете или редактирайте потребител и след това задайте потребителската квота. Приложете промените. настройка на  Квоти на устройството Device Quotas (Квоти на устройството) настройване"},{"UUID":"039bb4fc-b849-4c26-8f29-c83e992aefc6","title":"Управление на отметки","link":"using-home-screen-topic.html","desc":"Създаване на маркери Използвайте маркери,","descFull":"Създаване на маркери Използвайте маркери, за да отпечатвате често използвани документи, които се съхраняват в сървъри или в мрежата. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Щракнете върху  Bookmarks (Маркери) Add Bookmark (Добавяне на маркер) , след което напишете име на маркера. Изберете типа на адресния протокол и след това направете едно от следните: За HTTP и HTTPS въведете URL адреса, който искате да маркирате. За HTTPS се уверете, че използвате името на хоста вместо IP адреса. Например, въведете  myWebsite.com/sample.pdf  вместо да въведете  123.﻿123.123.123/sample.pdf . Уверете се, че името на хоста също съответства на стойността на обичайното име (CN) в сертификата на сървъра. За повече информация относно получаването на стойността на CN в сертификата на сървъра вижте помощната информация за Вашия уеббраузър. За FTP въведете FTP адреса. Например  myServer/myDirectory . Въведете FTP порт. Порт 21 е портът по подразбиране за изпращане на команди. За SMB въведете адреса на мрежовата папка. Например  myServer/myShare/myFile.pdf . Въведете името на мрежовия домейн. Ако е необходимо, изберете тип удостоверяване за FTP и SMB. За да ограничите достъпа до маркера, въведете PIN. Приложението поддържа следните типове файлове: PDF, JPEG, TIFF и HTML базирани уеб страници. Други типове файлове като DOCX и XLXS се поддържат при някои модели принтери. Кликнете върху  Save (Записване) . показалци създаване създаване на маркери"},{"UUID":"5c430239-e92a-4ed0-a1db-bac0c95302fb","title":"Управление на отметки","link":"using-home-screen-topic.html","desc":"Създаване на папки Отворете уеб","descFull":"Създаване на папки Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Щракнете върху  Bookmarks (Маркери) Add Folder (Добавяне на папка) , след което напишете име на папка. За да ограничите достъпа до папката, въведете PIN. Кликнете върху  Save (Записване) . Можете да създавате папки или маркери в дадена папка. За да създадете маркер, вижте  . показалци създаване на папки за създаване на папки за маркери"},{"UUID":"50cbf59d-fd3c-451a-9e64-0288c181175b","title":"Настройване и използване на приложенията на началния екран","link":"using-home-screen-topic.html","desc":"Address Book (Адресен указател) Управление","descFull":"Address Book (Адресен указател) Управление на контактите От началния екран докоснете  Address Book (Адресен указател). Извършете едно или повече от следните действия: За да добавите контакт, докоснете   в горната част на екрана, след което докоснете  Create Contact (Създаване на контакт) . Ако е необходимо, укажете начин за влизане, за да се позволи достъп до приложението. За да изтриете контакт, докоснете   в горната част на екрана, докоснете  Delete Contacts (Изтриване на контакти) , след което изберете контакта. За да редактирате информация за контакт, докоснете името на контакта. За да създадете група, докоснете   в горната част на екрана, след което докоснете  Create Group (Създаване на група) . Ако е необходимо, укажете начин за влизане, за да се позволи достъп до приложението. За да изтриете група, докоснете   в горната част на екрана, докоснете  Delete Groups (Изтриване на групи) , след което изберете групата. За да редактирате група с контакти, докоснете  GROUPS (ГРУПИ) , изберете име на група  изберете действието, което желаете да извършите. Приложете промените. добавяне на контакти изтриване на контакти добавяне на групи с контакти изтриване на групи с контакти редактиране на контакти Адресен указател използване"},{"UUID":"5b9b2940-57f2-4c68-af4d-a733bbd163d4","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Активиране на гласовата навигация От","descFull":"Активиране на гласовата навигация От началния екран С едно движение и с един пръст плъзгайте бавно наляво и след това нагоре по дисплея, докато чуете гласово съобщение. За модели на принтери без вградени високоговорители използвайте слушалки, за да чуете съобщението. Докоснете с два пръста  OK . Ако управлението с жестове не работи, тогава приложете по-силен натиск. От клавиатурата Натиснете и задръжте клавиша  5 , докато чуете гласово съобщение. За модели на принтери без вградени високоговорители използвайте слушалки, за да чуете съобщението. Натиснете  Tab , за да навигирате курсора на фокуса до бутона OK, след това натиснете  Enter . Когато е активирана Voice Guidance (Гласова навигация), винаги използвайте два пръста за избор на някой от елементите на дисплея. Voice Guidance (Гласова навигация) има ограничена езикова поддръжка. Гласова навигация активиране активиране на гласовата навигация"},{"UUID":"2fc244dc-a16c-4809-91de-3c7ed8521147","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Дезактивиране на гласовата навигация С","descFull":"Дезактивиране на гласовата навигация С едно движение и с един пръст плъзгайте бавно наляво и след това нагоре по дисплея, докато чуете гласово съобщение. За модели на принтери без вградени високоговорители използвайте слушалки, за да чуете съобщението. С два пръста направете някое от следните неща: Докоснете  Voice Guidance (Гласова навигация) , след което докоснете  OK . Докоснете  Cancel (Отмяна) . Ако управлението с жестове не работи, тогава приложете по-силен натиск. Можете също да дезактивирате гласовата навигация, като направите някое от следните неща: Чукнете два пъти по началния екран с два пръста. Натиснете бутона за захранване, за да поставите принтера в режим Sleep (Заспиване) или Hibernate (Хибернация). Гласова навигация дезактивиране дезактивиране на гласовата навигация"},{"UUID":"24801970-fbdf-44ab-bd7e-2a3381ebe5c6","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Навигиране на екрана с помощта","descFull":"Навигиране на екрана с помощта на жестове Повечето от жестовете са приложими само когато е активирана Voice Guidance (Гласова навигация). Активирайте Magnification (Увеличение), за да използвате мащабирането и панорамните жестове. Използвайте физическа клавиатура, за да въведете знаци и да регулирате определени настройки. Жестове и други функции Жест Функция Плъзгане с един пръст наляво и след това нагоре Включва режим Accessibility (Достъпност). Използвайте същия жест, за да излезете от режим Accessibility (Достъпност). Този жест е приложим и когато принтерът е в нормален режим. Двукратно чукване с един пръст Изберете опция или елемент на екрана. Двукратно чукване с два пръста върху иконата за началния екран Дезактивира режим Accessibility (Достъпност). Трикратно чукване с един пръст Увеличете или намалете мащаба на текст и изображения. Плъзгане с един пръст надясно или надолу Придвижете се към следващия елемент на екрана. Плъзгане с един пръст наляво или нагоре Придвижете се към предишния елемент на екрана. Плъзгане с един пръст нагоре и след това надолу Премества до първия елемент на екрана. Панорамиране Достъп до частите на мащабираното изображение, които са извън границата на екрана. Използвайте два пръста за преместване на мащабирано изображение. Плъзгане с един пръст нагоре и след това надясно Увеличава силата на звука. Този жест е приложим и когато принтерът е в нормален режим. Плъзгане с един пръст надолу и след това надясно Намалява силата на звука. Този жест е приложим и когато принтерът е в нормален режим. Плъзгане с един пръст нагоре и след това наляво Излезте от приложение и се върнете към началния екран. Плъзгане с един пръст надолу и след това наляво Върнете се назад към предишната настройка. навигиране по екрана използване на жестове навигиране на екрана с помощта на жестове"},{"UUID":"587b8c76-00a7-4b8d-91b5-4b2c90fb8e34","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Използване на екранната клавиатура Когато","descFull":"Използване на екранната клавиатура Когато се появи екранната клавиатура, извършете едно или повече от следните действия: Докоснете клавиш за потвърждаване и въведете знака в полето. Плъзгайте пръста върху различни знаци, за да ги потвърдите, и въведете знака в полето. Докоснете текстово поле с два пръста, за да потвърдите знаците в полето. Изберете  Backspace , за да изтриете знаци. екранна клавиатура използване"},{"UUID":"20725f75-67ab-4079-84e0-6265c0f5e783","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Активиране на режим \"Увеличение\" С","descFull":"Активиране на режим \"Увеличение\" С едно движение и с един пръст плъзгайте бавно наляво и след това нагоре по дисплея, докато чуете гласово съобщение. За модели на принтери без вградени високоговорители използвайте слушалки, за да чуете съобщението. С два пръста направете следното: Докоснете  режим Magnification (Увеличение) . Докоснете  ОК . Ако управлението с жестове не работи, тогава приложете по-силен натиск. За повече информация относно навигирането в увеличен екран вижте  . режим \"Увеличение\" разрешаване активиране на режим \"Увеличение\""},{"UUID":"6486e91e-71f2-496e-9b5d-56405ca1cac1","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Регулирайте скоростта на говорене на","descFull":"Регулирайте скоростта на говорене на гласовата навигация От началния екран докоснете  Settings (Настройки) Device (Устройство) Accessibility (Достъпност) Speech Rate (Скорост на говора) . Изберете скоростта на говорене. Гласова навигация скорост на говор Скорост на говор при гласовата навигация регулиране регулиране на скоростта на говора Гласова навигация"},{"UUID":"1093c520-5bd6-4b72-b447-93c63d9608dc","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Регулиране на силата на звука","descFull":"Регулиране на силата на звука на слушалките по подразбиране От началния екран докоснете  Settings (Настройки) Device (Устройство) Accessibility (Достъпност) . Регулира силата на звука на слушалките. Силата на звука се нулира до стойността по подразбиране, след като потребителят излезе от режима Accessibility (Достъпност) или когато принтерът се събуди от режим Sleep (Заспиване) или Hibernate (Хибернация). сила на звука на слушалките по подразбиране регулиране регулиране на силата на звука по подразбиране слушалки"},{"UUID":"6a987fc8-ff7a-4b11-af9b-4c6724d5ac13","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Регулиране на силата на звука","descFull":"Регулиране на силата на звука за вътрешния говорител по подразбиране От началния екран докоснете  . Регулиране на силата на звука. Ако е активиран Quiet Mode (Безшумен режим), звуковите предупреждения са изключени. Тази настройка също забавя работното представяне на принтера. Силата на звука се нулира до стойността по подразбиране, след като потребителят излезе от режима Accessibility (Достъпност) или когато принтерът се събуди от режим Sleep (Заспиване) или Hibernate (Хибернация). сила на звука на високоговорителя по подразбиране регулиране регулиране на силата на звука по подразбиране високоговорител"},{"UUID":"d441b6db-5da7-45fa-a37e-22a7740b33a7","title":"Настройване и използване на функциите за достъпност","link":"activating-voice-guidance-topic.html","desc":"Активиране на гласови пароли или","descFull":"Активиране на гласови пароли или персонални идентификационни номера От началния екран докоснете  Settings (Настройки) Device (Устройство) Accessibility (Достъпност) Speak Passwords/PINs (Гласови пароли/ПИН) . Активирайте настройката. гласови пароли разрешаване персонални идентификационни номера разрешаване активиране на гласови пароли активиране на лични идентификационни номера"},{"UUID":"917e1c6e-04d3-48e8-a1f7-15816c7fd0f9","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Поддържан факс Модели на принтери","descFull":"Поддържан факс Модели на принтери и техния поддържан факс Модел на принтер Аналогов факс etherFAX 1 Факс сървър Факс по IP (FoIP) 2 1  Необходим е абонамент. За повече информация отидете на  https://www.etherfax.net/lexmark  или се свържете с мястото, откъдето сте закупили принтера. 2  Трябва да има инсталиран лицензионен пакет. За повече информация се свържете с мястото, откъдето сте закупили принтера. MX532adwe MX632adwe XM3350 поддържан факс"},{"UUID":"7fc20cac-d9a6-466c-aecd-05995d21c3bd","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Настройване на функцията за факс","descFull":"Настройване на функцията за факс чрез използване на аналогов факс Някои начини за свързване са приложими само в някои държави или региони. Ако функцията за факс е активирана и не е напълно настроена, тогава индикаторната светлина може да мига в червено. Ако не разполагате с TCP/IP среда, тогава използвайте контролния панел за настройка на факса. За да избегнете загуба на данни или повреда на принтера, не докосвайте кабелите или принтера в показаните зони по време на активно изпращане или получаване на факс. Използване на контролния панел От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) General Fax Settings (Общи настройки на факс) . Конфигурирайте настройките. Използване на Embedded Web Server Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) General Fax Settings (Общи настройки на факс) . Конфигурирайте настройките. Приложете промените. аналогов факс настройване настройване на аналогов факс"},{"UUID":"08a67d2b-1f60-44d9-8e34-9d0bec5294bc","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Настройване на функцията за факс","descFull":"Настройване на функцията за факс чрез използване на etherFAX Фърмуерът на принтера трябва да се актуализира до най-новата версия. За повече информация вижте  . Във Вашия принтер трябва да се инсталира подходящ лицензионен пакет. За повече информация се свържете с etherFAX. Уверете се, че сте регистрирали принтера си в портала на etherFAX. За повече информация отидете на  https://www.etherfax.net/lexmark . При регистрацията се изисква серийният номер на принтера. За да откриете серийния номер, вижте  . Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) General Fax Settings (Общи настройки на факс) . Fax Setup (Конфигуриране на факс)  се показва само ако опцията  Fax Mode (Режим факс)  е зададена на  Fax (Факс) . В полето  Fax Name (Име на факс)  въведете уникално име. В полето  Fax Number (Номер на факс)  въведете номера на факс, предоставен от etherFAX. От менюто  Fax Transport (Транспортиране на факс)  изберете  etherFAX . Това меню се показва само когато има повече от един вид предаване на факс. Ако принтерът има инсталиран само etherFAX, тогава той се конфигурира автоматично. Приложете промените. etherFAX настройване на функцията за факс настройване на функцията за факс използване на etherFAX"},{"UUID":"8af9c74d-86c1-4e63-b8ad-b42c311a9ca2","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Настройване на функцията за факс","descFull":"Настройване на функцията за факс чрез факс сървър Тази функция Ви позволява да изпращате факс съобщения до доставчик на факс услуги, който поддържа получаване на имейли. Тази функция поддържа само изходящи факс съобщения. За поддържане на получаването на факс се уверете, че имате базиран на устройство факс, като например аналогов факс, etherFAX или факс по IP (FoIP), конфигуриран във Вашия принтер. Тази функция поддържа само изходящи факс съобщения. За поддържане на получаването на факс се уверете, че имате базиран на устройство факс, като например аналогов факс или Факс по IP (FoIP), конфигуриран във Вашия принтер. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Fax (Факс) . От менюто  Fax Mode (Режим факс)  изберете  Fax Server (Факс сървър) , след което кликнете върху  Save (Запазване) . Кликнете върху  Fax Server Setup (Конфигуриране на факс сървър) . В полето  To Format (До формат)  въведете  [#]@myfax.com , където  [#]  е факс номерът, а  myfax.com  е домейнът на доставчика на факс. Ако е необходимо, конфигурирайте полетата  Reply Address (Адрес за отговор) ,  Subject (Тема)  или  Message (Съобщение) . За да позволите на принтера да получава факс съобщения, разрешете настройката за базирано на устройство получаване на факс. Уверете се, че сте конфигурирали базиран на устройство факс. Кликнете върху  Save (Записване) . Кликнете върху  Fax Server E‑mail Settings (Имейл настройки на факс сървър) , след което направете едно от следните неща: Разрешете  Use E‑mail SMTP Server (Използване на SMTP сървър на имейл) . Ако SMTP настройките за на имейл не са конфигурирани, тогава вижте  . Конфигурирайте SMTP настройките. За повече информация се свържете с Вашия доставчик на имейл услуги. Приложете промените. факс сървър, използване настройване на функцията за факс настройване на функцията за факс чрез факс сървър"},{"UUID":"581b9dbb-3737-4977-8c6a-d53d28c88650","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Настройване на факса чрез използване","descFull":"Настройване на факса чрез използване на стандартна телефонна линия Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За повече информация вижте  . Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За да избегнете риска от токов удар, по време на гръмотевична буря не задавайте настройки на продукта и не го свързвайте с електрически или кабелни връзки, като например със захранващия кабел, функцията за факс или телефона. За да се избегне рискът от токов удар, не използвайте функцията за факс по време на гръмотевична буря. За да намалите риска от пожар, използвайте само 26 AWG или по-голям телекомуникационен (RJ-11) кабел, когато свързвате този продукт към обществената комутируема телефонна мрежа. За потребители в Австралия кабелът трябва да бъде одобрен от Службата за комуникации и медии на Австралия. Настройка 1: Принтерът е свързан към специално отредена за целта факс линия Свържете единия край на телефонния кабел към порта Line на принтера. Свържете другия край на кабела към активна аналогова стенна розетка. Можете да настроите принтера да приема факсове автоматично (задайте  Автоматичен отговор  на  Вкл. ) или ръчно (задайте  Автоматичен отговор  на  Изкл ). Ако искате да получавате факсове автоматично, тогава настройте принтера да приема факсове след определен брой позвънявания. Настройка 2: Принтерът споделя линията с телефонен секретар Ако се абонирате за услуга за специално позвъняване, се уверете, че сте задали правилния начин на звънене за принтера. В противен случай принтерът няма да получава факсове дори ако сте го настроили да приема факсове автоматично. Ако са свързани към различни стенни розетки Свържете единия край на телефонния кабел към порта Line на принтера. Свържете другия край на кабела към активна аналогова стенна розетка. Ако на телефонната Ви линия има само един номер, трябва да зададете автоматично получаване на факсове от принтера. Настройте принтера да приема обаждания две позвънявания след телефонния секретар. Например, ако сте настроили телефонния секретар да приема повиквания след четири позвънявания, настройте функцията  Позвънявания преди отговор  на  6 . настройване на факса връзка по стандартна телефонна линия конфигуриране на факс връзка по стандартна телефонна линия телефонен секретар настройване"},{"UUID":"a07a2f97-bc74-4420-94ff-83d0c86f89ab","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Настройване на факс в страни","descFull":"Настройване на факс в страни или региони с различни телефонни стенни розетки и щепсели Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За повече информация вижте  . Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За да избегнете риска от токов удар, по време на гръмотевична буря не задавайте настройки на продукта и не го свързвайте с електрически или кабелни връзки, като например със захранващия кабел, функцията за факс или телефона. За да се избегне рискът от токов удар, не използвайте функцията за факс по време на гръмотевична буря. За да намалите риска от пожар, използвайте само 26 AWG или по-голям телекомуникационен (RJ-11) кабел, когато свързвате този продукт към обществената комутируема телефонна мрежа. За потребители в Австралия кабелът трябва да бъде одобрен от Службата за комуникации и медии на Австралия. Стандартната стенна розетка, приета от повечето държави или региони, е RJ-11. Ако стенната розетка или оборудването в помещението Ви не е съвместимо с този тип свързване, тогава използвайте телефонен адаптер. Възможно е принтерът Ви да не е оборудван с адаптер за Вашата страна или регион и може да се наложи да закупите такъв отделно. Може да има адаптерен щепсел, монтиран в телефонния порт на принтера. Не сваляйте адаптерния щепсел от телефонния порт на принтера, ако се свързвате към серийна или каскадна телефонна система. Номер на частта на адаптерния щепсел Име на частта Номер на част Адаптерен щепсел на Lexmark 40X8519 Свързване на принтера със стенна розетка, която не е RJ-11 Свържете единия край на телефонния кабел към порта Line на принтера. Свържете другия край на кабела към адаптера RJ-11, след което свържете адаптера към стенната розетка. Ако искате да свържете друго устройство, което няма конектор RJ-11, към същата стенна розетка, тогава го свържете директно към телефонния адаптер. настройване на факса използване на различни стенни розетки настройване на факса използване на различни щепсели конфигуриране на факс използване на различни стенни розетки конфигуриране на факс използване на различни щепсели адаптер RJ-11"},{"UUID":"2d2054c8-e0ac-44f6-9b46-68f8df09f120","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Свързване към услуга за специално","descFull":"Свързване към услуга за специално позвъняване С услугата за специално позвъняване можете да имате множество телефонни номера на една телефонна линия. На всеки телефонен номер е назначен различен модел на звънене. Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За повече информация вижте  . Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Admin Controls (Контроли за администратор) Answer On (Отговор – включен) . Изберете модел на звънене. отличително звънене конфигуриране на факс разрешаване на отличително звънене назначаване на принтер към модел на звънене"},{"UUID":"1f1334eb-86c4-489a-a74c-2f3da973527e","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Задаване на датата и часа","descFull":"Задаване на датата и часа на факса Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Device (Устройство) Preferences (Предпочитания) Date and Time (Дата и час) Configure (Конфигуриране) . Конфигурирайте настройките. изпращане на факс задаване на датата и часа дата и час настройки на факса"},{"UUID":"271acf54-abc2-49fc-b623-5a19cac1b877","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Конфигуриране на лятното часово време","descFull":"Конфигуриране на лятното часово време Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Device (Устройство) Preferences (Предпочитания) Date and Time (Дата и час) Configure (Конфигуриране) . От менюто  Времева зона  изберете  (UTC + потребител) Персонализиране . Докоснете  UTC (GMT) Offset (UTC (GMT) офсет) , след което конфигурирайте настройките. конфигуриране на лятното часово време лятно часово време конфигуриране"},{"UUID":"607a7f07-1294-4a04-b717-1558209dd82d","title":"Настройване на принтера за изпращане на факс","link":"setting-up-printer-to-fax-group.html","desc":"Конфигуриране на настройките за говорителя","descFull":"Конфигуриране на настройките за говорителя на факса Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Speaker Settings (Настройки на високоговорителя) . Направете следното: Задайте  Режим на високоговор.  на  Винаги включено . Задайте  Сила на звука на високогов.  на  Висока . Разрешаване на  Сила на звънене . конфигуриране на настройките на говорителя на факса настройки на говорителя на факса конфигуриране"},{"UUID":"8adbd84a-075e-484e-b4aa-ef4f1d4ab76f","title":"Настройване, инсталиране и конфигуриране","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Конфигуриране на SMTP настройките за","descFull":"Конфигуриране на SMTP настройките за имейл Конфигурирайте настройките на Протокола за обикновено прехвърляне на имейли (SMTP), за да изпратите сканиран документ чрез имейл. Настройките варират при всеки доставчик на имейл услуги. Преди да започнете, се уверете, че принтерът е свързан с мрежа и че мрежата е свързана с интернет. Използване на Embedded Web Server Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Натиснете върху  Settings  (Настройки). Имейл . От раздела  Настройка на имейл  конфигурирайте настройките. За повече информация, вижте списъка с  доставчиците на имейл услуги . За доставчици на имейл услуги, които не са в списъка, се свържете с Вашия доставчик и поискайте настройките. Натиснете върху  Save (Записване) . Използване на менюто  Settings (Настройки)  в принтера От началния екран докоснете  Settings  (Настройки). Имейл Конфигурирайте имейла . Конфигурирайте настройките. За повече информация, вижте списъка с  доставчиците на имейл услуги . За доставчици на имейл услуги, които не са в списъка, се свържете с Вашия доставчик и поискайте настройките. Доставчици на имейл услуги AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live или Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Ако възникнат грешки при използване на предоставените настройки, се свържете с Вашия доставчик на имейл услуги. За доставчици на имейл услуги, които не са в списъка, се свържете с Вашия доставчик. AOL Mail Настройка за AOL Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.aol.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на приложението  За да създадете парола на приложението, отидете на страницата  AOL Account Security (Защита на акаунта в AOL) , влезте във Вашия акаунт, след което натиснете върху  Generate app password (Генериране на парола на приложение) . Comcast Mail Настройки за Comcast Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.comcast.net Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на акаунта Уверете се, че в настройката за достъп на Вашия акаунт има разрешение за достъп на трети страни. За повече информация отидете на  страницата с помощ на Comcast Xfinity Connect . Gmail Уверете се, че е разрешено потвърждаване в две стъпки във Вашия акаунт в Google. За да разрешите потвърждаване в две стъпки, отидете на страницата  Google Account Security (Защита на акаунта в Google) , влезте във Вашия акаунт, след което от раздела „ Signing in to Google (Влизане в Google) “ натиснете върху  2‑Step Verification (Потвърждаване в 2 стъпки) . SMTP настройки за Gmail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.gmail.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на приложението За да създадете парола на приложението, отидете на страницата  Google Account Security (Защита на акаунта в Google) , влезте във Вашия акаунт, след което от раздела „ Signing in to Google (Влизане в Google) “ натиснете върху  App passwords (Пароли на приложението) . „ App passwords (Пароли на приложението) “ се показва само ако е разрешено потвърждаване в две стъпки. iCloud Mail Уверете се, че е разрешено потвърждаване в две стъпки във Вашия акаунт. Настройки за iCloud Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.mail.me.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на приложението За да създадете парола на приложението, отидете на страницата  iCloud Account Management (Управление на акаунти в iCloud) , влезте във Вашия акаунт, след което от раздела  Security (Защита)  натиснете върху  Generate Password (Генериране на парола) . Mail.com Настройки за Mail.com Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.mail.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на акаунта NetEase Mail (mail.126.com) Уверете се, че SMTP service (SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на QQ Mail, натиснете върху  Settings  (Настройки), POP3/SMTP/IMAP  и след това разрешете или  IMAP/SMTP service   (IMAP/SMTP услуга) или  POP3/SMTP service  (POP3/SMTP услуга). Настройки за NetEase Mail (mail.126.com) Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.126.com Първичен порт на SMTP шлюза 465 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола за удостоверяване Паролата за удостоверяване се предоставя, когато е разрешена  IMAP/SMTP service (IMAP/SMTP услуга)  или  POP3/SMTP service (POP3/SMTP услуга) . NetEase Mail (mail.163.com) Уверете се, че SMTP service (SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на QQ Mail, натиснете върху  Settings  (Настройки), POP3/SMTP/IMAP  и след това разрешете или  IMAP/SMTP service   (IMAP/SMTP услуга) или  POP3/SMTP service  (POP3/SMTP услуга). Настройки за NetEase Mail (mail.163.com) Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.163.com Първичен порт на SMTP шлюза 465 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола за удостоверяване Паролата за удостоверяване се предоставя, когато е разрешена  IMAP/SMTP service (IMAP/SMTP услуга)  или  POP3/SMTP service (POP3/SMTP услуга) . NetEase Mail (mail.yeah.net) Уверете се, че SMTP service (SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на QQ Mail, натиснете върху  Settings  (Настройки), POP3/SMTP/IMAP  и след това разрешете или  IMAP/SMTP service   (IMAP/SMTP услуга) или  POP3/SMTP service  (POP3/SMTP услуга). Настройки за NetEase Mail (mail.yeah.net) Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.yeah.net Първичен порт на SMTP шлюза 465 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола за удостоверяване Паролата за удостоверяване се предоставя, когато е разрешена  IMAP/SMTP service (IMAP/SMTP услуга)  или  POP3/SMTP service (POP3/SMTP услуга) . Outlook Live или Microsoft 365 Тези настройки се отнасят за имейл домейните на outlook.com и hotmail.com, както и за акаунтите в Microsoft 365. Настройки за Outlook Live или Microsoft 365 Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.office365.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на акаунта или парола на приложението За акаунти със забранено потвърждаване в две стъпки използвайте паролата на Вашия акаунт. За акаунти в outlook.com или hotmail.com с разрешено потвърждаване в две стъпки използвайте парола на приложението. За да създадете парола на приложението, отидете на страницата  Outlook Live Account Management (Управление на акаунти в Outlook Live) , след което влезте във Вашия акаунт. За допълнителни опции за настройка за бизнеса, използващ Microsoft 365, отидете на  помощната страница на Microsoft 365 . QQ Mail Уверете се, че SMTP service (SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на QQ Mail, натиснете върху  Settings  (Настройки). Профил . От раздела  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service (POP3/IMAP/SMTP/размяна/CardDAV/CalDAV услуга)  разрешете или  POP3/SMTP service (POP3/SMTP услуга) , или  IMAP/SMTP service (IMAP/SMTP услуга) . Настройки за QQ Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.qq.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Код за удостоверяване За да генерирате код за удостоверяване, от началната страница на QQ Mail, натиснете върху  Settings  (Настройки), Account  (Акаунт) и след това от раздела на услугата  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV,   натиснете върху  Generate authorization code (Създаване на код за разрешаване). Sina Mail Уверете се, че POP3/SMTP service (POP3/SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на Sina Mail, натиснете върху  Settings  (Настройки) Повече настройки User‑end POP/IMAP/SMTP  (Краен потребител POP/IMAP/SMTP) и след това разрешете  POP3/SMTP service  (POP3/SMTP услуга). Настройки за Sina Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.sina.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Код за удостоверяване За да създадете код за удостоверяване, от началната страница натиснете върху  Settings  (Настройки). Повече настройки User‑end POP/IMAP/SMTP  (Краен потребител POP/IMAP/SMTP) и след това разрешете  Authorization code status  (Състояние на кода за разрешаване). Sohu Mail Уверете се, че SMTP service (SMTP услуга) е разрешена във Вашия акаунт. За да разрешите услугата, от началната страница на Sohu Mail, натиснете върху  Options  (Опции). Настройки POP3/SMTP/IMAP  и след това разрешете или  IMAP/SMTP service   (IMAP/SMTP услуга) или  POP3/SMTP service  (POP3/SMTP услуга). Настройки за Sohu Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.sohu.com Първичен порт на SMTP шлюза 465 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Независима парола Независимата парола се предоставя, когато е разрешена  IMAP/SMTP service (IMAP/SMTP услуга)  или  POP3/SMTP service (POP3/SMTP услуга) . Yahoo! Mail Настройки за Yahoo! Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.mail.yahoo.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на приложението  За да създадете парола на приложението, отидете на страницата  Yahoo Account Security (Защита на акаунта в Yahoo) , влезте във Вашия акаунт, след което натиснете върху  Generate app password (Генериране на парола на приложение) . Zoho Mail Настройки за Zoho Mail Настройка Стойност Primary SMTP Gateway (Първичен SMTP шлюз) smtp.zoho.com Първичен порт на SMTP шлюза 587 Използване на SSL/TLS Задължителен Изисква доверен сертификат Disabled (Забранено) Reply Address (Адрес за отговор) Вашият имейл адрес SMTP Server Authentication (Удостоверяване на SMTP сървър) Login / Plain (Вход / Опростен) Иницииран от устройството имейл Изп. SMTP данни от у-вото Device UserID (ИД на потребителя на устройството) Вашият имейл адрес Device Password (Парола на устройството) Парола на акаунта или парола на приложението За акаунти със забранено потвърждаване в две стъпки използвайте паролата на Вашия акаунт. За акаунти с разрешено потвърждаване в две стъпки използвайте парола на приложението. За да създадете парола на приложението, отидете на страницата  Zoho Mail Account Security (Защита на акаунта в Zoho Mail) , влезте във Вашия акаунт, след което от раздела  Application‑Specific Passwords (Пароли, специфични за приложението)  кликнете върху  Generate New Password (Генериране на нова парола) . доставчици на имейл услуги конфигуриране на настройките за имейл сървъра SMTP настройки конфигуриране функция за имейл настройване имейл сървър конфигуриране"},{"UUID":"783ba38d-a5e0-4bc8-9943-09ce8dcdcd26","title":"Зареждане на хартия и специални носители","link":"setting-paper-size-and-type-topic.html","desc":"Задаване размера и типа на","descFull":"Задаване размера и типа на хартията От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията)  изберете източник на хартия. Задайте размера и типа на хартията. настройка на размера на хартията настройка на типа хартия"},{"UUID":"73c45f4b-8860-422d-96c9-24c82615dbdb","title":"Зареждане на хартия и специални носители","link":"setting-paper-size-and-type-topic.html","desc":"Конфигуриране на универсални настройки за","descFull":"Конфигуриране на универсални настройки за хартия От началния екран докоснете  Settings (Настройки) Paper (Хартия) Media Configuration (Конфигуриране на носителите) Universal Setup (Универсална настройка) . Конфигурирайте настройките. хартия Универсална настройка на размера на хартията задаване на универсалния размер за хартия Универсален размер хартия настройка"},{"UUID":"6521db8b-0322-486e-bdf4-2f0e690be3b9","title":"Зареждане на хартия и специални носители","link":"setting-paper-size-and-type-topic.html","desc":"Зареждане на тави За да","descFull":"Зареждане на тави За да намалите риска от нестабилност в оборудването, заредете отделно всяка тава. Дръжте всички останали тави затворени, докато не стане необходимо да се използват. Извадете тавата. За да избегнете задръствания с хартия, не отстранявайте тавата, докато принтерът работи. Регулирайте водачите спрямо размера на хартията, която зареждате. Изпънете, развейте и изгладете ръбовете на хартията преди зареждане. Заредете хартията със страната за печат, обърната надолу, и след това се уверете, че водачите прилепват плътно към хартията. За едностранен печат заредете бланката, обърната надолу, като горният колонтитул е насочен към предната страна на тавата. За двустранен печат заредете бланката, обърната нагоре, като горният колонтитул е насочен към задната страна на тавата. Не плъзгайте хартията в тавата. За да избегнете задръствания с хартия, се уверете, че височината на топа е под индикатора за максимално ниво на хартията. Поставете тавата. Ако е необходимо, задайте от контролния панел размер и тип хартия, съвпадащи със заредената хартия. зареждане на тави зареждане на хартия зареждане на бланка"},{"UUID":"1820301a-cba5-4cfd-80fe-3e5a899ea3f8","title":"Зареждане на хартия и специални носители","link":"setting-paper-size-and-type-topic.html","desc":"Зареждане на многоцелевото подаващо устройство","descFull":"Зареждане на многоцелевото подаващо устройство Отворете многоцелевото подаващо устройство. Изпънете, развейте и изгладете ръбовете на хартията преди зареждане. Заредете хартия със страната за печат, обърната нагоре. За едностранен печат заредете бланката, обърната нагоре, като горният колонтитул е насочен към задната страна на принтера. За двустранен печат заредете бланката, обърната надолу, като горният колонтитул е насочен към предната страна на принтера. Заредете пликовете с предкрилката от лявата страна с лице надолу. Не използвайте пликове с марки, закопчалки, скоби, прозорци, покритие или самозалепващи лепенки. Регулирайте водача спрямо размера на хартията, която зареждате. От контролния панел задайте размера и типа на хартията да съответства на заредената хартия. многофунк. подав. у-во зареждане зареждане на бланка в многоцелевото подаващо устройство зареждане на пликове в многоцелевото подаващо устройство"},{"UUID":"e3438eb8-b201-40e7-93be-af7039c4bc44","title":"Зареждане на хартия и специални носители","link":"setting-paper-size-and-type-topic.html","desc":"Свързване на тави От началния","descFull":"Свързване на тави От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) , изберете източник на хартия. Задайте същия размер хартия и тип хартия за тавите, които свързвате. От началния екран докоснете  Настройки Устройство Поддръжка Меню за конфигуриране Конфигуриране на тава Свързване на тавите . Докоснете  Automatic (Автоматично) . За премахване на свързването на тавите се уверете, че няма тави с еднакви настройки за размер и тип хартия. Температурата на модула варира в зависимост от определения тип хартия. За избягване на проблеми с отпечатването изберете настройка за типа на хартията в принтера, които съответстват на хартията, заредена в тавата. прекъсване на връзката между тавите свързване на тави тави свързване тави прекъсване на връзката"},{"UUID":"0954f02e-d937-4499-aaef-cb2d9fa2e179","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Инсталиране на софтуера на принтера","descFull":"Инсталиране на софтуера на принтера Драйверът на принтера е включен в инсталационния пакет на софтуера. За компютри Macintosh с macOS версия 10.7 или по-нова не е необходимо да инсталирате драйвера за отпечатване на сертифициран принтер AirPrint. Ако желаете персонализирани функции за печат, изтеглете драйвера на принтера. Сдобийте се с копие от инсталационния пакет на софтуера. От CD със софтуера, който се доставя с принтера. Отидете на  www.lexmark.com/downloads . Отидете на  www.dell.com/support/printers . От нашия уебсайт или от мястото, откъдето сте закупили принтера. Стартирайте инсталиращата програма и след това следвайте инструкциите на екрана на компютъра. инсталиране на софтуера на принтера софтуер на принтера монтиране инсталиране на драйвера на принтера драйвер за принтера монтиране"},{"UUID":"18b2e006-0920-4791-97dc-f8d609a893a5","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Инсталиране на факс драйвера Отидете","descFull":"Инсталиране на факс драйвера Отидете на  www.lexmark.com/downloads , потърсете модела на Вашия принтер, след което изтеглете подходящия инсталационен пакет. Отидете на нашия уебсайт или на мястото, от което сте закупили принтера, и след това вземете инсталационния пакет. Отидете на  www.dell.com/support , след което изтеглете подходящия инсталационен пакет. От Вашия компютър кликнете върху  Printer Properties (Свойства на принтера) , след което навигирайте до раздела  Configuration (Конфигуриране) . Стартирайте инсталиращата програма и след това следвайте инструкциите на екрана на компютъра. Изберете  Fax (Факс) , след което кликнете върху  Apply (Приложи) . факс драйвер монтиране инсталиране на факс драйвера"},{"UUID":"a51fd8e2-6df4-438c-92ca-2850ea65b1eb","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Добавяне на принтери към компютър","descFull":"Добавяне на принтери към компютър Преди да започнете, направете едно от следните неща: Свържете принтера и компютъра към една и съща мрежа. За повече информация относно свързването на принтера към мрежа вижте  . Свържете компютъра към принтера. За повече информация вижте  . Свържете принтера към компютъра чрез USB кабел. За повече информация вижте  . USB кабелът се продава отделно. За потребители на Windows От компютър инсталирайте драйвера на принтера. За повече информация вижте  . Отворете папката за принтери, след което кликнете върху  Add a printer or scanner (Добавяне на принтер или скенер) . В зависимост от връзката на Вашия принтер направете едно от следните неща: Изберете принтер от списъка и след това кликнете върху  Add device (Добавяне на устройство) . Кликнете върху  Show Wi‑Fi Direct printers (Показване на принтери с Wi-Fi Direct) , изберете принтер и след това кликнете върху  Add device (Добавяне на устройство) . Кликнете върху  The printer that I want isn’t listed (Желаният от мен принтер не е в списъка)  и след това от прозореца  Add Printer (Добавяне на принтер)  направете следното: Изберете  Add a printer using a TCP/IP address or hostname (Добавяне на принтер чрез TCP/IP адрес или име на хост)  и след това кликнете върху  Next (Напред) . В полето „ Hostname or IP address (Име на хост или IP адрес) “ напишете IP адреса и след това кликнете върху  Next (Напред) . Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Изберете драйвер на принтер и след това кликнете върху  Next (Напред) . Изберете  Use the print driver that is currently installed (recommended) (Използване на драйвера на принтер, който е инсталиран в момента (препоръчително)  и след това кликнете върху  Next (Напред) . Напишете име на принтера и след това кликнете върху  Next (Напред) . Изберете опция за споделяне на принтер и след това кликнете върху  Next (Напред) . Кликнете върху  Готово . За потребители на Macintosh От компютър отворете  Printers & Scanners (Принтери и скенери) . Кликнете върху   и след това изберете принтер. От менюто  Use (Използване)  изберете драйвер на принтер. За да използвате драйвера на принтер на Macintosh, изберете  AirPrint  или  Secure AirPrint (Защитен AirPrint) . Ако желаете персонализирани функции за печат, изберете драйвера на принтер на Lexmark. За да инсталирате драйвера, вижте  . Ако желаете персонализирани функции за печат, изберете драйвера на принтер на производителя. За да инсталирате драйвера, вижте  . Добавете принтера. добавяне на принтери към компютър"},{"UUID":"250e6536-84cb-4447-b843-acf0eddcd90c","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Актуализиране на фърмуера За да","descFull":"Актуализиране на фърмуера За да подобрите производителността на принтера и да отстраните проблемите, актуализирайте редовно фърмуера на принтера. За повече информация относно актуализирането на фърмуера се свържете с Вашия представител на Lexmark. За повече информация относно актуализирането на фърмуера се свържете с Вашия представител на Dell. За повече информация относно актуализирането на фърмуера се свържете с Вашия търговски представител. За да получите най-новия фърмуер, отидете на  www.lexmark.com/downloads  и потърсете вашия модел на принтер. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Device (Устройство) Update Firmware (Актуализиране на фърмуер) . Извършете едно от следните неща: Кликнете върху  Check for updates now (Проверка за актуализации сега) I agree, start update (Приемам, стартиране на актуализацията) . Качете файл за запис на данни. Потърсете флаш файла. Уверете се, че сте разархивирали zip файла на фърмуера. Кликнете върху  Upload (Качване) Start (Старт) . актуализиране на фърмуера фърмуер, актуализиране"},{"UUID":"5c6c7284-895d-48fc-a492-e6955b55b524","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Експортиране или импортиране на конфигурационен","descFull":"Експортиране или импортиране на конфигурационен файл Може да експортирате конфигурационни настройки на Вашия принтер в текстов файл и след това да импортирате файла, за да приложите настройките на други принтери. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. От вградения уеб сървър щракнете върху  Export Configuration  (Експортиране на конфигурация) или  Import Configuration  (Импортиране на конфигурация). Следвайте инструкциите на екрана. Ако принтерът поддържа приложения, направете следното: Щракнете върху  Приложения изберете приложението Конфигуриране . Щракнете върху  Export  (Експортиране) или  Import  (Импортиране). експортиране на конфигурационен файл използване на вградения уебсървър импортиране конфигурационен файл използване на вградения уебсървър"},{"UUID":"fd1dde65-d44c-4b9b-92e9-bc23f032723b","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер","link":"installing-printer-software-topic.html","desc":"Добавяне на налични опции в","descFull":"Добавяне на налични опции в драйвера за принтера За потребители на Windows Отворете папката с принтери. Изберете принтера, който искате да актуализирате, и извършете едно от следните действия: За Windows 7 или по-нова версия изберете  Printer properties  (Свойства на принтера). За по-ранни версии изберете  Properties  (Свойства). Отидете до раздела Configuration (Конфигурация), след което изберете  Update Now ‑ Ask Printer  (Актуализиране сега – Допитване до принтера). Приложете промените. За потребители на Macintosh От системните предпочитания в менюто на Apple се придвижете до Вашия принтер и изберете  Options & Supplies  (Опции и консумативи). Отидете до списъка с хардуерни опции, след което добавете всички инсталирани опции. Приложете промените. добавяне на опции за хардуер драйвер за принтера драйвер за принтера опции за хардуер, добавяне добавяне на вътрешни опции драйвер за принтера опции за хардуер, добавяне драйвер за принтера вътрешни опции, добавяне драйвер за принтера"},{"UUID":"055525b0-8ece-4fb4-85b0-13b396c281d1","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Налични вътрешни опции Интелигентно запаметяващо","descFull":"Налични вътрешни опции Интелигентно запаметяващо устройство Шрифтове Опростен китайски Традиционен китайски Японски Корейски Арабски Запаметяващо устройство с голям обем Твърд диск Лицензирани функции Карта за IPDS Баркод Вътрешен порт за решения Карта със сериен интерфейс RS-232C Карта с паралелен интерфейс 1284-B MarkNet  N8230 Fiber Ethernet MarkNet  Безжичен сървър за печат N8450 Доверен платформен модул За активиране на Forms Merge (Обединяване на формуляри) и някои IPDS функции е необходимо интелигентно запаметяващо устройство или твърд диск. За активиране на Forms Merge (Обединяване на формуляри) и някои IPDS функции е необходимо интелигентно запаметяващо устройство или твърд диск. Някои опции са налични само при някои модели на принтери. За повече информация се свържете с мястото, откъдето сте закупили принтера. За активиране на Forms Merge (Обединяване на формуляри) и някои IPDS функции е необходимо интелигентно запаметяващо устройство или твърд диск. Някои опции са налични само при някои модели на принтери. За повече информация се свържете с Вашия дилър. вътрешни опции карта на фърмуера допълнителни карти твърд диск интелигентно запаметяващо устройство"},{"UUID":"94e9ced5-4d20-47f7-9e7a-cfae5a745386","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Инсталиране на допълнителни тави За","descFull":"Инсталиране на допълнителни тави За да избегнете риска от токов удар при достъп до платката на контролера или при инсталирането на допълнителен хардуер или устройство за памет, след като сте настроили принтера, изключете го и извадете захранващия кабел от електрическия контакт, преди да продължите. Ако има други устройства, свързани към принтера, изключете ги и извадете кабелите, които ги свързват с принтера. Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Извадете допълнителната тава и след това отстранете опаковъчния материал. Изравнете принтера с допълнителната тава и след това спуснете принтера, докато щракне на място. Ако принтерът тежи повече от 20 кг (44 фунта), тогава за безопасното му пренасяне могат да са необходими двама или повече човека. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. Включете принтера. Добавете тавата в драйвера на принтера, за да я направите достъпна за задания за печат. За повече информация вижте  . инсталиране на тави тави монтиране хардуерни опции тави"},{"UUID":"5ee6b894-ca51-4b0d-9e74-6d8572e2d4fb","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Монтиране на интелигентното запаметяващо устройство","descFull":"Монтиране на интелигентното запаметяващо устройство За да избегнете риска от токов удар при достъп до платката на контролера или при инсталирането на допълнителен хардуер или устройство за памет, след като сте настроили принтера, изключете го и извадете захранващия кабел от електрическия контакт, преди да продължите. Ако има други устройства, свързани към принтера, изключете ги и извадете кабелите, които ги свързват с принтера. Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. С помощта на права отвертка отворете капака за достъп до контролерната платка. Електронните компоненти на платката на контролера се повреждат лесно от статично електричество. Докоснете метална повърхност на принтера, преди да докоснете каквито и да е компоненти или конектори на платката на контролера. Отстранете факс-платката. Разопаковайте интелигентното запаметяващо устройство. Избягвайте да докосвате точките на свързване по страните на запаметяващото устройство. Намерете ISD конектора. Поставете ISD в конектора му. Монтирайте факс-платката и след това монтирайте винтовете. Затворете капака за достъп до контролерната платка, след което монтирайте винта. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. интелигентно запаметяващо устройство монтиране монтиране на вътрешни опции интелигентно запаметяващо устройство"},{"UUID":"2513f78b-019a-4703-bbf8-620194a7814e","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Инсталиране на твърд диск на","descFull":"Инсталиране на твърд диск на принтера Тези инструкции се отнасят само за принтери, които поддържат твърд диск на принтера. За да избегнете риска от токов удар при достъп до платката на контролера или при инсталирането на допълнителен хардуер или устройство за памет, след като сте настроили принтера, изключете го и извадете захранващия кабел от електрическия контакт, преди да продължите. Ако има други устройства, свързани към принтера, изключете ги и извадете кабелите, които ги свързват с принтера. Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. С помощта на права отвертка отворете капака за достъп до контролерната платка. Електронните компоненти на платката на контролера се повреждат лесно от статично електричество. Докоснете метална повърхност на принтера, преди да докоснете каквито и да е компоненти или конектори на платката на контролера. Извадете твърдия диск. Закрепете твърдия диск към контролерната платка и след това монтирайте винтовете. Не докосвайте или натискайте твърдия диск в центъра. Прикачете интерфейсния кабел на твърдия диск към контролерната платка. Затворете капака за достъп до контролерната платка, след което монтирайте винта. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. инсталиране на твърдия диск на принтера инсталиране на допълнителни компоненти твърд диск на принтера вътрешни опции твърд диск на принтера"},{"UUID":"be974d1f-7849-4f45-9b5c-002635c563f2","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Инсталиране на вътрешен порт за","descFull":"Инсталиране на вътрешен порт за решения За да избегнете риска от токов удар при достъп до платката на контролера или при инсталирането на допълнителен хардуер или устройство за памет, след като сте настроили принтера, изключете го и извадете захранващия кабел от електрическия контакт, преди да продължите. Ако има други устройства, свързани към принтера, изключете ги и извадете кабелите, които ги свързват с принтера. Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Разопаковайте комплекта вътрешни портове за решения (ISP). Съдържание на комплекта за ISP 1 ISP Карта със сериен интерфейс RS-232C Карта с паралелен интерфейс 1284-B MarkNet  N8230 Fiber Ethernet 2 удължен ISP кабел 3 Монтажна скоба 4 Винтове с крилчата глава 5 База Отстранете предварително инсталирания интерфейсен кабел от ISP. Инсталирайте ISP в базата му. Фиксирайте ISP на място и след това закрепете удължения кабел на ISP. С помощта на права отвертка отстранете капака за достъп до контролерната платка. Електронните компоненти на платката на контролера се повреждат лесно от статично електричество. Докоснете метална повърхност на принтера, преди да докоснете каквито и да е електронни компоненти или конектори на платката на контролера. Свържете ISP комплекта към принтера. Затворете комплекта за ISP и след това монтирайте винта. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. вътрешен порт за решения монтиране монтиране на вътрешни опции вътрешен порт за решения"},{"UUID":"1c79ae40-5b17-4646-bc78-68a642a773d3","title":"Инсталиране на допълнителен хардуер","link":"available-internal-options-topic.html","desc":"Монтиране на универсалното телбод устройство","descFull":"Монтиране на универсалното телбод устройство Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Разопаковайте универсалното телбод устройство. Отстранете капаците на колоната. Не изхвърляйте капаците на колоната. Поставете захранващото устройство през принтера и след това го свържете към универсалното телбод устройство. За да избегнете повреждане на универсалното телбод устройство, използвайте само захранващото устройство, което е доставено с него. Монтирайте универсалното телбод устройство. Позиционирайте правилно захранващото устройство. Закрепете капака на колоната. Фиксирайте правилно захранващото устройство. Свържете единия край на захранващия кабел на телбод устройството към захранващото устройство, а след това другия край към електрическия контакт. Свържете единия край на захранващия кабел на принтера към принтера, а след това другия край към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. универсално телбод устройство монтиране монтиране на универсалното телбод устройство"},{"UUID":"98d1baa7-5fb8-4f62-aca0-a3dbc77f6da4","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Поддръжка на безжична връзка Модели","descFull":"Поддръжка на безжична връзка Модели принтери и тяхната поддръжка на безжична връзка Модел на принтер Вид машина Номер на модел Безжично MX532adwe 7020 476 X 486 MX635adwe 676 X 686 XM3350 689 поддръжка на безжична връзка"},{"UUID":"a84e01b7-11bd-4cf5-80bd-4e97875b9c6f","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Свързване на принтера с Wi‑Fi","descFull":"Свързване на принтера с Wi‑Fi мрежа Уверете се, че  Active Adapter (Активен адаптер)  е зададен на  Auto (Автоматично) . От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Network Overview (Преглед на мрежата) Active Adapter (Активен адаптер) . Използване на контролния панел От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wireless (Безжична връзка) Setup On Printer Panel (Конфигуриране на панела на принтера) Choose Network (Избор на мрежа) . Изберете Wi‑Fi мрежа, след което въведете паролата на мрежата. При моделите на принтер с Wi‑Fi мрежова функционалност, по време на първоначалното конфигуриране се появява подкана за настройка на Wi‑Fi мрежата. Използване на Lexmark Mobile Assistant В зависимост от мобилното Ви устройство изтеглете приложението Мобилен асистент на Lexmark от  Google Play  или от онлайн магазина App Store. От началния екран на принтера докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wireless (Безжична връзка) Setup Using Mobile App (Конфигуриране с помощта на мобилно приложение) Printer ID (ИД на принтер) . Стартирайте приложението от мобилното си устройство и приемете условията за ползване. Ако е необходимо, предоставете разрешения. Докоснете  Connect to Printer (Свързване към принтер) Go to Wi‑Fi Settings (Отидете до Wi‑Fi настройките) . Свържете мобилното си устройство към безжичната мрежа на принтера. Върнете се към приложението, след което докоснете  Setup Wi-Fi Connection (Конфигуриране на Wi-Fi връзка) Изберете Wi-Fi мрежа, след което въведете паролата на мрежата. Докоснете  Done (Готово) . безжична мрежа свързване на принтера с свързване на принтера с безжична мрежа безжична мрежа"},{"UUID":"fb35e1be-2518-40eb-823b-c86c4d4e66ea","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Свързване на принтера към безжична","descFull":"Свързване на принтера към безжична мрежа чрез Wi‑Fi Protected Setup (WPS) Преди да започнете, се уверете, че: Точката за достъп (безжичния рутер) е сертифицирана по WPS или е съвместима с WPS. За повече информация вижте документацията, доставена с точката за достъп. Безжичен мрежов адаптер е инсталиран на вашия принтер. За повече информация вижте инструкциите, доставени с адаптера. Active Adapter (Активен адаптер)  е зададен на  Auto (Автоматично) . От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Network Overview (Преглед на мрежата) Active Adapter (Активен адаптер) . Използване на метода чрез натискане на бутон От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wireless (Безжична връзка) Wi‑Fi Protected Setup (Защитено конфигуриране на Wi‑Fi) Start Push Button Method (Метод с натискане на стартов бутон) . Следвайте инструкциите на дисплея. Използване на метода с персонален идентификационен номер (PIN) От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wireless (Безжична връзка) Wi‑Fi Protected Setup (Защитено конфигуриране на Wi‑Fi) Start PIN Method (Метод за стартиране с PIN) . Копирайте осемцифрения WPS PIN. Отворете уеб браузър и въведете IP адреса на точката за достъп в полето за адрес. За да разберете IP адреса, вижте документацията, доставена с точката за достъп. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Отворете на настройките за WPS. За повече информация вижте документацията, доставена с точката за достъп. Въведете осемцифрения PIN и след това запишете промените. Wi‑Fi Protected Setup безжична мрежа безжична мрежа Wi‑Fi Protected Setup свързване с безжична мрежа чрез метода с PIN метод с персонален идентификационен номер свързване с безжична мрежа чрез метода с натискане на бутон Метод с натискане на бутон"},{"UUID":"1d7577ba-4c33-4fd4-b2c5-abc62195bec2","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Конфигуриране на Wi‑Fi Direct Wi‑Fi","descFull":"Конфигуриране на Wi‑Fi Direct Wi‑Fi Direct  е базирана на Wi-Fi технология за равноправен достъп, която позволява на безжични устройства да се свързват директно към принтер с разрешена Wi-Fi Direct, без да се използва точка за достъп (безжичен рутер). Уверете се, че  Active Adapter (Активен адаптер)  е зададен на  Auto (Автоматично) . От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Network Overview (Преглед на мрежата) Active Adapter (Активен адаптер) . От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wi-Fi Direct . Конфигурирайте настройките. Enable Wi‑Fi Direct (Разрешаване на Wi‑Fi Direct)  – разрешава на принтера да излъчва своя собствена Wi‑Fi Direct мрежа. Wi‑Fi Direct Name (Име на Wi‑Fi Direct)  – назначава име за Wi‑Fi Direct мрежата. Wi‑Fi Direct Password (Парола на Wi‑Fi Direct)  – назначава паролата за договаряне на безжичната защита, когато се използва връзката с равноправен достъп. Show Password on Setup Page (Показване на парола на страницата за конфигуриране)  – показва паролата на страницата за настройка на мрежата. Auto-Accept Push Button Requests (Автоматично приемане на заявки с бутон)  – позволява на принтера да приема автоматично заявки за връзка. Автоматичното приемане на заявки с бутон не е защитено. По подразбиране паролата за Wi-Fi Direct мрежата не се вижда на дисплея на принтера. За да се покаже паролата, активирайте иконата за показване на парола. От началния екран докоснете  Settings (Настройки) Security (Защита) Miscellaneous (Разни) Enable Password/PIN Reveal (Разрешаване на показването на паролата/PIN) . Можете да видите паролата на мрежата Wi-Fi Direct, без тя да се показва на дисплея на принтера. От началния екран докоснете  Settings (Настройки) Reports (Отчети) Network (Мрежа) Network Setup Page (Страница за настройка на мрежа) . Wi‑Fi Direct конфигуриране конфигуриране на Wi‑Fi Direct"},{"UUID":"6df580fb-c501-4296-aa78-9513945cbe9f","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Свързване на мобилно устройство към","descFull":"Свързване на мобилно устройство към принтера Преди да свържете своето мобилно устройство, се уверете, че Wi‑Fi Direct е конфигуриран. За повече информация вижте  . Свързване чрез Wi‑Fi Direct Тези инструкции се отнасят само за мобилни устройства с Android. От мобилното устройство отидете на менюто с настройки. Разрешете  Wi‑Fi  и след това докоснете  Wi‑Fi Direct . Изберете името на Wi-Fi Direct на принтера. Потвърдете връзката на контролния панел на принтера. Свързване чрез Wi‑Fi От мобилното устройство отидете на менюто с настройки. Докоснете  Wi‑Fi  и след това изберете името на Wi-Fi Direct на принтера. Низът DIRECT-xy (където x и y са два произволни знака) се добавя преди името на Wi-Fi Direct. Въведете паролата на Wi‑Fi Direct. свързване на мобилно устройство към принтер мобилно устройство свързване към принтер Wi‑Fi Direct разрешаване активиране на Wi‑Fi Direct"},{"UUID":"ea722053-cd8a-45cb-ba0c-3df5fee9c05d","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Wi‑Fi Direct Свързване на компютър","descFull":"Wi‑Fi Direct Свързване на компютър към принтера Преди да свържете своя компютър, се уверете, че Wi‑Fi Direct е конфигуриран. За повече информация вижте  . За потребители на Windows Отворете папката за принтери, след което кликнете върху  Add a printer or scanner (Добавяне на принтер или скенер) . Кликнете върху  Show Wi-Fi Direct printers (Показване на принтери с Wi-Fi Direct) , след което изберете името на принтера с Wi‑Fi Direct. От дисплея на принтера обърнете внимание на осемцифрения PIN на принтера. Въведете PIN на принтера в компютъра. Ако драйверът на принтера не е инсталиран, тогава Windows изтегля подходящия драйвер. За потребители на Macintosh Кликнете върху иконата за безжична връзка, след което изберете името на принтера с Wi‑Fi Direct. Низът DIRECT-xy (където x и y са два произволни знака) се добавя преди името на Wi-Fi Direct. Въведете паролата на Wi‑Fi Direct. Върнете компютъра си към неговата предишна мрежа, след като прекъснете връзката с Wi-Fi Direct мрежата. компютър свързване към принтера свързване на компютър към принтера"},{"UUID":"b803b4aa-0557-4b13-9b01-67484b66ed2a","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Дезактивиране на Wi‑Fi мрежата От","descFull":"Дезактивиране на Wi‑Fi мрежата От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Network Overview (Преглед на мрежа) Active Adapter (Активен адаптер) Standard Network (Стандартна мрежа) . Следвайте инструкциите на дисплея. Wi‑Fi мрежа дезактивиране дезактивиране на Wi‑Fi мрежата"},{"UUID":"2c8739a7-5575-45b3-87af-6d430837acb0","title":"Работа в мрежа","link":"wireless-support-topic.html","desc":"Проверка на свързването на принтера","descFull":"Проверка на свързването на принтера От началния екран докоснете  Settings (Настройки) Reports (Отчети) Network (Мрежа) Network Setup Page (Страница за настройка на мрежа) . Проверете първия раздел на Страница за настройка на мрежа и потвърдете, че състоянието е Свързано. Ако състоянието е несвързано, отворът за LAN може да не е активен или мрежовият кабел може да е дефектен. Свържете се с вашия администратор за помощ. отпечатване страница за настройка на мрежа отпечатване на страница за настройка на мрежа страница за настройка на мрежа отпечатване"},{"UUID":"f94cf3f5-69a1-4887-8f68-29ee31f9fa50","title":"Защита на принтера","link":"locating-security-slot-topic.html","desc":"Намиране на слота за защита","descFull":"Намиране на слота за защита Принтерът е оборудван с функция за заключване за защита. Прикрепете заключване за защита на показаното място, съвместимо с повечето модели лаптопи, за да защитите принтера на мястото му. слот за защита намиране намиране на слота за защита"},{"UUID":"f4a01081-e62d-4c91-8d0d-1577eee1437d","title":"Защита на принтера","link":"erasing-printer-memory-topic.html","desc":"Изтриване на паметта на принтера","descFull":"Изтриване на паметта на принтера Изключете принтера, за да изтриете енергозависимата памет или буферираните данни във Вашия принтер. За изтриване на енергонезависимата памет, настройки на устройството и мрежата, настройки на защитата и внедрени решения извършете следното: От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Out of Service Erase (Изтр. при неизправност) . Докоснете полето с отметка  Sanitize all information on nonvolatile memory (Изчистване на цялата информация на енергонезависимата памет) , след което докоснете  ERASE (ИЗТРИВАНЕ) . Докоснете  Start initial setup wizard (Стартиране на съветник за първоначално конфигуриране)  или  Leave printer offline (Оставяне на принтера офлайн) , след което докоснете  Next (Напред) . Стартирайте операцията. Този процес унищожава също кода за шифроване, който се използва за защита на потребителските данни. Унищожаването на кода за шифроване прави данните невъзстановими. енергозависима памет изтриване енергонезависима памет изтриване памет на принтера изтриване изтриване памет на принтера"},{"UUID":"130647ea-6f15-44ed-9857-5d11c86ff478","title":"Защита на принтера","link":"erasing-printer-storage-drive-topic.html","desc":"Изтриване на запаметяващо устройство на","descFull":"Изтриване на запаметяващо устройство на принтера От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Out of Service Erase (Изтр. при неизправност) . В зависимост от монтираното на Вашия принтер запаметяващо устройство направете едно от следните неща: За твърдия диск докоснете квадратчето за отметка  Sanitize all information on hard disk (Изчистване на цялата информация на твърдия диск) , докоснете  ERASE (ИЗТРИВАНЕ)  и след това изберете метод за изтриване на данните. Процесът за изчистване на твърдия диск може да отнеме от няколко минути до повече от час, през което време принтерът не е на разположение за други задания. За интелигентно запаметяващо устройство (ISD) докоснете  Erase Intelligent Storage Drive (Изтриване на интелигентно запаметяващо устройство)  и след това докоснете  ERASE (ИЗТРИВАНЕ) , за да изтриете всички потребителски данни. Стартирайте операцията. запаметяващо устройство изтриване изтриване на запаметяващо устройство на принтера твърд диск изтриване интелигентно запаметяващо устройство изтриване"},{"UUID":"05c746e7-30b7-49ff-a2c4-851ce935063f","title":"Защита на принтера","link":"restoring-factory-default-settings-topic.html","desc":"Възстановяване на фабричните настройки по","descFull":"Възстановяване на фабричните настройки по подразбиране От началния екран докоснете  Settings (Настройки) Device (Устройство) Restore Factory Defaults (Възстановяване на фабрични настройки по подразбиране) . От менюто  Restore Settings (Възст. настр.)  изберете настройките, които искате да възстановите  RESTORE  (ВЪЗСТАНОВЯВАНЕ). Стартирайте операцията. фабрични настройки по подразбиране възстановяване настройки на принтера възстановяване на фабрични настройки по подразбиране"},{"UUID":"e2b24589-08e4-4a9f-8ef2-83e7b4366b28","title":"Защита на принтера","link":"statement-of-volatility-topic.html","desc":"Изявление за енергозависимост Типове памет","descFull":"Изявление за енергозависимост Типове памет и техните описания Типове памет Описание Енергозависима памет Вашият принтер използва стандартна оперативна памет с произволен достъп (RAM), за да буферира временно потребителски данни по време на обикновени задания за печат и копиране. Енергонезависима памет Принтерът може да използва две форми енергонезависима памет: EEPROM и NAND (флаш памет). Двата типа запаметяват операционната система, настройките за принтера и информацията за мрежата. Те също така запаметяват настройки на скенера и маркерите и внедрени решения. Запаметяващо устройство – твърд диск Някои принтери може да разполагат с инсталиран твърд диск. Твърдият диск на принтера е проектиран за характерна за принтера функция. Твърдият диск позволява на принтера да задържа буферирани потребителски данни от сложни задания за печат, данни за формуляри и за шрифтове. Интелигентно запаметяващо устройство (ISD) В някои принтери може да е монтирано ISD. В ISD се използва енергонезависима флаш памет за запаметяване на потребителски данни от сложни задания за печат, данни от формуляри и данни за шрифтове. Изтрийте съдържанието на даден вид инсталирана памет на принтера при следните обстоятелства: Принтерът се извежда от експлоатация. Твърдият диск на принтера или ISD е сменен. Принтерът е преместен в различен раздел или на различно местоположение. Принтерът е обслужван от лице извън вашата организация. Принтерът е отстранен от вашето помещение за обслужване. Принтерът е продаден на друга организация. За изхвърлянето като отпадък на запаметяващото устройство следвайте политиките и процедурите на Вашата организация. изявление за енергозависимост енергозависима памет енергонезависима памет запаметяващо устройство – твърд диск интелигентно запаметяващо устройство изтриване на паметта на принтера защитаване на данните на принтера"},{"UUID":"5ccb4600-17c9-4c7e-8fbc-91339500449b","title":"Печат","link":"printing-from-computer-h2-topic.html","desc":"Отпечатване от компютър За етикети,","descFull":"Отпечатване от компютър За етикети, картони и пликове задайте размера и типа на хартията в принтера, преди да отпечатате документа. Отворете диалоговия прозорец „Печат“ от документа, който искате да отпечатате. Променете настройките, ако е необходимо. Отпечатайте документа. отпечатване от компютър документи, отпечатване от компютър отпечатване от вашия принтер"},{"UUID":"c7f533a3-174a-410b-84e2-bd322d19dd63","title":"Отпечатване от мобилно устройство","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Отпечатване от мобилно устройство чрез","descFull":"Отпечатване от мобилно устройство чрез Lexmark Mobile Print Отпечатване от мобилно устройство чрез Lexmark Mobile Print Lexmark  С Mobile Print можете да изпращате документи и изображения директно до поддържан принтер Lexmark. Отворете документа и след това изпратете до или споделете документа с Lexmark Mobile Print. Някои приложения на трети страни може да не поддържат версията за изпращане или споделяне. За повече информация вижте документацията на приложението. Изберете принтер. Отпечатайте документа. Мобилен печат на Lexmark използване документи, отпечатване от мобилно устройство мобилно устройство отпечатване от"},{"UUID":"7366077b-a3d4-4125-89cb-911bb9ebb3c7","title":"Отпечатване от мобилно устройство","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Отпечатване от мобилно устройство чрез","descFull":"Отпечатване от мобилно устройство чрез печат на Lexmark Lexmark  Print (Печат) е решение за мобилен печат за мобилни устройства, които използват  Android , версия 6.0 или по-нова. То Ви позволява да изпращате документи и изображения към свързани в мрежа принтери и сървъри за управление на печат. Уверете се, че сте изтеглили приложението за печат на Lexmark от магазина на  Google Play , и го активирайте в мобилното устройство. Уверете се, че принтерът и мобилното устройство са свързани към една и съща мрежа. От Вашето мобилно устройство изберете документ от мениджъра на файлове. Изпратете на или споделете документа с печата на Lexmark. Някои приложения на трети страни може да не поддържат версията за изпращане или споделяне. За повече информация вижте документацията на приложението. Изберете принтер, след което регулирайте настройките, ако е необходимо. Отпечатайте документа. Печат на Lexmark използване документи, отпечатване от мобилно устройство мобилно устройство отпечатване от"},{"UUID":"b709e7b3-6e53-4aa3-a0b6-b64b9bc81286","title":"Отпечатване от мобилно устройство","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Отпечатване от мобилно устройство чрез","descFull":"Отпечатване от мобилно устройство чрез услугата на принтера Mopria Mopria  Услугата на принтера е решение за мобилен печат за мобилни устройства, които използват  Android , версия 5.0 или по-нова. Позволява директното отпечатване на всеки сертифициран за Mopria принтер. Уверете се, че сте свалили приложението за услуга на принтер Mopria от магазина на  Google Play , и го активирайте в мобилното устройство. От Вашето мобилно устройство с Android стартирайте съвместимо приложение или изберете документ от Вашия файлов мениджър. Докоснете  Print (Отпечатване) . Изберете принтер, след което регулирайте настройките, ако е необходимо. Натиснете  . Услуга за печат Mopria отпечатване от мобилно устройство мобилно устройство отпечатване от отпечатване Услуга на принтер Mopria"},{"UUID":"108e45d5-2bec-40e6-b259-e0a549909091","title":"Отпечатване от мобилно устройство","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Отпечатване от мобилно устройство чрез","descFull":"Отпечатване от мобилно устройство чрез AirPrint Софтуерната функция AirPrint е решение за мобилен печат, което ви позволява да отпечатвате директно от устройства на Apple на принтер, сертифициран по AirPrint. Уверете се, че Apple устройството и принтерът са свързани към една и съща мрежа. Ако в мрежата има няколко безжични хъба, се уверете, че и двете устройства са свързани към една и съща подмрежа. Това приложение е поддържано само в някои устройства Apple. От Вашето мобилно устройство изберете документ от файловия мениджър или стартирайте съвместимо приложение. Докоснете  Print (Отпечатване) . Изберете принтер, след което регулирайте настройките, ако е необходимо. Отпечатайте документа. AirPrint използване отпечатване от мобилно устройство мобилно устройство отпечатване от"},{"UUID":"447c3697-7ba7-4b62-af00-6028144c4447","title":"Отпечатване от мобилно устройство","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Отпечатване от мобилно устройство чрез","descFull":"Отпечатване от мобилно устройство чрез Wi‑Fi Direct® Wi‑Fi Direct  е услуга на принтер, която Ви позволява да отпечатвате на всеки принтер с готовност за печат от Wi‑Fi Direct. Уверете се, че мобилното устройство е свързано към безжичната мрежа на принтера. За повече информация вижте  . От Вашето мобилно устройство стартирайте съвместимо приложение или изберете документ от Вашия файлов мениджър. В зависимост от мобилното Ви устройство направете едно от следните: Докоснете  Print (Отпечатване) . Докоснете  Print (Отпечатване) . Докоснете  Print (Отпечатване) . Изберете принтер, след което регулирайте настройките, ако е необходимо. Отпечатайте документа. Wi‑Fi Direct отпечатване от мобилно устройство отпечатване от мобилно устройство мобилно устройство отпечатване от отпечатване чрез Wi‑Fi Direct"},{"UUID":"45e89687-ff95-4372-9016-24d4821eb62a","title":"Печат","link":"printing-from-flash-drive-topic.html","desc":"Отпечатване от флаш устройство Поставете","descFull":"Отпечатване от флаш устройство Поставете флаш устройството. Ако вкарате флаш устройството, когато се появи съобщение за грешка, принтерът игнорира флаш устройството. Ако поставите флаш устройството, докато принтерът обработва други задания за печат, тогава на дисплея се появява  Busy (Зает) . От дисплея докоснете документа, който желаете да отпечатате. Ако е необходимо, конфигурирайте настройките за печат. Отпечатайте документа. За отпечатване на друг документ докоснете  USB Drive (USB устройство) . За да избегнете загуба на данни или повреда на принтера, не докосвайте флаш устройството или принтера в показаните зони по време на печат, разчитане и записване от устройството с памет. отпечатване от флаш устройство флаш диск отпечатване от"},{"UUID":"fab920d0-601f-4438-94b7-b2c136bbc648","title":"Печат","link":"supported-flash-drives-and-file-types-topic.html","desc":"Поддържани флаш устройства и типове","descFull":"Поддържани флаш устройства и типове файлове Флаш устройства Флаш устройства, които поддържат USB 2.0 или по-ниска версия. Флаш устройства, които поддържат файлова система New Technology File System (NFTS) или файлова система File Allocation Table (FAT32). Типове файлове Поддържани типове файлове Оригинален Изображения PDF (версия 1.7 или по-ранна) Файлови формати на Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG или JPG TIFF или TIF GIF BMP PNG PCX DCX поддържани флаш устройства поддържани видове файлове"},{"UUID":"bca7eebd-a166-4be7-8f3b-8d913d857581","title":"Печат","link":"configuring-confidential-jobs-topic.html","desc":"Конфигуриране на поверителни задания От","descFull":"Конфигуриране на поверителни задания От началния екран докоснете  Settings (Настройки) Security (Защита) Confidential Print Setup (Конфигуриране на поверителен печат) . Конфигурирайте настройките. Елементи от меню  Настройка на поверителен печат  и техните описания Настройка Описание Макс. невалидни PIN кодове Задава ограничение за въвеждане на невалиден PIN. Когато се достигне лимитът, заданията за печат за това потребителско име се изтриват. Срок на поверително задание Задава индивидуален срок за всяко задържано задание, преди да бъде изтрито автоматично от паметта на принтера, твърдия диск или от интелигентното запаметяващо устройство. Задържаното задание е  Confidential (Поверително) ,  Repeat (Повторение) ,  Reserve (Резервно)  или  Verify (Проверка) . Повтаряне на срока на задание Задава срока за заданията за печат, които желаете да повторите. Потвърждаване на крайния срок на задание Задава срока за отпечатване на копие на задание, за да проверите качеството му, преди да отпечатате останалите копия. Резервиране на срока на задание Задава срока за задания, които желаете да запаметите в принтера за отпечатване по-късно. Require All Jobs to be Held (Изискване всички задания да бъдат задържани) Настройва принтера да задържи всички задания за печат. Запазване на дублирани документи Задава принтерът да запази всички документи със същото име на файл. задания за поверителен печат конфигуриране задържани задания задаване на срок Няма задания за печат повтаряне на задания за печат потвърдете задания за печат"},{"UUID":"faff02fd-70ce-4f84-913c-527c66cf2595","title":"Печат","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Отпечатване на конфиденциални и други","descFull":"Отпечатване на конфиденциални и други изчакващи задания за печат За потребители на Windows С отворен документ кликнете върху  File  (Файл) Print  (Отпечатване). Изберете принтер, след което кликнете върху  Properties (Свойства) ,  Preferences (Предпочитания) ,  Options (Опции)  или  Setup (Конфигуриране) . Кликване върху  Print and Hold  (Отпечатване и задържане). Изберете  Use Print and Hold  (Използване на отпечатване и задържане) и след това задайте име на потребител. Изберете типа задание за печат (\"Поверителен\", \"Повтарящ се\", \"Резервен\" или \"Потвърждаващ\"). Ако изберете  Confidential (Поверителен) , след това защитете заданието за печат с персонален идентификационен номер (PIN). Кликнете върху  OK  или  Print (Отпечатване) . Пуснете заданието за печат от началния екран на принтера. За задания за поверителен печат докоснете  Задържани задания  изберете потребителското си име Поверително  въведете PIN  изберете заданието за печат  конфигурирайте настройките Отпечатване . За други задания за печат докоснете  Задържани задания  изберете потребителското си име  изберете заданието за печат  конфигурирайте настройките Отпечатване . За потребители на Macintosh Използване на AirPrint С отворен документ изберете  File  (Файл) Print  (Отпечатване). Изберете принтер, след което от падащото меню, следващо менюто  Orientation (Ориентация) , изберете  PIN Printing (Отпечатване с PIN) . Разрешете  Отпечатване с PIN  и след това въведете четирицифрен PIN. Натиснете  [Print/Печат] . Пуснете заданието за печат от началния екран на принтера. Докоснете  Задържани задания  изберете името на Вашия компютър Поверително  въведете PIN изберете заданието за печат Отпечатване . Използване на драйвера на принтера С отворен документ изберете  File  (Файл) Print  (Отпечатване). Изберете принтер, след което от падащото меню, следващо менюто  Orientation (Ориентация) , изберете  Print and Hold (Отпечатване и задържане) . Изберете  Confidential Print (Поверителен печат) , след което въведете четирицифрен PIN. Натиснете  [Print/Печат] . Пуснете заданието за печат от началния екран на принтера. Докоснете  Held jobs (Задържани задания)  изберете името на Вашия компютър Confidential (Поверителен) изберете заданието за печат въведете PIN Print (Отпечатване) . отпечатване задържани задания отпечатване задания за поверителен печат задания за поверителен печат отпечатване задържани задания отпечатване"},{"UUID":"48382e80-1251-4349-b454-6f5b2dd64b2e","title":"Печат","link":"printing-font-sample-list-h2-topic.html","desc":"Отпечатване на списък с примери","descFull":"Отпечатване на списък с примери на шрифтове От началния екран докоснете  Settings (Настройки)  Reports (Отчети) Print (Отпечатване) Print Fonts (Отпечатване на шрифтовете) . Докоснете  PCL Fonts (PCL шрифтове)  или  PS Fonts (PS шрифтове) . отпечатване списък с примери на шрифтове отпечатване на списък с примери на шрифтове списък с примери на шрифтове отпечатване"},{"UUID":"2990acbf-8a47-47ff-ace9-74548590c5d9","title":"Печат","link":"printing-directory-list-h2-topic.html","desc":"Отпечатване на списък на директории","descFull":"Отпечатване на списък на директории От началния екран докоснете  Settings (Настройки) Reports (Отчети) Print (Отпечатване) Print Directory (Отпечатване на директория) . отпечатване списък с директории отпечатване на списък с директории списък с директории отпечатване"},{"UUID":"5b0f2ece-abdd-4507-b680-76ca51e09d4e","title":"Печат","link":"placing-separator-sheets-topic.html","desc":"Поставяне на разделителни листове между","descFull":"Поставяне на разделителни листове между копията От началния екран докоснете  Настройки Отпечатване Оформление Разделителни листове Между копията . Отпечатайте документа. разделящи листове поставяне поставяне на разделителни листове"},{"UUID":"fdc87f6c-57e1-43cf-9c9f-9fd28ba16be1","title":"Печат","link":"canceling-print-job-topic.html","desc":"Отмяна на задание за печат","descFull":"Отмяна на задание за печат От началния екран докоснете  . Изберете заданието, което искате да отмените. Можете също да отмените дадено задание чрез докосване на  Job Queue (Опашка на заданията) . задание за печат отменяне отмяна на задание за печат"},{"UUID":"a6f357fe-2b41-4996-acb0-7d6f156b4829","title":"Печат","link":"adjusting-toner-darkness-topic.html","desc":"Регулиране на тъмнотата на тонера","descFull":"Регулиране на тъмнотата на тонера От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Toner Darkness (Плътност на тонера) . Регулирайте настройката. тъмнота на тонера регулиране регулиране на тъмнотата на тонера"},{"UUID":"c6c5d843-a7fc-4922-bf0f-9e9652bcdc47","title":"Копиране","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"С помощта на автоматичното подаващо","descFull":"С помощта на автоматичното подаващо устройство и стъклото на скенера Зареждане на хартия в тавата на АПУ и върху стъклото на скенера Автоматично подаващо устройство (АПУ) Стъкло на скенера Използвайте АПУ за многостранични или двустранни документи. Заредете оригинален документ с лицевата част нагоре. За многостранични документи подравнете водещия край преди зареждане. Регулирайте водачите на АПУ спрямо ширината на хартията, която зареждате. Използвайте стъклото на скенера за документи от една страница, страници от книга, малки обекти (като пощенски картички или снимки), прозрачно фолио, фотохартия или тънки носители (като изрезки от списания). Поставете документа с лицевата част надолу в ъгъла със стрелката. копиране с помощта на автоматичното подаващо устройство (АПУ) копиране използване на стъклото на скенера"},{"UUID":"3b8010d4-2e4a-4a83-a022-52d62e57d15a","title":"Копиране","link":"making-copies-topic.html","desc":"Правене на копия Заредете оригиналния","descFull":"Правене на копия Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. За да не допуснете изрязано изображение, уверете се, че оригиналният документ и изходящият са с еднакъв размер на хартията. От началния екран докоснете  Copy (Копиране) , след което посочете броя на копията. Променете настройките за копиране, ако е необходимо. Копирайте документа. За да направите бързо копие, докоснете   от началния екран. правене на копия използване на АПУ копиране използване на стъклото на скенера копиране копиране от избрана тава копиране на различни размери хартия различни размери хартия, копиране"},{"UUID":"d93a9b8c-1aca-455c-8c65-c4e06a775230","title":"Копиране","link":"copying-photos-topic.html","desc":"Копиране на снимки Поставете снимка","descFull":"Копиране на снимки Поставете снимка върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Settings (Настройки) Content (Съдържание) Content Type (Тип съдържание) Photo (Снимка) . Докоснете  Content Source (Източник на съдържание) , след което изберете настройката, която съответства най-добре на оригиналната снимка. Копирайте снимката. копиране снимки снимки, копиране"},{"UUID":"bf1c2407-19ac-410a-bd5a-004e19978cd2","title":"Копиране","link":"copying-transparencies-or-letterhead-topic.html","desc":"Копиране върху бланка Заредете оригиналния","descFull":"Копиране върху бланка Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Copy From (Копиране от) изберете размера на оригиналния документ. Докоснете  Copy to  (Копиране в), след което изберете източника на хартия, който съдържа бланката. Ако сте заредили бланката в многоцелевото подаващо устройство, тогава докоснете  Copy To (Копиране в) Multipurpose Feeder (Многоцелево подаващо устройство)  изберете размера на хартията Letterhead (Бланка) . Копирайте документа. копиране върху бланка бланка копиране върху"},{"UUID":"ceb44c85-19f2-415f-9004-6f4af2bf1e7b","title":"Копиране","link":"copying-on-both-sides-of-paper-topic.html","desc":"Копирайте от двете страни на","descFull":"Копирайте от двете страни на хартията Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Settings (Настройки) Sides (Страни) . Докоснете  1 sided to 2 sided (едностранно към двустранно)  или  2 sided to 2 sided (двустранно към двустранно) . Копирайте документа. копиране от двете страни на хартията двустранно копиране"},{"UUID":"c19abe99-614b-4c71-8e58-720b73bcc701","title":"Копиране","link":"reducing-enlarging-copies-topic.html","desc":"Намаляване или увеличаване на копията","descFull":"Намаляване или увеличаване на копията Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Settings (Настройки) Scale (Мащаб) изберете стойност на мащаба. Промяна на размера на оригиналния документ или изходящ резултат след задаването на  Мащабиране  възстановява стойността на мащаба на  Автоматично . Копирайте документа. намаляване на размера на копиране увеличаване на размера на копиране"},{"UUID":"20cdee95-5b9a-4129-ae94-381756d638aa","title":"Копиране","link":"collating-copies-topic.html","desc":"Сортиране на копия Заредете оригиналния","descFull":"Сортиране на копия Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Collate (Колиране) On (Вкл.) [1,2,1,2,1,2] . Копирайте документа. сортиране на копия сортиране на множество копия"},{"UUID":"94383176-0829-4632-b48f-80c7a539d432","title":"Копиране","link":"placing-separator-sheets-between-copies-topic.html","desc":"Поставяне на разделителни листове между","descFull":"Поставяне на разделителни листове между копията Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От контролния панел се придвижете до: Copy  (Копиране) Settings  (Настройки) Separator Sheets  (Разделителни листове) регулиране на настройките Копирайте документа. копиране разделителни листове между копията поставяне на разделителни листове между копията"},{"UUID":"6b1fed99-b188-4422-b058-0d14cbd242ea","title":"Копиране","link":"saving-paper-topic.html","desc":"Копиране на няколко страници върху","descFull":"Копиране на няколко страници върху един лист Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Copy (Копиране) Settings (Настройки) Pages per Side (Страници на страна) . Активирайте настройката и след това изберете брой на страна и ориентация на страницата. Копирайте документа. копиране на множество страници върху единичен лист спестяване на хартия"},{"UUID":"01b17bcd-7175-41d0-8bfe-f935650d9385","title":"Копиране","link":"copying-cards-topic.html","desc":"Копиране на карти Заредете карта","descFull":"Копиране на карти Заредете карта върху стъклото на скенера. От началния екран докоснете  Card Copy (Копиране на карти) . Променете настройките за сканиране, ако е необходимо. Докоснете  Scan (Сканиране) . Ако искате няколко копия на картата, докоснете  Print a Copy (Отпечатване на копие) . копиране на карти Копиране на карти"},{"UUID":"33115f26-8d80-48d6-8ad5-f28347c64025","title":"Копиране","link":"creating-copy-shortcut-topic.html","desc":"Създаване на бърза команда за","descFull":"Създаване на бърза команда за копиране От началния екран докоснете  Copy  (Копиране). Коригирайте настройките и след това докоснете  . Създайте бърза команда. създаване на пряк път копиране добавяне на бърза команда копиране бърза команда, създаване копиране"},{"UUID":"c506e411-9391-4ac0-9526-385dfa7c64c4","title":"Имейл","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"С помощта на автоматичното подаващо","descFull":"С помощта на автоматичното подаващо устройство и стъклото на скенера Зареждане на хартия в тавата на АПУ и върху стъклото на скенера Автоматично подаващо устройство (АПУ) Стъкло на скенера Използвайте АПУ за многостранични или двустранни документи. Заредете оригинален документ с лицевата част нагоре. За многостранични документи подравнете водещия край преди зареждане. Регулирайте водачите на АПУ спрямо ширината на хартията, която зареждате. Използвайте стъклото на скенера за документи от една страница, страници от книга, малки обекти (като пощенски картички или снимки), прозрачно фолио, фотохартия или тънки носители (като изрезки от списания). Поставете документа с лицевата част надолу в ъгъла със стрелката. изпращане на имейл с помощта на автоматичното подаващо устройство (АПУ) изпращане на имейл използване на стъклото на скенера"},{"UUID":"bec89aad-7f48-4d1b-a84a-356a2ca7c3c2","title":"Имейл","link":"sending-email-topic.html","desc":"Изпращане на имейл Преди да","descFull":"Изпращане на имейл Преди да започнете, се уверете, че SMTP настройките са конфигурирани. За повече информация вижте  . Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  E-mail (Имейл) , след което въведете необходимата информация. Ако е необходимо, конфигурирайте настройките за сканиране. Изпратете имейла. имейл изпращане изпращане на имейл"},{"UUID":"695f36c6-247d-4e3c-911b-d1a77a588443","title":"Имейл","link":"creating-email-shortcut-topic.html","desc":"Създаване на бърза команда за","descFull":"Създаване на бърза команда за имейл От началния екран докоснете  E‑mail (Имейл) . Коригирайте настройките и след това докоснете  . Създайте бърза команда. създаване на бърза команда имейл добавяне на бърза команда имейл бърза команда, създаване имейл бърза команда за имейл създаване"},{"UUID":"9f8f1e49-424c-4550-b983-85b55b0c4c73","title":"Факс","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"С помощта на автоматичното подаващо","descFull":"С помощта на автоматичното подаващо устройство и стъклото на скенера Зареждане на хартия в тавата на АПУ и върху стъклото на скенера Автоматично подаващо устройство (АПУ) Стъкло на скенера Използвайте АПУ за многостранични или двустранни документи. Заредете оригинален документ с лицевата част нагоре. За многостранични документи подравнете водещия край преди зареждане. Регулирайте водачите на АПУ спрямо ширината на хартията, която зареждате. Използвайте стъклото на скенера за документи от една страница, страници от книга, малки обекти (като пощенски картички или снимки), прозрачно фолио, фотохартия или тънки носители (като изрезки от списания). Поставете документа с лицевата част надолу в ъгъла със стрелката. изпращане на факс с помощта на автоматичното подаващо устройство (АПУ) изпращане на факс използване на стъклото на скенера"},{"UUID":"94621b67-aac1-41fe-8fb2-eb1b65db7ff3","title":"Факс","link":"sending-fax-topic.html","desc":"Изпращане на факс Уверете се,","descFull":"Изпращане на факс Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Използване на контролния панел Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Fax (Факс) , след което въведете необходимата информация. Променете настройките, ако е необходимо. Изпратете факса. С помощта на компютър Преди да започнете, се уверете, че драйверът на факса е инсталиран. За повече информация вижте  . За потребители на Windows От документа, който се опитвате да изпратите по факса, отворете диалоговия прозорец  Print (Отпечатване) . Изберете принтера, след което кликнете върху  Properties  (Свойства),  Preferences  (Предпочитания),  Options  (Опции) или  Setup  (Конфигуриране). Кликнете върху  Fax (Факс) Enable fax (Разрешаване на факс) Always display settings prior to faxing (Винаги показвай настройките преди изпращане по факс) , след което въведете номера на получателя. Ако е необходимо, конфигурирайте други настройките за факс. Изпратете факса. За потребители на Macintosh С отворен документ изберете  File (Файл) Print (Отпечатване) . Изберете принтера, към който след името му е добавена думата  – Факс . В полето  To (До)  въведете номера на получателя. Ако е необходимо, конфигурирайте други настройките за факс. Изпратете факса. изпращане на факс факс изпращане"},{"UUID":"bf915865-c12e-4e27-98b9-7535c4d54f13","title":"Факс","link":"scheduling-fax-topic.html","desc":"Насрочване на факс Уверете се,","descFull":"Насрочване на факс Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Fax (Факс) To (Към) въведете номера на факса  Done (Готово) . Докоснете  Send Time (Час на изпращане) , конфигурирайте датата и часа, след което докоснете  Done (Готово) . Изпратете факса. насрочване на факс факс, планиране"},{"UUID":"bd4daaf2-db4e-4a05-b8c2-b5571fa0d8cd","title":"Факс","link":"creating-fax-destination-shortcut-topic.html","desc":"Създаване на бърза команда за","descFull":"Създаване на бърза команда за факсово местоназначение Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Fax (Факс) To (До) . Въведете номера на получателя, след което докоснете  Done (Готово) . Коригирайте настройките и след това докоснете  . Създайте бърза команда. създаване на бърза команда факсово местоназначение добавяне на бърза команда факсово местоназначение бърза команда, създаване факсово местоназначение бърза команда за местоназначение на факс създаване"},{"UUID":"26a47bd1-8ddc-4182-afe3-ece0794fa6d3","title":"Факс","link":"changing-fax-resolution-topic.html","desc":"Намаляване на разделителната способност на","descFull":"Намаляване на разделителната способност на факса Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Fax (Факс) , след което въведете необходимата информация. Докоснете  Settings (Настройки) Resolution (Разделителна способност) изберете настройка. Изпратете факса. разделителна способност на факса променяне промяна на разделителната способност на факса"},{"UUID":"0cc844ac-ab8b-45ce-b1f2-c97845c1757a","title":"Факс","link":"adjusting-fax-darkness-topic.html","desc":"Регулиране на тъмнината на факса","descFull":"Регулиране на тъмнината на факса Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Fax (Факс) , след което въведете необходимата информация. Докоснете  Settings (Настройки) Darkness (Тъмнота) регулирайте настройката. Изпратете факса. регулиране на тъмнината на факса тъмнина на факс регулиране"},{"UUID":"9c2d3dab-ada2-472e-b73f-e724747064f9","title":"Факс","link":"printing-fax-log-topic.html","desc":"Печат на дневник на факсове","descFull":"Печат на дневник на факсове Уверете се, че аналоговият факс или etherFAX е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Reports (Отчети) Fax (Факс) . Щракнете върху  Fax Job Log (Дневник задания факс)  или  Fax Call Log (Дневник повик. факс) . дневник на факсове отпечатване отпечатване дневник на факсове"},{"UUID":"8e42e9a5-20ac-4f03-b388-b2e848b8bb2e","title":"Факс","link":"blocking-junk-faxes-topic.html","desc":"Блокиране на нежелани факсове Уверете","descFull":"Блокиране на нежелани факсове Уверете се, че аналоговият факс или etherFAX е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Admin Controls (Контроли за администратор) . Настройте  Block No Name Fax (Блокиране на факсове без име)  на  On (Вкл.) . нежелани факсове блокиране блокиране на нежелани факсове"},{"UUID":"86de851e-2d6b-45aa-bd73-ebb2ece5780b","title":"Факс","link":"holding-faxes-topic.html","desc":"Задържане на факсове Уверете се,","descFull":"Задържане на факсове Уверете се, че аналоговият факс или etherFAX е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Holding Faxes (Задържане на факсове) . Изберете режим. задържане на факсове получени факсове задържане"},{"UUID":"8f79f69b-f414-42c5-9116-1cfdfa9bd2b3","title":"Факс","link":"forwarding-fax-topic.html","desc":"Препращане на факс Уверете се,","descFull":"Препращане на факс Уверете се, че аналоговият факс или etherFAX е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Уверете се, че факсът е конфигуриран. За повече информация вижте раздела  Конфигуриране на принтера за факс . Създайте бърза команда за местоназначение. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Shortcuts (Бързи команди) Add Shortcut (Добавяне на бърза команда) . Изберете тип бърза команда, след което конфигурирайте настройките. Запишете си номера на бързата команда. Приложете промените. Кликнете върху  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Admin Controls (Контроли за администратор) . От менюто  Fax Forwarding (Препращане на факс)  изберете  Forward (Препращане)  или  Print and Forward (Отпечатване и препращане) . В менюто  Forward to (Препращане до)  изберете типа местоназначение, след което въведете номера на бързата команда. Приложете промените. препращане на факс"},{"UUID":"ac5d73ba-4f28-445e-8c8f-b4a9d68cfa40","title":"Сканиране","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"С помощта на автоматичното подаващо","descFull":"С помощта на автоматичното подаващо устройство и стъклото на скенера Зареждане на хартия в тавата на АПУ и върху стъклото на скенера Автоматично подаващо устройство (АПУ) Стъкло на скенера Използвайте АПУ за многостранични или двустранни документи. Заредете оригинален документ с лицевата част нагоре. За многостранични документи подравнете водещия край преди зареждане. Регулирайте водачите на АПУ спрямо ширината на хартията, която зареждате. Използвайте стъклото на скенера за документи от една страница, страници от книга, малки обекти (като пощенски картички или снимки), прозрачно фолио, фотохартия или тънки носители (като изрезки от списания). Поставете документа с лицевата част надолу в ъгъла със стрелката. сканиране с помощта на автоматичното подаващо устройство (АПУ) сканиране използване на стъклото на скенера"},{"UUID":"c912c8e1-ed61-4e3f-89b0-396bf50e0e43","title":"Сканиране","link":"scanning-to-computer-topic.html","desc":"Сканиране към компютър Преди да","descFull":"Сканиране към компютър Преди да започнете, се уверете, че компютърът и принтерът са свързани към една и съща мрежа. За потребители на Windows Използване на помощна програма Lexmark ScanBack От компютъра стартирайте помощната програма Lexmark ScanBack, след което кликнете върху  Next (Напред) . За да изтеглите помощната програма, отидете на  www.lexmark.com/downloads . Кликнете върху  Настройка  и след това добавете IP адреса на принтера. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. Кликнете върху  Close (Затваряне) Next (Напред) . Изберете размера на оригиналния документ и след това кликнете върху  Напред . Изберете формат на файла и разделителната способност на сканиране и след това кликнете върху  Напред . Въведете уникално име на профил на сканиране и след това кликнете върху  Напред . Отидете до мястото, където искате да запазите сканирания документ, създайте име на файл, след което кликнете върху  Next (Напред) . За повторно използване на профила на сканиране разрешете  Create Shortcut (Създаване на бърза команда) , след което създайте уникално име на бърза команда. Кликнете върху  Готово . Заредете оригинален документ в автоматичното подаващо устройство или върху стъклото на скенера. От началния екран на принтера докоснете  Scan Profiles (Сканиране на профили) Scan to Computer (Сканиране към компютър) , след което изберете профил за сканиране. За потребители на Windows Използване на програмата за факс и сканиране в Windows Уверете се, че принтерът е добавен в компютъра. За повече информация вижте  . Заредете оригинален документ в автоматичното подаващо устройство или върху стъклото на скенера. От компютъра отворете  Windows Fax and Scan (Факс и сканиране в Windows) . Кликнете върху  New Scan (Ново сканиране)  и след това изберете източник на сканиране. Ако е необходимо, променете настройките за сканиране. Сканирайте документа. Кликнете върху  Save as (Запазване като) , напишете име на файл и след това кликнете върху  Save (Запазване) . За потребители на Macintosh Уверете се, че принтерът е добавен в компютъра. За повече информация вижте  . Заредете оригинален документ в автоматичното подаващо устройство или върху стъклото на скенера. От компютъра извършете едно от следните действия: Отворете  Image Capture (Заснемане на изображение) . Отворете  Printers & Scanners (Принтери и скенери) , след което изберете принтер. Кликнете върху  Scan (Сканиране) Open Scanner (Отваряне на скенер) . От прозореца  Scanner (Скенер)  извършете едно от следните действия: Изберете мястото, където искате да запазите сканирания документ. Изберете размера на оригиналния документ. За да сканирате от АПУ, изберете  Document Feeder (Подаващо устройство)  от  Scan Menu (Меню за сканиране)  или разрешете  Use Document Feeder (Използване на подаващо устройство) . Ако е необходимо, конфигурирайте настройките за сканиране. Кликнете върху  Сканиране . сканиране към компютър компютър, сканиране към Помощна програма Lexmark ScanBack"},{"UUID":"1bd34aa8-974c-4be3-aa0c-e3f59620b970","title":"Сканиране","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Сканиране към FTP сървър Заредете","descFull":"Сканиране към FTP сървър Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  FTP , след което въведете необходимата информация. Ако е необходимо, конфигурирайте другите настройки на FTP. Изпратете заданието за FTP. FTP сървър, сканиране към използване на контролния панел сканиране към FTP сървър сканиране към FTP сървър използване на контролния панел"},{"UUID":"137d5d6c-663a-483a-b3bf-e24a9aa55ff4","title":"Сканиране","link":"creating-FTP-shortcut-topic.html","desc":"Създаване на бърза команда за","descFull":"Създаване на бърза команда за FTP От началния екран докоснете  FTP . Въведете адреса на FTP сървъра, след което докоснете  . Създайте бърза команда. създаване на бърза команда FTP адрес добавяне на бърза команда FTP адрес FTP адрес създаване на бърза команда бърза команда, създаване FTP адрес"},{"UUID":"8bb3c4f1-900d-4ef2-a5bb-f92fdb319706","title":"Сканиране","link":"s2a-scanning-to-network-folders-topic.html","desc":"Сканиране към мрежова папка Заредете","descFull":"Сканиране към мрежова папка Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. От началния екран докоснете  Scan Center (Център за сканиране) . Иконата и името може да са променени. За повече информация се свържете с Вашия администратор. Извършете едно от следните неща: Изберете местоназначение. При SFTP, за номер на порта задайте  22 . Използвайте бърза команда, като докоснете  , а след това изберете бързата команда от списъка. Сканирайте документа. сканиране към мрежова папка SMB сканиране"},{"UUID":"cff53e59-82e8-42a8-818b-78829974e7a7","title":"Сканиране","link":"creating-network-folder-shortcut-topic.html","desc":"Създаване на бърза команда за","descFull":"Създаване на бърза команда за мрежова папка Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Shortcuts  (Бързи команди) Add Shortcut  (Добавяне на бърза команда). От менюто Shortcut Type (Тип бърза команда) изберете  Network Folder (Мрежова папка) , след което конфигурирайте настройките. Приложете промените. мрежова папка създаване на пряк път създаване на пряк път мрежова папка"},{"UUID":"6a7a4a11-ea21-4cec-b4dc-3d70a8baf563","title":"Сканиране","link":"scanning-to-flash-drive-topic.html","desc":"Сканиране към флаш устройство Заредете","descFull":"Сканиране към флаш устройство Заредете оригиналния документ в тавата на АПУ или върху стъклото на скенера. Поставете флаш устройството. Докоснете  Сканиране към USB  и коригирайте настройките, ако е необходимо. За да запазите сканирания документ в папка, докоснете  Scan to (Сканиране към) , изберете папка, след което докоснете  Scan Here (Сканиране тук) . Ако екранът на  USB Drive (USB устройство)  не се изведе, тогава докоснете  USB Drive (USB устройство)  на контролния панел. Сканирайте документа. За да избегнете загуба на данни или повреда на принтера, не докосвайте флаш устройството или принтера в показаните зони по време на печат, разчитане и записване от устройството с памет. сканиране към флаш устройство флаш диск сканиране към"},{"UUID":"3ff1f26a-65df-488a-a97c-2219a6d873e9","title":"Използване на менютата на принтера","link":"menu-map-mfp-topic.html","desc":"Карта на менюто 1 ","descFull":"Карта на менюто 1  Показва се само в Embedded Web Server. 2  Появява се само когато е монтиран твърд диск или интелигентно запаметяващо устройство. Устройство Предпочитания Екологичен режим Панел Remote Operator (Дистанционен оператор) Известия Управление на захранването Събиране на анонимни данни Достъпност Възстановяване на фабрични настройки Поддръжка Home Screen Customization (Персонализиране на начален екран) 1 Актуализация на фърмуера Информация за този принтер Печат Оформление Настройка Качество Отчитане задан. PDF PostScript PCL Изображение Хартия Конфигуриране на тава Конфигурация на носител Копиране Копиране по подр. Факс Настройки по подразбиране за факс Имейл Конфигуриране на имейл Имейл по подразбиране Настр.уеб връзка FTP FTP по подразбиране USB у-во Сканиране от флаш устройство Печатане от флаш устройство Мрежа/портове Преглед на мрежата Безжично Wi‑Fi Direct AirPrint Управление на мобилни услуги Ethernet TCP/IP SNMP IPSec 802.1x Конфигуриране на LPD Настройки на HTTP/FTP ThinPrint USB Ограничаване на външен достъп до мрежата Защита Методи за влизане Планиране на USB устройства Дневник на проведена защита Ограничения за вход Настройка на поверителен печат Кодиране диск Изтр. временни файлове Solutions LDAP Settings (Решения за настройки на LDAP) Разни Услуги в облака Регистрация за услуги в облака Отчети Стр. с настр. на меню Устройство Печат Бързи команди Факс Мрежа Откриване и отстраняване на неизправности Тестови страници за качество на печат Почистване на скенера Forms Merge (Обединяване на формуляри) 2 Forms Merge (Обединяване на формуляри) менюта на принтера"},{"UUID":"a1829266-7deb-4e8d-a642-ab83e890ec48","title":"Устройство","link":"preferences-topic.html","desc":"Предпочитания Елементи от менюто ","descFull":"Предпочитания Елементи от менюто  Предпочитания  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Display Language (Език на дисплея) [Списък с езици] Зададете езика на текста, който се появява на дисплея. Country/Region (Държава/Регион) [List of countries or regions] (Списък с държави и региони) Идентифицирайте държавата или региона, където принтерът е конфигуриран да работи. Run initial setup (Стартиране на първоначални настройки) Off (Изкл.) * On (Вкл.) Изпълните съветника за конфигуриране. Keyboard (Клавиатура) Keyboard Type (Вид клавиатура) [Списък с езици] Изберете език като тип клавиатура. Всичките стойности за  Keyboard Type  (вид клавиатура) могат да не се появят или могат да изискват специален хардуер, за да се появят. Displayed information (Показвана информация) Display Text 1 (Текст на дисплея 1)  ( IP Address (IP адрес) *) Display Text 2 (Текст на дисплея 2)  ( Date/Time (Дата/час) *) Custom Text 1 (Персонализиран текст 1) Custom Text 2 (Персонализиран текст 2) Посочете информацията, която да се появява на началния екран. Date and Time (Дата и час) Configure (Конфигуриране) Current Date and Time (Текущи дата и час) Manually Set Date and Time (Ръчно задаване на дата и час) Date Format (Формат за дата)  (ММ-ДД-ГГГГ*) Time Format (Формат за час)  (12 часа преди обяд/след обяд*) Time Zone (Часова зона) UTC (GMT) офсет DST старт DST край DST офсет Network Time Protocol Enable NTP (Разрешаване на NTP)  ( On (Вкл.) *) NTP Server (NTP сървър) Enable Authentication (Разрешаване на удостоверяване)  ( None (Няма) *) Key ID (ИД клавиш) Парола Конфигурира датата и часа на принтера и протокола за време на мрежата. MM‑DD‑YYYY (ММ‑ДД‑ГГГГ)  е фабричната настройка по подразбиране в САЩ.  MM‑DD‑YYYY (ММ‑ДД‑ГГГГ)  е международната фабрична настройка по подразбиране. UTC (GMT) Offset (UTC (GMT) офсет) ,  DST Start (Начало на DST) ,  DST End (Край на DST)  и  DST Offset (Офсет на DST)  се появяват, само когато  Time Zone (Часова зона)  е зададена на  (UTC+user) Custom (UTC + потребител) Персонализиране) . Key ID (ID на ключа)  и  Password (Парола)  се появяват само когато  Enable Authentication (Разрешаване на удостоверяване)  е зададено на  MD5 key (MD5 ключ) . Paper Sizes (Размери на хартия) U.S. (САЩ) * Metric (Метрични) Определите единицата за измерване на размери хартия. Страната или регионът, избрани в съветника за първоначално конфигуриране, определя първоначалната настройка за размер на хартия. Screen Brightness (Яркост на екран) 20 – 100% (100*) Регулира яркостта на дисплея. Flash Drive Access (Достъп до флаш устройство) Disabled (Забранено) Enabled (Разрешено) * Позволява достъп до флаш устройството. Позволяване отстраняване на фон Off (Изкл.) On (Вкл.) * Посочва дали е позволено отстраняването на фона. Позвол. сканир. персон. задан. Off (Изкл.) On (Вкл.) * Посочва дали настройката  Custom Job Scanning (Сканиране на персонализирано задание)  се показва за копиране, сканиране и факс. Този елемент от менюто се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство. One Page Flatbed Scanning (Хоризонтално сканиране на една страница) Off (Изкл.) * On (Вкл.) Конфигурира принтера да сканира всякакъв вид задание, включващо стъклото на скенера като една страница. Принтерът се връща в началния екран след извършване на единично хоризонтално сканиране, вместо да извежда подкани. Звукови сигнали на устройството Mute All Sounds (Заглушаване на всички звукови сигнали)  ( Off (Изкл.) *) Button Feedback (Обратна връзка от бутона)  ( On (Вкл.) *) Volume (Сила на звука)  (5*) ADF Loaded Beep (Звуков сигнал за заредено АПУ)  ( On (Вкл.) *) Alarm Control (Управление на алармата)  ( Single (Единично) *) Cartridge Alarm (Аларма касета)  ( Off (Изкл.) *) Speaker Mode (Режим на високоговор.)  ( Always Off (Винаги изкл.) *) Ringer Volume (Сила на звънене)  ( Off (Изкл.) *) Конфигурира настройките на звуковия сигнал на принтера. Screen Timeout (Време за изчакване на екрана) 5 – 300 секунди (60*) Задайте времето за режим на готовност в секунди, преди на дисплея да бъде изведен началният екран или преди принтерът автоматично да изключи акаунт на потребител. меню Предпочитания"},{"UUID":"95a2c47b-e0c2-4545-9f9e-9f7808d9fd0f","title":"Устройство","link":"preferences-topic.html","desc":"Еко-режим Елементи на менюто ","descFull":"Еко-режим Елементи на менюто  Eco-Mode (Режим Еко)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Отпечатване Страни Едностранно * 2‑Sided (Двустранно) Определя дали отпечатването да се извършва от едната страна или и на двете страни на хартията. Отпечатване Страници на страна Off (Изкл.) * 2 pages per side (2 страници на страна) 3 pages per side (3 страници на страна) 4 pages per side (4 страници на страна) 6 pages per side (6 страници на страна) 9 pages per side (9 страници на страна) 12 pages per side (12 страници на страна) 16 pages per side (16 страници на страна) Отпечатване на многостранични изображения на едната страна на лист хартия. Отпечатване Плътност на тонера 1 – 10 (8*) Определете светлостта или тъмнотата на текстовите изображения. Копиране Страни Едностранно към едностранно * Едностранно към двустранно Двустранно към едностранно Двустранно към двустранно Посочва сканиращото поведение въз основа на оригиналния документ. Копиране Страници на страна Off (Изкл.) * 2 страници с вертикална ориентация 4 страници с вертикална ориентация 2 страници с хоризонтална ориентация 4 страници с хоризонтална ориентация Посочва сканиращото поведение въз основа на оригиналния документ. Копиране Мрак 1 – 9 (5*) Определя плътността на сканираните текстови изображения. меню Екологичен режим"},{"UUID":"ea870ebc-ed00-435c-85fe-86a1c5876fbc","title":"Устройство","link":"preferences-topic.html","desc":"Панел Remote Operator (Дистанционен оператор)","descFull":"Панел Remote Operator (Дистанционен оператор) Елементи от меню  Панел “Дистанционен оператор”  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. External VNC Connection (Външна VNC връзка) Не позволявам * Позволяване Свързва външен Virtual Network Computing (VNC) клиент към отдалечения контролен панел. Вид удостоверяване Няма * Standard Authentication (Стандартно удостоверяване) Задава типа на удостоверяването при достъп до клиентския сървър VNC. VNC Password (VNC парола) Задава паролата за свързване към клиентския сървър VNC. Този елемент от менюто се появява само ако  Тип на удостоверяването  е зададен на  Стандартно удостоверяване . меню Панел Remote Operator (Дистанционен оператор)"},{"UUID":"c7dd1638-b4b0-4aa3-8867-3e9baf188c08","title":"Устройство","link":"preferences-topic.html","desc":"Известия Елементи от менюто ","descFull":"Известия Елементи от менюто  Известия  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. ADF Loaded Beep (Звуков сигнал за заредено АПУ) Off (Изкл.) On (Вкл.) * Активира звук при зареждане на хартия в АПУ. Alarm Control (Управление на аларма) Off (Изкл.) Single (Единично) * Continuous (Продължителен) Задава колко пъти да звучи алармата, когато принтерът изисква намеса от потребителя. Консумативи Show Supply Estimates (Показване на приблизителни изчисления на консумативи) Show estimates (Показване на приблизителни изчисления) * Do not show estimates (Без показване на приблизителни изчисления) Показва очакваното състояние на консумативите. Консумативи Cartridge Alarm (Аларма касета) Off (Изкл.) * Single (Единично) Continuous (Продължителен) Задава колко пъти да звучи алармата, когато тонер касетата е изчерпана. Консумативи Custom Supply Notifications (Персонализирани известявания за консумативи) Конфигурирайте настройките за известията, когато принтерът изисква намеса от страна на потребителя. Този елемент от менюто е достъпен само в вградения уебсървър. E‑mail Alerts Setup (Настройка на известия по имейл) Primary SMTP Gateway (Първичен SMTP шлюз) Primary SMTP Gateway Port (Първичен порт на SMTP шлюза)  (25*) Secondary SMTP Gateway (Вторичен SMTP шлюз) Secondary SMTP Gateway Port (Вторичен порт на SMTP шлюза)  (25*) SMTP Timeout (Таймаут на SMTP сървъра)  (30 секунди*) Reply Address (Адрес за отговор) Always use SMTP default Reply Address (Да се използва винаги адрес за отговор по подразбиране на SMTP)  ( Off (Изкл.) *) Използване на SSL/TLS  ( Забранено *) Изискване на доверен сертификат  ( Вкл. *) SMTP Server Authentication (Удостоверяване на SMTP сървър)  ( No authentication required* (Не е необходимо удостоверяване) *) Device‑Initiated E‑mail (Иницииран от устройството имейл)  ( None (Няма) *) User‑Initiated E‑mail (Иницииран от потребителя имейл)  ( None (Няма) *) Use Active Directory Device Credentials (Използ. удостов. от у-то за Active Directory)  ( Off (Изкл.) *) Device Userid (ИД потребител у-во) Device Password (Парола на устройството) Kerberos 5 зона NTLM Domain (NTLM домейн) Disable “SMTP server not set up” error (Дезактивиране на грешката „SMTP сървърът не е настроен“)  ( Off (Изкл.) *) Конфигурирайте принтера да изпраща уведомления по имейл на списък от контакти, когато изисква потребителска намеса. E‑mail Alerts Setup (Настройка на известия по имейл) Конфигуриране на имейл списъци и сигнали E‑mail List 1 (Имейл списък 1) E‑mail List 2 (Имейл списък 2) Текст за тема Имейл събития Посочва имейл адресите и разрешава събития за имейл известия. Този елемент от менюто е достъпен само в вградения уебсървър. Error Prevention (Предотвратяване на грешки) Jam Assist (Подпомагане при засядане) Off (Изкл.) On (Вкл.) * Задаване на принтера автоматично да почиства празни страници или страници с частично отпечатване след изчистване на заседнала страница. Error Prevention (Предотвратяване на грешки) Auto Continue (Автоматично продължаване) Enabled (Разрешено) 5 – 255 (5*) Оставяне принтерът автоматично да продължи да обработва или отпечатва задание след изчистване на някои условия за обслужване. Error Prevention (Предотвратяване на грешки) Auto Reboot (Автоматично рестартиране) Auto Reboot (Автоматично рестартиране) Reboot when idle (Рестарт при режим на готовност) Reboot always (Рестарт – всеки път) * Reboot never (Рестарт – никога) Задайте на принтера да се рестартира, когато се появи грешка. Error Prevention (Предотвратяване на грешки) Auto Reboot (Автоматично рестартиране) Максимален брой автоматични рестартирания 1 – 20 (2*) Задайте броя автоматични рестартирания, които принтерът може да извърши. Error Prevention (Предотвратяване на грешки) Auto Reboot (Автоматично рестартиране) Прозорец за автоматично рестартиране 1 – 525600 (720*) Задайте броя на секундите, преди принтерът да извърши автоматично рестартиране. Error Prevention (Предотвратяване на грешки) Auto Reboot (Автоматично рестартиране) Auto Reboot Counter (Брояч за автоматично рестартиране) Показване на информация само за четене на брояча за рестартиране. Error Prevention (Предотвратяване на грешки) Auto Reboot (Автоматично рестартиране) Reset Auto Reboot Counter (Нулиране на брояч за автоматично рестартиране) Отказ Продължаване Нулирайте стойностите на  Брояч за автоматично рестартиране . Error Prevention (Предотвратяване на грешки) Display Short Paper Error (Показване на грешка за къса хартия) On (Вкл.) Auto‑clear (Автоматично изчистване) * Задайте на принтера да показва съобщение при възникването на грешка на къса хартия. Късата хартия се отнася до размера на заредената хартия. Error Prevention (Предотвратяване на грешки) Page Protect (Защита на страница) Off (Изкл.) * On (Вкл.) Задайте на принтера да обработва цялата страница в паметта, преди да я отпечата. Jam Content Recovery (Възстановяване при засядане на съдържание) Jam Recovery (Възстановяване при засядане на хартия) Off (Изкл.) On (Вкл.) Auto (Автоматично) * Задайте на принтера да отпечатва отново заседналите страници. Jam Content Recovery (Възстановяване при засядане на съдържание) Scanner Jam Recovery (Възстановяване на засядане на скенер) Job level (Ниво на задание) Page level (Ниво на страница) * Посочва как да се рестартира задание за сканиране след отстраняване на засядане на хартия. меню Известия"},{"UUID":"0384b8d5-7cdf-47de-94d8-fcd5429eb057","title":"Устройство","link":"preferences-topic.html","desc":"Управление на захранването Елементи от","descFull":"Управление на захранването Елементи от меню  Управление на захранването  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Sleep Mode Profile (Профил на режим на заспиване) Отпечатване от режим на заспиване Оставане в будно състояние след отпечатване Влизане в режим на заспиване след отпечатване * Задава принтерът да остане в будно състояние или да влезе в режим Sleep (Заспиване) след отпечатване. Sleep Mode Profile (Профил на режим на заспиване) Докосване за събуждане от режим Deep Sleep (Дълбок сън) Off (Изкл.) On (Вкл.) * Събужда принтера от режим Deep Sleep (Дълбок сън) чрез докосване на дисплея на принтера. Край на време Режим на заспиване 1 – 114 минути (15*) Задайте времето на готовност, преди принтерът да започне да работи в режим на заспиване. Край на време Време на изчакване за активиране на режим на хибернация Disabled (Забранено) 1 час 2 часа 3 часа 6 часа 1 ден 2 дни 3 дни * 1 седмица 2 седмици 1 месец Задаване на времето, преди принтерът да се изключи. Край на време Време на изчакване за хибернация при връзка Хибернация Без хибернация * Задаване на  Време на изчакване за активиране на режим на хибернация , за да се изключи принтерът, докато съществува активна Ethernet връзка. Планиране на режими на захранване Schedules (Планове) Add New Schedule (Добавяне на нов график) Планиране кога принтерът да влиза в режим Sleep (Заспиване) или в режим Hibernate (Хибернация). меню Управление на захранването"},{"UUID":"08d7d43c-a64c-4099-bfb5-fd43e2db5f9f","title":"Устройство","link":"preferences-topic.html","desc":"Събиране на анонимни данни Елементи","descFull":"Събиране на анонимни данни Елементи на менюто  Anonymous Data Collection (Събиране на анонимни данни)  и тяхното описание Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Събиране на анонимни данни Информация за използването и производителността на устройството Няма * Изпратете на Lexmark информация за използването и производителността на принтера. Изпратете на производителя информация за използването и производителността на принтера. Anonymous Data Send Time (Час на изпращане на анонимни данни)  се показва само когато сте задали  Anonymous Data Collection (Събиране на анонимни данни)  на  Device Usage and Performance Information (Информация за използването и производителността на устройство) . Час на изпращане на анонимни данни Начален час Краен час меню Събиране на анонимни данни"},{"UUID":"73b9561a-a9fb-4538-9734-e014a4f237fd","title":"Устройство","link":"preferences-topic.html","desc":"Достъпност Елементи от менюто Достъпност","descFull":"Достъпност Елементи от менюто Достъпност и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Duplicate Key Strike Interval (Интервал за двойно натискане на клавиши) 0 – 5 (0*) Задава интервала в секунди, пред който принтерът игнорира дублираното натискане на клавиши на прикрепена клавиатура. Първоначално закъснение преди повторение на клавиш 0,25 – 5 (1*) Задава първоначалната продължителност на закъснението в секунди, преди повтарящият клавиш да започне повтарянето. Честота на повторение на клавиш 0,5 – 30 (30*) Задава броя на натисканията в секунда за повтарящ се клавиш. Удължаване време изч. екран Off (Изкл.) * On (Вкл.) Позволява на потребителя да остане на същото място и да нулира таймера за  Време на изчакване  на екрана, когато то изтече, вместо да се връща на началния екран. Звук на слушалката 1 – 10 (5*) Регулира силата на звука на слушалките. Enable Voice Guidance When Headphone Is Attached (Активиране на гласова навигация при прикачена слушалка) Off (Изкл.) * On (Вкл.) Активира гласова навигация при прикачена слушалка към принтера. Speak Passwords/PINs (Гласови пароли/ПИН) Off (Изкл.) * On (Вкл.) Настройва принтера да разчита гласови пароли или персонални идентификационни номера. Скорост на говор Много бавна Бавна Нормална * Бърза По-бърза Много бърза Рязка Много рязка Най-бърза Задава скоростта на говорене на гласовата навигация. меню Достъпност"},{"UUID":"68a457ea-bcea-4472-83e7-a0423d6b8f65","title":"Устройство","link":"preferences-topic.html","desc":"Възстановяване на фабрични настройки по","descFull":"Възстановяване на фабрични настройки по подразбиране Елемент от менюто  Възстановяване на фабрични настройки  и неговото описание Елемент от меню Описание Възст. настр. Restore all settings (Възст. всички настр.) Restore printer settings (Възст. настр. принтер) Restore network settings (Възстан. мрежови настр.) Restore fax settings (Възст. настр. за факс) Restore app settings (Възст. настр. за приложение) Възстановите фабричните настройки по подразбиране на принтера. меню Възстановяване на фабрични настройки по подразбиране"},{"UUID":"00794f6c-c374-4787-906f-e4bd7132bb38","title":"Поддръжка","link":"preferences-topic.html","desc":"Меню „Конфигур.“ Меню „Конфигур.“ Елементи","descFull":"Меню „Конфигур.“ Меню „Конфигур.“ Елементи от  Configuration Menu (Меню за конфигуриране)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. USB Configuration (Конфигуриране на USB) USB PnP 1* 2 Променете режима на USB драйвера на принтера, за да подобрите неговата съвместимост с персонален компютър. USB Configuration (Конфигуриране на USB) USB сканиране към локален On (Вкл.) * Off (Изкл.) Посочва дали драйверът на USB устройството да отчита като обикновено USB устройство (единичен интерфейс) или като комплексно USB устройство (няколко интерфейса). USB Configuration (Конфигуриране на USB) USB скорост Full (Пълно) Auto (Автоматично) * Задава USB порта да работи на пълна скорост и дезактивира неговите възможности за висока скорост. Конфигуриране на тава Тавата се свързва Автоматично * Off (Изкл.) Задайте принтера да свързва тавите, които имат същите настройки на тип и размер хартия. Конфигуриране на тава Показване на съобщение за подвижен модул на тава Off (Изкл.) Само за неизвестни размери * Винаги Показва съобщение, което позволява на потребителя да сменя настройките за размер и тип на хартията след поставяне на тавата. Конфигуриране на тава A5 зареждане Къса страна * Дълга страна Определя ориентацията за зареждане по подразбиране за хартия с размер A5 във всички източници на хартия. Конфигуриране на тава Запит. х-я Auto (Автоматично) * Многоф.подав. у-во Ръчно под.х-я Задава източника на хартия, който потребителят да постави при показване на подкана за зареждане на хартия. За да се появи  Multipurpose Feeder (Многоцелево подаващо устройство)  в менюто  Paper (Хартия) , задайте  Configure MP (Конфигуриране на MP)  на  Cassette (Касета) . Конфигуриране на тава Запитване плик Auto (Автоматично) * Многоф.подав. у-во Ръчно плик Задава източника на хартия, който потребителят да постави при показване на подкана за зареждане на плик. За да се появи  Multipurpose Feeder (Многоцелево подаващо устройство)  в менюто  Paper (Хартия) , задайте  Configure MP (Конфигуриране на MP)  на  Cassette (Касета) . Конфигуриране на тава Действ.при запит. Запитване на потребител * Продължаване Използв. настоящите Задайте принтера да разрешава подкани, свързани с промяна на хартията или плика. Конфигуриране на тава Multiple Universal Sizes (Множество универсални размери) Off (Изкл.) * On (Вкл.) Задава тавата за поддръжка на множество универсални размери хартия. Отчети Стр. с настр. на меню Дневник събития Обобщение на регистъра на събитията Отпечатване на отчети относно настройки на менюто на принтера, състоянието и регистри за събития. Използване на консумативи и броячи Изчистване хронология изп. консум. Нулира хронологията за използването на консумативи, например броя страници и оставащите дни, до фабричните нива. Използване на консумативи и броячи Нулиране брояч поддръжка Нулира брояча след инсталирането на нов комплект за поддръжка. Емулации на принтер PPDS дубликат Off (Изкл.) * On (Вкл.) Задайте принтера да разпознава и използва потока за данни на PPDS. Емулации на принтер PS дубликат Off (Изкл.) On (Вкл.) * Задайте принтера да разпознава и използва потока за данни на PS. Емулации на принтер Use Native ISD Fonts (Използване на нативни ISD шрифтове) Off (Изкл.) * On (Вкл.) Позволява принтерът да използва нативните или свободните шрифтове в интелигентното запаметяващо устройство (ISD) за отпечатване. Емулации на принтер Enable Formsmerge (Разрешаване на сливането на форми) Off (Изкл.) On (Вкл.) * Активира Forms Merge (Обединяване на формуляри), за да се съхранят формулярите на твърдия диск или на ISD. За Forms Merge (Обединяване на формуляри) трябва да се монтира лиценз. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Емулации на принтер Enable Prescribe (Разрешаване на предписание) Off (Изкл.) * On (Вкл.) Активира предписание. Трябва да се монтира лиценз за предписание. Емулации на принтер Emulator Security (Защита на емулатор) Page Timeout (Време на изчакване на страница) 0 – 60 (60*) Задайте времето на изчакване на страница по време на емулация. Емулации на принтер Emulator Security (Защита на емулатор) Reset Emulator After Job (Нулиране на емулатор след заданието) Off (Изкл.) * On (Вкл.) Нулирайте емулатора след задание за печат. Емулации на принтер Emulator Security (Защита на емулатор) Disable Printer Message Access (Забраняване на достъп до съобщение на принтера) Off (Изкл.) On (Вкл.) * Забранете достъпа до съобщението на принтера по време на емулация. Fax Configuration (Конфигуриране на факс) Факс режим на ниска консум. Деактивиране на Sleep (\"спящ\" режим) Разрешаване на Sleep (\"спящ\" режим) Auto (Автоматично) * Настройва факса да влиза в режим на заспиване, когато принтерът определи, че това трябва да се случи. Fax Configuration (Конфигуриране на факс) Място съхран. факс NAND Disk (Диск) * Задава мястото за съхраняване на всички факсове. Този елемент от менюто се показва само когато е инсталирано ISD. Конфигурация на печат По-ярък шрифт 0 – 150 (24*) Задава стойност на размера на точките на текста, под която високочестотните екрани се използват при отпечатване на данни на шрифта. Например, ако стойността е 24, тогава всички размери на шрифтове с размер 24 точки или по-малко използват високочестотни екрани. Конфигурация на печат Print Density (Плътност на печата) Disabled (Забранено) 1 – 5 (3*) Регулирайте плътността на тонера, когато отпечатвате документи. Конфигурация на печат Copy Density (Плътност на копирането) Disabled (Забранено) 1 – 5 (3*) Регулирайте плътността на тонера, когато копирате документи. Операции с устройство Безшум. режим Off (Изкл.) * On (Вкл.) Настройте принтера да работи в  Безшумен режим . Разрешаването на тази настройка забавя общата производителност на принтера. Операции с устройство Безопасен режим Off (Изкл.) * On (Вкл.) Задайте принтера да работи в специален режим, в който се опитва да продължи да предлага възможно най-много функционалност, въпреки известни проблеми. Например, когато се настрои на  Вкл  и моторът за двустранен печат не функционира, принтерът извършва едностранен печат на документите дори ако заданието е двустранен печат. Операции с устройство Minimum Copy Memory (Минимална памет за копиране) 20 MB* 30 MB 50 MB 80 MB 100 MB Задава минималното разпределяне на паметта за съхраняване на задания за копиране. Операции с устройство Изчистване на персонализирано състояние Изтриване на дефинирани от потребителя низове за съобщения по избор  По подразбиране  или  Алтернативно . Операции с устройство Изчистване на всички дистанционно инсталирани съобщения Изтриване на съобщения, които са били дистанционно инсталирани. Операции с устройство Автоматично показване грешки Off (Изкл.) On (Вкл.) * Показва съществуващи съобщения за грешка на дисплея, след като принтерът остане неактивен на началния екран за известно време. Операции с устройство Honor orientation on fast path copy (Съобразяване с ориентация на копието на прекия избор) Off (Изкл.) * On (Вкл.) Разрешава на принтера да използва настройката за ориентация от менюто  Copy (Копиране) , когато изпращате задания за бързо копиране. App Configuration (Конфигуриране на приложения) LES приложения Off (Изкл.) On (Вкл.) * Активира приложенията Lexmark Embedded Solutions (LES). Scanner Configuration (Конфигуриране на скенера) Ръчна регистрацията на скенера Бърз тест за отпечатване Отпечатва \"Бърз тест за целева страница\". Уверете се, че разстоянието на полетата на целевата страница е равномерно от всичките й страни. Ако не е, тогава трябва да нулирате полетата на принтера. Scanner Configuration (Конфигуриране на скенера) Ръчна регистрацията на скенера Front ADF Registration (Предна регистрация на АПУ) Rear ADF Registration (Задна регистрация на АПУ) Flatbed Registration (Хоризонтална регистрация) Ръчно регистрирайте хоризонталния скенер и АПУ след подмяна на АПУ, стъклото на скенера или контролерната платка. Scanner Configuration (Конфигуриране на скенера) Нулиране брояч поддръжка Нулира брояча след смяната на комплекта за поддръжка на АПУ. Scanner Configuration (Конфигуриране на скенера) Изтриване ръбове Flatbed Edge Erase (Изтриване по хоризонтални ръбове)  (3*) ADF Edge Erase (Изтриване на ръбове от АПУ)  (3*) Задава размера в милиметри на зоната без печат около АПУ или задание за хоризонтално сканиране. Scanner Configuration (Конфигуриране на скенера) Изключване на скенер No (Не) * Да Само АПУ Дезактивира скенера, когато не работи правилно. Scanner Configuration (Конфигуриране на скенера) Tiff Byte Order (Tiff Byte ред) CPU формат за следване на байтовете * Little Endian (Формат за следване на байтове, започващ от най-малко значимия) Big Endian (Формат за следване на байтове, започващ от най-значимия от тях) Задава реда на байтовете на резултат от сканирането с формат TIFF. Scanner Configuration (Конфигуриране на скенера) Exact Tiff Rows Per Strip (Точни Tiff редове на лента) On (Вкл.) * Off (Изкл.) Задава стойността на етикета RowsPerStrip (Редове на лента) на форматиран с TIFF резултат от сканирането. меню Меню „Конфигур.“"},{"UUID":"afa24653-f893-405b-96a7-34c73a984854","title":"Поддръжка","link":"preferences-topic.html","desc":"Изтр. при неизправност Елементи от","descFull":"Изтр. при неизправност Елементи от менюто  Изтриване при неизправност  и описанието им Елемент от меню Описание Изтр. при неизправност Memory Last Sanitized (Последно изчистване на памет) Hard Disk Last Sanitized (Последно изчистване на твърд диск) ISD last erased (Последно изтрито ISD) Показва информация само за четене при последното изтриване на паметта на принтера или запаметяващото устройство. Hard Disk Last Sanitized (Последно изчистване на твърд диск)  и  ISD last erased (Последно изтрито ISD)  се показва само когато има монтирано запаметяващо устройство. Изтр. при неизправност Sanitize all information on nonvolatile memory (Изчистване на цялата информация на енергонезависимата памет) Erase all printer and network settings (Изтриване на всички настройки на принтера и мрежата) Изтриване на всички приложения и настройки на приложения Изтрийте всички преки пътища и настройки на преки пътища Sanitize all information on hard disk (Изтриване на цялата информация на твърдия диск) Изтриване на изтегляния (изтриване на всички макроси, шрифтове, PFO и т.н.) Изтриване на буферирани задания Изтриване задържани задания Изтриване на интелигентно запаметяващо устройство Изчиства цялата информация на енергонезависимата памет и информацията на запаметяващото устройство. Sanitize all information on hard disk (Изчистване на цялата информация на твърдия диск)  и  Erase Intelligent Storage Drive (Изтриване на интелигентно запаметяващо устройство)  се показва само когато има монтирано запаметяващо устройство. меню Изтр. при неизправност"},{"UUID":"8646f214-e1bd-4959-8dd1-eecd17a9b617","title":"Устройство","link":"preferences-topic.html","desc":"Персонализиране на начален екран Това","descFull":"Персонализиране на начален екран Това меню се появява само в Embedded Web Server. Елемент от менюто  Home Screen Customization (Персонализиране на начален екран)  и неговото описание Меню Описание Копиране Имейл Факс Задърж. факсове Освобождаване на задържани факсове Състояние/Консумативи Опашка на заданията Настройки Смяна на език Адресен указател Маркери Задържани задания USB у-во FTP Scan Profiles (Профили на сканиране) Заключ. у-во Scan Center (Център за сканиране) Копиране на карти Център за бързи команди Определя кои икони да се показват на началния екран. меню Персонализиране на начален екран"},{"UUID":"538b5a43-b39a-4510-85b2-39d89b3bb637","title":"Устройство","link":"preferences-topic.html","desc":"Update firmware (Актуализация на фърмуера)","descFull":"Update firmware (Актуализация на фърмуера) Елементи от менюто  Update firmware (Актуализация на фърмуера)  и техните описания Елемент от меню Описание Current Version (Текуща версия) Показва инсталираната на принтера текуща версия на фърмуера. Check for updates now (Проверка за актуализации сега) Проверява за актуализации на фърмуера. Auto check for updates (Автоматична проверка за актуализации) Задава принтерът да проверява автоматично за актуализации на фърмуера. меню Актуализация на фърмуера"},{"UUID":"1533ad6a-7078-4173-9185-27ed05eb1b36","title":"Устройство","link":"preferences-topic.html","desc":"Информация за този принтер Елементи","descFull":"Информация за този принтер Елементи от менюто  Информация за този принтер  и техните описания Елемент от меню Описание Маркер за актив Определя идентификационната информация на принтера. Максималната дължина е 32 знака. Printer’s Location (Местоположение на принтера) Посочите местоположението на принтера. Максималната дължина е 63 знака. Свържете се със Определя информацията за контакт за принтера. Максималната дължина е 63 знака. Версия на фърмуера Показва инсталираната на принтера версия на фърмуера. Двигател Показва фабричния номер на принтера. Сериен номер Показва серийния номер на принтера. Export Configuration File to USB (Експортиране на конфигурационен файл на USB) Експортира конфигурационния файл към флаш устройство. Export Compressed Logs to USB (Експортиране на компресирани. регистрационни файлове на USB) Експортира компресираните файлове с дневници на флаш устройство. Send Logs (Изпращане на регистрационни файлове) Изпраща документирана информация за принтера до Lexmark. меню Информация за този принтер"},{"UUID":"ef908db6-d65a-40dc-97c8-3e9bedb8f89d","title":"Печат","link":"layout-topic.html","desc":"Оформление Елементи от меню ","descFull":"Оформление Елементи от меню  Оформление  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Страни Едностранно * 2‑Sided (Двустранно) Посочва дали да отпечатва от едната страна или и от двете страни на хартията. Начин на обръщане Дълга страна * Къса страна Определя коя страна на хартията ще бъде свързана при двустранен печат. Празни страници Отпечатване Do Not Print (Без печат) * Отпечатайте празни страници, които са включени в задание за печат. Сортиране Изкл. (1,1,1,2,2,2) On (Вкл.) (1,2,1,2,1,2) * Запазва страниците на задание за печат наредени една върху друга в последователност, особено когато печатате множество копия на заданието. Разделящи листове Няма * Между копията Между задания Между стран. Вкарва празни разделящи листове по време на печат. Източник на разделителен лист Tray (Тава)  [x] (1*) Многоф.подав. у-во Определете източника на хартия за разделящия лист. Страници на страна Off (Изкл.) * 2 pages per side (2 страници на страна) 3 pages per side (3 страници на страна) 4 pages per side (4 страници на страна) 6 pages per side (6 страници на страна) 9 pages per side (9 страници на страна) 12 pages per side (12 страници на страна) 16 pages per side (16 страници на страна) Отпечатване на многостранични изображения на едната страна на лист хартия. Pages per Side Ordering (Подреждане на страници на една страна) Хоризонтално * Хориз., обърн. Вертикално Верт., обърн. Посочва позиционирането на многостранични изображения, когато използвате менюто  Pages per Side (Страници на страна) . Pages per Side Orientation (Ориентация на страници на една страна) Auto (Автоматично) * Пейзаж Портрет Посочва ориентацията на многостранични изображения, когато използвате менюто  Pages per Side (Страници на страна) . Pages per Side Border (Граница на страници на една страна) Няма * Солидна Отпечатва рамка около изображението на всяка страница, когато използвате меню  Pages per Side (Страници на страна) . Копия 1 – 9999 (1*) Посочете броя копия за всяко задание за печат. Зона на печат Нормална * Цяла страница Задава зоната за печат върху лист хартия. меню Оформление"},{"UUID":"64ac8fe7-34ce-4663-b8e9-c0023de48a6f","title":"Печат","link":"layout-topic.html","desc":"Настройка Елементи от менюто ","descFull":"Настройка Елементи от менюто  Setup (Конфигуриране)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Език на принтера PCL Emulation (PCL дубликат) * PS дубликат Задайте езика на принтера. Настройването на език на принтера по подразбиране не възпрепятства софтуерна програма да изпраща задания за печат, които използват друг език на принтера. Изчакване на задание Off (Изкл.) * On (Вкл.) Задържа задания за печат, изискващи консумативи, така че заданията, неизискващи липсващите консумативи, да се отпечатат. Този елемент от менюто се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Край задържане 0  –  255  ( 30 *) Задайте времето в секунди, през което принтерът изчаква намеса от потребител, преди да задържи задания, които се нуждаят от ресурси, които липсват. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Изтегляне от RAM * Диск Определя къде да се запазват всички постоянни ресурси, които се изтеглят на принтера. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Иконом.ресурси Off (Изкл.) * On (Вкл.) Определете как принтерът работи с изтеглените ресурси, в случай че получи задание, изискващо повече от наличната памет. Когато се настрои на  Изкл. , принтерът запазва изтеглените ресурси само докато е необходима памет. Ресурсите, свързани с неактивния език на принтера, се изтриват. Когато се настрои на  Вкл. , принтерът запазва всички изтеглени постоянни ресурси при всяко превключване на езици. Когато е необходимо, принтерът показва съобщения, че паметта е пълна, вместо да изтрие постоянни ресурси. Ред печат вс.докум. По азбучен ред * Първо най-новите Първо най-старите Посочете последователността, когато избирате да отпечатате всички задържани и поверителни задания. меню Настройка"},{"UUID":"bad7f33d-9a99-4c0b-82e3-fa0bba60276c","title":"Печат","link":"layout-topic.html","desc":"Качество Елементи на меню ","descFull":"Качество Елементи на меню  Качество  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Раздел. способн. при печат 600 dpi 1200 Image Q (1200 изобр. Q) * 2400 изобр.Q 1200 dpi 300 dpi Задайте разделителната способност за разпечатките. Усилване на пиксели Off (Изкл.) * Fonts (Шрифтове) * Хоризонтално Вертикално Двупосочно Разрешете повече пиксели за отпечатване в групи за яснота, за да подобрите изображенията хоризонтално, вертикално или за да подобрите шрифтовете. Плътност на тонера 1 до 10 (8*) Определете светлостта или тъмнотата на текстовите изображения. Фотогравюра Нормална * Detail (Подробни данни) Подобрете разпечатката за по-плавни линии с по-остри ръбове. Яркост ‑6 до 6 (0*) Регулирайте разпечатките или чрез осветяване, или чрез затъмняване. Контраст 0 до 5 (0*) Регулирайте контраста на отпечатаните обекти. Корекция на сивото Off (Изкл.) Auto (Автоматично) * Разрешете алгоритъма за корекция на сивото на принтера при отпечатани изображения в средното ниво на сивото. меню Качество"},{"UUID":"9e229ed7-92de-4457-a2ec-dd4ed62ec6ca","title":"Печат","link":"layout-topic.html","desc":"Отчитане задан. Елементи от меню","descFull":"Отчитане задан. Елементи от меню  Job Accounting (Отчитане задан.)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Отчитане задан. Off (Изкл.) * On (Вкл.) Настройва принтерът да създава дневник на заданията за печат, които получава. Честота на дневник за отчитане Eжедневно Седмично Monthly (Месечно) * Посочва колко често принтерът създава файл с дневник. Действия дневник в края на честотата Няма * Изпращане на текущия дневник по имейл Изпращане на текущия дневник по имейл и изтриване Публикуване на текущия дневник Изпращане на текущия дневник по поща и изтриване Посочва как принтерът да реагира, когато се надвиши праговата стойност за честота. Стойността, зададена в  Accounting Log Frequency (Честота на дневник за отчитане)  определя кога се активира това действие. Ниво на почти пълен регистър Off (Изкл.) On (Вкл.) * (5) Посочете максималния размер на регистрационния файл, преди принтерът да изпълни  Log Action at Near Full (Действие с дневник при почти пълно) . Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Действия дневник почти пълно Няма * Изпращане на текущия дневник по имейл Изпращане на текущия дневник по имейл и изтриване Изпращане на най-стар дневник по имейл и изтриване Публикуване на текущия дневник Изпращане на текущия дневник по поща и изтриване Публик. най-стария дневн. и изтриване Изтриване на текущия дневник Изтриване на най-стария дневник Изтриване на всички освен текущия Изтриване на всички регистрационни файлове Определя как да реагира принтерът, когато твърдият диск или ISD е почти пълно. Стойността, зададена в  Log Near Full Level (Ниво на почти пълен дневник)  определя кога се активира това действие. Действия дневник пълно Няма * Изпращане на текущия дневник по имейл и изтриване Изпращане на най-стар дневник по имейл и изтриване Изпращане на текущия дневник по поща и изтриване Публик. най-стария дневн. и изтриване Изтриване на текущия дневник Изтриване на най-стария дневник Изтриване на всички освен текущия Изтриване на всички регистрационни файлове Определя как да реагира принтерът, когато използването на твърдия диск или ISD достигне максималната граница (100 MB). URL публик. дневник Посочва къде принтерът да изпраща дневниците за отчитане на заданията. Имейл адрес за изпращане на дневници Посочва имейл адреса, на който принтерът изпраща дневниците за отчитане на заданията. Префикс файл дневник Посочва префикса за файловете с дневник. Текущото име на хост, дефинирано в меню  TCP/IP , се използва като префикс за файловете с дневници по подразбиране. меню Отчитане задан."},{"UUID":"e62a322b-b436-46cd-9a72-d6fda0183ac5","title":"Печат","link":"layout-topic.html","desc":"PDF Елементи от менюто ","descFull":"PDF Елементи от менюто  PDF  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Scale To Fit (Мащабиране до побиране) Off (Изкл.) * On (Вкл.) Мащабира съдържанието на страницата, за да съответства на избрания размер на хартията. Annotations (Анотации) Print (Отпечатване) Do Not Print (Без печат) * Определя дали да се отпечатват анотации в PDF. Print PDF Error (Отпечатване на PDF грешка) Off (Изкл.) On (Вкл.) * Разрешава отпечатването на PDF грешка. меню PDF"},{"UUID":"b3faa141-5ba8-4cc9-bade-3e3e8a24c6ad","title":"Печат","link":"layout-topic.html","desc":"PostScript Елементи от меню ","descFull":"PostScript Елементи от меню  PostScript  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Отпечатване на PS грешка Off (Изкл.) * On (Вкл.) Отпечатва една страница, която описва грешката PostScript®. Когато се появи грешка, обработката на заданието спира, принтерът разпечатва съобщение за грешка и останалата част от задание за печат се изчиства. Минимална ширина на линията 1 – 30 (2*) Задава минимална ширина на щрих. Задания, отпечатани в 1200 dpi, използват стойността директно. PS режим на стартиране Off (Изкл.) On (Вкл.) * Дезактивирайте файла SysStart. Разрешаването на файла SysStart излага Вашия принтер или мрежа на риск, свързан със сигурността. Приоритет на шрифта Resident (На устройство) * От флаш/диск Установяване на последователността за търсене на шрифт. Resident (На устройство)  задава принтера да търси в неговата памет необходимия шрифт, преди да извърши търсене в твърдия диск или в интелигентното запаметяващо устройство (ISD). Flash/Disk (Запис на данни/диск)  задава принтера да търси в твърдия диск или в ISD необходимия шрифт, преди да извърши търсене в паметта на принтера. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Край изчакване Off (Изкл.) Вкл. * ( 40 секунди ) Активира времето, през което принтерът да изчаква допълнителни данни, преди да отмени задание за печат. меню PostScript"},{"UUID":"2ee8a752-1648-4092-b685-d139e7844115","title":"Печат","link":"layout-topic.html","desc":"PCL Елементи на менюто ","descFull":"PCL Елементи на менюто  PCL  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Източник на шрифт Resident (На устройство) * Диск Изтегляне Флаш устройства Карта за шрифт Всички Изберете източника, който съдържа селекцията от шрифтове по подразбиране. Disk (Диск)  и  Flash (Флаш устройство)  се появяват само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD), което съдържа шрифтове. Изтегляне  се появява само ако изтеглените шрифтове съществуват в паметта на принтера. Font Card (Карта за шрифт)  се появява само когато е монтирано ISD. Име на шрифт [Списък на наличните шрифтове] ( Courier *) Изберете шрифт от посочения източник на шрифтове. Набор символи [Списък на наличния набор символи] (10U PC‑8*) Определете комплекта от символи за всяко име на шрифт. Комплектът от символи е набор от символи от букви и цифри, препинателни знаци и специални символи. Комплектите от символи поддържат различни езици или специфични програми, като например математически символи за научен текст. Стъпка 0,08 – 100,00 (10,00*) Посочете стъпката за фиксирани или едноразредни шрифтове. Pitch (Стъпка)  се отнася за броя на символите с фиксирано разстояние на хоризонтален инч тип. Ориентация Вертикална ориентация * Пейзаж Reverse Portrait (Обръщане на вертикална ориентация) Reverse Landscape (Обръщане на хоризонтална ориентация) Определете ориентацията на текста и изображенията на страницата. Редове стр. 1 – 255 Определете броя редове текст за всяка страница, отпечатана чрез потока за данни PCL®. Този елемент от менюто задейства вертикалния механизъм, който осигурява отпечатването на избрания брой редове между полетата по подразбиране на страницата. 60 е фабричната настройка по подразбиране в САЩ. 64 е международната фабрична настройка по подразбиране. PCL5 Minimum Line Width (Минимална ширина на линията PCL5) 1 – 30 (2*) Задава първоначалната минимална ширина на щрих. PCLXL Minimum Line Width (Минимална ширина на линията PCLXL) 1 – 30 (2*) Ширина на A4 198 мм* 203 мм Задава ширината на логическата страница при печатане върху хартия с размер A4. Логическата страница е мястото върху физическата страница, на което се отпечатва информацията. Авт.CR след LF On (Вкл.) Off (Изкл.) * Настройва да връща касетата след контролна команда за подаване на ред. Връщането на касетата е механизъм, който кара принтера да премести позицията на курсора до първата позиция на същия ред. Авт.LF след CR On (Вкл.) Off (Изкл.) * Настройва принтера да извършва подаване на ред след връщане на касетата след контролна команда. Повт.номер.тава Задав.под.у-во Задаване на тава  [x] Задав.ръчно подав. Задаване ръчно подаване на пликове Конфигурира принтерът да работи с различен драйвер за печат или с приложение по избор, което използва различен набор от задания за източник за заявка на посочен източник на хартия. Изберете от следните опции: Off (Изкл.)*  – принтерът използва фабричните задания за източник на хартия по подразбиране. None (Няма)  – източникът на хартия игнорира командата за избор на подаване на хартия. 0 – 199 – изберете цифрова стойност, за да зададете стойност по избор към източник на хартия. Повт.номер.тава Преглед фабрични настройки Показва фабричната стойност по подразбиране, зададена за всеки източник на хартия. Повт.номер.тава Възст. осн. Възстановяване на повтарящите номера на тавата към фабричните им стойности по подразбиране. Край на време за печат Off (Изкл.) Вкл.*  (90 секунди) Зададете на принтера да завършва задание за печат, след като е бил в режим на готовност за определения период от време. Print Timeout Time (Време на изчакване за печат)  се показва само когато  Print Timeout (Време на изчакване за печат)  е разрешено. меню PCL"},{"UUID":"ed2419f1-12dd-4e7f-b382-e0271aeb4728","title":"Печат","link":"layout-topic.html","desc":"Изображение Елементи от меню ","descFull":"Изображение Елементи от меню  Изображение  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Авт.побиране Вкл. Изкл. * Изберете най-добрия наличен размер на хартията и ориентация на настройката за дадено изображение. Когато е зададен на  Вкл. , този елемент от менюто заменя настройките за мащабиране и ориентация за изображението. Инверсия Изкл. * Вкл. Инвертирани двутонни монохромни изображения. Това меню не се прилага за GIF или JPEG формати на изображенията. Мащабиране Фиксир.горе вляво Най-добро побиране * Фиксир.в център Побир.шир./вис. Побир.височ. Побир.ширина Коригира изображението, за да се вмести в зоната за печат. Когато  Автоматично побиране  е зададена като  Вкл. ,  Мащабиране  автоматично се задава като  Най-добро побиране . Ориентация Вертикална ориентация * Пейзаж Reverse Portrait (Обръщане на вертикална ориентация) Reverse Landscape (Обръщане на хоризонтална ориентация) Определете ориентацията на текста и изображенията на страницата. меню Изображение"},{"UUID":"41d38b23-5688-4939-a711-16403846ff12","title":"Хартия","link":"tray-configuration-topic.html","desc":"Конфигуриране на тава Елементи от","descFull":"Конфигуриране на тава Елементи от меню  Tray Configuration (Конфигуриране на тава)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Осн.източник Tray (Тава)  [x] (1*) Многоф.подав. у-во Ръчно под.х-я Ръчно плик Задава източника на хартия за всички задания за печат. Разм./вид х-я Tray (Тава)  [x] Многоф.подав. у-во Ръчно под.х-я Ръчно плик Определя размера на хартията или вида на хартията, заредена във всеки източник на хартия. Смяна на размер Off (Изкл.) Letter/A4 Всички в списъка * Указва на принтера да замени определен размер хартия, ако исканият размер не е зареден в нито един от източниците на хартия. Изкл.  изисква от потребителя да зареди искания размер на хартията. All Listed (Всички в списъка)  разрешава всички налични замествания. Конф.подав. у-во Cassette (Касета) * Ръчен Първи Определя поведението на многоцелевото подаващо устройство. Cassette (Касета)  конфигурира многоцелевото подаващо устройство като автоматичен източник на хартия. Manual (Ръчно)  настройва многоцелевото подаващо устройство само за задания за печат с ръчно подаване. First (Първи)  конфигурира многоцелевото подаващо устройство като основен източник на хартия. меню Конфигуриране на тава"},{"UUID":"0e2be544-401b-45f4-aed6-e217af21bc19","title":"Конфигурация на носител","link":"tray-configuration-topic.html","desc":"Универсална настройка Елементи на меню","descFull":"Универсална настройка Елементи на меню  Universal Setup  (Универсална настройка) и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Мерни единици Инчове Милиметри Определя единицата за измерване за универсалната хартия. Инчове  e фабричната настройка по подразбиране в САЩ.  Милиметри  е международната фабрична настройка по подразбиране. Ширина на вертикалната ориентация 3,5 – 19 инча (8,5*) 88,9 – 482,6 мм (216*) Задава ширината на вертикалната ориентация на универсалната хартия. Височина на портрета 3,5 – 19 инча (14*) 88,9 – 482,6 мм (356*) Задава височината на вертикалната ориентация на универсалната хартия. Посока на подаване Къса страна * Дълга страна Настройва принтера да взема хартия от посоката на късата или дългата страна. Дълга страна  се появява само когато най-дългата страна е по-къса от максималната поддържана ширина. Multiple Universal Sizes (Множество универсални размери) Тава [x] Многоф.подав. у-во Назначете уникален размер за множеството универсални размери, които се зареждат, за всеки източник на хартия. Тази настройка се показва само когато е разрешена в менюто  Device (Устройство) . От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Tray Configuration (Конфигуриране на тава) Multiple Universal Sizes (Множество универсални размери) . меню Универсална настройка"},{"UUID":"a914081b-cbfc-4740-946d-dead2ebc8c10","title":"Конфигурация на носител","link":"tray-configuration-topic.html","desc":"Персонал. размери сканиране Елементи на","descFull":"Персонал. размери сканиране Елементи на менюто  Custom Scan Sizes (Персонализирани размери на сканиране)  и техните описания Елемент от меню Описание Персонализирани размери на сканиране  [x] Име на размера за сканиране Ширина 1 – 8,5 инча (8,5*) 25,4 – 215,9 mm (215,9*) Височина 1 – 25 инча (11*) 25,4 – 635 mm (279,4*) Ориентация Вертикална ориентация * Пейзаж 2 сканирания на страна Off (Изкл.) * On (Вкл.) Задава име на размера на сканиране и конфигурира настройките за сканиране. меню Персонал. размери сканиране"},{"UUID":"471a04bf-0685-4876-8d6e-c86f134e3b4e","title":"Конфигурация на носител","link":"tray-configuration-topic.html","desc":"Типове носители Елемент от менюто","descFull":"Типове носители Елемент от менюто  Media Types (Типове носители)  и неговото описание Елемент от меню Описание Обикн.хартия Х-я за визитки Рецикл. хартия Етикети Ленена хартия Плик Тежки пликове Бланка Пред.отп. Цветна хартия Лека хартия Тежка хартия Груба/памук Custom Type (Персонализиран тип)  [X] Задава текстурата, теглото и ориентацията на хартията. меню Типове носители"},{"UUID":"8d58eb36-9e83-493b-ab15-8a4cb740e9b0","title":"Копиране","link":"copy-defaults-topic.html","desc":"Копиране по подр. Елементи от","descFull":"Копиране по подр. Елементи от менюто  Копиране по подразбиране  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Вид съдържание Текст Текст/снимка * Снимка Графики Подобрява изходния резултат въз основа на съдържанието на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултата въз основа на източника на оригиналния документ. Страни Едностранно към едностранно * Едностранно към двустранно Двустранно към едностранно Двустранно към двустранно Посочва сканиращото поведение въз основа на оригиналния документ. Разделящи листове Няма * Между копията Между задания Между стран. Определя дали да включва празни разделящи листове по време на отпечатване. Източник на разделителен лист Tray (Тава)  [x] (1*) Многоф.подав. у-во Определете източника на хартия за разделящия лист. Цвят Off (Изкл.) On (Вкл.) * Auto (Автоматично) Задайте принтера за генериране на цветно отпечатване от задание за сканиране. Страници на страна Off (Изкл.) * 2 страници с вертикална ориентация 4 страници с вертикална ориентация 2 страници с хоризонтална ориентация 4 страници с хоризонтална ориентация Определя дали броя на страниците с изображения да бъдат отпечатвани на едната страна на хартията. Печат рамк.стр. Off (Изкл.) * On (Вкл.) Поставя граница около всяко изображение, когато отпечатва много страници на една-единствена страница. Сортиране Изключ. [1,1,1,2,2,2] Вкл. [1,2,1,2,1,2] * Отпечатване на множество копия в поредица. „Копиране от“ размер [Списък с размери хартия] Посочва размера на хартията на оригиналния документ. Letter  е фабричната настройка по подразбиране в САЩ.  A4  е международната фабрична настройка по подразбиране. „Копиране в“ източник Tray (Тава)  [x] (1*) Многоф.подав. у-во Автом. съвпад. размер Посочва източника на хартия за заданията за копиране. Температура –4 до 4 (0*) Посочете дали да се генерира по-студено или по-топло изходящо изображение. Мрак 1 до 9 (5*) Посочва тъмнината на сканираното изображение. Брой копия 1 – 9999 (1*) Посочва броя на копията. Гор./дол.колонт. Ляв горен колонтитул Среден горен колонтитул Десен горен колонтитул Ляв долен колонтитул Среден долен колонтитул Десен долен колонтитул Посочва информация за горен и долен колонтитул на сканираното изображение. Наслагване Поверително Копиране Чернова Спешно По избор Off (Изкл.) * Посочете текста за наслагване за отпечатване върху всяко копие. Персонализирано наслагване Въведете текста за  Custom (Персонализиран)  избор в менюто  Overlay (Наслагване) . Усъвършенствани изображения Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Баланс на цветовете Циан – Червен  (0*) Магента – Зелен  (0*) Yellow ‑ Blue (Жълт – Син)  (0*) Регулира интензивността на цвета за циан, магента и жълто. Премахване на цвят Color Dropout (Премахване на цвят)  ( None (Няма) *) Default Red Threshold (Осн. граница на червеното)  (128*) Default Green Threshold (Осн. граница на зеленото)  (128*) Default Blue Threshold (Осн. граница на синьото)  (128*) Посочва кой цвят да се изпусне по време на сканиране и регулира настройката за премахване на този цвят. Авт. откр. цвят Color Sensitivity (Цветна чувствителност)  (5*) Area Sensitivity (Чувствителност на зона)  (5*) Конфигурира автоматичната настройка за откриване на цвят. Контраст Best for content (Оптимално за съдържание) * 0 – 5 Посочва контраста на сканираното изображение. Изчистване на фона Background Detection (Разпознаване на фон)  ( Content‑based (На база на съдържание) *) Level (Ниво)  (0*) Премахва фоновия цвят или цифровия шум на изображението от оригиналния документ. Content-based (На база на съдържание)  премахва фоновия цвят от оригиналния документ. Fixed (Фиксирано)  премахва цифровия шум от снимка. Автом. център Off (Изкл.) * On (Вкл.) Подравнява съдържанието в центъра на страницата. Огледално изображение Off (Изкл.) * On (Вкл.) Създадете огледално изображение на оригиналния документ. Негатив Off (Изкл.) * On (Вкл.) Създадете негативно изображение на оригиналния документ. Сенки –4 до 4 (0*) Регулира сенките в оригиналния документ. Сканиране от край до край Off (Изкл.) * On (Вкл.) Сканира оригиналния документ от край до край. Рязкост 1 – 5 (3*) Регулира рязкостта на сканираното изображение. Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Позволява цветни копия Off (Изкл.) On (Вкл.) * Отпечатване на цветни копия. Позволяване на приоритетни копия Off (Изкл.) On (Вкл.) * Прекъсва задание за печат за разпечатване на копия. Сканиране по избор Off (Изкл.) * On (Вкл.) Задава принтера да сканира първия комплект оригинални документи с помощта на посочените настройки, след което сканира следващия комплект със същите или с различни настройки. Този елемент от менюто се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Позволяв. „Запамет. като бърза команда“ Off (Изкл.) On (Вкл.) * Запазва настройките за копиране като пряк път. Регулиране АПУ изкревяне Off (Изкл.) On (Вкл.) * Конфигурира принтера да регулира изкривени изображения от документи, които са сканирани от АПУ. Пробно копиране Off (Изкл.) * On (Вкл.) Отпечатва пробно копие за проверка на качеството преди отпечатване на останалите копия. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. меню Копиране по подр."},{"UUID":"673a06e9-7bd7-434d-877d-0612b0a5d2fe","title":"Настройки по подразбиране за факс","link":"fax-defaults-subgroup.html","desc":"Режим факс Елемент на менюто","descFull":"Режим факс Елемент на менюто  Fax Mode (Режим Факс)  и неговото описание Елемент от меню Описание Режим факс Fax (Факс) * Сървър за факс Disabled (Забранено) Изберете режим факс. меню Режим факс"},{"UUID":"d3ed4c48-20cc-4450-968f-33c5b9b3fa07","title":"Настройки по подразбиране за факс","link":"fax-defaults-subgroup.html","desc":"Конфигуриране на факс Общи настройки","descFull":"Конфигуриране на факс Общи настройки за факс Елементи на менюто  General Fax Settings (Общи настройки за факс)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Име на факс Определя ID на Вашия факс. Номер на факс Определя номера на Вашия факс. Идент. на факс Име на факс Номер на факс * Задава ID на факс, който да се използва по време на договарянето на факса. Включване ръчен факс Off (Изкл.) * On (Вкл.) Включва функцията за ръчен факс на принтера. Този елемент на менюто изисква сплитер на линия или телефонна слушалка. Използвайте обикновена телефонна линия за отговор на входящо задание за факс или за набиране на факс номер. За да отидете директно на функцията за ръчен факс, докоснете  #  и  0  на клавиатурата. Използвана памет Всичката за получаване Повечето за получаване Равно * Повечето за изпращане Всичката за изпращане Настройва количеството вътрешна памет на принтера, определена за изпращане или получаване на факсове. Този елемент на менюто предотвратява буферни състояния на паметта и неуспешни факсове. Отмяна факсове Позволявам * Не позволявам Отменя изходящите и входящите факсове. Маскиране на факс номер Off (Изкл.) * Отляво Отдясно Посочва формата за маскиране на номер на изходящ факс. Цифри за маскиране 0 – 58 (0*) Посочите броя цифри за маскиране в номер на изходящ факс. Разрешаване на установяване на свързана линия Off (Изкл.) On (Вкл.) * Определя дали телефонна линия е свързана с принтера. Събитията се откриват веднага. Разреши установяване линия в грешно гнездо Off (Изкл.) On (Вкл.) * Определя дали телефонна линия е свързана с правилния порт на принтера. Събитията се откриват веднага. Разреши поддръжка на използвано разширение Off (Изкл.) On (Вкл.) * Определя дали телефонна линия се използва от друго устройство, като например друг телефон на същата линия. Събитията се откриват веднага. Оптимизиране съвместимост факс. Конфигурира функционалността на факса с принтера за оптимална съвместимост с други факс машини. Транспорт. факс T.38 Аналогов G.711 etherFAX Задайте метода за транспортиране на факс. Този елемент от менюто се показва само ако в принтера е инсталиран лицензионен пакет за etherFAX или Факс по IP (FoIP). Този елемент от менюто се появява само ако в принтера е монтиран лицензионен пакет за Факс по IP (FoIP). Настройки на факс чрез HTTPS Това меню се показва само ако опцията  Fax Transport (Транспортиране на факс)  е зададена на  etherFAX . Елементи от менюто  HTTPS Fax Settings (Настройки на факс чрез HTTPS)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. URL адрес на HTTPS услуга Посочете URL адреса на etherFAX услугата. HTTPS прокси сървър Посочете URL адрес на прокси сървър. Потребител на HTTPS прокси сървър Посочва потребителското име и парола за прокси сървъра. Парола за HTTPS прокси сървър Шифроване за изпращане на факс Disabled (Забранено) Enabled (Разрешено) * Задължителен Разрешете шифроване за изходящите факс съобщения. Шифроване за получаване на факс Disabled (Забранено) Enabled (Разрешено) * Задължителен Разрешете шифроване за входящите факс съобщения. Състояние на факс чрез HTTPS Покажете състоянието на комуникацията на etherFAX. Настройки за изпращане на факс Елементи на менюто  Fax Send Settings (Настройки за изпращане на факс)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Разделителна способност Стандартен * Фина Суперфина Ултрафина Задава разделителната способност на сканираното изображение. По-високата разделителна способност увеличава времето за предаване на факс и изисква по-голяма памет. Оригинален размер [List of paper sizes (Списък с размери на хартия)] (Mixed Sizes (Смес. размери)*) Посочите размера на оригиналния документ. Ориентация Вертикална ориентация * Пейзаж Посочва ориентацията на оригиналния документ. Страни Off (Изкл.) * Къса страна Дълга страна Посочете ориентацията на оригиналния документ, когато сканирате и двете страни на документа. Вид съдържание Текст * Текст/снимка Снимка Графики Подобрява изходния резултат въз основа на съдържанието на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултата въз основа на източника на оригиналния документ. Мрак 1 – 9 (5*) Посочва тъмнината на сканираното изображение. През телефонна централа On (Вкл.) Off (Изкл.) * Настройва принтера да набира номера на факса, без да чака да разпознае сигнала \"свободно\". Вътрешна телефонна централа (PABX) е телефонна мрежа, която позволява от един телефонен номер за външни повиквания да бъде осъществяван достъп до множество линии. Режим набиране Тонално * Импулсно Посочва режима на набиране за входящи и изходящи факсове. Усъвършенствани изображения Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Баланс на цветовете Циан – Червен  (0*) Магента – Зелен  (0*) Yellow ‑ Blue (Жълт – Син)  (0*) Регулирайте наситеността на цвета по време на сканиране. Премахване на цвят Color Dropout (Премахване на цвят)  ( None (Няма) *) Default Red Threshold (Осн. граница на червеното)  (128*) Default Green Threshold (Осн. граница на зеленото)  (128*) Default Blue Threshold (Осн. граница на синьото)  (128*) Посочва кой цвят да се изпусне по време на сканиране и регулира настройката за премахване на този цвят. Контраст Best for content (Оптимално за съдържание) * 0 1 2 3 4 5 Настройва контраста на изходящото изображение. Изчистване на фона Ниво –4 до 4 (0*) Регулирате количеството на фона, който се вижда на дадено сканирано изображение. Огледално изображение Off (Изкл.) * On (Вкл.) Създадете огледално изображение на оригиналния документ. Негатив Off (Изкл.) * On (Вкл.) Създадете негативно изображение на оригиналния документ. Сенки –4 до 4 (0*) Регулирате количеството на сенките, който се виждат на дадено сканирано изображение. Сканиране от край до край On (Вкл.) Off (Изкл.) * Позволява сканиране от край до край на оригиналния документ. Рязкост 1 – 5 (3*) Регулира рязкостта на сканираното изображение. Температура –4 до 4 (0*) Посочете дали да се генерира по-студено или по-топло изходящо изображение. Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Автомат. повторно набиране 0 – 9 (5*) Определя броя опити за многократно набиране на принтера, преди да отмени изпращането на факса до определена дестинация. Честота на повторно набиране 1 – 200 минути (3*) Увеличава времевия интервал между опитите за повторно набиране, за да се увеличи вероятността за успешно изпращане на факс. Включване ECM On (Вкл.) * Off (Изкл.) Активира \"Режим коригиране на грешки\" (ECM) за задания за факс. ECM открива и коригира грешки в процеса на предаване на факс, причинени от шум по телефонната линия и слаба сила на сигнала. Включв. сканиране факс On (Вкл.) * Off (Изкл.) Създава факсове с помощта на скенера на принтера. Драйвер към факс On (Вкл.) * Off (Изкл.) Позволява драйвера на принтера да изпраща факс. Позволяв. „Запамет. като бърза команда“ On (Вкл.) * Off (Изкл.) Запазва факс номера като бързи команди на принтера. Максимална скорост 33600 * 14400 9600 4800 2400 Настройва максималната скорост за изпращане на факс. Сканиране по избор Off (Изкл.) * On (Вкл.) Включва сканиране по избор по подразбиране. Този елемент от менюто се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Преглед Off (Изкл.) * On (Вкл.) Показва преглед на сканираното изображение върху дисплея. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Регулиране АПУ изкревяне Off (Изкл.) On (Вкл.) * Коригирате лекото накланяне в сканираното изображение. Включ. сканиране цветен факс Off by Default (Изкл. по подразбиране) * On by Default (Вкл. по подразбиране) Never Use (Никога не се използва) Always Use (Винаги се използва) Разрешава цветни сканирания за факс. Автомат. конвертиране на цветни в едноцветни факсове On (Вкл.) * Off (Изкл.) Конвертира всички изходящи цветни факсове в черно-бели. Потвърждение на номер на факс Off (Изкл.) * On (Вкл.) Приканва потребителя да потвърди номера на факса. Код за набиране Настройва код за набиране. Правила за кодове на набиране Установите правило за код за набиране. Настройки за получаване на факс Елементи на меню  Настройки за получаване на факс  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Изчакващо задание за факс Няма * Тонер Тонер и консум. Отстранява задания за факс от опашката за отпечатване, изискващи специфични ресурси, които не са налични. Този елемент от менюто се показва само когато е инсталиран твърд диск. Позвънявания преди отговор 1 – 25 (3*) Задава необходимия брой позвънявания, преди принтерът да отговори на входящи обаждания. Авт. намаляв. On (Вкл.) * Off (Изкл.) Мащабира входящ факс до размера на страницата. Източник хартия Tray (Тава)  [X] Многоф.подав. у-во Auto (Автоматично) * Настройва източника на хартията за отпечатване на входящ факс. Страни On (Вкл.) Off (Изкл.) * Отпечатвайте от двете страни на хартията. Разделящи листове Няма * Преди заданието След заданието Определя дали да включва празни разделящи листове по време на отпечатване. Източник на разделителен лист Tray (Тава)  [X] (1*) Многоф.подав. у-во Определете източника на хартия за разделящия лист. Изходяща тава Станд.изх.т. Посочва изходна тава за получени факсове. Долен колонтитул факс On (Вкл.) Off (Изкл.) * Отпечатате информация за предаването в долния край на всяка страница от получен факс. Обозн. час за факс в долен колонтитул Получаване * Печат Отпечатва времеви щемпел в долния край на всяка страница от получен факс. Задържане на факсове Режим Задържан факс Off (Изкл.) * Винаги включ. Ръчен Планиран Задържа получени факсове, за да не се отпечатват, докато не се освободят. Задържане на факсове План за задържане на факс Назначава план за задържане на факсове. Този елемент от менюто се появява само ако  Held Fax Mode (Режим на задържан факс)  е зададен на  Scheduled (Планиран) . Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Включв. получаване факс On (Вкл.) * Off (Изкл.) Настройва принтера за получаване на факс. Включ. получав. цветен факс On (Вкл.) * Off (Изкл.) Настройва принтера за получаване на факс в цвят. Разреши ИД викащ On (Вкл.) Off (Изкл.) * Показва информация за ID на повикващия при входящо повикване върху дисплея на принтера. Блокиране на факсове без\n име On (Вкл.) Off (Изкл.) * Блокира входящи факсове без ID на факс. Списък с блокирани факс номера Добавя блокиран факс номер Посочва телефонните номера, които желаете да блокирате. Отговор включен Всички позвънявания * Само едно звънене Само двойно звънене Само тройно звънене Само единично или двойно звънене Само единично или тройно звънене Само двойно или тройно звънене Настройва специална последователност на позвъняване за входящ факс. Автоматичен отговор On (Вкл.) * Off (Изкл.) Настройва принтера да получава факсове автоматично. Код за ръчен отговор 0 – 9 (9*) Въведете ръчно код от цифровата клавиатура на телефона, за да започнете да получавате факс. Този елемент от менюто се извежда само когато принтерът споделя една линия с телефон. Този елемент от менюто се извежда само когато настроите принтера да получава факс ръчно. Препращане на факс Print (Отпечатване) * Отпечатване и препращане Препращане Посочва дали да бъде препратен получен факс. Препращане към Местоназначение 1 Местоназначение 2 Посочва къде да бъде препратен получен факс. Това меню се показва само когато  Fax Forwarding (Препращане на факс)  е зададено на  Print and Forward (Отпечатване и препращане)  или  Forward (Препращане) . Имейл за потвърждение Посочва имейл адреса за получаване на факсове чрез FTP или мрежова папка. Това меню се показва само когато  Fax Forwarding (Препращане на факс)  е зададено на  Print and Forward (Отпечатване и препращане)  или  Forward (Препращане) . Максимална скорост 33600* 14400 9600 4800 2400 Настройва максималната скорост при предаване на факс. Заглавна страница на факс Елементи от менюто  Fax Cover Page (Заглавна страница за факс)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Заглавна страница на факс Off by Default (Изкл. по подразбиране) * On by Default (Вкл. по подразбиране) Never Use (Никога не се използва) Always Use (Винаги се използва) Конфигурира настройките за заглавната страница на факс. Включване на поле „До“ Off (Изкл.) * On (Вкл.) Включване на поле „От“ Off (Изкл.) * On (Вкл.) От Включване на поле „Съобщение“ Off (Изкл.) * On (Вкл.) Съобщ.: Включване на лого Off (Изкл.) * On (Вкл.) Include Footer (Включва долен колонтитул) [x] Off (Изкл.) * On (Вкл.) Footer (Долен колонтитул) [x] Настройки факс дневник Елементи на менюто  Fax Log Settings (Настройки факс дневник)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Transmission Log Frequency (Честота на дневник за предаване) Винаги * Никога Само за грешка Посочва колко често принтерът създава файл за предаване. Transmission Log Action (Действие на дневник за предаване) Печат Off (Изкл.) On (Вкл.) * Имейл Off (Изкл.) * On (Вкл.) Отпечатва и изпраща по имейл на дневник за успешно изпращане на факс или грешка при изпращането. Получаване дневник грешки Отпечатване никога * Печатане при грешка Отпечатване на дневник за проблеми при получаване на факс. Автом. печат дневници On (Вкл.) * Off (Изкл.) Отпечатване на цялата дейност на факса. Дневн.източ.х-я Tray (Тава)  [x] (1*) Многоф.подав. у-во Посочва източника на хартия за отпечатване на дневници. Показване дневници Име на другия факс * Набран номер Установява подателя по име на другия факс или номер на факс. Включв. дневник задания On (Вкл.) * Off (Изкл.) Вижте резюме на всички задания на факса. Включв. дневник повикв. On (Вкл.) * Off (Изкл.) Преглед на резюме на хронологията на повикванията на факса. Дневник изходяща тава Стандартна изходна тава * Bin (Изходна тава) [x] Посочва изходна тава за отпечатани дневници. Настройки високоговорител Елементи на менюто  Speaker Settings (Настройки на високоговорителя)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Режим на високоговор. Always Off (Винаги изключ.) * Винаги включ. Включ. докато е свързан Настройва режима на високоговорителя на факса. Сила звук високогов. Слаба * Висока Регулира силата на звука на високоговорителя на факса. Сила на звънене Off (Изкл.) * On (Вкл.) Разрешава силата на звука на звънене. VoIP Settings (Настройки на VoIP) Елементи от менюто  VoIP Settings (Настройки на VoIP)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. VoIP Protocol (VoIP протокол) SIP * H.323 Задава протокол за гласова комуникация по интернет (VoIP). STUN сървър Определя STUN сървъра за преминаване през защитна стена. Принудителен режим Факс Off (Изкл.) On (Вкл.) * Превключва шлюза VoIP от аналогов на T.38 в началото на повикване на факса. Принуд. забав. факс режим 0 – 15 (7*) Задава закъснение в секунди при изпращането на друга покана за  Force Fax Mode (Принудителен режим Факс) . SIP Settings (Настройки на SIP) Елементи от менюто  SIP Settings (Настройки на SIP)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Прокси Определя IP адреса на системата, която конвертира телефонния номер в IP адрес, където се изпраща факсът. Registrar (Регистратор) Определя име или IP адрес на системата, която обработва регистрацията на клиентите на протокола за започване на сесия (SIP). User (Потребител) Определя името на потребителя за SIP. Парола Определя паролата, която се използва при регистрация в SIP регистратора. Auth ID (ID за удостоверяване) Потребителското име, което се използва при регистрацията. Ако не бъде зададена настройка за Auth ID (ID за удостоверяване), вместо нея настройката използва потребителското име в полето  User (Потребител) . Transport For Registration (Предаване за регистрацията) UDP * TCP Задава типа предаване на SIP за регистрацията. Transport For Incoming Calls (Предаване за входящи повиквания) UDP * TCP UDP и TCP Задава типа предаване за входящи повиквания. Transport For Outgoing Calls (Предаване за изходящи повиквания) UDP * TCP Задава типа предаване за изходящи повиквания. Outbound Proxy (Изходящ прокси) Определя изходящ прокси за препращане на цялата SIP комуникация. Свържете се със Определя име на контакт за SIP. Зона Определя име на област за SIP. Ако не е зададена настройката за име на област, вместо нея настройката използва името на  Contact (Контакт) . SIP Registration Status (Състояние на регистрацията на SIP) Показва състоянието на регистрацията на SIP. H.323 Settings (Настройки на H.323) Елементи от менюто  H.323 Settings (Настройки на H.323)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Gateway (Шлюз) Определя ІР адреса на шлюза H.323. Gatekeeper (Контрольор на шлюза) Определя контрольора на шлюза H.323. User (Потребител) Посочва потребителското име, което се използва с шлюза H.323. Парола Определя паролата за шлюза H.323. Enable Fast Start (Разрешаване на бързо стартиране) Off (Изкл.) * On (Вкл.) Разрешава бързо стартиране. Disable H.245 Tunneling (Забрана за тунелиране на H.245) Off (Изкл.) * On (Вкл.) Забранява тунелирането на H.323. Disable Gatekeeper Discovery (Забрана за разкриването на контрольора на шлюза) Off (Изкл.) On (Вкл.) * Забранява разкриването на контрольора на шлюза H.323. T.38 Settings (Настройки на T.38) Елементи от менюто  T.38 Settings (Настройки на T.38)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Indicator Redundancy (Резервиране на индикатор) 0 – 5 (3*) Задава колко пъти се повтаря индикаторът на факса в комуникацията на T.38. Low Speed Redundancy (Резервиране при ниска скорост) 0 – 5 (3*) Задава колко пъти се повтарят данните с ниска скорост в комуникацията на T.38. High Speed Redundancy (Резервиране при висока скорост) 0 – 5 (1*) Задава колко пъти се повтарят данните с висока скорост в комуникацията на T.38. меню Конфигуриране на факс меню Общи настройки за факс меню Настройки на факс чрез HTTPS меню Настройки за изпращане на факс меню Настройки за получаване на факс меню Заглавна страница на факс меню Настройки факс дневник меню Настройки високоговорител меню VoIP Settings (Настройки на VoIP) меню SIP Settings (Настройки на SIP) меню H.323 Settings (Настройки на H.323) меню T.38 Settings (Настройки на T.38)"},{"UUID":"f72e39f5-6fd3-4e6c-99d5-6d503e02189b","title":"Настройки по подразбиране за факс","link":"fax-defaults-subgroup.html","desc":"Настройка факс сървър Общи настройки","descFull":"Настройка факс сървър Общи настройки за факс Елементи на менюто  General Fax Settings (Общи настройки за факс)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Формат за изпращане Посочва получател на факса. Ако желаете да използвате номера на факса, тогава въведете знака за номер (#) преди номера. Reply Address (Адрес за отговор) Посочете адрес за отговор на изпращания факс. Тема Посочва темата на факса и съобщението. Съобщение Включване приемане на аналогов сигнал Off (Изкл.) * On (Вкл.) Задава на принтера да приема аналогови факсове. Настройки на имейл във факс сървър Елементи от меню  Настройки на имейл във факс сървър  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Използване на SMTP сървър на имейл On (Вкл.) Off (Изкл.) * Използвайте настройките за имейл на Протокола за обикновено прехвърляне на имейли (SMTP) при получаване и изпращане на факсове. Когато опцията е зададена на  On (Вкл.) , всички други настройки на менюто  Fax Server E‑mail Settings (Имейл настройки на факс сървър)  не се показват. Primary SMTP Gateway (Първичен SMTP шлюз) Въведете IP адреса или името на хоста на първичния SMTP сървър. Първичен порт на SMTP шлюза 1 – 65535 (25*) Въведете номер на порт на първичния SMTP сървър. Secondary SMTP Gateway (Вторичен SMTP шлюз) Въведете IP адрес на сървъра или име на хост на вторичен или резервен SMTP сървър. Вторичен порт на SMTP шлюза 1 – 65535 (25*) Въведете номер на порта на сървъра на Вашия вторичен или резервен SMTP сървър. Таймаут на SMTP сървъра 5 – 30 (30*) Задайте времето, преди да изтече времето на сесията за принтера, ако SMTP сървъра не отговаря. Reply Address (Адрес за отговор) Посочете адрес за отговор на изпращания факс. Използване на SSL/TLS Disabled (Забранено) * Договаряне Задължителен Посочете дали да се изпрати факс, като се използва шифрована връзка. Изисква доверен сертификат Off (Изкл.) On (Вкл.) * Изисква доверен сертификат при достъп за SMTP сървър. SMTP Server Authentication (Удостоверяване на SMTP сървър) Не е необходимо удостоверяване * Login / Plain (Вход / Опростен) NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Посочва вида на удостоверяване на SMTP сървър. Иницииран от устройството имейл Няма * Изп. SMTP данни от у-вото Посочва дали са необходими данни за устройството за иницииран от устройството имейл. Иницииран от потребителя имейл Няма * Изп. SMTP данни от у-вото Изп. потреб. ИД и парола за сесията Използване на имейл адрес и парола за сесията Запит.потреб. Посочва дали са необходими данни за устройството за иницииран от потребителя имейл. Използ.удостов. от у-то за Active Directory Off (Изкл.) * On (Вкл.) Активира данни за потребителя и наименования на групи за свързване към SMTP сървър. Device Userid (ИД потребител у-во) Посочва потребителска ИД и парола за свързване към SMTP сървъра. Device Password (Парола на устройството) Kerberos 5 зона Посочва протокола за удостоверяване на зоната за Kerberos 5. NTLM Domain (NTLM домейн) Посочва име на домейна за протокол на NTLM защита. Дезактивира грешката „SMTP сървърът не е настроен“ Off (Изкл.)* On (Вкл.) Скрива съобщението за грешка “SMTP сървър не е настроен”. Настройки на сканиране във факс сървър Елементи от менюто  Fax Server Scan Settings (Настройки на сканиране във факс сървър)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Формат изображение TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Посочва формата на файла за сканираното изображение. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  и  CSV (.csv)  се появяват само ако сте закупили и инсталирали OCR решение. Вид съдържание Текст * Текст/снимка Снимка Графики Подобрява изходния резултат въз основа на съдържанието на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултата въз основа на източника на оригиналния документ. Разделителна способн. факс Стандартен * Фина Суперфина Ултрафина Задава разделителната способност на факса. Страни Off (Изкл.) * Къса страна Дълга страна Посочете ориентацията на оригиналния документ, когато сканирате и двете страни на документа. Мрак 1 – 9 (5*) Задава тъмнината на изходящото изображение. Ориентация Вертикална ориентация * Пейзаж Определете ориентацията на текста и изображенията на страницата. Оригинален размер [Списък с размери хартия] Посочва размера на хартията на оригиналния документ. Смес. размери  е настройката по подразбиране в САЩ. A4 е международната фабрична настройка по подразбиране. Тази настройка може да варира в зависимост от модела на Вашия принтер. Изп. TIFF множество стран. Off (Изкл.) On (Вкл.) * Избор между TIFF файлове от една или от много страници. меню Настройка факс сървър меню Общи настройки за факс меню Настройки на имейл във факс сървър меню Настройки на сканиране във факс сървър"},{"UUID":"f63fe187-b13d-454e-8dac-30ebfa504e14","title":"Имейл","link":"email-setup-topic.html","desc":"Конфигуриране на имейл Елементи от","descFull":"Конфигуриране на имейл Елементи от меню  Конфигуриране на имейл  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Primary SMTP Gateway (Първичен SMTP шлюз) Въведете IP адрес или име на хост на първичния SMTP сървър за изпращане на имейл. Първичен порт на SMTP шлюза 1 – 65535 (25*) Въведете номер на порт на първичния SMTP сървър. Secondary SMTP Gateway (Вторичен SMTP шлюз) Въведете IP адрес на сървъра или име на хост на вторичен или резервен SMTP сървър. Вторичен порт на SMTP шлюза 1 – 65535 (25*) Въведете номер на порта на сървъра на Вашия вторичен или резервен SMTP сървър. Таймаут на SMTP сървъра 5 – 30 секунди (30*) Задайте времето, преди да изтече времето на сесията за принтера, ако SMTP сървъра не отговаря. Reply Address (Адрес за отговор) Посочете адрес за отговор в имейла. Винаги използвайте адреса за отговор по подразбиране на SMTP On (Вкл.) Off (Изкл.) * Винаги използвайте адрес за отговор по подразбиране в SMTP сървъра. Използване на SSL/TLS Disabled (Забранено) * Договаряне Задължителен Посочете дали да се изпрати имейл, като се използва шифрована връзка. Изисква доверен сертификат Off (Изкл.) On (Вкл.) * Изисква доверен сертификат при достъп до SMTP сървър. SMTP Server Authentication (Удостоверяване на SMTP сървър) Не е необходимо удостоверяване * Вход / Опростен NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Посочва вида на удостоверяване на SMTP сървър. Иницииран от устройството имейл Няма * Изп. SMTP данни от у-вото Посочва дали са необходими данни за устройството за иницииран от устройството имейл. Иницииран от потребителя имейл Няма * Изп. SMTP данни от у-вото Използване на потребителско ИД и парола за сесията Използване на имейл адрес и парола за сесията Запитване на потребител Посочва дали са необходими данни за устройството за иницииран от потребителя имейл. Използ. удостов. от у-то за Active Directory Off (Изкл.) * On (Вкл.) Посочва дали са необходими данни за устройството за иницииран от потребителя имейл. Device Userid (ИД потребител у-во) Посочва потребителска ИД и парола за свързване към SMTP сървъра. Device Password (Парола на устройството) Kerberos 5 зона Посочва протокола за удостоверяване на зоната за Kerberos 5. NTLM Domain (NTLM домейн) Посочва име на домейна за протокол на NTLM защита. Disable “SMTP server not set up” error (Дезактивира грешката \"SMTP сървърът не е настроен\") Off (Изкл.) * On (Вкл.) Скрива съобщението за грешка “SMTP сървър не е настроен”. меню Конфигуриране на имейл"},{"UUID":"4f1be3e2-04e2-43db-9db3-2fa0832048ed","title":"Имейл","link":"email-setup-topic.html","desc":"Имейл по подразбиране Елементи на","descFull":"Имейл по подразбиране Елементи на меню  E‑mail Defaults (Настройки по подразбиране за имейл)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Тема: Посочва темата на имейла и съобщението. Съобщ.: Име на файл Посочва името на файла за сканирания документ. Формат JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Посочва формата на файла за сканирания документ. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  и  CSV (.csv)  се появяват само ако сте закупили и инсталирали OCR решение. Глобални OCR настройки Разпознати езици Auto Rotate (Автоматично завъртане)  (Off (Изкл.)*) Despeckle (Отстраняване на петна)  (Off (Изкл.)*) Auto Contrast Enhance (Автоматично подобряване на контраста)  (Off (Изкл.)*) Конфигурира настройките за оптично разпознаване на знаци (OCR). Този елемент от менюто се появява само ако сте закупили и инсталирали OCR решение. PDF настройки PDF Version (Версия на PDF)  (1,5*) Archival Version (Архивна версия)  (A‑1a*) Highly Compressed (Изключително компресиран)  ( Off (Изкл.) *) Secure (Защитено)  ( Off (Изкл.) *) Searchable (С възможност за търсене)  ( Off (Изкл.) *) Archival (PDF/A) (Архивни (PDF/A)  ( Off (Изкл.) *) Конфигурира PDF настройките на сканирания документ. Archival Version (Архивна версия)  и  Archival (PDF/A) (Архивни (PDF/A)  се поддържат само ако  PDF Version (Версия на PDF)  е зададена на 1,4. Highly Compressed (Силно компресиран)  се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Searchable (С възможност за търсене)  се появява само ако сте закупили и инсталирали OCR решение. Вид съдържание Текст Текст/снимка * Снимка Графики Подобрява изходния резултат въз основа на вида съдържание на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултат въз основа на източника на съдържание на оригиналния документ. Цвят Черно-бяло Сиво Цветно * Auto (Автоматично) Задава принтера да отпечатва съдържание на файл в цвят или черно-бяло. Разделителна способност 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Задава разделителната способност на сканираното изображение. Мрак 1 – 9 (5*) Посочва тъмнината на сканираното изображение. Ориентация Вертикална ориентация * Пейзаж Посочва ориентацията на оригиналния документ. Оригинален размер Mixed Sizes (Смес. размери) * Посочва размера на хартията на оригиналния документ. Страни Off (Изкл.) * Къса страна Дълга страна Посочете ориентацията на оригиналния документ, когато сканирате и двете страни на документа. Усъвършенствани изображения Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Баланс на цветовете Циан – Червен  (0*) Магента – Зелен  (0*) Yellow ‑ Blue (Жълт – Син)  (0*) Регулира интензивността на цвета за циан, магента и жълто. Премахване на цвят Color Dropout (Премахване на цвят)  ( None (Няма) *) Default Red Threshold (Осн. граница на червеното)  (128*) Default Green Threshold (Осн. граница на зеленото)  (128*) Default Blue Threshold (Осн. граница на синьото)  (128*) Посочва кой цвят да се изпусне по време на сканиране и регулира настройката за премахване на този цвят. Авт. откр. цвят Color Sensitivity (Цветна чувствителност)  (5*) Area Sensitivity (Чувствителност на зона)  (5*) E‑mail Bit Depth (Брой битове имейл)  (1 бит*) Minimum Scan Resolution (Минимална разделителна способност за сканиране)  (300 dpi*) Конфигурира автоматичната настройка за откриване на цвят. Качество JPEG Best for content (Оптимално за съдържание) * 5-95 Задава качество JPEG на сканираното изображение. Контраст Best for content (Оптимално за съдържание) * 0 – 5 Посочва контраста на сканираното изображение. Изчистване на фона Background Detection (Разпознаване на фон)  ( Content‑based (На база на съдържание) *) Level (Ниво)  (0*) Премахва фоновия цвят или цифровия шум на изображението от оригиналния документ. Content-based (На база на съдържание)  премахва фоновия цвят от оригиналния документ. Fixed (Фиксирано)  премахва цифровия шум от снимка. Огледално изображение Off (Изкл.) * On (Вкл.) Създадете огледално изображение на оригиналния документ. Негатив Off (Изкл.) * On (Вкл.) Създадете негативно изображение на оригиналния документ. Сенки –4 до 4 (0*) Регулира сенките в сканираното изображение. Сканиране от край до край Off (Изкл.) * On (Вкл.) Сканира оригиналния документ от край до край. Рязкост 1 – 5 (3*) Регулира рязкостта в сканираното изображение. Температура –4 до 4 (0*) Генерира по-сини или по-червени изходящи изображения на оригиналния документ. Празни страници Blank Page Removal (Премахване на празни страници)  ( Do Not Remove (Не премахвайте) *) Blank Page Sensitivity (Чувствителност спрямо празна страница)  (5*) Задава чувствителността на сканирани изображения по отношение на празни страници в оригиналния документ. Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Максимален размер на имейл 0 – 65535 (0*) Посочва разрешения размер на файла за всеки имейл. Размер съобщение за грешка Посочва съобщението за грешка, което принтера изпраща, когато имейла надвиши разрешения размер на файла. Можете да въведете до 1024 знака. Ограничаване на направления Ограничава изпращането на имейл само до посочения списък с име на домейн. Използвайте запетая за отделяне на адреси. Изпрати ми копие Никога не се появява * On by Default (Вкл. по подразбиране) Изкл. по подразбиране Винаги включ. Изпраща копие от имейла към Вас. Разрешаване само на имейли до Вас Off (Изкл.) * On (Вкл.) Настройва принтера да изпраща имейли само до Вас. Използв. cc:/bcc: Off (Изкл.) * On (Вкл.) Активира копие с индиго и скрито копие в имейла. Изп. TIFF множество стран. Off (Изкл.) On (Вкл.) * Разрешава сканиране на множество TIFF изображения в един TIFF файл. TIFF компресиране JPEG LZW * Посочва типа компресиране за TIFF файлове. Настройки по подразбиране за текст 5 – 95 (75*) Задава качеството на текста в съдържанието, което ще сканирате. Осн. настр. за текст/снимка 5 – 95 (75*) Задава качеството на текста и снимката в съдържанието, което ще сканирате. Настройки по подразбиране за снимка 5 – 95 (50*) Задава качеството на снимката в съдържанието, което ще сканирате. Регулиране АПУ изкревяне Off (Изкл.) On (Вкл.) * Конфигурира принтера да регулира изкривени изображения от документи, които са сканирани от АПУ. Дневник за предаване Отпечатване дневник * Без отпечатване дневник Отпечатване само при грешка Отпечатва дневник за предаване за сканиране на имейли. Дневн.източ.х-я Tray (Тава)  [x] (1*) Многоф.подав. у-во Посочва източника на хартия за отпечатване на имейл дневници. Сканиране по избор Off (Изкл.) * On (Вкл.) Задава принтера да сканира първия комплект оригинални документи с помощта на посочените настройки, след което сканира следващия комплект със същите или с различни настройки. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Преглед Off (Изкл.) * On (Вкл.) Показва преглед на сканиране на оригиналния документ. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Позволяв. „Запамет. като бърза команда“ Off (Изкл.) On (Вкл.) * Запаметява имейл адрес като бърза команда. Изображения от имейли „Изпрати като“ Attachment (Прикачен файл) * Уеб връзка Посочва как да изпращате изображенията, които са включени в имейла. Нулирайте информацията за имейла след изпращане Off (Изкл.) On (Вкл.) * Нулира полетата To (До), Subject (Тема), Message (Съобщение) и Filename (Име на файл) до техните стойности по подразбиране, след като изпратите имейл. меню Имейл по подразбиране"},{"UUID":"fdf32fa8-6831-4d1b-856d-f596baea8759","title":"Имейл","link":"email-setup-topic.html","desc":"Настр.уеб връзка Елементи на меню","descFull":"Настр.уеб връзка Елементи на меню  Web Link Setup (Настройка на уебвръзка)  и техните описания Елемент от меню Описание Сървър Посочва идентификационните данни на сървъра, който хоства изображенията, които са включени в имейла. Вход Парола Път Име на файл Уеб връзка меню Настр.уеб връзка"},{"UUID":"78102791-a00d-4384-ab92-5f3783cffa1c","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP по подразбиране Елементи от","descFull":"FTP по подразбиране Елементи от меню  FTP по подразбиране  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Формат JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Посочва формата на файла за сканираното изображение. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  и  CSV (.csv)  се появяват само ако сте закупили и инсталирали OCR решение. Глобални OCR настройки Разпознати езици Auto Rotate (Автоматично завъртане)  ( Off (Изкл.) *) Despeckle (Отстраняване на петна)  ( Off (Изкл.) *) Auto Contrast Enhance (Автоматично подобряване на контраста)  ( Off (Изкл.) *) Конфигурира настройките за оптично разпознаване на знаци (OCR). Този елемент от менюто се появява само ако сте закупили и инсталирали OCR решение. PDF настройки PDF Version (Версия на PDF)  (1,5*) Archival Version (Архивна версия)  ( A‑1a *) Highly Compressed (Изключително компресиран)  ( Off (Изкл.) *) Secure (Защитено)  ( Off (Изкл.) *) Searchable (С възможност за търсене)  ( Off (Изкл.) *) Archival (PDF/A) (Архивни (PDF/A)  ( Off (Изкл.) *) Конфигурира PDF настройките за сканираното изображение. Archival Version (Архивна версия)  и  Archival (PDF/A) (Архивни (PDF/A)  се поддържат само ако  PDF Version (Версия на PDF)  е зададена на 1,4. Highly Compressed (Силно компресиран)  се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Searchable (С възможност за търсене)  се появява само ако сте закупили и инсталирали OCR решение. Вид съдържание Текст Текст/снимка * Графики Снимка Подобрява изходния резултат въз основа на вида съдържание на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултат въз основа на източника на съдържание на оригиналния документ. Цвят Черно-бяло Сиво Цветно * Auto (Автоматично) Задава принтера да отпечатва съдържание на файл в цвят или черно-бяло. Разделителна способност 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Задава разделителната способност на сканираното изображение. Мрак 1 – 9 (5*) Посочва тъмнината на сканираното изображение. Ориентация Вертикална ориентация * Пейзаж Посочва ориентацията на оригиналния документ. Оригинален размер Mixed Sizes (Смес. размери) * Посочва размера на хартията на оригиналния документ. Страни Off (Изкл.) * Дълга страна Къса страна Посочва ориентацията, когато сканирате и двете страни на документа. Име на файл Посочва името файла на сканираното изображение. Усъвършенствани изображения Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Баланс на цветовете Циан – Червен  (0*) Магента – Зелен  (0*) Yellow ‑ Blue (Жълт – Син)  (0*) Регулира интензивността на цвета за циан, магента и жълто. Премахване на цвят Color Dropout (Премахване на цвят)  ( None (Няма) *) Default Red Threshold (Осн. граница на червеното)  (128*) Default Green Threshold (Осн. граница на зеленото)  (128*) Default Blue Threshold (Осн. граница на синьото)  (128*) Посочва кой цвят да се изпусне по време на сканиране и регулира настройката за премахване на този цвят. Авт. откр. цвят Color Sensitivity (Цветна чувствителност)  (5*) Area Sensitivity (Чувствителност на зона)  (5*) FTP Bit Depth (Брой битове за FTP)  (1 бит*) Minimum Scan Resolution (Минимална разделителна способност за сканиране)  (300 dpi*) Конфигурира автоматичната настройка за откриване на цвят. Качество JPEG Best for content (Оптимално за съдържание) * 5-95 Задава качество JPEG на сканираното изображение. Контраст Best for content (Оптимално за съдържание) * 0 1 2 3 4 5 Посочва контраста на сканираното изображение. Изчистване на фона Background Detection (Разпознаване на фон)  ( Content‑based (На база на съдържание) *) Level (Ниво) (0*) Премахва фоновия цвят или цифровия шум на изображението от оригиналния документ. Content-based (На база на съдържание)  премахва фоновия цвят от оригиналния документ. Fixed (Фиксирано)  премахва цифровия шум от снимка. Огледално изображение Off (Изкл.) * On (Вкл.) Създадете огледално изображение на оригиналния документ. Негатив Off (Изкл.) * On (Вкл.) Създадете негативно изображение на оригиналния документ. Сенки –4 до 4 (0*) Регулира сенките в сканираното изображение. Сканиране от край до край Off (Изкл.) * On (Вкл.) Позволява сканиране от край до край на оригиналния документ. Рязкост 1 – 5 (3*) Регулира рязкостта в сканираното изображение. Температура –4 до 4 (0*) Генерира по-сини или по-червени изходящи изображения на оригиналния документ. Празни страници Blank Page Removal (Премахване на празни страници)  ( Do Not Remove (Не премахвайте) *) Blank Page Sensitivity (Чувствителност спрямо празна страница)  (5*) Задава чувствителността на сканирани изображения по отношение на празни страници в оригиналния документ. Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Настройки по подразбиране за текст 5 – 95 (75*) Задава качеството на текст на сканираното изображение. Осн. настр. за текст/снимка 5 – 95 (75*) Задава качеството на текст и снимка на сканираното изображение. Настройки по подразбиране за снимка 5 – 95 (50*) Задава качеството на снимка на сканираното изображение. Изп. TIFF множество стран. On (Вкл.) * Off (Изкл.) Разрешава сканиране на множество TIFF изображения в един TIFF файл. TIFF компресиране LZW * JPEG Посочва типа компресиране за TIFF файлове. Дневник за предаване Отпечатване дневник * Без отпечатване дневник Отпечатване само при грешка Отпечатва дневник за предаване за FTP сканиране. Дневн.източ.х-я Tray (Тава)  [x] (1*) Многоф.подав. у-во Посочва източника на хартия за отпечатване на FTP дневници. Сканиране по избор Off (Изкл.) * On (Вкл.) Задава принтера да сканира първия комплект оригинални документи с помощта на посочените настройки, след което сканира следващия комплект със същите или с различни настройки. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Преглед Off (Изкл.) * On (Вкл.) Показва преглед на оригиналния документ. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Позволяв. „Запамет. като бърза команда“ Off (Изкл.) On (Вкл.) * Запаметява FTP адрес като пряк път. Регулиране АПУ изкревяне Off (Изкл.) * On (Вкл.) Конфигурира принтера да регулира изкривени изображения от документи, които са сканирани от АПУ. Use Passive FTP (Използване на пасивен FTP) Off (Изкл.) * On (Вкл.) Позволява на FTP сървъра да определи порта за данни, към който да се свързва принтерът. меню FTP по подразбиране"},{"UUID":"c4ee9ead-09bf-4d24-96c0-2fb4fd2d7594","title":"USB у-во","link":"flash-drive-scan-topic.html","desc":"Сканиране от флаш устройство Елементи","descFull":"Сканиране от флаш устройство Елементи от менюто  Сканиране от флаш устройство  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Формат JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Посочва формата на файла за сканираното изображение. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  и  CSV (.csv)  се появяват само ако сте закупили и инсталирали OCR решение. Глобални OCR настройки Разпознати езици Auto Rotate (Автоматично завъртане)  ( Off (Изкл.) *) Despeckle (Отстраняване на петна)  ( Off (Изкл.) *) Auto Contrast Enhance (Автоматично подобряване на контраста)  ( Off (Изкл.) *) Конфигурира настройките за оптично разпознаване на знаци (OCR). Този елемент от менюто се появява само ако сте закупили и инсталирали OCR решение. PDF настройки PDF Version (Версия на PDF)  (1,5*) Archival Version (Архивна версия)  (A‑1a*) Highly Compressed (Изключително компресиран)  ( Off (Изкл.) *) Secure (Защитено)  ( Off (Изкл.) *) Searchable (С възможност за търсене)  ( Off (Изкл.) *) Archival (PDF/A) (Архивни (PDF/A)  ( Off (Изкл.) *) Конфигуриране на PDF настройките на сканираното изображение. Archival Version (Архивна версия)  и  Archival (PDF/A) (Архивни (PDF/A)  се поддържат само ако  PDF Version (Версия на PDF)  е зададена на 1,4. Highly Compressed (Силно компресиран)  се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство (ISD). Searchable (С възможност за търсене)  се появява само ако сте закупили и инсталирали OCR решение. Вид съдържание Текст Текст/снимка * Графики Снимка Подобрява изходния резултат въз основа на вида съдържание на оригиналния документ. Източник на съдържание Black and White Laser (Черно-бял лазерен) * Цветен лазерен Мастиленоструен Снимка/филм Списание Вестник Печатно издание Други Подобрява изходния резултат въз основа на източника на съдържание на оригиналния документ. Цвят Черно-бяло Сиво Цветно * Auto (Автоматично) Задава принтера да отпечатва съдържание на файл в цвят или черно-бяло. Разделителна способност 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Задава разделителната способност на сканираното изображение. Мрак 1 – 9 (5*) Посочва тъмнината на сканираното изображение. Ориентация Вертикална ориентация * Пейзаж Посочва ориентацията на оригиналния документ. Оригинален размер Mixed Sizes (Смес. размери) * Посочва размера на хартията на оригиналния документ. Страни Off (Изкл.) * Дълга страна Къса страна Посочете ориентацията на оригиналния документ, когато сканирате и двете страни на документа. Име на файл Посочва името файла на сканираното изображение. Усъвършенствани изображения Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Баланс на цветовете Циан – Червен (0*) Магента – Зелен (0*) Yellow ‑ Blue (Жълт – Син) (0*) Регулира интензивността на цвета за циан, магента и жълто. Премахване на цвят Color Dropout (Премахване на цвят)  ( None (Няма) *) Осн. граница на червеното (128*) Осн. граница на зеленото (128*) Осн. граница на синьото (128*) Посочва кой цвят да се изпусне по време на сканиране и регулира настройката за премахване на този цвят. Авт. откр. цвят Color Sensitivity (Цветна чувствителност) (5*) Area Sensitivity (Чувствителност на зона)  (5*) Scan Bit Depth (Брой битове за сканиране)  (1 бит*) Minimum Scan Resolution (Минимална разделителна способност за сканиране)  (300 dpi*) Конфигурира автоматичната настройка за откриване на цвят. Качество JPEG Best for content (Оптимално за съдържание) * 5-95 Задава качество JPEG на сканираното изображение. Контраст Best for content (Оптимално за съдържание) * 0 – 5 Посочва контраста на сканираното изображение. Изчистване на фона Background Detection (Разпознаване на фон)  ( Content‑based (На база на съдържание) *) Level (Ниво) (0*) Премахва фоновия цвят или цифровия шум на изображението от оригиналния документ. Content-based (На база на съдържание)  премахва фоновия цвят от оригиналния документ. Fixed (Фиксирано)  премахва цифровия шум от снимка. Огледално изображение Off (Изкл.) * On (Вкл.) Създадете огледално изображение на оригиналния документ. Негатив Off (Изкл.) * On (Вкл.) Създадете негативно изображение на оригиналния документ. Сенки –4 до 4 (0*) Регулира сенките в сканираното изображение. Сканиране от край до край Off (Изкл.) * On (Вкл.) Сканира оригиналния документ от край до край. Рязкост 1 – 5 (3*) Регулира рязкостта в сканираното изображение. Температура –4 до 4 (0*) Генерира по-сини или по-червени изходящи изображения на оригиналния документ. Празни страници Blank Page Removal (Премахване на празни страници)  ( Do Not Remove (Не премахвайте) *) Blank Page Sensitivity (Чувствителност спрямо празна страница)  (5*) Задава чувствителността на сканирани изображения по отношение на празни страници в оригиналния документ. Контроли за администратор Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Настройки по подразбиране за текст 5 – 95 (75*) Задава качеството на текст на сканираното изображение. Осн. настр. за текст/снимка 5 – 95 (75*) Задава качеството на текст и снимка на сканираното изображение. Настройки по подразбиране за снимка 5 – 95 (50*) Задава качеството на снимка на сканираното изображение. Изп. TIFF множество стран. Off (Изкл.) On (Вкл.) * Разрешава сканиране на множество TIFF изображения в един TIFF файл. TIFF компресиране LZW * JPEG Посочва типа компресиране за TIFF файлове. Сканиране по избор Off (Изкл.) * On (Вкл.) Задава принтера да сканира първия комплект оригинални документи с помощта на посочените настройки, след което сканира следващия комплект със същите или с различни настройки. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Преглед Off (Изкл.) * On (Вкл.) Показва преглед на сканиране на оригиналния документ. Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Регулиране АПУ изкревяне Off (Изкл.) * On (Вкл.) Конфигурира принтера да регулира изкривени изображения от документи, които са сканирани от АПУ. меню Сканиране от флаш устройство"},{"UUID":"75c9c8f6-9462-48b1-a34e-14a131c9ebbf","title":"USB у-во","link":"flash-drive-scan-topic.html","desc":"Печатане от флаш устройство Елементи","descFull":"Печатане от флаш устройство Елементи на менюто  Flash Drive Print (Печат от флаш устройство)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Брой копия 1 – 9999 (1*) Задава броя на копията. Източник хартия Tray (Тава)  [x] (1*) Многоф.подав. у-во Ръчно под.х-я Ръчно плик Задава източника на хартия за заданието за печат. Сортиране Изключ. [1,1,1,2,2,2] Вкл. [1,2,1,2,1,2] * Запазва страниците на задание за печат наредени една върху друга в последователност, особено когато печатате множество копия на заданието. Страни Едностранно * 2‑Sided (Двустранно) Определя дали да отпечатва от едната страна или и от двете страни на хартията. Начин на обръщане Дълга страна * Къса страна Определя коя страна на хартията ще бъде свързана при двустранен печат. Страници на страна Off (Изкл.) * 2 pages per side (2 страници на страна) 3 pages per side (3 страници на страна) 4 pages per side (4 страници на страна) 6 pages per side (6 страници на страна) 9 pages per side (9 страници на страна) 12 pages per side (12 страници на страна) 16 pages per side (16 страници на страна) Отпечатване на многостранични изображения на едната страна на лист хартия. Pages per Side Ordering (Подреждане на страници на една страна) Хоризонтално * Хориз., обърн. Верт., обърн. Вертикално Посочва позиционирането на многостранични изображения, когато използвате менюто  Pages per Side (Страници на страна) . Pages per Side Orientation (Ориентация на страници на една страна) Auto (Автоматично) * Пейзаж Портрет Посочва ориентацията на многостранични изображения, когато използвате менюто  Pages per Side (Страници на страна) . Pages per Side Border (Граница на страници на една страна) Няма * Солидна Отпечатва рамка около изображението на всяка страница, когато използвате менюто  Pages per Side (Страници на страна) . Разделящи листове Off (Изкл.) * Между копията Между задания Между стран. Вкарва празни разделящи листове по време на печат. Източник на разделителен лист Tray (Тава)  [x] (1*) Многоф.подав. у-во Определете източника на хартия за разделящия лист. Празни страници Do Not Print (Без печат) * Печат Отпечатва празни страници в задание за печат. меню Печатане от флаш устройство"},{"UUID":"c52ec323-67bc-440d-866b-b1e5090bb1e9","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Преглед на мрежата Преглед на","descFull":"Преглед на мрежата Преглед на мрежата  елементи от менюто и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Active Adapter (Активен адаптер) Автоматично * Стандартна мрежа Безжично Посочете типа мрежова връзка. Wireless (Безжично)  е налично само при принтери, които са свързани към безжична мрежа. Network Status (Състояние на мрежата) Показва състоянието на свързване на мрежата на принтера. Показва състоянието на мрежата на принтера Изкл. Вкл. * Показва състоянието на мрежата на дисплея. Скорост, дуплекс Показва скоростта на текущата активна мрежова карта. IPv4 Показва IPv4 адреса. Всички IPv6 адреси Показва всички IPv6 адреси. Рестартиране на сървъра за печат Нулира всички активни мрежови свързвания към принтера. Тази настройка премахва всички настройки за мрежова конфигурация. Таймаут на задача в мрежата Изкл. On (Вкл.) * (90  секунди ) Задава времето, преди принтерът да анулира мрежово задание за печат. Разделителна страница Изкл. * Вкл. Отпечатване на разделителна страница. Скан. в обхват комп.порт Посочете валиден обхват на порта за принтери, които са зад защитна стена, блокираща порта. Активиране на мрежови връзки Изкл. Вкл. * Разрешете на принтера да се свърже с мрежа. Разрешаване на LLDP Изкл. * Вкл. Разрешете Link Layer Discovery Protocol (LLDP) в принтера. меню Преглед на мрежата"},{"UUID":"ab2378d8-9981-4e9f-adef-9f3a6d5dea09","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Безжично Това меню е налично","descFull":"Безжично Това меню е налично само при принтери, свързани с Wi‑Fi мрежа или принтери, които имат безжичен мрежов адаптер. Елементи на менюто  Безжична връзка  и техните описания Елемент от меню Описание Setup Using Mobile App (Конфигуриране чрез използване на мобилно приложение) Конфигурирайте Wi‑Fi връзката чрез използване на Lexmark Mobile Assistant. Setup On Printer Panel (Конфигуриране на панела на принтера) Избор на мрежа Прибавяне на Wi-Fi мрежа Мрежово име Мрежов режим Инфраструктура Режим на защита на безжичната връзка Disabled (Забранено) * WPA2/WPA – персонален WPA2 – персонален WPA2/WPA3 – персонален WPA3 – персонален 802.1x – RADIUS Конфигурирайте Wi‑Fi връзката чрез използване на контролния панел. Този елемент от менюто се появява като  Конфигуриране на безжична връзка в Embedded Web Server. Wi‑Fi Protected Setup Метод с натискане на стартов бутон Метод за стартиране с PIN Установете Wi‑Fi мрежа и активирайте мрежовата защита. Методът на стартиране с натискане на бутон  свързва принтера с Wi‑Fi мрежа, когато бутоните на принтера и точката за достъп (безжичния рутер) бъдат натиснати в рамките на определен период от време. Методът на стартиране с PIN  свързва принтера с Wi‑Fi мрежа след въвеждане на PIN на принтера в настройките за безжична мрежа на точката за достъп. Съвместимост 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz/5 GHz) 802.11a/n/ac (5 GHz) Определете стандарт за Wi‑Fi мрежата. 802.11a/b/g/n/ac (2,4 GHz/5 GHz)  и  802.11a/n/ac (5 GHz)  се появяват само когато е инсталирана Wi‑Fi опция. Режим на защита на безжичната връзка Disabled (Забранено) * WPA2/WPA – персонален WPA2 – персонален WPA2/WPA3 – персонален WPA3 – персонален 802.1x – RADIUS Задайте режима на защита при свързване на принтера с Wi‑Fi устройства. WPA2/WPA персонален AES * Активирайте Wi‑Fi защитата чрез защитено конфигуриране на Wi‑Fi (WPA). Този елемент от менюто се появява само когато  Режимът на безжична защита  е настроен на  WPA2/WPA – Персонален . Задаване на PSK Задайте паролата за защитена Wi‑Fi връзка. WPA2 – персонален AES * Активиране на Wi‑Fi защита чрез WPA2. Този елемент от менюто се появява само когато  Режимът на безжична защита  е настроен на  WPA2 – Персонален . Режим 802.1x шифроване WPA+ WPA2 * WPA2 + PMF * Активиране на Wi‑Fi защита чрез стандарта 802.1x. Този елемент от менюто се появява само когато  Режимът на безжична защита  е настроен на  802.1x – RADIUS . IPv4 Enable DHCP (Разрешаване на DHCP) On (Вкл.) * Off (Изкл.) Set Static IP Address (Задава статичен IP адрес) IP Address (IP адрес) Netmask (Маска на мрежата) Gateway (Шлюз) Разрешава и конфигурира IPv4 настройките на принтера. IPv6 Enable IPv6 (Разрешаване на IPv6) On (Вкл.) * Off (Изкл.) Enable DHCPv6 (Разрешаване на IPv6) On (Вкл.) Off (Изкл.) * Stateless Address Autoconfiguration (Сателитен адрес за автоматично конфигуриране) On (Вкл.) * Off (Изкл.) Адрес на DNS сървър Ръчно зададен IPv6 адрес Ръчно зададен IPv6 маршрутизатор Address Prefix (Префикс на адреса) All IPv6 Addresses (Всички IPv6 адреси) All IPv6 Router Addresses (Всички IPv6 адреси на маршрутизатори) Разрешава и конфигурира IPv6 настройките на принтера. Network Address (Мрежов адрес) UAA LAA Видите мрежовите адреси. PCL SmartSwitch On (Вкл.) * Off (Изкл.) Задава на принтера автоматично да превключва на „PCL дубликат“, когато заданието за печат го изисква, без значение от езика по подразбиране на принтера. Ако  PCL SmartSwitch  е изключен, тогава принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Конфигуриране . PS SmartSwitch On (Вкл.) * Off (Изкл.) Задава на принтера автоматично да превключва на „PS дубликат“, когато заданието за печат го изисква, без значение от езика по подразбиране на принтера. Ако  PS SmartSwitch  е изключен, принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Конфигуриране . Буфер.задание On (Вкл.) Off (Изкл.) * Преди отпечатването запаметете временно заданията за печат в твърдия диск или в интелигентното запаметяващо устройство (ISD). Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Mac Binary PS (Бинарен PS на Mac) Auto (Автоматично) * On (Вкл.) Off (Изкл.) Задава на принтера да обработва бинарни PostScript задания за печат на Macintosh. Вкл.  обработва необработени бинарни PostScript задания за печат. Изкл.  филтрира заданията за печат чрез стандартния протокол. меню Безжично"},{"UUID":"823090c1-f1b5-436c-919a-21cadb100926","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Това меню е","descFull":"Wi‑Fi Direct Това меню е налично само при принтери, свързани с Wi‑Fi мрежа или принтери, които имат безжичен мрежов адаптер. Елементи на менюто на  Wi‑Fi Direct  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Активирайте Wi‑Fi Direct On (Вкл.) Off (Изкл.) * Задайте принтера за директно свързване към Wi-Fi устройства. Име на Wi‑Fi Direct Посочете името на Wi‑Fi Direct мрежата. Парола за Wi‑Fi Direct Задайте паролата за удостоверяване и потвърждаване на потребителите на Wi‑Fi връзка. Show Password on Setup Page (Показване на паролата на страницата за конфигуриране) Off (Изкл.) On (Вкл.) * Показване на  Wi‑Fi Direct Password (Парола за Wi‑Fi Direct)  на  Network Setup Page (Страницата за настройка на мрежата) . Предпочитан номер на канал 1 – 11 Auto (Автоматично) * Задайте предпочитания канал на Wi‑Fi мрежата. Group Owner IP Address (Собственик на група на IP адрес) Определя IP адреса на собственика на групата. Auto‑Accept Push Button Requests (Бутони за автоматични искания) Off (Изкл.) * On (Вкл.) Приема автоматично искания за свързване към мрежа. Автоматичното приемане на клиенти не е сигурно. меню Wi‑Fi Direct"},{"UUID":"25e93b81-9411-4c2d-8079-7e69c29877c8","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"AirPrint Това меню се появява","descFull":"AirPrint Това меню се появява само в Embedded Web Server. Елементи от менюто  AirPrint  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. All AirPrint Functions (Всички функции на AirPrint) Показва състоянието на AirPrint на принтера. Активиране на AirPrint On (Вкл.) * Off (Изкл.) Активира функцията AirPrint. Този елемент от менюто се показва само ако е забранен интернет протоколът за печат (IPP) или mDNS. Enable iBeacon (Активиране на iBeacon) On (Вкл.) Off (Изкл.) * Активира функцията iBeacon. Bonjour Name (Име в Bonjour) Идентифицира обозначението и местоположението на принтера. Име на организация Организационна единица Местоположение на принтера Геогр. ширина на принтера Геогр. дължина на принтера Геогр. височина на принтера More Options (Още опции) меню AirPrint"},{"UUID":"77f727f8-9768-4b1e-9bb1-c315d1a3150d","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Управление на мобилни услуги Елементи","descFull":"Управление на мобилни услуги Елементи от менюто  Mobile Services Management (Управление на мобилни услуги)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Enable IPP Print (Разрешаване на отпечатване чрез IPP) On (Вкл.) * Off (Изкл.) Разрешава печат от мобилни устройства чрез интернет протокол за печат (IPP). Enable IPP Fax (Разрешаване на факс чрез IPP) On (Вкл.) * Off (Изкл.) Разрешава изпращането на факсове чрез интернет протокол за печат (IPP). Enable IPP Over USB (Разрешаване на IPP чрез USB) On (Вкл.) * Off (Изкл.) Разрешава задания за печат или за сканиране чрез USB връзка. Enable Scan (Разрешаване на сканиране) On (Вкл.) * Off (Изкл.) Разрешава сканиране чрез протокол eSCL. Enable Mopria Discovery (Разрешаване на откриване на Mopria) On (Вкл.) * Off (Изкл.) Разрешава принтерът да бъде откриван чрез устройства, способни да работят с Mopria. меню Управление на мобилни услуги"},{"UUID":"1142c5b2-cd02-4694-9b5c-033bae23beaf","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Ethernet Елементи от менюто ","descFull":"Ethernet Елементи от менюто  Ethernet  и тяхното описание Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Network Speed (Мрежова скорост) Показва скоростта на активния мрежов адаптер. IPv4 Enable DHCP (Разрешаване на DHCP)  ( On (Вкл.) *) Set Static IP Address (Задава статичен IP адрес) Конфигурира IPv4 настройките. IPv6 Enable IPv6 (Разрешаване на IPv6)  ( On (Вкл.) *) Enable DHCPv6 (Разрешаване на IPv6)  ( Off (Изкл.) *) Stateless Address Autoconfiguration (Сателитен адрес за автоматично конфигуриране)  ( On (Вкл.) *) Адрес на DNS сървър Ръчно зададен IPv6 адрес Ръчно зададен IPv6 маршрутизатор Префикс на адреса (64*) All IPv6 Addresses (Всички IPv6 адреси) All IPv6 Router Addresses (Всички IPv6 адреси на маршрутизатори) Конфигурира IPv6 настройките. Network Address (Мрежов адрес) UAA LAA Определя мрежовия адрес. PCL SmartSwitch Off (Изкл.) On (Вкл.) * Задава на принтера автоматично да превключва на „PCL дубликат“, когато заданието за печат го изисква, без значение от езика по подразбиране на принтера. Когато тази настройка е дезактивирана, принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Setup (Настройка) . PS SmartSwitch Off (Изкл.) On (Вкл.) * Задава на принтера автоматично да превключва на „PostScript дубликат“, когато заданието за печат го изисква, без значение от езика по подразбиране на принтера. Когато тази настройка е дезактивирана, принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Setup (Настройка) . Буфер.задание Off (Изкл.) * On (Вкл.) Преди отпечатването запаметете временно заданията за печат в твърдия диск или в интелигентното запаметяващо устройство (ISD). Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Mac Binary PS (Бинарен PS на Mac) Auto (Автоматично) * On (Вкл.) Off (Изкл.) Задава на принтера да обработва бинарни PostScript задания за печат на Macintosh. Auto (Автоматично)  обработва задания за печат от компютрите, като използва операционна система Windows или Macintosh. Off (Изкл.)  филтрира PostScript заданията за печат чрез стандартния протокол. Energy Efficient Ethernet (Енергийно-ефективен Ethernet) On (Вкл.) Off (Изкл.) Auto (Автоматично) * Намалява консумацията на енергия, когато принтерът не получава данни от Ethernet мрежа. меню Ethernet"},{"UUID":"f3bab0d2-1f75-4bb8-a09f-f557edc27208","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"TCP/IP Това меню се появява","descFull":"TCP/IP Това меню се появява само в мрежовите принтери или принтерите, свързани към сървърите за печат. Елементи на менюто  TCP/IP  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Задаване на име на хост Задайте текущото TCP/IP име на хост. Име на домейна Задава името на домейна. Позволява на DHCP/BOOTP да актуализира NTP сървър On (Вкл.) * Off (Изкл.) Позволява на DHCP и BOOTP клиентите да актуализират NTP настройките на принтера. Няма име на конфигурация Посочва име на услуга за нулева мрежова конфигурация. Разрешаване на автоматичен IP Off (Изкл.) On (Вкл.) * Автоматично задаване на IP адрес. Адрес на DNS сървър Посочва адреса на настоящия сървър на Системата от домейн имена (DNS). Архивиране на адреса на DNS сървъра Посочва адреса на резервния DNS сървър. Архивиране на адрес 2 на DNS сървъра Архивиране на адрес 3 на DNS сървъра Последователност за търсене на домейни Посочва списък с имена на домейни за локализиране на принтера и неговите ресурси, които се намират в различни домейни на мрежата. Разрешаване на DDNS Off (Изкл.) * On (Вкл.) Актуализиране на динамичните настройки на DNS. DDNS TTL Посочва текущите настройки на DDNS. TTL (Time-to-live) по подразбиране Време за обновяване на DDNS Разрешаване на mDNS Off (Изкл.) On (Вкл.) * Актуализира мултикаст настройките на DNS. Адрес на WINS сървър Посочва адрес на сървъра за Windows Internet Name Service (WINS). Разрешаване на BOOTP Off (Изкл.) * On (Вкл.) Позволява BOOTP да зададе IP адрес на принтера. Ограничен списък със сървъри Посочва IP адресите, които имат право да комуникират с принтера през TCP/IP. Използвайте запетая за отделяне на всеки IP адрес. Можете да добавите до 50 IP адреса. Опции „Списък с ограничени сървъри“ Блокира всички портове * Блокира само отпечатване Блокира само отпечатване и HTTP Посочва опцията за достъп за IP адреси, които не са в списъка. MTU 256 – 1500 Ethernet  (1500*) Посочва параметър на максимална единица на предаване (MTU) за TCP връзки. Raw порт за отпечатване 1 – 65535 (9100*) Посочва номер на raw порт за принтери, свързани в мрежа. Максимална скорост на изходящия трафик Off (Изкл.) * On (Вкл.) Задава максималната скорост на прехвърляне на принтера. Когато е разрешена, опцията за тази настройка е 100 – 1 000 000 килобита/секунда. TLS Support (Поддръжка на TLS) Enable TLSv1.0 (Разрешаване на TLSv1.0)  ( Off (Изкл.) *) Enable TLSv1.1 (Разрешаване на TLSv1.1) ( Off (Изкл.) *) Enable TLSv1.2 (Разрешаване наTLSv1.2)  ( On (Вкл.) *) Разрешаване на протокола Transport Layer Security (Безопасност на равнище предаване). SSL Cipher List (Списък с шифри SSL) Посочва алгоритмите с шифри за използване за SSL или TLS връзките. Списък с шифри TLSv1.3 SSL меню TCP/IP"},{"UUID":"3e04eccc-cded-46a5-b1de-e7872ebefa84","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"SNMP Това меню се появява","descFull":"SNMP Това меню се появява само в мрежовите принтери или в принтерите, които са прикачени към сървъри за печат. Елементи от менюто  SNMP  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. SNMP Versions 1 and 2c (SNMP протокол за управление на опростена мрежа версии 1 и 2c) Enabled (Разрешено) Off (Изкл.) On (Вкл.) * Разрешаване на SNMP Off (Изкл.) On (Вкл.) * Enable PPM MIB (Активирай PPM MIB) Off (Изкл.) On (Вкл.) * SNMP група Конфигурирайте Протокол за управление на опростена мрежа (SNMP) версии 1 и 2c, за да инсталирате драйвери и приложения за печат. SNMP версия 3 Enabled (Разрешено) Off (Изкл.) On (Вкл.) * Име на контекст Set Read/Write Credentials (Задаване на данни за четене/запис) Потребителско име Парола за удостоверяване Парола за поверителност Set Read‑only Credentials (Задаване на данни само за четене) Потребителско име Парола за удостоверяване Парола за поверителност Authentication Hash (Удостоверяване на хеширане) MD5 SHA1 * Minimum Authentication Level (Минимално ниво за удостоверяване) Няма удостоверяване, няма поверителност Удостоверяване, няма поверителност Удостоверяване, поверителност * Privacy Algorithm (Алгоритъм за поверителност) DES AES‑128 * Конфигурирайте SNMP версия 3, за да инсталирате и обновявате защитата на принтера. меню SNMP"},{"UUID":"8a62ec71-5e6b-4222-b570-0b09c7d68a46","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"IPSec Това меню се появява","descFull":"IPSec Това меню се появява само в мрежовите принтери или в принтерите, които са прикачени към сървъри за печат. Елементи от менюто  IPSec  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Активиране на IPSec Off (Изкл.) * On (Вкл.) Активира защита на интернет протокол (IPSec). Базова конфигурация По подразбиране * Съвместимост Защитено Задава базовата конфигурация на IPSec. Този елемент от менюто се появява само когато  Активиране на IPSec  е зададено на  Вкл. DH (Diffie‑Hellman) Group Proposal (Предложение на група DH (Diffie-Hellman Group) modp 2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Задава базовата конфигурация на IPSec. Този елемент от менюто се появява само когато  Базова конфигурация  е зададена на  Съвместимост . Предложен метод за шифроване 3DES AES * Задава метода на шифроване. Този елемент от менюто се появява само когато  Базова конфигурация  е зададена на  Съвместимост . Предложен метод за удостоверяване SHA1 SHA256 * SHA512 Задава метода на удостоверяване. Този елемент от менюто се появява само когато  Базова конфигурация  е зададена на  Съвместимост . IKE SA Lifetime (Hours) (IKE SA работен ресурс (часове) 1 2 4 8 24* Посочете срок на IKE SA. Този елемент от менюто се появява само когато  Базова конфигурация  е зададена на  Защитена . IPSec SA Lifetime (Hours) (IPSec SA работен ресурс (часове) 1 2 4 8* 24 Посочете срок на IPSec SA. Този елемент от менюто се появява само когато  Базова конфигурация  е зададена на  Защитена . IPSec сертификат на устройство Посочва сертификат на IPSec. Този елемент от менюто се появява само когато  Активиране на IPSec  е зададено на  Вкл. Връзки, удостоверени с предварително споделен ключ Хост  [x] Конфигурира удостоверените връзки на принтера. Тези елементи от менюто се появяват само когато  Активиране на IPSec  е зададено на  Вкл. Връзки, удостоверени със сертификат Хост  [x]  Адрес[/подмрежа] меню IPSec"},{"UUID":"c1510d4c-5472-44bd-be24-6dddbd0a1f3f","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"802.1x Това меню се появява","descFull":"802.1x Това меню се появява само в мрежовите принтери или в принтерите, които са прикачени към сървъри за печат. Елементи от менюто  802.1x  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Активен Off (Изкл.) * On (Вкл.) Позволява на принтера да се присъедини към мрежи, които изискват удостоверяване преди разрешаване на достъп. 802.1x удостоверяване Име за влизане на устройството Парола за влизане на устройството Validate Serve Certificate (Потвърждаване на сертификата на сървъра)  ( On (Вкл.) *) Enable Event Logging (Разрешаване на регистрирането на събития)  ( Off (Изкл.) *) 802.1x сертификат на устройство Конфигурира настройките за удостоверяване на връзката на 802.1x. Механизми за удостоверяване EAP – MD5  ( On (Вкл.) *) EAP – MSCHAPv2  ( On (Вкл.) *) LEAP  ( On (Вкл.) *) PEAP  ( On (Вкл.) *) EAP – TLS  ( On (Вкл.) *) EAP – TTLS  ( On (Вкл.) *) TTLS Authentication Method (Метод за удостоверяване на TTLS)  ( MSCHAPv2 *) Конфигурира разрешените механизми за удостоверяване на връзката на 802.1x. меню 802.1x"},{"UUID":"358ee0c4-6f18-4843-89a7-97e0c8b99aeb","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Конфигуриране на LPD Това меню","descFull":"Конфигуриране на LPD Това меню се появява само в мрежовите принтери или в принтерите, които са прикачени към сървъри за печат. Елементи от меню  Конфигуриране на LPD  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. LPD таймаут 0–65535 seconds (90*) (0 – 65 535 секунди (90*) Задава стойността за таймаут, за да спре сървъра Line Printer Daemon (LPD) от неопределено изчакване за висящи или невалидни задания за печат. Разделителна страница при протокола LPD Изкл. * Вкл. Отпечатване на разделителна страница за всички задания за печат за LPD. Разделителната страница е първата страница на дадено задание за печат, използвана за отделяне на заданията за печат и за идентифициране на автора на заявката на заданието за печат. Страница за край при протокола LPD Изкл. * Вкл. Отпечатване на страница за край за всички задания за печат за LPD. Страницата за край е последната страница на заданието за печат. Преобразуване на символа за връщане на каретката при протокола LPD Изкл. * Вкл. Активира преобразуването при връщане на касетата. Връщането на касетата е механизъм, който кара принтера да премести позицията на курсора до първата позиция на същия ред. меню Конфигуриране на LPD"},{"UUID":"35db23c1-a0aa-4eeb-9183-9d5643ae293a","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Настройки на HTTP/FTP Елементи на","descFull":"Настройки на HTTP/FTP Елементи на меню  Настройки на HTTP/FTP  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Прокси IP адрес на HTTP прокси IP порт по подразбиране за HTTP IP адрес на прокси сървър за FTP IP порт по подразбиране за FTP Удостоверяване Потребителско име Парола Локални домейни Конфигуриране на настройките на HTTP и FTP сървъра. Други настройки Enable HTTP Server (Разрешаване на HTTP сървър)  ( On (Вкл.) *) Достъп до вградения уебсървър да наблюдава и управлява принтера. Други настройки Enable HTPPS (Разрешаване на HTPPS)  ( On (Вкл.) *) Разрешава Защитен протокол за прехвърляне на хипертекст (HTTPS) за криптиране на данни, които се прехвърлят към и от сървър за печат. Други настройки Force HTTPS Connections (Принудителни HTTPS връзки)  ( Off (Изкл.) *) Принуждава принтера да използва HTTPS връзки. Други настройки Enable FTP/TFTP (Разрешаване на FTP/TFTP)  ( On (Вкл.) *) Изпраща файлове с помощта на FTP/TFTP. Други настройки HTTPS Device Certificate (HTTPS сертификат на устройство)  ( по подразбиране *) Вижте използвания на принтера HTTP сертификат на устройство. Други настройки Timeout for HTTP/FTP Requests (Време за изчакване на HTTP/FTP заявки)  (30*) Задайте необходимото време преди връзката на сървъра да спре. Други настройки Retries for HTTP/FTP Requests (Повторни опити за HTTP/FTP заявки)  (3*) Задаване на броя на повторни опити за свързване към HTTP/FTP сървъра. меню Настройки на HTTP/FTP"},{"UUID":"53f95579-041e-43df-9f28-e3c30b948a54","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"ThinPrint Елементи от менюто ","descFull":"ThinPrint Елементи от менюто  ThinPrint  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Enable ThinPrint (Активирайте ThinPrint) Off (Изкл.) * On (Вкл.) Отпечатване с ThinPrint. Номер на порт 4000 – 4999 (4000*) Задава номера на порта за сървъра ThinPrint. Честотна лента (бита/сек.) 100 – 1 000 000 (0*) Задава скоростта за предаване на данни в средата ThinPrint. Размер на пакета (килобайта) 0 – 64000 (0*) Задава размера на пакета за предаване на данни. меню ThinPrint"},{"UUID":"559a514f-c496-46ca-b87a-8349576fbfe5","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"USB Елементи от менюто ","descFull":"USB Елементи от менюто  USB  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. PCL SmartSwitch Off (Изкл.) On (Вкл.) * Задава принтерът автоматично да превключва на „PCL дубликат“, когато полученото от USB порт задание за печат го изисква, без значение от езика на принтера по подразбиране. Когато тази настройка е дезактивирана, принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Setup (Настройка) . PS SmartSwitch Off (Изкл.) On (Вкл.) * Задава принтерът да превключва на PostScript емулация, когато полученото от USB порт задание за печат го изисква, без значение от езика по подразбиране на принтера. Когато тази настройка е дезактивирана, принтерът не преглежда входящите данни и използва езика по подразбиране на принтера, зададен в меню  Setup (Настройка) . Буфер.задание Off (Изкл.) * On (Вкл.) Преди отпечатването запаметете временно заданията за печат в твърдия диск или в интелигентното запаметяващо устройство (ISD). Този елемент от менюто се показва само когато е монтиран твърд диск или ISD. Mac Binary PS (Бинарен PS на Mac) Auto (Автоматично) * On (Вкл.) Off (Изкл.) Задава на принтера да обработва бинарни PostScript задания за печат на Macintosh. Auto (Автоматично)  обработва задания за печат от компютрите, като използва операционна система Windows или Macintosh. Off (Изкл.)  филтрира PostScript заданията за печат чрез стандартния протокол. Активиране на USB порт Off (Изкл.) On (Вкл.) * Активиране на предния порт за USB устройство. меню USB"},{"UUID":"99c87212-6fc1-4e33-81b6-71a9d58e1421","title":"Мрежа/портове","link":"network-overview-topic.html","desc":"Ограничаване на външен достъп до","descFull":"Ограничаване на външен достъп до мрежата Елементи от менюто за настройки  Ограничаване на външен достъп до мрежата  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Ограничаване на външен достъп до мрежата Изкл. * Вкл. Ограничаване на достъпа до места в мрежата. Външен мрежов адрес Посочване на мрежовите адреси с ограничен достъп. Имейл адрес за известия Посочване на имейл адреса, на който да се изпращат известия за вписани събития. Честота на PING 1-300 (10*) Посочване на интервала за заявки към мрежата в секунди. Тема Посочете темата и съобщението на имейла за уведомяване. Съобщение меню Ограничаване на външен достъп до мрежата"},{"UUID":"bc5c475a-98b7-42e9-b3bc-574abebbec81","title":"Методи за влизане","link":"login-methods-subgroup.html","desc":"Управление на разрешения Елементи от","descFull":"Управление на разрешения Елементи от меню  Manage Permissions (Управление на разрешения)  и техните описания Елемент от меню Описание Достъп до функции Access Address Book in Apps (Достъп до адресника в приложенията) Промяна на адресник Управление на бързи команди Създав. профили Manage Bookmarks (Управление на маркери) Печатане от флаш устройство Сканиране от флаш устройство Функция Копиране Премахване на цвят E‑mail Function (Функция Имейл) Функция Факс FTP функция Освобождаване на задържани факсове Достъп до задържани задания User Profiles (Потребителски профили) Отмяна задания в у-вото Смяна на език Протокол за интернет печат (IPP) Initiate Scans Remotely (Започнете сканирания дистанционно) B/W Print (Черно-бял печат) Сканиране на мрежова папка Контролира достъпа до функциите на принтера. Административни менюта Security Menu (Меню за сигурност) Network/Ports Menu (Меню мрежа/портове) Меню „Хартия“ Меню Reports (Отчети) Function Configuration Menus (Менюта конфигуриране на функция) Меню Supplies (Консумативи) „Допъл.карта“ SE меню Menu Device (Меню устройство) Контролира достъпа до настройките за менюто на принтера. Управление на устройства Външно управление Актуал.фърмуер Apps Configuration (Конфигуриране на приложения) Заключ. операторски панел Достъп до Embedded Web Server Import/Export All Settings (Импортиране/експортиране на всички настройки) Изтр. при неизправност Регистрация за услуги в облака Контролира достъпа до опциите за управление на принтера. Прил. New Apps (Нови приложения) Scan Center (Център за сканиране) Scan Center Custom (Персонализиран център за сканиране) [x] Контролира достъпа до приложенията на принтера. меню Управление на разрешения"},{"UUID":"7455b3a5-eb38-4fdc-ad8f-353b01f77dd2","title":"Методи за влизане","link":"login-methods-subgroup.html","desc":"Local Accounts (Локални акаунти) Елементи","descFull":"Local Accounts (Локални акаунти) Елементи от меню Локални акаунти и техните описания Елемент от меню Описание Manage Groups/Permissions (Управление на групи/разрешения) Добавяне на група Import Access Controls (Контроли за достъп при импортиране) Достъп до функции Административни менюта Управление на устройства All Users (Всички потребители) Import Access Controls (Контроли за достъп при импортиране) Достъп до функции Административни менюта Управление на устройства Admin (Администратор) Контролира достъпа на групи или потребители до функции, приложения и настройки за сигурност на принтера. Add User (Добавяне на потребител) User Name/Password (Потребителско име/парола) Потребителско име Парола ПИН Създава локални акаунти за управление на достъпа до функциите на принтера. User Name/Password Accounts (Акаунти за потребителско име/парола) Add User (Добавяне на потребител) User Name Accounts (Акаунти за потребителско име) Add User (Добавяне на потребител) Password Accounts (Акаунти за парола) Add User (Добавяне на потребител) PIN Accounts (Акаунти с ПИН) Add User (Добавяне на потребител) меню Local Accounts (Локални акаунти)"},{"UUID":"9ab599b8-a594-43be-83db-a8fa382236bc","title":"Защита","link":"login-methods-subgroup.html","desc":"Планиране на USB устройства Елемент","descFull":"Планиране на USB устройства Елемент на менюто  Schedule USB Devices (Планиране на USB устройства)  и неговото описание Елемент от меню Описание Schedules (Планове) Add New Schedule (Добавяне на нов график) Планира достъп до предния USB порт. меню Планиране на USB устройства"},{"UUID":"822b355c-8a55-4fc0-8ea2-b1743bd2f280","title":"Защита","link":"login-methods-subgroup.html","desc":"Дневник на проведена защита Елементи","descFull":"Дневник на проведена защита Елементи от менюто  Security Audit Log (Регистър на проведената защита)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Вкл.проверка Off (Изкл.) * On (Вкл.) Записва събитията в сигурен дневник на проверките и дистанционен системен регистър (syslog). Вкл.външ.Syslog Off (Изкл.) * On (Вкл.) Изпраща дневник на проверки до дистанционен сървър. Външ.Syslog сърв. Определя сървъра на дистанционния системен регистър. Външ.Syslog порт 1 – 65535 (514*) Определя порта на дистанционния системен регистър. Външ.Syslog метод Normal UDP (Нормален UDP) * Stunnel Определя метода, чрез който системният регистър изпраща регистрирани събития до дистанционен сървър. Външ.Syslog съоръж. 0 - Kernel Messages (Основни съобщения) 1 - User‑Level Messages (Съобщения ниво – потребител) 2 - Mail System (Система за имейл) 3 - System Daemons (Системни демони) 4 – Security/Authorization Messages (Съобщения за защита/оторизация) * 5 – Messages Generated Internally by Syslogs (Съобщения, генерирани вътрешно от системния регистър) 6 – Line Printer Subsystem (Подсистема линеен принтер) 7- Network News Subsystem (Подсистема мрежови новини) 8 - UUCP Subsystem (Подсистема UUCP) 9 - Clock Daemon (Часовников демон) 10 – Security/Authorization Messages (Съобщения за защита/оторизация) 11 - FTP Daemon (FTP демон) 12 – NTP Subsystem (Подсистема NTP) 13 – Log Audit (Проверка на дневника) 14 – Log Alert (Сигнал за дневник) 15 - Clock Daemon (Часовников демон) 16 – Local Use 0 (local0) (Местно, използвай 0 (местно0) 17 – Local Use 1 (local1) (Местно, използвай 1 (местно1) 18 – Local Use 2 (local2) (Местно, използвай 2 (местно2) 19 – Local Use 3 (local3) (Местно, използвай 3 (местно3) 20 – Local Use 4 (local4) (Местно, използвай 4 (местно4) 21 – Local Use 5 (local5) (Местно, използвай 5 (местно5) 22 – Local Use 6 (local6) (Местно, използвай 6 (местно6) 23 – Local Use 7 (local7) (Местно, използвай 7 (местно7) Определя код на устройството, което принтерът използва при изпращане на събития от дневника до дистанционен сървър. Сериозност на събития, които да се записват в дневника 0 - Emergency (Спешно) 1 - Alert (Внимание) 2 - Critical (Критично) 3 - Error (Грешка) 4 – Warning (Предупреждение) * 5 - Notice (Известие) 6 - Informational (Информационно) 7 - Debug (Отстраняване на грешки) Определя границата за приоритетно ниво за регистриране на съобщения и събития. Remote Syslog Non‑Logged Events (Събития, незаписани в дневника на дистанционния системен регистър) Off (Изкл.) * On (Вкл.) Изпраща всички събития, независимо от нивото на тежест, до дистанционния сървър. Admin’s E‑mail Address (Имейл адрес на администратора) Изпраща известие по имейл за регистрираните събития до администратора. E‑mail Log Cleared Alert (Имейл сигнал за изтрит дневник) Off (Изкл.) * On (Вкл.) Изпраща известие по имейл до администратора при изтриване на запис от дневника. E‑mail Log Wrapped Alert (Имейл сигнал за запис върху дневник) Off (Изкл.) * On (Вкл.) Изпраща известие по имейл до администратора, когато дневникът се запълни и започне да презаписва върху най-старите записи. Log Full Behavior (Поведение при пълен дневник) Wrap Over Oldest Entries (Пренасяне на най-старите записи) * E‑mail Log Then Delete All Entries (Изпращане на дневника по имейл и изтриване на всички записи) Решава проблемите със съхранението, когато дневникът запълни разпределената му памет. E‑mail % Full Alert (Сигнал за пълна имейл кутия %) Off (Изкл.) * On (Вкл.) Изпраща известие по имейл до администратора, когато дневникът запълни разпределената му памет. % Full Alert Level (Ниво на сигнал за % пълна памет) 1 – 99 (90*) E‑mail Log Exported Alert (Имейл сигнал за експортиран дневник) Off (Изкл.) * On (Вкл.) Изпраща известие по имейл до администратора при експортиране на дневник. E‑mail Log Settings Changed Alert (Имейл сигнал за променени настройки на дневник) Off (Изкл.) * On (Вкл.) Изпраща известие по имейл до администратора при задаване на  Enable Audit (Разрешаване на проверка) . Log Line Endings (Окончателни записи) LF (\\n) * CR (\\r) CRLF (\\r\\n) Определя как файлът от регистър прекратява края на всеки ред. Digitally Sign Exports (Цифров подпис на експорта) Off (Изкл.) * On (Вкл.) Добавя цифров подпис към всеки експортиран файл от регистъра. Clear Log (Изчистване на дневник) Изтрива всички дневници от проверки. Днев.експорт Syslog (RFC 5424) (Системен регистър (RFC 5424) Syslog (RFC 3164) (Системен регистър (RFC 3164) CSV (Стойности, разделени със запетая) Експортира регистър за сигурност до флаш устройство. меню Дневник на проведена защита"},{"UUID":"9c601616-a772-41cc-8db3-77917e6ebe85","title":"Защита","link":"login-methods-subgroup.html","desc":"Ограничения за вход Елементи от","descFull":"Ограничения за вход Елементи от меню  Ограничения за влизане  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Неуспешни опити за вход 1 – 10 (3*) Задава броя неуспешни опити за влизане, преди потребителят да бъде блокиран. Недостатъчно време 1–60 minutes (5*) (1 – 60 минути (5*) Задава времевата рамка между неуспешните опити за влизане, преди потребителят да бъде блокиран. Време за заключване 1–60 minutes (5*) (1 – 60 минути (5*) Задава времето за заключване. Web Login Timeout (Край на време за уеб влизане) 1–120 minutes (10*) (1 – 120 минути (10*) Задава закъснението за дистанционно влизане, преди потребителят да бъде изключен автоматично. меню Ограничения за вход"},{"UUID":"0287e430-f1aa-46fb-a1dd-775a0bf4c679","title":"Защита","link":"login-methods-subgroup.html","desc":"Настройка на поверителен печат Елементи","descFull":"Настройка на поверителен печат Елементи от меню  Настройка на поверителен печат  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Макс. невалидни PIN кодове 2–10 Задава ограничение за въвеждане на невалиден PIN. Когато се достигне лимитът, заданията за печат за това потребителско име се изтриват. Срок на поверително задание Off (Изкл.) * 1 Hour (1 час) 4 Hours (4 часа) 24 Hours (24 часа) 1 Week (1 седмица) Задава индивидуален срок за всяко задържано задание, преди да бъде изтрито автоматично от твърдия диск или от интелигентното запаметяващо устройство. Задържаното задание е  Confidential (Поверително) ,  Repeat (Повторение) ,  Reserve (Резервно)  или  Verify (Проверка) . Повтаряне на срока на задание Off (Изкл.) * 1 Hour (1 час) 4 Hours (4 часа) 24 Hours (24 часа) 1 Week (1 седмица) Задава срока за заданието за печат, което желаете да повторите. Потвърждаване на крайния срок на задание Off (Изкл.) * 1 Hour (1 час) 4 Hours (4 часа) 24 Hours (24 часа) 1 Week (1 седмица) Задава срока за отпечатване на копие на задание, за да проверите качеството му, преди да отпечатате останалите копия. Резервиране на срока на задание Off (Изкл.) * 1 Hour (1 час) 4 Hours (4 часа) 24 Hours (24 часа) 1 Week (1 седмица) Задава срока за задания, които желаете да запаметите в принтера за отпечатване по-късно. Require All Jobs to be Held (Изискване всички задания да бъдат задържани) Off (Изкл.) * On (Вкл.) Настройва принтера да задържи всички задания за печат. Запазване на дублирани документи Off (Изкл.) * On (Вкл.) Задава принтерът да запази всички документи със същото име на файл. меню Настройка на поверителен печат"},{"UUID":"0cba74d8-aaee-4f04-9066-d7339f1d0e45","title":"Защита","link":"login-methods-subgroup.html","desc":"Кодиране диск Този елемент от","descFull":"Кодиране диск Този елемент от менюто се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство. Елементи от меню  Disk Encryption (Шифроване на диск)  и техните описания Елемент от меню Описание Твърд диск Показва състоянието на кодиране на твърдия диск или на интелигентното запаметяващо устройство. Интелигентно запаметяващо устройство меню Кодиране диск"},{"UUID":"5064e8b9-ee6e-4cda-ad77-3cc1a77ddb14","title":"Защита","link":"login-methods-subgroup.html","desc":"Изтр. временни файлове Елементи на","descFull":"Изтр. временни файлове Елементи на меню  Изтриване на временни файлове с данни  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Stored in onboard memory (Съхранени в паметта на машината) Изкл. * Вкл. Изтрива всички файлове, съхранени в паметта на принтера. меню Изтр. временни файлове"},{"UUID":"3854eede-4f99-4981-9f8d-8ffe6219e9a7","title":"Защита","link":"login-methods-subgroup.html","desc":"Решения за настройки на LDAP","descFull":"Решения за настройки на LDAP Елементи от меню  Solutions LDAP Settings (Решения за настройки на LDAP)  и техните описания Елемент от меню Описание Следване на LDAP препращания Off (Изкл.) * On (Вкл.) Търсене в различните сървъри в домейна на профили на потребители, които са влезнали. Удостоверяване на LDAP сертификат Yes (Да) No (Не) * Активиране на проверка на LDAP сертификати. меню Решения за настройки на LDAP"},{"UUID":"0ea213b1-4d86-4e09-9609-ecd388459221","title":"Защита","link":"login-methods-subgroup.html","desc":"Разни Елементи от меню ","descFull":"Разни Елементи от меню  Разни  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Защитени функции Show (Показване) * Скриване Показва всички функции, които „Контрол на достъп до функции (FAC)“ защитава независимо от разрешението за сигурност, което потребителя има. Hide (Скриване)  показва само защитени с FAC функции, до които има достъп потребителят. Разрешение за отпечатване Off (Изкл.) * On (Вкл.) Оставя потребителя да влезе преди печат. Влизане по подразбиране в „Разрешение за печат“ PIN (ПИН) * User Name/Password (Потребителско име/парола) Потребителско име Задава влизането по подразбиране в  Print Permission (Разрешение за отпечатване) . Security Reset Jumper (Джъмпер за нулиране на защитата) Enable “Guest” access (Разрешаване на достъп на „Гост“) * No Effect (Няма ефект) Посочете потребителски достъп до принтера. Enable \"Guest\" access (Разрешаване на достъп на „Гост“)  позволява възстановяване на устройството, ако паролата на администратора е изгубена. Ако проблемът остане, се свържете с центъра за поддръжка на клиенти. No effect (Няма ефект)  предотвратява използването на защитния джъмпер за възстановяване на устройството. Този елемент от менюто се появява само когато има монтирана актуална хардуерна опция за джъмпер за защита. Използване на интелигентно запаметяващо устройство за потребителски данни Off (Изкл.) On (Вкл.) * Разрешава на интелигентното запаметяващо устройство да запаметява потребителски данни. Този елемент от менюто се показва само когато е инсталирано интелигентно запаметяващо устройство. Minimum Password Length (Минимална дължина на паролата) 0 – 32 (0*) Посочете дължината на паролата. Разрешаване на показването на паролата/PIN Off (Изкл.) * On (Вкл.) Покажете паролата или персоналния идентификационен номер. меню Разни"},{"UUID":"86294050-89ad-4342-b1cc-c3d3a3b995e5","title":"Услуги в облака","link":"cloud-services-enrollment-topic.html","desc":"Регистрация за услуги в облака","descFull":"Регистрация за услуги в облака Елементи от менюто  Cloud Services Enrollment (Регистрация за услуги в облака)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Преглед на допълнителна информация Преглед на допълнителна информация за използването на услуги в облака на Lexmark. Разрешаване на комуникация с услуги в облака на Lexmark Off (Изкл.) * On (Вкл.) Разрешава на принтера да комуникира с услуги в облака на Lexmark. Преглед на текущото състояние Преглед на състоянието на връзката между принтера и услуги в облака на Lexmark. меню Регистрация за услуги в облака"},{"UUID":"a0120503-2318-4b74-9806-acfb5bf06bf0","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Стр. с настр. на меню","descFull":"Стр. с настр. на меню Елемент от менюто  Страница с настройки на менюто  и описанието му Елемент от меню Описание Стр. с настр. на меню Отпечатване на отчет, който съдържа менютата на принтера. меню Стр. с настр. на меню"},{"UUID":"7c093f31-015a-438d-954e-47df0666749f","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Устройство Устройство Елементи от менюто","descFull":"Устройство Устройство Елементи от менюто  Устройство  и техните описания Елемент от меню Описание Информация за устройството Отпечатване на отчет, съдържащ информация за принтера. Статистики за устройството Отпечатване на отчет за използването на принтера и статуса на консумативите. Списък профили Отпечатване на списък с профили, съхранени в принтера. Отчет за актив Отпечатва диагностичен инструмент за проблеми с печата. За да избегнете изрязването на съдържанието, отпечатайте отчета на хартия с размер Letter или A4. меню Устройство"},{"UUID":"535b535f-8471-4e89-98c6-56a8de715711","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Печат Елементи от меню ","descFull":"Печат Елементи от меню  Print (Отпечатване)  и техните описания Елемент от меню Описание Шрифт печат PCL шрифтове PS шрифтове Печатни мостри и информация за наличните шрифтове за всеки език на принтера. Демо печат Демо стр. Отпечатайте страница, която показва възможностите на принтера и поддържаните решения. Печат указател Отпечатва ресурсите, които се запаметяват във флаш устройството, твърдия диск или интелигентното запаметяващо устройство (ISD). Този елемент от менюто се показва само ако е монтирано флаш устройство, твърд диск или ISD. меню Печат"},{"UUID":"ff060d18-a5a0-47c4-b7c8-be49b2f64aac","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Бързи команди Елементи от меню","descFull":"Бързи команди Елементи от меню  Бързи команди  и техните описания Елемент от меню Описание Всички бързи команди Отпечатване на справка, която изброява бързите команди, съхранени в принтера. Бързи команди факс Бързи команди копиране Бързи команди имейл FTP бързи команди Бърза команда за мрежова папка меню Бързи команди"},{"UUID":"0bccf6d8-06e5-4cb4-9ec8-ce48ab16454a","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Факс Това меню се появява","descFull":"Факс Това меню се появява само ако е конфигуриран Fax (Факс), а  Enable Job Log (Разрешаване на дневник на заданията)  и  Enable Call Log (Разрешаване на дневник на повикванията)  са зададени на  On (Вкл.) . Елементи от менюто  Факс  и техните описания Елемент от меню Описание Дневник задания факс Отпечатване на отчет за последните 200 изпълнени задания за факс. Дневник повик. факс Отпечатване на отчет за последните 100 опитани, получени и блокирани обаждания. меню Факс"},{"UUID":"58f3dfcc-0685-4811-bec4-c4f10cb9b92d","title":"Отчети","link":"menu-settings-page-topic.html","desc":"Мрежа Елемент от менюто ","descFull":"Мрежа Елемент от менюто  Мрежа  и описанието му Елемент от меню Описание Страница за настройка на мрежата Отпечатване на страница, показваща конфигурираната мрежа и безжичните настройки по принтера. Елементът на това меню е наличен само в мрежовите принтери или принтери, свързани със сървърите за печат. Свързани клиенти чрез Wi‑Fi Direct Отпечатване на страница със списък на устройствата, които са свързани към принтера чрез Wi‑Fi Direct. Този елемент от менюто се появява само когато  Разрешаване на Wi‑Fi Direct  е зададено на  Вкл . меню Мрежа"},{"UUID":"521a465b-7e74-4429-89f2-9df03790d087","title":"Използване на менютата на принтера","link":"troubleshooting-menu-topic.html","desc":"Откриване и отстраняване на неизправности","descFull":"Откриване и отстраняване на неизправности Елементи от менюто Troubleshooting (Отстраняване на неизправности) и техните описания Елемент от меню Описание Тестови страници за качество на печат Отпечатайте пробни страници, за да идентифицирате и коригирате дефектите в качеството на печата. Почистване на скенера Отпечатайте инструкции за това как да почиствате на скенера. меню Откриване и отстраняване на неизправности Тестови страници за качество на печат Почистване на скенера"},{"UUID":"e2f22711-d0d9-4589-9737-f170976945cc","title":"Използване на менютата на принтера","link":"forms-merge-topic.html","desc":"Forms Merge (Обединяване на формуляри)","descFull":"Forms Merge (Обединяване на формуляри) Това меню се показва само когато е монтиран твърд диск или интелигентно запаметяващо устройство. Елементи от менюто  Forms Merge (Обединяване на формуляри)  и техните описания Елемент от меню Описание Звездичка (*) до стойността указва фабричната настройка по подразбиране. Merge Mode (Режим на обединяване) Print (Отпечатване) * Data Capture (Събиране на данни) Disabled (Забранено) Определя режима на работа за Forms Merge (Обединяване на формуляри). Data Capture Target (Цел за събиране на данни) Flash (Флаш устройства)* Задава целевата дестинация, към която се препращат събраните данни. Този елемент от менюто се появява само когато Merge Mode (Режим на обединяване) е зададен на Data Capture (Събиране на данни). Print Port and Filter Settings (Настройки на порта за отпечатване и филтъра) Network Port (Мрежов порт) On (Вкл.) * Off (Изкл.) Разрешава Forms Merge (Обединяване на формуляри), за да се обработват всички данни, които се изпращат към мрежовия порт. Print Port and Filter Settings (Настройки на порта за отпечатване и филтъра) Network Filter (Мрежов филтър) Disabled (Забранено) * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Определя мрежовия филтър за всички данни, изпращани към принтера. Print Port and Filter Settings (Настройки на порта за отпечатване и филтъра) USB порт On (Вкл.) * Off (Изкл.) Разрешава Forms Merge (Обединяване на формуляри), за да се обработват всички данни, които се изпращат към USB порта. Print Port and Filter Settings (Настройки на порта за отпечатване и филтъра) USB Filter (USB филтър) Disabled (Забранено) * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Определя USB филтъра за всички данни, изпращани към принтера. Print Port and Filter Settings (Настройки на порта за отпечатване и филтъра) Local Port Timeout (Време на изчакване на локален порт) 1–100 (10*) Определя стойността на времето на изчакване за задачите за Forms Merge (Обединяване на формуляри), които се изпращат към локалния порт. Разни Print All Forms (Отпечатване на всички формуляри) Отпечатва всички списъци с формуляри, съхранени на интелигентното запаметяващо устройство или на твърдия диск на принтера. Разни Error Page Print (Отпечатване на страница с грешки) On (Вкл.) * Off (Изкл.) Разрешава отпечатването на страница с грешки при възникване на грешка в задача за Forms Merge (Обединяване на формуляри). меню Forms Merge (Обединяване на формуляри)"},{"UUID":"8918e33c-2413-49ae-a6cf-d9fb232ab5f9","title":"Използване на менютата на принтера","link":"printing-menu-settings-page-topic.html","desc":"Отпечатване на  страница с","descFull":"Отпечатване на  страница с настройки на менюто От началния екран докоснете  Settings (Настройки) Reports (Отчети)  Menu Settings Page (Страница с настройки на менюто) . отпечатване Стр. с настр. на меню Стр. с настр. на меню отпечатване менюта на принтера"},{"UUID":"8cdfc57e-c337-4226-8209-14a920e93b82","title":"Поддръжка на принтера","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Проверка на състоянието на части","descFull":"Проверка на състоянието на части и консумативи От началния екран докоснете  Status/Supplies (Състояние/консумативи) . Изберете детайлите или консумативите, които желаете да проверите. Можете също да имате достъп до тази настройка, като докоснете горната част на началния екран. проверка на състоянието на части и консумативи състояние на консумативите проверка статус на частите проверка"},{"UUID":"9d06beee-12a1-4c34-99ad-59bc6bad9bd4","title":"Поддръжка на принтера","link":"configuring-supply-notifications-topic.html","desc":"Конфигуриране на известия за консумативи","descFull":"Конфигуриране на известия за консумативи Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Щракнете върху  Настройки Устройство Известия . От меню Консумативи щракнете върху  Персонализирани известия за консумативи . Изберете известие за всеки консуматив. Приложете промените. известявания за консумативи конфигуриране конфигуриране на уведомления за консумативи"},{"UUID":"148c28b0-99ba-4d9e-98d7-e6507383f277","title":"Поддръжка на принтера","link":"setting-up-e-mail-alert-topic.html","desc":"Конфигуриране на уведомления с имейл","descFull":"Конфигуриране на уведомления с имейл Конфигурирайте принтера да изпраща имейл уведомления, когато консумативите са на привършване, когато хартията трябва да бъде сменена или добавена или когато има заседнала хартия. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран на принтера. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Settings (Настройки) Device (Устройство) Notifications (Известия) E‑mail Alert Setup (Конфигуриране на имейл уведомления) , след което конфигурирайте настройките. За повече информация относно SMTP настройки се свържете с Вашия имейл доставчик. Приложете промените. Щракнете върху  Задаване на имейл списъци и уведомления , след което конфигурирайте настройките. Приложете промените. уведомления с имейл настройване конфигуриране на уведомления с имейл"},{"UUID":"fd1fc4b6-e127-4d1c-9f47-b635ddcb4a8a","title":"Поддръжка на принтера","link":"viewing-reports-topic.html","desc":"Преглед на отчетите От началния","descFull":"Преглед на отчетите От началния екран докоснете  Settings (Настройки) Reports (Отчети) . Изберете отчета, който желаете да прегледате. преглед на отчетите отчети състояние на принтера отчети използване на принтера"},{"UUID":"387fcde8-6664-45e9-a8ee-d2cf124b22b8","title":"Поръчване на части и консумативи","link":"ordering-supplies-group.html","desc":"За да поръчате консумативи в","descFull":"За да поръчате консумативи в САЩ, свържете се с Lexmark на 1-800-539-6275 за информация относно оторизирани доставчици на консумативи Lexmark във Вашия регион. Ако се намирате в друга държава или регион, отидете на  www.lexmark.com  или се свържете с мястото, откъдето сте закупили принтера. За да поръчате консумативи, се свържете с мястото, откъдето сте закупили принтера. Очакваната трайност на консумативите на принтера е съобразена с печатане на обикновена хартия с размер А4 или letter. Неуспешното поддържане на оптимална работа на принтера или неподменянето на части и консумативи може да доведе до повреда на вашия принтер. оригинални части и консумативи"},{"UUID":"5959f030-67c9-4b2d-ac40-8113c8c6d63d","title":"Поръчване на части и консумативи","link":"ordering-supplies-group.html","desc":"Употреба на оригинални части и","descFull":"Употреба на оригинални части и консумативи Lexmark Вашият принтер Lexmark е проектиран за най-добра работа с оригинални части и консумативи на Lexmark. Използването на консумативи и части от трети страни може да повлияе на качеството на работа, надеждността или живота на принтера и неговите компоненти. Може също да засегне покритието на гаранцията. Повреди, причинени от използването на части и консумативи от трети страни, не се покриват от гаранцията. Всички показатели за срока на експлоатация са проектирани за работа с части и консумативи на Lexmark и може да предоставят неочаквани резултати, ако се използват части и консумативи от трети страни. Използването на модула за изображения извън предназначения срок на експлоатация може да повреди вашия принтер Lexmark или свързаните с него компоненти. Консумативи и части, които не са обхванати от споразумение по програма за връщане, могат да бъдат нулирани и преработени. Гаранцията на производителя обаче не покрива щети, причинени от употребата на неоригинални консумативи или части. Нулирането на броячите за консумативи или части без правилно преработване може да причини повреда на Вашия принтер. След нулиране на брояча за консумативи или части Вашият принтер може да покаже грешка на дисплея, според която нулираният елемент е още наличен. употреба на оригинални части и консумативи Lexmark оригинални части и консумативи Lexmark"},{"UUID":"c9d4509c-2732-43f8-8d9f-e64e02f28f5f","title":"Поръчване на части и консумативи","link":"ordering-supplies-group.html","desc":"Поръчване на касета с тонер","descFull":"Поръчване на касета с тонер Прогнозираният капацитет на касетата е въз основа на стандарт ISO/IEC 19752. Изключително ниското покритие на отпечатване за продължителен период от време може да се отрази негативно на действителния капацитет. За да поръчате касета с тонер, се свържете с мястото, откъдето сте закупили принтера. Касети с тонер MX532 от програмата за връщане на Lexmark Елемент САЩ и Канада Европейска икономическа зона, Исландия, Лихтенщайн и Норвегия Останалата част от Тихоокеанска Азия Латинска Америка Останалата част от Европа, Близкия изток и Африка Тонер касета от програма за връщане 66S1000 66S2000 66S3000 66S4000 66S5000 Тонер касета с висок капацитет от програмата за връщане 66S1H00 66S2H00 66S3H00 66S4H00 66S5H00 Обикновена касета с тонер MX532 на Lexmark Елемент По света Обикновена касета с тонер с висок капацитет 66S0HA0 Касети с тонер MX632 от програмата за връщане на Lexmark Елемент САЩ и Канада Европейска икономическа зона, Исландия, Лихтенщайн и Норвегия Останалата част от Тихоокеанска Азия Латинска Америка Останалата част от Европа, Близкия изток и Африка Тонер касета от програма за връщане 66S1000 66S2000 66S3000 66S4000 66S5000 Тонер касета с много висок капацитет от програмата за връщане 66S1X00 66S2X00 66S3X00 66S4X00 66S5X00 Обикновена касета с тонер MX632 на Lexmark Елемент По света Обикновена касета с тонер с много висок капацитет 66S0XA0 Касети с тонер XM3350 от програмата за връщане на Lexmark Елемент САЩ и Канада Европейска икономическа зона, Исландия, Лихтенщайн и Норвегия Останалата част на света Тонер касета с много висок капацитет от програмата за връщане 24B7541 24B7542 24B7543 поръчка на консумативи касета с тонер касета с тонер поръчване"},{"UUID":"0b17ee30-d2fe-4219-b4d3-95cd5a60409c","title":"Поръчване на части и консумативи","link":"ordering-supplies-group.html","desc":"Поръчка на модул за изображения","descFull":"Поръчка на модул за изображения Изключително слабото покритие на отпечатване за продължителен период от време може да доведе до неизправност на частите на модула за изображения преди изчерпване на тонера. За да поръчате модул за изображения, се свържете с мястото, откъдето сте закупили принтера. Консуматив за принтера и номер на част Елемент Партиден номер Обикновен модул за изображения 66S0ZA0 фотобарабан поръчване поръчка на консумативи фотобарабан"},{"UUID":"8e34093a-a78d-4386-bb7e-5c05cbf28f8d","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на касетата с тонер","descFull":"Смяна на касетата с тонер Отворете вратичка А. Отстранете използваната касета с тонер. Разопаковайте новата касета с тонер. Разклатете тонер касетата, за да разпределите тонера. Поставете новата касета с тонер. Затворете вратичка А. касета с тонер замяна подмяна на консумативи касета с тонер"},{"UUID":"c5b3d90d-8901-4ac2-abc4-4b4ace758e8e","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Подмяна на модула за изображения","descFull":"Подмяна на модула за изображения Отворете вратичка А. Отстранете касетата с тонер. Отстранете използвания модул за изображения. Разопаковайте новия модул за изображения. Разклатете модула за изображения, за да разпределите тонера. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте фоточувствителния барабан. Това може да се отрази на качеството на бъдещите задания за печат. Поставете новия модул за изображения. Вкарайте касетата с тонер. Затворете вратичка А. фотобарабан замяна подмяна на консумативи фотобарабан"},{"UUID":"4189a275-6226-4202-9b7e-c37547001561","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на патрона със скоби","descFull":"Смяна на патрона със скоби за телбод Отворете вратичката за достъп до универсалното телбод устройство. Отстранете касетата със скоби за телбод. Отстранете празния патрон със скоби за телбод. Поставете новия патрон със скоби за телбод, докато щракне на мястото си. Поставете касетата със скоби за телбод и след това затворете вратичката за достъп до универсалното телбод устройство. Проверете състоянието на светодиодния индикатор. Универсалното телбод устройство е готово за използване, когато светне синята светлина. патрон със скоби за телбод замяна смяна на патрона със скоби за телбод"},{"UUID":"bf200c19-e747-4e29-984a-db11dd6ba7a9","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на захранващото устройство на","descFull":"Смяна на захранващото устройство на универсалното телбод устройство Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Изключете захранващото устройство от електрическия контакт. Отстранете капака на колоната и захранващия кабел. Отстранете универсалното телбод устройство. Отстранете използваното захранващо устройство. Разопаковайте новото захранващо устройство. Поставете новото захранващо устройство в принтера и след това го свържете към универсалното телбод устройство. Монтирайте универсалното телбод устройство. Позиционирайте правилно захранващото устройство. Закрепете капака на колоната. Фиксирайте правилно захранващото устройство. Свържете единия край на захранващия кабел на телбод устройството към захранващото устройство, а след това другия край към електрическия контакт. Свържете единия край на захранващия кабел на принтера към принтера, а след това другия край към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. захранване замяна смяна на захранващото устройство"},{"UUID":"40c0070b-d65d-43e3-b55a-17b6bc64da43","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на безжичния сървър за","descFull":"Смяна на безжичния сървър за печат  MarkNet  N8450 За да избегнете риска от токов удар при достъп до платката на контролера или при инсталирането на допълнителен хардуер или устройство за памет, след като сте настроили принтера, изключете го и извадете захранващия кабел от електрическия контакт, преди да продължите. Ако има други устройства, свързани към принтера, изключете ги и извадете кабелите, които ги свързват с принтера. За тази цел се нуждаете от отвертка с плоска глава. Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Отворете капака за достъп до контролерната платка. Електронните компоненти на платката на контролера се повреждат лесно от статично електричество. Докоснете метална повърхност на принтера, преди да докоснете каквито и да е компоненти или конектори на платката на контролера. Отстранете капака на безжичния сървър за печат. Отстранете факс-платката. Отстранете използвания безжичен сървър за печат. Разопаковайте новия безжичен сървър за печат. Поставете новия безжичен сървър за печат, докато същият  щракне  на мястото си. Поставете факс-платката и след това монтирайте винтовете. Закрепете капака на безжичния сървър за печат, след което монтирайте винта. Затворете капака за достъп до контролерната платка, след което монтирайте винта. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. безжичен сървър за печат замяна смяна на безжичния сървър за печат Безжичен сървър за печат MarkNet N8450"},{"UUID":"8543cb2e-56f5-4c02-ba9f-2b0e4063a102","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Подмяна на гумите за поемане","descFull":"Подмяна на гумите за поемане Изключете принтера. Извадете кабела за захранване от електрическия контакт и след това от принтера. Извадете тавата. Извадете използваните гуми за поемане. Разопаковайте новите гуми за поемане. Поставете новите гуми за поемане. Поставете тавата. Свържете захранващия кабел към принтера, а след това и към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Включете принтера. гуми за поемане замяна подмяна на части гуми за поемане"},{"UUID":"ebb0379d-b869-455b-86db-e44fb69b9abd","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на подложката на стъклото","descFull":"Смяна на подложката на стъклото на скенера Отворете капака на скенера. Отстранете използваната подложка на стъклото на скенера. Разопаковайте новата подложка на стъклото на скенера. Подравнете новата подложка на стъклото на скенера към стъклото на скенера. Затворете капака на скенера, за да се закрепи новата подложка на стъклото на скенера. Отворете капака на скенера. Приложете натиск върху подложката на стъклото на скенера, за да я фиксирате. Затворете капака на скенера. подложка на стъклото на скенера замяна подмяна на части подложка на стъклото на скенера"},{"UUID":"2b6dd6c6-f626-480f-9273-53b12df019a3","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Смяна на ролките на АПУ","descFull":"Смяна на ролките на АПУ Отворете вратичка С. Отстранете използваната поемаща ролка на АПУ. Отстраняване на използваната разделителна ролка на АПУ. Разопаковайте новите поемаща ролка на АПУ и разделителна ролка на АПУ. Вкарвайте новата разделителна ролка на АПУ, докато  кликне  на място. Вкарвайте новата поемаща ролка на АПУ, докато  кликне  на място. Затворете вратичка С. подмяна на части Ролки на ADF Ролки на ADF замяна подмяна на части Поемаща ролка на АПУ Поемаща ролка на АПУ замяна подмяна на части Разделителна ролка на АПУ Разделителна ролка на АПУ замяна"},{"UUID":"10ea698e-9c58-4341-a565-c980c86e88d2","title":"Замяна на части и консумативи","link":"replacing-toner-cartridge-topic.html","desc":"Нулиране на броячите за използването","descFull":"Нулиране на броячите за използването на консумативи От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Supply Usage And Counters (Използване на консумативи и броячи) . Изберете брояча, който искате да нулирате. Консумативи и части, които не са обхванати от споразумение по програма за връщане, могат да бъдат нулирани и преработени. Гаранцията на производителя обаче не покрива щети, причинени от употребата на неоригинални консумативи или части. Нулирането на броячите за консумативи или части без правилно преработване може да причини повреда на Вашия принтер. След нулиране на брояча за консумативи или части Вашият принтер може да покаже грешка на дисплея, според която нулираният елемент е още наличен. Консумативи и части, които не са обхванати от споразумение по програма за използване и връщане, може да бъдат нулирани и преработени. Гаранцията на производителя обаче не покрива щети, причинени от употребата на неоригинални консумативи или части. Нулирането на броячите за консумативи или части без правилно преработване може да причини повреда на Вашия принтер. След нулиране на брояча за консумативи или части Вашият принтер може да покаже грешка на дисплея, според която нулираният елемент е още наличен. броячи за използването на консумативи нулиране нулиране на броячите за използването на консумативи"},{"UUID":"4367169d-aa70-465d-bcf5-0130438c9a48","title":"Почистване на частите на принтера","link":"cleaning-printer-topic.html","desc":"Почистване на принтера За да","descFull":"Почистване на принтера За да избегнете опасността от електрически удар при почистване на външните части на принтера, изключете захранващия кабел от контакта в стената и откачете всички кабели от принтера, преди да продължите нататък. Изпълнявайте тази задача на всеки няколко месеца. Щети по принтера, които са причинени от неправилно обслужване, не се покриват от гаранцията на принтера. Изключете принтера и след това извадете кабела от контакта. Извадете хартията от стандартната изходна тава и многоцелевото подаващо устройство. Отстранете прах, влакна и парчета хартия около принтера чрез мека четка или прахосмукачка. Изтрийте външните повърхности на принтера с мокра, мека, немъхеста кърпа. Не използвайте битови почистващи или перилни препарати, тъй като могат да повредят покритието на принтера. Уверете се, че всички части на принтера са сухи след почистване. Включете захранващия кабел в контакт на стената и след това включете принтера. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. почистване на принтера почистване вътрешни части на принтера почистване външни части на принтера"},{"UUID":"1f90b9bf-6515-4b1b-b587-c5868c0768a5","title":"Почистване на частите на принтера","link":"cleaning-printer-topic.html","desc":"Почистване на сензорния екран За","descFull":"Почистване на сензорния екран За да избегнете опасността от електрически удар при почистване на външните части на принтера, изключете захранващия кабел от електрическия контакт и откачете всички кабели от принтера, преди да продължите нататък. Изключете принтера и след това извадете кабела от контакта. Почистете сензорния екран с помощта на влажна, мека и немъхеста кърпа. Не използвайте домакински препарати или почистващи препарати, тъй като те може да повредят сензорния екран. След почистване се уверете, че сензорният екран е сух. Включете захранващия кабел в контакт на стената и след това включете принтера. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. сензорен екран почистване почистване на сензорния екран"},{"UUID":"f60e5898-c214-4185-9684-ac1d0d6c4392","title":"Почистване на частите на принтера","link":"cleaning-printer-topic.html","desc":"Почистване на скенера Отворете капака","descFull":"Почистване на скенера Отворете капака на скенера. Почистете следните зони с помощта на влажна, мека и немъхеста кърпа: Подложката на стъклото на АПУ Подложката на стъклото на скенера Стъкло на АПУ Стъкло на скенера Затворете капака на скенера. Отворете вратичка С. Почистете следните зони с помощта на влажна, мека и немъхеста кърпа: Подложка на стъклото на АПУ във вратичка C Стъкло на АПУ във вратичка C Затворете вратичка С. скенер почистване почистване на скенера"},{"UUID":"e5c939a6-8372-46c0-b2ae-32fb415b9a3c","title":"Почистване на частите на принтера","link":"cleaning-printer-topic.html","desc":"Почистване на ролките на АПУ","descFull":"Почистване на ролките на АПУ Отворете вратичка С. Отстранете поемащата ролка на АПУ. Отстранете разделителната ролка на АПУ. Нанесете изопропилов алкохол върху мека кърпа без власинки, след което избършете поемащата ролка на АПУ и разделителната ролка на АПУ. Поставете разделителната ролка на АПУ, докато  кликне  на място. Вкарайте поемащата ролка на АПУ, докато  кликне  на място. Затворете вратичка С. почистване на поемащата ролка на АПУ Поемаща ролка на АПУ почистване почистване на разделителната ролка на АПУ Разделителна ролка на АПУ почистване почистване на ролките на АПУ Ролки на ADF почистване"},{"UUID":"1ef2c959-1bd6-455b-a94a-7063c56a54c3","title":"Пестене на енергия и хартия","link":"configuring-power-save-mode-settings-topic.html","desc":"Конфигуриране на настройките за режим","descFull":"Конфигуриране на настройките за режим на пестене на енергия Режим на заспиване От началния екран докоснете  Settings (Настройки) Device (Устройство) Power Management (Управление на захранването) Timeouts (Времена на изчакване) Sleep Mode (Режим на заспиване) . Определете времето, през което принтерът остава в режим на готовност, преди да влезе в  Sleep Mode (Режим на заспиване) . Режим на хибернация От началния екран докоснете  Settings (Настройки) Device (Устройство) Power Management (Управление на захранването) Timeouts (Времена на изчакване) Hibernate Timeout (Време на изчакване за активиране на режим на хибернация) . Изберете времето, през което принтерът остава в режим на готовност, преди да влезе в режим Hibernate (Хибернация). За да работи  Hibernate Timeout (Време на изчакване за активиране на режим на хибернация) , настройте  Hibernate Timeout on Connection (Време на изчакване за хибернация при връзка)  на  Hibernate (Хибернация) . Embedded Web Server е дезактивиран, когато принтерът е в режим  Hibernate (Хибернация) . Режим на заспиване конфигуриране Режим на хибернация конфигуриране настройки за опазване на околната среда режими за енергоспестяване конфигуриране"},{"UUID":"c3ece66a-bb50-402b-bccb-76c497686853","title":"Пестене на енергия и хартия","link":"configuring-power-save-mode-settings-topic.html","desc":"Регулира яркостта на дисплея От","descFull":"Регулира яркостта на дисплея От началния екран докоснете  Settings (Настройки) Device (Устройство) Preferences (Предпочитания) . От менюто  Screen Brightness (Яркост на екран)  регулирайте настройката. яркост на дисплея регулиране регулиране на яркостта на дисплея"},{"UUID":"108b753b-038c-4c17-8542-29e6e378c956","title":"Пестене на енергия и хартия","link":"configuring-power-save-mode-settings-topic.html","desc":"Пестене на консумативи Отпечатвайте от","descFull":"Пестене на консумативи Отпечатвайте от двете страни на хартията. Двустранният печат е настройка по подразбиране в драйвера на принтера. Отпечатвайте няколко страници на един лист хартия. Използвайте функцията за предварителен преглед, за да видите как ще изглежда документа, преди да го разпечатате. Разпечатайте едно копие на документа, за да проверите съдържанието му и формата за точност. пестене на консумативи консумативи пестене"},{"UUID":"43662262-8311-46b4-9a1a-aedeb26a1436","title":"Поддръжка на принтера","link":"moving-printer-topic.html","desc":"Преместване на принтера в друго","descFull":"Преместване на принтера в друго местоположение Преместване на принтера в друго местоположение Ако принтерът тежи повече от 20 кг (44 фунта), тогава за безопасното му пренасяне могат да са необходими двама или повече човека. За да избегнете риска от пожар или токов удар, използвайте само захранващия кабел, предоставен с този продукт, или предложения за замяна от производителя разрешен кабел. Следвайте указанията по-долу при преместване на принтера, за да избегнете нараняване или повреда на принтера: Уверете се, че всички врати и тави са затворени. Изключете принтера и след това извадете кабела от контакта. Разкачете всички кабели от принтера. Ако принтерът има отделни допълнителни тави, стоящи на пода, или допълнителни изходни компоненти, свързани към него, тогава ги разкачете, преди да преместите принтера. Ако принтерът има основа на колелца, тогава внимателно го изтърколете на новото място. Бъдете внимателни при преминаване през прагове и прекъсвания в подовата настилка. Ако принтерът няма основа за колелца, но е конфигуриран с допълнителни тави или допълнителни изходни компоненти, тогава премахнете допълнителните изходни компоненти и повдигнете принтера от тавите. Не се опитвайте да вдигнете принтера и някои от допълнителните компоненти едновременно. Винаги използвайте дръжките на принтера, за да го вдигнете. Ако за преместване на принтера се използва количка, тя трябва да е с повърхност, побираща целия размер на принтера. Ако за преместване на допълнителния хардуер се използва количка, тя трябва да е с повърхност, побираща целия размер на допълнителните компоненти. Дръжте принтера в изправено положение. Избягвайте силни удари при движение. Уверете се, че пръстите ви не са под принтера, когато го поставяте. Уверете се, че около принтера има достатъчно свободно пространство. Щети по принтера, които са причинени от неправилно преместване, не се покриват от гаранцията на принтера. преместване на принтера"},{"UUID":"8b43e04d-481d-4c3c-83ce-73523569be5e","title":"Поддръжка на принтера","link":"shipping-printer-topic.html","desc":"Транспортиране на принтера За инструкции","descFull":"Транспортиране на принтера За инструкции за изпращане отидете на адрес  https://support.lexmark.com  или се свържете с поддръжка на клиенти. Когато изпращате принтера, използвайте оригиналната опаковка или се обадете на мястото, където сте закупили принтера. принтер транспортиране транспортиране на принтера"},{"UUID":"b87a5ae9-c66b-44ba-967b-63ccea75df95","title":"Отстраняване на проблем","link":"print-quality-problems-picker-topic.html","desc":"Проблеми с качеството на печата","descFull":"Проблеми с качеството на печата Намерете изображението, което прилича на проблема с качеството на печат, който изпитвате, и после кликнете на връзката под него, за да прочетете стъпките по решаването на проблема. проблеми с качеството на печата отстраняване на неизправности проблеми с качеството на печата отстраняване на неизправности на печата проблеми с качеството на печата"},{"UUID":"d3d287b3-47ed-4b11-bff5-1bfbb1049178","title":"Отстраняване на проблем","link":"printer-error-codes-topic.html","desc":"Кодове за грешки на принтера","descFull":"Кодове за грешки на принтера Кодове за грешки и начини за разрешаване на свързания с тях проблем Кодове за грешки Съобщение за грешка Решение 8,01 Затворете предна вратичка A. Дръжте всички вратички затворени, освен ако не извършвате дейност по поддръжката. 9.00 Принтерът трябваше да се рестартира. Последното задание може да не е завършено. Докоснете  Continue (Продължаване) , за да изчистите съобщението и да продължите да печатате. 11,11, 11,21, 11,31, 11,41 Заредете <type/> <size/> в <source/>. Отворете посочената тава, след което заредете хартия. За повече информация вижте  . 11,12, 11,22, 11,32, 11,42 Заредете <type/> <size/> <orientation/> в <source/>. 11.91 Заредете <type/> <size/> в многоцелевото подаващо устройство. Отворете многоцелевото подаващо устройство, след което заредете хартия. За повече информация вижте  . 11.92 Заредете <type/> <size/> <orientation/> в многоцелевото подаващо устройство. 12,11, 12,21, 12,31, 12,41 Променете <source/> на <type/> <size/>. Отворете посочената тава, отстранете хартията, след което заредете правилния тип и размер хартия. За повече информация вижте  . 12,12, 12,22, 12,32, 12,42 Променете <source/> на <type/> <size/> <orientation/>. 12.91 Променете многоцелевото подаващо устройство на <type/> <size/>. Отстранете хартията, след което заредете правилния тип и размер хартия. За повече информация вижте  . 12.92 Променете многоцелевото подаващо устройство на <type/> <size/> <orientation/>. 29.08 Отстранете опаковъчния материал. Отворете вратичка А. Отстранете касетата с тонер. Отстранете модула за изображения. Отстранете опаковъчния материал. Не излагайте модула с фотопроводник на пряка светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте лъскавия барабан на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Вкарайте модула за изображения. Вкарайте касетата с тонер. Затворете вратичка А. Отстранете всички тави и след това отстранете всичкия опаковъчен материал. Поставете всички тави. 31.40z Монтирайте отново липсващата касета или тази, която не отговаря. Отворете вратичка А. Отстранете касетата с тонер. Вкарайте касетата с тонер. Затворете вратичка А. 31.60z Монтирайте отново липсващия модул за изображения или този, който не отговаря. Отворете вратичка А. Отстранете касетата с тонер. Отстранете модула за изображения. Не излагайте модула с фотопроводник на пряка светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте лъскавия барабан на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Вкарайте модула за изображения. Вкарайте касетата с тонер. Затворете вратичка А. 32.40z Сменете неподдържаната касета. Вижте  . 32.60z Сменете неподдържания модул за изображения. Вижте  . 33,40 Касета, която не от Lexmark, вижте ръководството за потребителя. Вижте  . 33.60 Модул за изображения, който не е от Lexmark, вижте ръководството за потребителя. 37.1 Недостатъчно памет за колиране на задание. Опитайте едно или няколко от следните неща: Докоснете  Continue (Продължаване) , за да отпечатате частта от заданието, която е запаметена, и да започнете колирането на останалата част от заданието за печат. Отменете текущото задание за печат. 37.3 Недостатъчно памет, някои задържани задания са изтрити. Докоснете  Continue (Продължаване) , за да изчистите съобщението и да продължите да печатате. 38,1 Паметта е пълна. Опитайте едно или няколко от следните неща: Докоснете  Cancel job (Отмяна задание) , за да изчистите съобщението. Отпечатайте документа на няколко части или го изпратете на друг принтер. Инсталирайте още памет на принтера. 39.1 Сложна страница, възможно е някои данни да не са отпечатани. Опитайте едно или няколко от следните неща: Докоснете  Continue (Продължаване) , за да изчистите съобщението и да продължите да печатате. Отменете текущото задание за печат. Инсталирайте още памет на принтера. Намалете сложността и размера на заданието за печат, преди да го изпратите отново за отпечатване. Намалете броя на страниците в заданието за печат. Намалете броя и размера на изтеглените шрифтове. Изтрийте излишните шрифтове или макроси от заданието за печат. Намалете броя на графиките в заданието за печат. 42.yy Сменете касетата, несъответствие с региона на принтера. Вижте  . 43.40z Монтирайте отново касетата. Вижте  . 44.40 Сменете касетата, несъответствие с принтера. Вижте  . 55.1 Греш.чет.USB Извадете USB. Отстранете флаш устройството, за да продължите. 55.2 Грешка при четене на USB устройство. Премахнете устройството. Отстранете USB хъба, за да продължите. 58 Твърде много тави са закрепени. Може/гат да се поддържа/т само <x/> тава/и. Изключете принтера и след това извадете кабела от контакта. Отстранете една или повече тави. Включете захранващия кабел в контакт на стената и след това включете принтера. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. 59 Несъвместима тава [x]. Изключете принтера и след това извадете кабела от контакта. Отстранете посочената тава. Включете захранващия кабел в контакт на стената и след това включете принтера. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. 61 Отстранете дефектния диск. Сменете дефектното запаметяващо устройство. 62 Дискът е пълен. Опитайте едно или няколко от следните неща: Докоснете  Continue  (Продължаване), за да изчистите съобщението. Изтрийте шрифтове, макроси и други данни, съхранявани на интелигентното запаметяващо устройство. Инсталирайте интелигентно запаметяващо устройство. 63 Форматирайте диска. Форматирането на момента изтрива цялата информация от запаметяващото устройство. За да форматирате диска, направете следното: От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Out of Service Erase (Изтр. при неизправност) . Докоснете  Sanitize all information on hard disk (Изчистване на цялата информация на твърдия диск)  или  Erase Intelligent Storage Drive (Изтриване на интелигентно запаметяващо устройство) , след което докоснете  ERASE (ИЗТРИВАНЕ) . 71.01 Име на факс станция не е конфигурирано. Свържете се със системния администратор. Вижте  . 71.02 Номер на факс станция не е конфигуриран. Свържете се със системния администратор. 71.03 Няма аналог.тел. линия свърз.с модема, факсът не раб. Проверете връзката и линията за сигнал. За повече информация вижте  . 71.06 Свързването с HTTPS факс сървъра е невъзможно. Връзката с HTTPS факс сървъра е прекъсната. Проверете интернет връзката на принтера. 71.12 Паметта е пълна, не могат да се отпечатват факсове. Докоснете  Print All (Отпечатване на всички) , за да отпечатате всички запазени факсове. 71.13 Паметта е пълна. Не могат да се изпращат факсове. Опитайте едно или няколко от следните неща: Продължете и се опитайте да изпратите факса отново. Сканирайте страниците на оригиналния документ една по една, наберете номера на факса, след което сканирайте документа. 71.4 Неправилно време на принтера. За да зададете правилното време на принтера, направете следното: Докоснете  Settings (Настройки) Device (Устройство) Preferences (Предпочитания) Докоснете  Date and Time (Дата и час)  и след това задайте правилния час. 72.01 SMTP сървърът за имейл не е конфигуриран. Свържете се със системния администратор. Опитайте която и да е от следните две опции: Конфигурирайте Вашата функция за имейл. За повече информация вижте  . Дезактивирайте съобщението за грешка. За повече информация вижте  . 80,01, 80,03, 80,09 Почти ниско ниво на комплекта за поддръжка. Докоснете  Continue  (Продължаване), за да изчистите съобщението. 80,11, 80,13, 80,19 Ниско ниво на комплекта за поддръжка. 80,21, 80,23, 80,29 Комплектът за поддръжка е на привършване. 84,00, 84,01, 84,02, 84,03, 84,09 Нивото на модула за изображения е почти ниско. Докоснете  Continue  (Продължаване), за да изчистите съобщението. 84.11, 84.12, 84.13, 84.19 Нивото на модула за изображения е ниско. 84.21, 84.22, 84.23, 84.29 Нивото на модула за изображения е много ниско. 84.31, 84.32, 84.33 Сменете модула за изображения, препоръчителният срок на експлоатация е надхвърлен. Вижте  . 84.41, 84.42, 84.43 Сменете модула за изображения, за да продължите с отпечатването. 88.00, 88.08, 88.09 Нивото на касетата е почти ниско. Докоснете  Continue  (Продължаване), за да изчистите съобщението. 88.10, 88.18, 88.19 Нивото на касетата е ниско. 88.20, 88.28, 88.29 Нивото на касетата е много ниско. 88,30, 88,38 Сменете касетата, остават прогнозирано още <num/> страници. Вижте  . 88,30, 88,38 Сменете касетата. 88.40, 88.48 Сменете касета, остават още 0 страници. 200.03 Заседнала хартия, [заседнал горен колонтитул]. [хxx.yy] Вижте  . 200.04, 200.05, 200.14, 200.24, 200.25, 200.34, 200.35, 200.44, 200.45, 202.05, 202.15, 202.25, 202.35, 202.45, 230.03, 230.13, 230.23, 230.33, 230.43 Заседнала хартия, [заседнал горен колонтитул]. [хxx.yy] Вижте  . 200,12, 200,15, 200,22, 200,32, 200,33, 200,42, 200,91, 202,03, 200,13, 202,33, 202,43, 202,93 Заседнала хартия, [заседнал горен колонтитул]. [хxx.yy] Вижте  . 200,13, 200,23, 200,33, 200,43, 241,86 Заседнала хартия, [заседнал горен колонтитул]. [хxx.yy] Вижте  . 230,15, 230,25, 230,33, 230,45, 232,13, 232,23, 232,33, 232,43, 232,53, 232,93 Заседнала хартия, [заседнал горен колонтитул]. [хxx.yy] Вижте  . 24x.x6, 24x.8y, 602.x9 66x.x3, 66x.8y Грешка при зареждане на хартия, [jam header]. [хxx.yy] Вижте  . 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01, 680.10, 680.20, 680.40 Засядане на скенер. [хxx.yy] Вижте  . кодове за грешки на принтера кодове за грешки съобщения за грешки на принтера съобщения за грешки"},{"UUID":"22c95eaa-0f35-4cbd-9163-4d02d90fa6df","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Празни или бели страници Преди","descFull":"Празни или бели страници Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности)  Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Печата ли принтерът празни или бели страници? Проблемът е решен. Отстранете всичкия опаковъчен материал, който е останал на модула за изображения. Отстранете касетата с тонер и след това отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Проверете модула за изображения за признаци на повреда и го заменете при необходимост. Уверете се, че контактите на барабана на фотопроводника не са изкривени или изместени. Разклатете модула за изображения енергично, за да разпределите тонера. Поставете модула за изображения и след това поставете касетата с тонер. Отпечатайте документа. Печата ли принтерът празни или бели страници? Проблемът е решен. Проверете състоянието на касетата с тонер и я заметете, ако е необходимо. От началния екран докоснете  Status/Supplies (Състояние/консумативи) Supplies (Консумативи) . Отпечатайте документа. Печата ли принтерът празни или бели страници? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата празни страници проблем с качеството на печата бели страници бели страници празни страници"},{"UUID":"c1b21cfb-5f1b-4af2-941f-bf5bd34a345c","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Тъмно отпечатване Преди разрешаване на","descFull":"Тъмно отпечатване Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Намалете тъмнината на тонера. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Toner Darkness (Плътност на тонера) . Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. Проверете дали хартията разполага с текстурирано, или грубо покритие. Отпечатвате ли върху текстурирана или груба хартия? Отидете на стъпка 6. Заменете текстурираната хартия с обикновена хартия. Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. Заредете хартия от нов пакет. Хартията абсорбира влагата поради високото ниво на влажност. Съхранявайте хартията в оригиналната опаковка, докато не сте готови да я използвате. Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. Отстранете и след това поставете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отпечатайте документа. Отпечатването тъмно ли е? Проблемът е решен. Подменете модула за изображения. Отпечатайте документа. Отпечатването тъмно ли е? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата тъмно отпечатване тъмно отпечатване"},{"UUID":"80e313ff-7302-40b7-855d-5bda1d0f8a7a","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Фините линии не се отпечатват","descFull":"Фините линии не се отпечатват правилно Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Правилно ли се отпечатват фините линии? Проблемът е решен. Регулирайте настройките за качество на печат. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Pixel Boost (Усилване на пиксели) Fonts (Шрифтове) . Регулирайте тъмнината на тонера на 7. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Toner Darkness (Плътност на тонера) . Отпечатайте документа. Правилно ли се отпечатват фините линии? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с качеството на печата фините линии не се отпечатват правилно фините линии не се отпечатват правилно"},{"UUID":"e1b1cab4-c6ae-49cd-b2b3-fd2fc4e82278","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Прегъната или намачкана хартия Преди","descFull":"Прегъната или намачкана хартия Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Прегъната или намачкана ли е хартията? Проблемът е решен. Заредете хартия от нов пакет. Хартията абсорбира влагата поради високото ниво на влажност. Съхранявайте хартията в оригиналната опаковка, докато не сте готови да я използвате. Отпечатайте документа. Прегъната или намачкана ли е хартията? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец \"Предпочитания за печат\" или \"Отпечатване\". Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Прегъната или намачкана ли е хартията? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата прегъната хартия проблем с качеството на печата намачкана хартия прегъната хартия намачкана хартия"},{"UUID":"5995b10e-9334-45cd-b39c-89bcd21eccc2","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Сив фон Преди разрешаване на","descFull":"Сив фон Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Изключете принтера, изчакайте 10 секунди и след това включете принтера. Намалете тъмнината на тонера. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Toner Darkness (Плътност на тонера) . Отпечатайте документа. Върху разпечатките появява ли се сив фон? Проблемът е решен. Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Върху разпечатките появява ли се сив фон? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Върху разпечатките появява ли се сив фон? Проблемът е решен. Отстранете и след това поставете модула за изображения. Не излагайте модула за изображения на директна светлина. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте фоточувствителния барабан. Това може да се отрази на качеството на бъдещите задания за печат. Отпечатайте документа. Върху разпечатките появява ли се сив фон? Проблемът е решен. Актуализирайте фърмуера на принтера. За повече информация вижте  . Отпечатайте документа. Върху разпечатките появява ли се сив фон? Проблемът е решен. Подменете модула за изображения. Отпечатайте документа. Върху разпечатките появява ли се сив фон? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата сив фон върху разпечатките сив фон върху разпечатките"},{"UUID":"b16f42bd-859c-4470-a9b4-fe49e17993a3","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Грешни полета Грешни полета Преди","descFull":"Грешни полета Грешни полета Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Регулирайте водачите на хартията в тавата до правилната позиция за заредената хартия. Отпечатайте документа. Правилни ли да полетата? Проблемът е решен. В зависимост от операционната система определете размера на хартията от диалоговия прозорец \"Предпочитания за печат\" или \"Отпечатване\". Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Правилни ли да полетата? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . грешни полета проблем с качеството на печата грешни полета"},{"UUID":"5f981b0a-8245-444b-bd65-b3e05559cbe4","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Светло отпечатване Преди разрешаване на","descFull":"Светло отпечатване Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Светла ли е разпечатката? Проблемът е решен. Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Увеличаване на тъмнината на тонера. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Toner Darkness (Плътност на тонера) . Отпечатайте документа. Светла ли е разпечатката? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Светла ли е разпечатката? Проблемът е решен. В зависимост от операционната система определете разделителната способност за печат от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Задайте разделителната способност на  600 dpi . Отпечатайте документа. Светла ли е разпечатката? Проблемът е решен. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина. Продължителното излагане на светлина може да причини проблеми с качеството на печат. Не докосвайте фоточувствителния барабан. Това може да се отрази на качеството на бъдещите задания за печат. Разклатете модула за изображения енергично, за да разпределите тонера. Вкарайте модула за изображения. Изключете принтера, изчакайте 10 секунди и след това включете принтера. Отпечатайте документа. Светла ли е разпечатката? Проблемът е решен. Проверете състоянието на касетата с тонер. От началния екран докоснете  Settings (Настройки) Reports (Отчети) Device (Устройство) Device Statistics (Статистики за устройството) . От раздела Информация за консуматив на отпечатаните страници проверете състоянието на касетата с тонер. Изтича ли експлоатационният срок на касетата с тонер? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Сменете касетата с тонер. Отпечатайте документа. Светла ли е разпечатката? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата светло отпечатване светло отпечатване"},{"UUID":"862246bd-10c4-4c6d-a893-7bae6637af36","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Изцапана разпечатка и точки Преди","descFull":"Изцапана разпечатка и точки Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Изцапана ли е разпечатката? Проблемът е решен. Проверете принтера за замърсяване от протекъл тонер. Има ли в принтера протекъл тонер? Отидете на стъпка 4. Сменете касетата с тонер. Отпечатайте документа. Изцапана ли е разпечатката? Проблемът е решен. Вижте състоянието на модула за изображения. От началния екран докоснете  Status/Supplies (Състояние/консумативи) Supplies (Консумативи) . Почти изтекъл ли е експлоатационният срок на модула за изображения? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Подменете модула за изображения. Отпечатайте документа. Изцапана ли е разпечатката? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата изцапана разпечатка проблем с качеството на печата точки на разпечатката изцапана разпечатка точки на разпечатката"},{"UUID":"d1b18d6d-ce58-4a4d-9e83-f5b54815ccee","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Набръчкване на хартията Стъпки за","descFull":"Набръчкване на хартията Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Набръчкана ли е хартията? Проблемът е решен. Регулирайте водачите в тавата до правилната позиция за заредената хартия. Отпечатайте документа. Набръчкана ли е хартията? Проблемът е решен. В зависимост от операционната система определете размера и типа на хартия от диалоговия прозорец „Предпочитания за печат“ или „Печат“. Уверете се, че настройките отговарят на тези на заредената хартия. Можете също да промените настройките от контролния панел на принтера. Отпечатайте документа. Набръчкана ли е хартията? Проблемът е решен. Извадете хартия от тавата и обърнете хартията. Отпечатайте документа. Набръчкана ли е хартията? Проблемът е решен. Заредете хартия от нов пакет. Хартията абсорбира влагата поради високото ниво на влажност. Съхранявайте хартията в оригиналната опаковка, докато не сте готови да я използвате. Отпечатайте документа. Набръчкана ли е хартията? Проблемът е решен. Проверете дали заредената хартия се поддържа. Ако хартията не се поддържа, тогава заредете хартия с поддържано тегло. Отпечатайте документа. Набръчкана ли е хартията? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата набръчкване на хартията набръчкване на хартията"},{"UUID":"6cb5737d-f6ce-4763-bc6b-3abc56d87971","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Изкривени или наклонени разпечатки Преди","descFull":"Изкривени или наклонени разпечатки Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Извадете тавата. Отстранете хартията, след което заредете хартия от нов пакет. Хартията абсорбира влагата поради високото ниво на влажност. Съхранявайте хартията в оригиналната опаковка, докато не сте готови да я използвате. Стиснете и избутайте водачите на хартията в правилната позиция за размера на заредената хартия. Поставете тавата. Отпечатайте документа. Изкривена или наклонена ли е разпечатката? Проблемът е решен. Проверете дали печатате върху поддържан тип хартия. Отпечатайте документа. Изкривена или наклонена ли е разпечатката? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. разпечатка с изкривяване изкривен печат проблем с качеството на печата разпечатка с изкривяване проблем с качеството на печата изкривен печат разпечатка с изкривяване изкривен печат"},{"UUID":"780c08a2-d4fd-49e0-86cc-9331874e8599","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Изцяло черни страници Преди разрешаване","descFull":"Изцяло черни страници Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, монтирайте такава, която се поддържа. Отпечатайте документа. Принтерът отпечатва ли изцяло черни страници? Проблемът е решен. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отстранете всичкия опаковъчен материал, който е заседнал на модула за изображения. Уверете се, че сте премахнали всякакви препятствия между зареждащата ролка и барабана на фотопроводника. Вкарайте модула за изображения. Отпечатайте документа. Принтерът отпечатва ли изцяло черни страници? Проблемът е решен. Проверете модула за изображения за признаци на повреда. Без повреди ли е модулът за изображения? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Подменете модула за изображения. Отпечатайте документа. Принтерът отпечатва ли изцяло черни страници? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата изцяло черни страници изцяло черни страници черни страници"},{"UUID":"32d078be-c9eb-46a8-b9ef-c7faacad0334","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Изрязан текст или изображения Преди","descFull":"Изрязан текст или изображения Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Има ли изрязан текст или изображения? Проблемът е решен. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отстранете всичкия опаковъчен материал, който е заседнал на модула за изображения. Уверете се, че сте премахнали всякакви препятствия между зареждащата ролка и барабана на фотопроводника. Вкарайте модула за изображения. Отпечатайте документа. Има ли изрязан текст или изображения? Проблемът е решен. Подменете модула за изображения. Отпечатайте документа. Има ли изрязан текст или изображения? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата изрязан текст или изображения изрязване на текст при отпечатване изрязване на изображения при отпечатване"},{"UUID":"3cef9e21-35ab-4965-91ce-b50fd5589c3d","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Тонерът се изтрива лесно Преди","descFull":"Тонерът се изтрива лесно Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Лесно ли се изтрива тонерът? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Лесно ли се изтрива тонерът? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата тонерът се изтрива лесно тонерът се изтрива лесно"},{"UUID":"944a46ce-6bb2-4a6a-a346-a6ab04ed75f8","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Светли хоризонтални ленти Преди разрешаване","descFull":"Светли хоризонтални ленти Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Появяват ли се върху разпечатките светли хоризонтални ленти? Проблемът е решен. Отстранете и след това поставете модула за изображения. Не излагайте модула за изображения на директна светлина. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте фоточувствителния барабан. Това може да се отрази на качеството на бъдещите задания за печат. Отпечатайте документа. Появяват ли се върху разпечатките светли хоризонтални ленти? Проблемът е решен. Подменете модула за изображения. Отпечатайте документа. Появяват ли се върху разпечатките светли хоризонтални ленти? Проблемът е решен. Изключете принтера, изчакайте 10 секунди и след това включете принтера. Отпечатайте документа. Появяват ли се върху разпечатките светли хоризонтални ленти? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата светли хоризонтални ленти светли хоризонтални ленти"},{"UUID":"6b22778b-72ff-4fc1-af54-6e0bcc7c0f03","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Светли вертикални ленти Преди разрешаване","descFull":"Светли вертикални ленти Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Появяват ли се върху разпечатките светли вертикални ленти? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата светли вертикални ленти светли вертикални ленти"},{"UUID":"a92918b8-53b2-4aa9-86d8-1bae7847400a","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Вертикални бели линии Преди разрешаване","descFull":"Вертикални бели линии Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Появяват ли се върху разпечатките бели вертикални линии? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Отпечатайте документа. Появяват ли се върху разпечатките бели вертикални линии? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата вертикални бели линии вертикални бели линии"},{"UUID":"c21b8b05-1d8f-4cac-a696-2933fef1d84b","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Тъмни вертикални ленти Преди разрешаване","descFull":"Тъмни вертикални ленти Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Появяват ли се върху разпечатките тъмни вертикални ленти? Проблемът е решен. Отстранете касетата с тонер и след това отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Поставете модула за изображения и след това поставете касетата. Отпечатайте документа. Появяват ли се върху разпечатките тъмни вертикални ленти? Проблемът е решен. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отстранете всичкия опаковъчен материал, който е заседнал на модула за изображения. Уверете се, че сте премахнали всякакви препятствия между зареждащата ролка и барабана на фотопроводника. Вкарайте модула за изображения. Отпечатайте документа. Появяват ли се върху разпечатките тъмни вертикални ленти? Проблемът е решен. Проверете дали навлиза ярка светлина от дясната страна на принтера и го преместете, ако е необходимо. Отпечатайте документа. Появяват ли се върху разпечатките тъмни вертикални ленти? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата тъмни вертикални ленти вертикални тъмни ленти на разпечатките"},{"UUID":"cbef2ae2-3f3e-4c65-a568-de4ff0ff1a6d","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Вертикални тъмни линии или черти","descFull":"Вертикални тъмни линии или черти Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Cleaning the Scanner (Почистване на скенера) Отпечатайте документа. Има ли върху разпечатките вертикални тъмни линии или ивици? Отидете на стъпка 3. Почистете скенера с помощта на влажна, мека и немъхеста кърпа. За повече информация вижте  . Копирайте документа с помощта на АПУ. Има ли върху разпечатките вертикални тъмни линии или ивици? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. Има ли върху разпечатките вертикални тъмни линии или ивици? Проблемът е решен. Отстранете и след това поставете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини проблеми с качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отпечатайте документа. Има ли върху разпечатките вертикални тъмни линии или ивици? Проблемът е решен. Подменете модула за изображения. Отпечатайте документа. Има ли върху разпечатките вертикални тъмни линии или ивици? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата вертикални тъмни линии или черти вертикални тъмни линии на разпечатките вертикални черти на разпечатките"},{"UUID":"d98bb473-8c85-43a8-ade7-a930b7bc9985","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Тъмни вертикални черти с липса","descFull":"Тъмни вертикални черти с липса в разпечатката Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не Проверете дали в принтера се използва оригинална и поддържана касета с тонер на Lexmark. Проверете дали в принтера се използва оригинална и поддържана касета с тонер. Ако касетата не се поддържа, инсталирайте такава, която се поддържа. Отпечатайте документа. В разпечатките появяват ли се тъмни вертикални черти и има ли липсващи изображения? Проблемът е решен. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте барабана на фотопроводника под модула за изображения. Това може да се отрази на качеството на бъдещите задания за печат. Отстранете всичкия опаковъчен материал, който е заседнал на модула за изображения. Уверете се, че сте премахнали всякакви препятствия между зареждащата ролка и барабана на фотопроводника. Вкарайте модула за изображения. Отпечатайте документа. В разпечатките появяват ли се тъмни вертикални черти и има ли липсващи изображения? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. вертикални тъмни черти липсващ печат проблем с качеството на печата тъмни вертикални черти с липса в разпечатката"},{"UUID":"bd213fbc-6f3c-463c-b022-015ddaac4c97","title":"Качеството на печат е лошо","link":"solving-printing-problems.html","desc":"Повтарящи се дефекти Преди разрешаване","descFull":"Повтарящи се дефекти Преди разрешаване на проблема отпечатайте тестови страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Стъпки за решаване на проблема Действие Да Не С използване на Тестови страници за качество на печат проверете дали разстоянието между повтарящите се дефекти е равно на някое от следните: 97 мм (3,82 in) 47 мм (1,85 инча) 38 мм (1,5 инча) Съвпада ли разстоянието между повтарящите се дефекти с някои от измерванията? Запишете си разстоянието и след това се свържете с  поддръжка на клиенти . Запишете си разстоянието и след това се свържете с  техническа поддръжка . Запишете си разстоянието и след това се свържете с Вашия  дилър . Подменете модула за изображения. Отпечатайте документа. Повтарящите се дефекти появяват ли се? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на печата повтарящи се дефекти повтарящи се дефекти върху разпечатките"},{"UUID":"8c20b5e7-9e79-4068-a530-e1fba42f592e","title":"Проблеми с печата","link":"solving-printing-problems.html","desc":"Заданията за печат не се","descFull":"Заданията за печат не се отпечатват Стъпки за решаване на проблема Действие Да Не Отворете диалоговия прозорец \"Отпечатване\" от документа, който се опитвате да отпечатате, и проверете дали сте избрали правилния принтер. Отпечатайте документа. Отпечатан ли е документът? Проблемът е решен. Проверете дали принтерът е включен. Разрешете всички съобщения за грешка, които се появяват на дисплея. Отпечатайте документа. Отпечатан ли е документът? Проблемът е решен. Проверете дали портовете работят и дали кабелите са добре свързани към компютъра и принтера. За повече информация вижте документацията за конфигуриране, доставена с принтера. Отпечатайте документа. Отпечатан ли е документът? Проблемът е решен. Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Отпечатайте документа. Отпечатан ли е документът? Проблемът е решен. Премахнете и повторно инсталирайте драйвера за принтера. Отпечатайте документа. Отпечатан ли е документът? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с печата заданията за печат не се отпечатват неотпечатани задания за печат"},{"UUID":"7b1b749f-5972-428a-ab70-b5b12a5dce1d","title":"Проблеми с печата","link":"solving-printing-problems.html","desc":"Конфиденциални и други изчакващи документи","descFull":"Конфиденциални и други изчакващи документи не се отпечатват Стъпки за решаване на проблема Действие Да Не От контролния панел проверете дали документите се показват в списъка с  Held Jobs (Задържани задания) . Ако документите не са в списъка, тогава отпечатайте документите чрез опциите Print and Hold (Отпечатване и задържане). Отпечатайте документите. Отпечатани ли са документите? Проблемът е решен. Заданието за печат може да съдържа грешки във формата или невалидни данни. Изтрийте заданието за печат и след това го изпратете отново. За PDF файлове генерирайте нов файл, след което отпечатайте документите. Отпечатани ли са документите? Проблемът е решен. Ако отпечатвате от интернет, тогава принтерът може да разчита множеството заглавия на задания като дубликати. За потребители на Windows Отворете диалоговия прозорец Printing Preferences (Предпочитания за печат). От раздела Print and Hold (Отпечатване и задържане) кликнете върху  Use Print and Hold (Използване на отпечатване и задържане) , след което кликнете върху  Keep duplicate documents (Запазване на дублирани документи) . Въведете PIN код и след това запазете промените. Изпратете заданието за печат. За потребители на Macintosh Запазете и наименувайте всяко задание отделно. Изпратете заданието отделно. Отпечатани ли са документите? Проблемът е решен. Изтрийте някои задържани задания, за да освободите памет в принтера. Отпечатайте документите. Отпечатани ли са документите? Проблемът е решен. Добавяне на памет на принтера. Отпечатайте документите. Отпечатани ли са документите? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности, отпечатване конфиденциални и други изчакващи документи не се отпечатват отстраняване на неизправности на печата конфиденциални и други изчакващи документи не се отпечатват поверителни документи не се отпечатват задържаните документи не се отпечатват"},{"UUID":"95d45433-140a-422e-8630-9c56c57663c5","title":"Проблеми с печата","link":"solving-printing-problems.html","desc":"Заданието се отпечатва от грешната","descFull":"Заданието се отпечатва от грешната тава или върху грешната хартия Стъпки за решаване на проблема Действие Да Не Проверете дали печатате върху правилната хартия. Отпечатайте документа. Документът отпечатан ли е върху правилната хартия? Заредете правилния размер и тип на хартията. В зависимост от операционната система определете размера и типа на хартия от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Можете също да промените настройките от контролния панел на принтера. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Уверете се, че настройките отговарят на тези на заредената хартия. Отпечатайте документа. Документът отпечатан ли е върху правилната хартия? Проблемът е решен. Проверете дали тавите са свързани. За повече информация вижте  . Отпечатайте документа. Документът отпечатан ли е от правилната тава? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности на печата задания за печат от неправилната тава отстраняване на неизправности на печата задания за печат върху неправилната хартия отстраняване на неизправности, отпечатване задания за печат от неправилната тава отстраняване на неизправности, отпечатване задания за печат върху неправилната хартия задания за печат от неправилната тава задания за печат върху неправилната хартия"},{"UUID":"37ce990e-7b2c-4701-a9b4-d23786919016","title":"Проблеми с печата","link":"solving-printing-problems.html","desc":"Бавно отпечатване Стъпки за решаване","descFull":"Бавно отпечатване Стъпки за решаване на проблема Действие Да Не Уверете се, че кабелът на принтера е свързан надеждно към принтера и компютъра, сървъра за печат, допълнително или друго мрежово устройство. Принтерът отпечатва ли бавно? Проблемът е решен. Уверете се, че принтерът не е в Quiet Mode (Безшумен режим). От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Device Operations (Операции с устройство) Quiet Mode (Безшумен режим) . Отпечатайте документа. Принтерът отпечатва ли бавно? Проблемът е решен. В зависимост от операционната система определете разделителната способност за печат от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Задайте разделителната способност на  600 dpi . Отпечатайте документа. Принтерът отпечатва ли бавно? Проблемът е решен. От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Quality (Качество) Print Resolution (Разделителна способност на печат) . Задайте разделителната способност на  600 dpi . Отпечатайте документа. Принтерът отпечатва ли бавно? Проблемът е решен. В зависимост от операционната система определете типа на хартията от диалоговия прозорец Printing Preferences (Предпочитания за печат) или Print (Отпечатване). Уверете се, че настройките отговарят на заредената хартия. Можете също да промените настройките от контролния панел на принтера. Разпечатките с по-тежка хартия са по-бавни. Хартия, която е по-тясна от Letter, A4 и Legal може да се отпечатва по-бавно. Отпечатайте документа. Принтерът отпечатва ли бавно? Проблемът е решен. Уверете се, че настройките на принтера за текстура и тегло съвпадат със заредената хартия. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Media Configuration (Конфигуриране на носителите) Media Types (Типове носители) . Хартията с груба текстура и тежките хартии може да се отпечатват по-бавно. Отпечатайте документа. Принтерът отпечатва ли бавно? Проблемът е решен. Отстраняване на задържани задания. Принтерът отпечатва ли бавно? Проблемът е решен. Уверете се, че принтерът не прегрява. Оставете принтера да се охлади след дълго задание за печат. Спазвайте препоръчаната околна температура за принтера. За повече информация вижте  . Отпечатайте документа. Принтерът отпечатва ли бавно? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с печата бавно отпечатване бавно отпечатване"},{"UUID":"7d58975f-e38b-4fde-8629-3b72db0f5ced","title":"Отстраняване на проблем","link":"trb-printer-not-responding-topic.html","desc":"Принтерът не отговаря Стъпки за","descFull":"Принтерът не отговаря Стъпки за решаване на проблема Действие Да Не Проверете дали захранващият кабел е свързан към електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Отговаря ли принтерът? Проблемът е решен. Проверете дали електрическият контакт не е изключен от превключвател или прекъсвач. Изключен ли е електрическият контакт от превключвател или прекъсвач? Включете превключвателя или рестартирайте прекъсвача. Проверете дали принтерът е включен. Включен ли е принтерът? Включете принтера. Проверете дали принтерът се намира в режим Sleep (Заспиване), или в режим Hibernate (Хибернация). Намира ли се принтерът в режим Sleep (Заспиване), или в режим Hibernate (Хибернация)? Натиснете бутона за захранване, за да събудите принтера. Проверете дали кабелите, свързващи принтера и компютъра, са включени в правилните портове. В правилните портове ли са включени кабелите? Включете кабелите в правилните портове. Изключете принтера, инсталирайте хардуерните опции и след това го включете отново. За повече информация вижте документацията на опцията. Отговаря ли принтерът? Проблемът е решен. Инсталирайте правилния драйвер на принтера. Отговаря ли принтерът? Проблемът е решен. Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Отговаря ли принтерът? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности принтерът не отговаря принтерът не отговаря"},{"UUID":"81ad9d56-d3fe-4730-aa78-0fc75dcb7383","title":"Отстраняване на проблем","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Не може да разчете флаш","descFull":"Не може да разчете флаш устройството Не може да разчете флаш устройството Стъпки за решаване на проблема Действие Да Не Проверете дали принтерът не е зает с обработването на друго задание за отпечатване, копиране, сканиране или факс. Готов ли е принтерът? Отидете на стъпка 3. Изчакайте, докато принтерът обработва другото задание. Отстранете и след това вкарайте флаш устройството. Разпознава ли принтерът флаш устройството? Проблемът е решен. Проверете дали флаш устройството е поставено в предния USB порт. Флаш устройството не работи, когато е поставено в задния USB порт. Флаш устройството поставено ли е в правилния порт? Отидете на стъпка 5. Поставете флаш устройството в правилния порт. Разпознава ли принтерът флаш устройството? Проблемът е решен. Проверете дали флаш устройството се поддържа. За повече информация вижте  . Поддържано ли е флаш устройството? Отидете на стъпка 7. Вкарайте поддържано флаш устройство. Разпознава ли принтерът флаш устройството? Проблемът е решен. Отстранете и след това вкарайте флаш устройството. Разпознава ли принтерът флаш устройството? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . не може да разчете флаш устройството отстраняване на неизправности, отпечатване отстраняване на неизправности на печата не може да разчете флаш устройството"},{"UUID":"d33ea9f2-f82f-417a-bdea-7910b46b26af","title":"Отстраняване на проблем","link":"enabling-usb-port-topic.html","desc":"Разрешаване на USB порт От","descFull":"Разрешаване на USB порт От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежи/портове) USB Enable USB Port (Активиране на USB порт) . портът разрешаване разрешаване на USB порт"},{"UUID":"e0b0289a-3a78-411c-9db7-2940200bfc21","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Предотвратяване на засядането Правилно зареждане","descFull":"Предотвратяване на засядането Правилно зареждане на хартия Уверете се, че хартията е поставена хоризонтално в тавата. Правилно и неправилно зареждане на хартия Правилно зареждане на хартия Неправилно зареждане на хартия Не зареждайте и не изваждайте тавата, докато принтерът печата. Не зареждайте прекалено много хартия. Уверете се, че височината на топа е под индикатора за максимално ниво на хартията. Не плъзгайте хартията в тавата. Заредете хартията, както е показано на илюстрацията. Уверете се, че водачите на хартията са позиционирани правилно и не са притиснати плътно към хартията или пликовете. Избутайте добре тавата в принтера, след като заредите хартия. Използване на препоръчана хартия Използвайте само препоръчана хартия или специален печатен носител. Не зареждайте намачкана, нагъната, влажна, подгъната или набръчкана хартия. Изпънете, развейте и изгладете ръбовете на хартията преди зареждане. Не използвайте хартия, която е срязана или подрязана на ръка. Не смесвайте хартия с различен размер, тегло или тип в същата тава. Уверете се, че размерът и типът хартия са зададени правилно на компютъра или контролния панел на принтера. Съхранявайте хартията в съответствие с препоръките на производителя. заседнала хартия избягване засядания, хартия избягване предотвратяване на засядането на хартия"},{"UUID":"bd6ec51d-d412-498b-8442-8fc3ae2b2497","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Идентифициране на места на засядане","descFull":"Идентифициране на места на засядане Когато функцията  Помощ при засядане  е зададена на  Вкл. , принтерът почиства празни страници или страници с частичен печат след изчистване на заседнала страница. Проверете Вашите отпечатани страници за празни страници. Когато функцията  Възстановяване при засядане  е зададена на  Вкл.  или  Автоматично , принтерът отпечатва повторно заседналите страници. Места на заседнала хартия Места на заседнала хартия 1 Устройство за автоматично подаване на документи 2 Многоцелево подаващо устройство 3 Тави 4 Вратичка A 5 Модул за двустранен печат 6 Вратичка B места на заседнала хартия разпознаване заседнала хартия намиране намиране на заседнала хартия"},{"UUID":"636a8c45-3761-474d-9975-d919bc16d6af","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Засядане на хартия във врата","descFull":"Засядане на хартия във врата A Отворете вратичка А. Отстранете касетата с тонер. Отстранете модула за изображения. Не излагайте модула за изображения на директна светлина за повече от 10 минути. Продължителното излагане на светлина може да причини някои проблеми при качеството на печат. Не докосвайте фоточувствителния барабан. Това може да се отрази на качеството на бъдещите задания за печат. Отстранете заседналата хартия. Вътрешността на принтера може да е гореща. За да намалите риска от нараняване от горещ компонент, изчакайте повърхността да изстине, преди да я докоснете. Уверете се, че всички парчета хартия са отстранени. Вкарайте модула за изображения. Използвайте стрелките от вътрешната страна на принтера като ориентири. Вкарайте касетата с тонер. Използвайте стрелките от вътрешната страна на принтера като ориентири. Затворете вратичка А. отстраняване на заседнала хартия във врата A отстраняване на заседнала хартия във врата A засядане на хартия във врата A"},{"UUID":"16e97266-7f95-4d71-8c36-7eaae36a034c","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Засядане на хартия във врата","descFull":"Засядане на хартия във врата B Отворете врата B. Вътрешността на принтера може да е гореща. За да намалите риска от нараняване от горещ компонент, изчакайте повърхността да изстине, преди да я докоснете. Отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Затворете вратичка В. отстраняване на заседнала хартия във врата B отстраняване на заседнала хартия във врата B засядане на хартия във врата B"},{"UUID":"32542edc-0138-4444-8e04-ed5df54b0067","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Засядане на хартия в устройството","descFull":"Засядане на хартия в устройството за двустранен печат Извадете тавата. Натиснете фиксатора на модула за двустранен печат, за да го отворите. Отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Поставете тавата. отстраняване на заседнала хартия в устройството за двустранен печат отстраняване на заседнала хартия в устройството за двустранен печат засядане на хартия в устройството за двустранен печат"},{"UUID":"80822acc-dbd7-4332-b6a5-2fd53e98ff76","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Заседнала хартия в тавите Извадете","descFull":"Заседнала хартия в тавите Извадете тавата. За да предотвратите повреди от електростатичен разряд, докоснете която и да е открита метална рамка на принтера, преди да осъществите достъп до или да докоснете вътрешните части на принтера. Отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Поставете тавата. отстраняване на заседнала хартия в тавите отстраняване на заседнала хартия в тавите заседнала хартия в тавите"},{"UUID":"a2f907f0-abe6-4fe0-a039-c47f72aa17b8","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Заседнала хартия в многоцелевото подаващо","descFull":"Заседнала хартия в многоцелевото подаващо устройство Отстранете хартията от многоцелевото подаващо устройство. Отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Заредете хартия и регулирайте водача на хартията. отстраняване на заседнала хартия в многоцелевото подаващо устройство отстраняване на заседнала хартия в многоцелевото подаващо устройство заседнала хартия в многофункционалното устройство за подаване"},{"UUID":"0bfe6af9-d519-4f79-95b3-dc694d3b61f3","title":"Отстраняване на заседнала хартия","link":"clearing-jams.html","desc":"Заседнала хартия в автоматичното подаващо","descFull":"Заседнала хартия в автоматичното подаващо устройство (АПУ) Заседнала хартия под горния капак на АПУ Отстр.всички оригинали от тавата на АПУ. Отворете вратичка С. Отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Затворете вратичка С. Заседнала хартия под изходната тава на АПУ Отстр.всички оригинали от тавата на АПУ. Повдигнете тавата на АПУ, след което отстранете заседналата хартия. Уверете се, че всички парчета хартия са отстранени. Поставете тавата на АПУ обратно на мястото й. отстраняване на заседнала хартия в устройството за автоматичното подаващо устройство отстраняване на заседнала хартия в устройството за автоматичното подаващо устройство заседнала хартия в автоматичното подаващо устройство (АПУ)"},{"UUID":"72d4e9a3-65e1-408a-937f-597fc78194de","title":"Проблеми с мрежовата връзка","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Не може да отвори Embedded","descFull":"Не може да отвори Embedded Web Server Стъпки за решаване на проблема Действие Да Не Проверете дали принтерът е включен. Отидете на Embedded Web Server (EWS) на принтера. Можете ли да отворите EWS? Проблемът е решен. Уверете се, че IP адресът на принтера е правилен. Вижте IP адреса на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, например 123.123.123.123. Отидете на EWS. Можете ли да отворите EWS? Проблемът е решен. Уверете се, че сте инсталирали поддържан браузър: Internet Explorer версия 11 или по-нова Microsoft Edge Safari версия 6 или по-нова Google Chrome  версия 32 или по-нова Mozilla Firefox версия 24 или по-нова Отидете на EWS. Можете ли да отворите EWS? Проблемът е решен. Проверете дали мрежовата връзка работи. Ако връзката не функционира, тогава се свържете с Вашия администратор. Отидете на EWS. Можете ли да отворите EWS? Проблемът е решен. Уверете се, че кабелните връзки към принтера и сървъра за печат са добре фиксирани. За повече информация вижте доставената със сървъра за печат документация. Отидете на EWS. Можете ли да отворите EWS? Проблемът е решен. Проверете дали са забранени уебпрокси сървърите. Ако сървърите са дезактивирани, тогава се свържете с Вашия администратор. Отидете на EWS. Можете ли да отворите EWS? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . не може да отвори Embedded Web Server отстраняване на неизправности не може да отвори Embedded Web Server"},{"UUID":"b04855dc-a4ea-4cce-a3a9-1c9ebd42e1fd","title":"Проблеми с мрежовата връзка","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Неуспешно свързване на принтера с","descFull":"Неуспешно свързване на принтера с Wi‑Fi мрежата Стъпки за решаване на проблема Действие Да Не Уверете се, че  Active Adapter (Активен адаптер)  е зададен на  Auto (Автоматично) . От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Network Overview (Преглед на мрежата) Active Adapter (Активен адаптер) Auto (Автоматично) . Може ли принтерът да се свърже с Wi‑Fi мрежата? Проблемът е решен. Проверете дали е избрана правилната Wi‑Fi мрежа. Някои рутери може да споделят SSID по подразбиране. Свързвате ли се с правилната Wi‑Fi мрежа? Отидете на стъпка 4. Свържете се с правилната Wi‑Fi мрежа. За повече информация вижте  . Може ли принтерът да се свърже с Wi‑Fi мрежата? Проблемът е решен. Проверете режима на безжична защита. От началния екран докоснете  Settings (Настройки) Network/Ports (Мрежа/портове) Wireless (Безжична връзка) Wireless Security Mode (Режим на безжична защита) . Избран ли е правилният режим на безжична защита? Отидете на стъпка 6. Изберете правилния режим на безжична защита. Може ли принтерът да се свърже с Wi‑Fi мрежата? Проблемът е решен. Уверете се, че сте въвели правилната парола на мрежата. Обърнете внимание на интервалите, цифрите и главните букви в паролата. Може ли принтерът да се свърже с Wi‑Fi мрежата? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . неуспешно свързване на принтера към Wi‑Fi отстраняване на неизправности неуспешно свързване на принтера към Wi‑Fi"},{"UUID":"8343ff82-363d-4eba-9b69-6639f7801328","title":"Проблеми с хардуерните опции","link":"trb-cannot-detect-internal-option-topic.html","desc":"Не може да бъде разпозната","descFull":"Не може да бъде разпозната вътрешна опция Стъпки за решаване на проблема Действие Да Не Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Принтерът открива ли вътрешната опция? Проблемът е решен. Отпечатайте страница с настройки на менюто и след това проверете дали вътрешната опция фигурира в списъка на инсталираните функции. Вътрешната опция посочена ли е? Отидете на стъпка 4. Проверете дали вътрешната опция е инсталирана правилно в контролерната платка. Изключете принтера и след това извадете захранващия кабел от електрическия контакт. Уверете се, че вътрешната опция е инсталирана на подходящия конектор в контролерната платка. Включете захранващия кабел в електрическия контакт и след това включете принтера. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към правилно заземен електрически контакт с подходящо напрежение, който е в близост до продукта и е леснодостъпен. Принтерът открива ли вътрешната опция? Проблемът е решен. Проверете дали вътрешната опция е налична в драйвера на принтера. Ако е необходимо, ръчно добавете вътрешната опция в драйвера на принтера, за да я направите достъпна за задания за печат. За повече информация вижте  . Отпечатайте документа. Принтерът открива ли вътрешната опция? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности, опции на принтера не може да бъде разпозната вътрешна опция отстраняване на неизправности с опциите на принтера не може да бъде разпозната вътрешна опция не може да бъде разпозната вътрешна опция"},{"UUID":"fb4ce527-6509-4758-9da5-6d004dec8fc1","title":"Проблеми с хардуерните опции","link":"trb-cannot-detect-internal-option-topic.html","desc":"Открито дефектно флаш устройство Опитайте","descFull":"Открито дефектно флаш устройство Опитайте едно или няколко от следните неща: Сменете дефектното интелигентно запаметяващо устройство. От началния екран докоснете  Continue (Продължаване) , за да игнорирате съобщението и да продължите печатането. Отменете текущото задание за печат. Свържете се с Вашия  дилър . съобщения на принтера Открито дефектно флаш устройство дефектно интелигентно запаметяващо устройство"},{"UUID":"bfa3c539-06a4-4d3a-ab46-1f0dfd74111d","title":"Проблеми с хардуерните опции","link":"trb-cannot-detect-internal-option-topic.html","desc":"Няма достатъчно свободно пространство във","descFull":"Няма достатъчно свободно пространство във флаш паметта за ресурси Опитайте едно или няколко от следните неща: Докоснете  Continue (Продължаване) , за да изчистите съобщението и да продължите да печатате. Изтрийте шрифтове, макроси и други данни, съхранени във флаш паметта. Монтирайте твърд диск. Изтеглените шрифтове и макроси, които преди това не са съхранени във флаш паметта, се изтриват. Свържете се с Вашия  дилър . съобщения на принтера Няма достатъчно свободно пространство във флаш паметта за ресурси Няма достатъчно свободно пространство във флаш паметта за ресурси"},{"UUID":"1b101df3-a20c-41a7-8a29-ff442d9887d1","title":"Проблеми с хардуерните опции","link":"trb-cannot-detect-internal-option-topic.html","desc":"Червена светлина на универсалното телбод","descFull":"Червена светлина на универсалното телбод устройство Опитайте едно или няколко от следните неща: Затворете вратичката за достъп до телбода. Отстранете разхлабените скоби. След отстраняването на разхлабени скоби са необходими два цикъла на зареждане преди поставянето на скоби. Поставете три пъти топ хартия в телбод устройството. Поставянето на скоби започва при третото поставяне. Смяна на касетата със скоби за телбод. червена индикаторна светлина на универсалното телбод устройство универсално телбод устройство червена индикаторна светлина"},{"UUID":"1f69182b-8a15-4fb9-b82d-33debf0b2952","title":"Проблеми с консумативите","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Заменете касетата, несъответствие с региона","descFull":"Заменете касетата, несъответствие с региона на принтера За да разрешите този проблем, купувайте касети за правилния регион, отговарящ на региона на принтера, или касети, които могат да се използват в целия свят. Първата цифра след 42 в съобщението посочва региона на принтера. Втората цифра след 42 в съобщението посочва региона на касетата. Инсталирайте правилната касета с тонер. Региони на касета с тонер и принтер Регион Цифров код За целия свят или за неопределен регион 0 Северна Америка (САЩ, Канада), Австралия, Нова Зеландия 1 Европейска икономическа зона, Исландия, Лихтенщайн и Норвегия 2 Азиатско-тихоокеански регион 3 Латинска Америка 4 Останалата част от Европа, Близкия изток, Африка 5 Невалиден регион 9 За да откриете регионалните настройки на принтера и касетата с тонер, отпечатайте тестовите страници за качество на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . съобщения на принтера Заменете касетата, несъответствие с региона на принтера Заменете касетата, несъответствие с региона на принтера"},{"UUID":"cc214053-5587-4c47-adee-32cc89682859","title":"Проблеми с консумативите","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Консумативи, които не са на","descFull":"Консумативи, които не са на Lexmark Консумативи, които не са на Dell Консумативи, които не са на производителя на принтера Принтерът установи инсталиран консуматив или част, която не е на Lexmark. Принтерът установи инсталиран консуматив или част, която не е на Dell. Принтерът установи инсталиран непознат консуматив или част. Вашият принтер Lexmark е разработен за най-добра работа с оригинални консумативи и части на Lexmark. Използването на консумативи и части от трети страни може да повлияе на качеството на работа, надеждността или живота на принтера и неговите компоненти. Вашият принтер Dell е разработен за най-добра работа с оригинални консумативи и части на Dell. Използването на консумативи и части от трети страни може да повлияе на качеството на работа, надеждността или живота на принтера и неговите компоненти. Вашият принтер е разработен за най-добра работа с оригинални консумативи и части от производителя на принтера. Използването на консумативи и части от трети страни може да повлияе на качеството на работа, надеждността или живота на принтера и неговите компоненти. Всички показатели за срока на експлоатация са проектирани за работа с консумативи и части на Lexmark и може да предоставят неочаквани резултати, ако се използват консумативи или части от трети страни. Използването на модула за изображения извън предназначения срок на експлоатация може да повреди Вашия принтер Lexmark или свързаните с него компоненти. Всички показатели за срока на експлоатация са проектирани за работа с консумативи и части на Dell и може да предоставят неочаквани резултати, ако се използват консумативи или части от трети страни. Използването на модула за изображения извън предназначения срок на експлоатация може да повреди Вашия принтер Dell или свързаните с него компоненти. Всички показатели за срока на експлоатация са проектирани за работа с консумативи и части на производителя на принтера и може да предоставят неочаквани резултати, ако се използват консумативи или части от трети страни. Използването на модула за изображения извън предназначения срок на експлоатация може да повреди Вашия принтер или свързаните с него компоненти. Използването на консумативи или части от трети страни може да повлияе на гаранционния обхват. Щети, причинени от използването на консумативи или части от трети страни, може да не се покриват от гаранцията. За да приемете някои от или всички тези рискове и да продължите с използването на неоригинални консумативи или части във Вашия принтер, докоснете и задръжте съобщението за грешка върху дисплея в продължение на 15 секунди. Когато се появи диалогов прозорец за потвърждение, докоснете  Continue (Продължаване) . Ако не желаете да приемате тези рискове, отстранете консумативите или частите на трети страни и след това инсталирайте в принтера си оригинални консумативи или части на Lexmark. За повече информация вижте  . Ако не желаете да приемате тези рискове, отстранете консумативите или частите от трети страни и след това инсталирайте в принтера си оригинални консумативи или части на Dell. Ако не желаете да приемате тези рискове, отстранете консумативите или частите от трети страни и след това инсталирайте в принтера си оригинални консумативи или части на производителя на принтера. Ако принтерът не печата след изчистването на съобщението за грешка, тогава нулирайте брояча за използването на консумативи. От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Supply Usage And Counters (Използване на консумативи и броячи) . Изберете частта или консуматива, който желаете да нулирате, след което докоснете  Start (Старт) . Прочетете предупредителното съобщение, след което докоснете  Continue (Продължаване) . Докоснете с два пръста дисплея в продължение на 15 секунди, за да изчистите съобщението. Ако не успеете да нулирате броячите за използване на консумативи, тогава върнете консуматива на обекта на закупуване. съобщения на принтера Консумативи, които не са на Lexmark Консумативи, които не са на Lexmark съобщения на принтера Консумативи, които не са на Dell Консумативи, които не са на Dell съобщения на принтера Консумативи, които не са на производителя на принтера Консумативи, които не са на производителя на принтера нулиране броячи за използването на консумативи броячи за използването на консумативи нулиране нулиране на броячите за използването на консумативи"},{"UUID":"6c0222fa-94c7-4080-85d0-1862f0f2a547","title":"Проблеми с подаването на хартия","link":"trb-envelope-seals-when-printing-topic.html","desc":"Пликът се запечатва при отпечатване","descFull":"Пликът се запечатва при отпечатване Стъпки за решаване на проблема Действие Да Не Използвайте плик, който е съхраняван в суха среда. Отпечатването на пликове при силно овлажнено съдържание може да запечата предкрилката. Изпратете заданието за печат. Пликът запечатва ли се по време на отпечатване? Проблемът е решен. Уверете се, че типът на хартията е настроен на Envelope (Плик). От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Изпратете заданието за печат. Пликът запечатва ли се по време на отпечатване? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. отстраняване на неизправности, отпечатване пликът се запечатва при отпечатване отстраняване на неизправности на печата пликът се запечатва при отпечатване пликът се запечатва при отпечатване"},{"UUID":"90907543-42d8-4dca-af9a-d7fbd4642d25","title":"Проблеми с подаването на хартия","link":"trb-envelope-seals-when-printing-topic.html","desc":"Отпечатването с колиране не работи","descFull":"Отпечатването с колиране не работи Стъпки за решаване на проблема Действие Да Не От началния екран докоснете  Settings (Настройки) Print (Отпечатване) Layout (Оформление) Collate (Колиране) . Докоснете  On [1,2,1,2,1,2] (Вкл. [1,2,1,2,1,2]) . Отпечатайте документа. Документът правилно ли е колиран? Проблемът е решен. От документа, който искате да отпечатате, отворете диалоговия прозорец за отпечатване и след това изберете  Collate  (Колиране). Отпечатайте документа. Документът правилно ли е колиран? Проблемът е решен. Намалете броя на страниците за отпечатване. Отпечатайте документа. Правилно ли са колирани страниците? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности на печата отпечатването с колиране не работи отстраняване на неизправности, отпечатване отпечатването с колиране не работи отпечатването с колиране не работи"},{"UUID":"211cdbfd-bee6-4157-9e72-8eef450773b7","title":"Проблеми с подаването на хартия","link":"trb-envelope-seals-when-printing-topic.html","desc":"Свързването на тавите не работи","descFull":"Свързването на тавите не работи Стъпки за решаване на проблема Действие Да Не Проверете дали хартията в тавите е с еднакъв размер и от един и същи тип. Проверете дали водачите на хартията са позиционирани правилно. Отпечатайте документа. Свързани ли са правилно тавите? Проблемът е решен. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Задайте размера и типа хартия да съвпадат с хартията, заредена в свързаните тави. Отпечатайте документа. Свързани ли са правилно тавите? Проблемът е решен. Уверете се, че  Tray Linking (Тавата се свързва)  е настроено на  Automatic (Автоматично) . За повече информация вижте  . Отпечатайте документа. Свързани ли са правилно тавите? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности, отпечатване свързването на тавите не работи отстраняване на неизправности на печата свързването на тавите не работи"},{"UUID":"41e9dede-5d96-45df-ba84-7202f4e9b7db","title":"Проблеми с подаването на хартия","link":"trb-envelope-seals-when-printing-topic.html","desc":"Хартията често засяда Стъпки за","descFull":"Хартията често засяда Стъпки за решаване на проблема Действие Да Не Извадете тавата. Проверете дали хартията е заредена правилно. Уверете се, че водачите на хартия са позиционирани правилно. Уверете се, че височината на топа е под индикатора за максимално ниво на хартията. Уверете се, че отпечатвате на препоръчаните размер и тип на хартията. Поставете тавата. Отпечатайте документа. Често ли засяда хартията? Проблемът е решен. От началния екран докоснете  Settings (Настройки) Paper (Хартия) Tray Configuration (Конфигуриране на тава) Paper Size/Type (Размер/тип на хартията) . Задайте правилния размер и тип на хартията. Отпечатайте документа. Често ли засяда хартията? Проблемът е решен. Заредете хартия от нов пакет. Хартията абсорбира влагата поради високото ниво на влажност. Съхранявайте хартията в оригиналната опаковка, докато не сте готови да я използвате. Отпечатайте документа. Често ли засяда хартията? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. отстраняване на неизправности, отпечатване хартията често засяда отстраняване на неизправности на печата хартията често засяда хартията често засяда"},{"UUID":"2bc7104e-91de-4610-9981-6cd52e428fc4","title":"Проблеми с подаването на хартия","link":"trb-envelope-seals-when-printing-topic.html","desc":"Заседналите страници не се отпечатват","descFull":"Заседналите страници не се отпечатват повторно Стъпка за решаване на проблема Действие Да Не От началния екран докоснете  Settings (Настройки) Device (Устройство) Notifications (Известия) Jam Content Recovery (Възстановяване на заседнало съдържание) . В менюто Jam Recovery (Възстановяване при засядане) докоснете  On (Вкл.)  или  Auto (Автоматично) . Отпечатайте документа. Заседналите страници отпечатват ли се отново? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности, отпечатване заседналите страници не се отпечатват повторно заседналите страници не се отпечатват повторно"},{"UUID":"2b9a843e-64be-40d6-bf72-2f75aa89f60c","title":"Проблеми с изпращането на имейли","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Дезактивиране на съобщението за грешка","descFull":"Дезактивиране на съобщението за грешка „SMTP сървърът не е настроен“ От началния екран докоснете  Settings (Настройки) E‑mail (Имейл) E‑mail Setup (Конфигуриране на имейл) Disable \"SMTP Server not set up\" error (Дезактивиране на грешката \"SMTP сървърът не е конфигуриран\") On (Вкл.) . За да предотвратите повторното възникване на грешката, извършете едно или повече от следните: Актуализирайте фърмуера на принтера. За повече информация вижте  . Конфигурирайте SMTP настройките за имейл. За повече информация вижте  . Дезактивирайте грешка „SMTP сървърът не е настроен“ деактивиране отстраняване на неизправности Дезактивирайте грешка „SMTP сървърът не е настроен“ дезактивиране на грешка „SMTP сървърът не е настроен“"},{"UUID":"c9b71d62-6663-4261-a116-66b88a18cbbe","title":"Проблеми с изпращането на имейли","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Не могат да се изпращат","descFull":"Не могат да се изпращат имейли Стъпки за решаване на проблема Действие Да Не Уверете се, че SMTP настройките за имейл са конфигурирани правилно. За повече информация вижте  . Можете ли да изпратите имейл? Проблемът е решен. Уверете се, че използвате правилната парола. В зависимост от Вашия доставчик на имейл услуги използвайте Вашата парола на акаунта, парола на приложението или парола за удостоверяване. За повече информация вижте  . Можете ли да изпратите имейл? Проблемът е решен. Уверете се, че принтерът е свързан с мрежа и че мрежата е свързана с интернет. Можете ли да изпратите имейл? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности с имейл не могат да се изпращат имейли отстраняване на неизправности, имейл не могат да се изпращат имейли не могат да се изпращат имейли"},{"UUID":"70940f78-f1a8-447f-a007-a251dbb71c5a","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Не се показва ID на","descFull":"Не се показва ID на повикващ Тези инструкции се отнасят само за принтери, които поддържат аналогов факс. За повече информация вижте раздела  Конфигуриране на принтера за факс . Стъпки за решаване на проблема Действие Да Не Разрешете ИД на повикващия. От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Admin Controls (Контроли за администратор) Enable Caller ID (Разрешаване на ID на повикващия) . Появява ли се ID на повикващ? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности, факс не се показва ID на повикващ отстраняване на неизправности при работа с факс не се показва ID на повикващ не се показва ID на повикващ"},{"UUID":"b106f433-54b3-4661-a57c-57c458a9c6c1","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Не могат да се изпращат","descFull":"Не могат да се изпращат или получават факсове чрез използване на аналогов факс Стъпки за решаване на проблема Действие Да Не Разрешете всички съобщения за грешка, които се появяват на дисплея. Можете ли да изпратите или получите факс? Проблемът е решен. Уверете се, че кабелните връзки за следното оборудване са стабилни: Телефон Слушалки с микрофон Телефонен секретар Можете ли да изпратите или получите факс? Проблемът е решен. Проверете за сигнал „свободно“. Обадете се на факс номера, за да се уверите, че работи правилно. Ако използвате функцията „On Hook Dial“, усилете нивото на звука, за да проверите дали чувате сигнал „свободно“. Можете ли да чуете сигнал \"свободно\"? Отидете на стъпка 5. Проверете стенната розетка на телефона. Свържете аналоговия телефон директно към стенната розетка. Слушайте за сигнал „свободно“. Ако не чувате сигнал \"свободно\", тогава използвайте друг телефонен кабел. Ако все още не чувате сигнал \"свободно\", свържете аналоговия телефон към друга стенна розетка. Ако чуете сигнал „свободно“, принтерът е свързан правилно. Можете ли да изпратите или получите факс? Проблемът е решен. Проверете дали принтерът е свързан към аналогова телефонна услуга или към правилния цифров конектор. Ако използвате телефонна услуга с комплексни услуги за дигитална мрежа (Integrated Services for Digital Network, ISDN), свържете към аналогов телефонен порт на ISDN клемен адаптер. За повече информация се обърнете към Вашия ISDN доставчик. Ако използвате DSL (цифрова абонатна линия), се свържете към DSL филтър или рутер, който поддържа аналогова употреба. За повече информация се обърнете към вашия DSL доставчик. Ако използвате телефонна услуга с частна телефонна централа (РВХ), се уверете, че се свързвате към аналогова връзка в PBX. Ако не съществува такава, обмислете инсталирането на аналогова телефонна линия за факс машината. Можете ли да изпратите или получите факс? Проблемът е решен. Временно изключете другото оборудване и дезактивирайте другите телефонни услуги. Разкачете другото оборудване (като телефонни секретари, компютри, модеми или сплитери на телефонни линии) между принтера и телефонната линия. Дезактивирайте изчакване на обаждането и гласова поща. За повече информация се обърнете към вашата телефонна компания. Можете ли да изпратите или получите факс? Проблемът е решен. Сканирайте оригиналния документ страница по страница. Наберете номера на факса. Сканирайте документа. Можете ли да изпратите или получите факс? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс не могат да се изпращат или получават факсове чрез използване на аналогов факс отстраняване на неизправности, факс не могат да се изпращат или получават факсове чрез използване на аналогов факс не могат да се изпращат или получават факсове чрез използване на аналогов факс"},{"UUID":"d0b0a702-0658-401f-87c2-c5a202515f1c","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Могат да се получават, но","descFull":"Могат да се получават, но не могат да се изпращат факсове чрез използване на аналогов факс Стъпки за решаване на проблема Действие Да Не Заредете оригинален документ правилно в тавата на АПУ или върху стъклото на скенера. Можете ли да изпращате факсове? Проблемът е решен. Настройте правилно номера на бързата команда. Проверете дали номерът на бързата команда е зададен за телефонния номер, който искате да наберете. Наберете телефонния номер ръчно. Можете ли да изпращате факсове? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс не могат да се изпращат факсове чрез използване на аналогов факс отстраняване на неизправности, факс не могат да се изпращат факсове чрез използване на аналогов факс"},{"UUID":"b4610e32-2ce7-4715-a8d1-b96122e5d8c4","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Могат да се изпращат, но","descFull":"Могат да се изпращат, но не могат да се получават факсове чрез използване на аналогов факс Стъпки за решаване на проблема Действие Да Не Уверете се, че източникът на хартията не е празен. Можете ли да изпращате факсове? Проблемът е решен. Проверете настройките за забавяне чрез броя позвънявания. От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) Fax Receive Settings (Настройки за получаване на факс) Rings to Answer (Позвънявания преди отговор) . Можете ли да изпращате факсове? Проблемът е решен. Ако принтерът отпечатва празни страници, тогава вижте  . Можете ли да изпращате факсове? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс могат да се изпращат, но не могат да се получават факсове чрез използване на аналогов факс отстраняване на неизправности, факс могат да се изпращат, но не могат да се получават факсове чрез използване на аналогов факс не могат да се получават факсове чрез използване на аналогов факс"},{"UUID":"e1e7b80f-6dc9-4e05-88b7-3c435d12c5b5","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Не може да се настрои","descFull":"Не може да се настрои etherFAX Стъпки за решаване на проблема Действие Yes (Да) Не Проверете връзката на принтера. Печат на  страницата за настройки на мрежата . От началния екран докоснете  Settings (Настройки) Reports (Отчети) Network (Мрежа) Network Setup Page (Страница за настройка на мрежа) . Проверете състоянието на мрежата. Принтерът свързан ли е към мрежата? Отидете на стъпка 3. Уверете се, че принтерът е свързан с мрежа и че мрежата е свързана с интернет. Можете ли да настроите etherFAX? Проблемът е решен. Уверете се, че etherFAX е настроен правилно. За повече информация вижте  . Можете ли да настроите etherFAX? Проблемът е решен. Отидете на  https://www.etherfax.net/lexmark . отстраняване на неизправности при работа с факс не може да се настрои etherFAX отстраняване на неизправности, факс не може да се настрои etherFAX"},{"UUID":"5c956a70-d0f6-4446-bd1b-a15f55ff7e56","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Не могат да се изпращат","descFull":"Не могат да се изпращат или получават факсове чрез използване на etherFAX Стъпки за решаване на проблема Действие Да Не Уверете се, че принтерът е свързан с мрежа и че мрежата е свързана с интернет. Можете ли да изпращате или получавате факсове чрез използване на etherFAX? Проблемът е решен. Уверете се, че etherFAX е настроен правилно. От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс) General Fax Settings (Общи настройки на факс) . Уверете се, че имате правилия номер на факс. Уверете се, че опцията  Fax Transport (Транспортиране на факс)  е зададена на  etherFAX . Това меню се показва само когато има повече от един вид предаване на факс. Ако принтерът има инсталиран само etherFAX, тогава той се конфигурира автоматично. Можете ли да изпращате или получавате факсове чрез използване на etherFAX? Проблемът е решен. Разделете големите документи на по-малки размери на файловете. Можете ли да изпращате или получавате факсове чрез използване на etherFAX? Проблемът е решен. Отидете на  https://www.etherfax.net/lexmark . отстраняване на неизправности при работа с факс не могат да се изпращат или получават факсове чрез използване на etherFAX отстраняване на неизправности, факс не могат да се изпращат или получават факсове чрез използване на etherFAX не могат да се изпращат или получават факсове чрез използване на etherFAX"},{"UUID":"4b6e45b6-77e7-4633-a498-9a79812def93","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Лошо качество на печат на","descFull":"Лошо качество на печат на факса Стъпки за решаване на проблема Действие Да Не Уверете се, че няма дефекти по качеството на печат. От началния екран докоснете  Settings (Настройки) Troubleshooting (Отстраняване на неизправности) Print Quality Test Pages (Тестови страници за качество на печат) . Коригирайте всеки дефект по качеството на печат. За повече информация вижте  . Задоволително ли е качеството на отпечатване на факса? Проблемът е решен. Ако използвате аналогов факс, тогава намалете скоростта на предаване на входящите факс съобщения. От началния екран докоснете  Settings (Настройки) Fax (Факс) Fax Setup (Конфигуриране на факс)  Fax Receive Settings (Настройки за получаване на факс) Admin Controls (Контроли за администратор) . В менюто Max Speed (Максимална скорост) изберете по-бавна скорост на предаване. Задоволително ли е качеството на отпечатване на факса? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс лошо качество на печат лошо качество на печат на факса отстраняване на неизправности, факс лошо качество на печат"},{"UUID":"18c3565a-e62c-439f-a79e-2119c1b929f3","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Липсваща информация на заглавната страница","descFull":"Липсваща информация на заглавната страница за факс Стъпки за решаване на проблема Действие Не Да Изключете принтера, изчакайте около 10 секунди и след това включете принтера. Изпратете или извлечете факса. Появи ли се липсващата информация на заглавната страница за факс? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс липсваща информация на заглавната страница за факс отстраняване на неизправности, факс липсваща информация на заглавната страница за факс липсваща информация на заглавната страница за факс"},{"UUID":"e88c833c-be65-447e-ad05-1bc07dbeee55","title":"Проблеми с работата на факса","link":"trb-caller-id-not-shown-topic.html","desc":"Не може да се изпраща","descFull":"Не може да се изпраща заглавната страница за факс от компютъра Стъпки за решаване на проблема Действие Да Не Уверете се, че драйверът на принтера е актуализиран. За повече информация вижте  . Изпратете факса. Можете ли да изпратите заглавната страница за факс? Проблемът е решен. От документа, който се опитвате да изпратите по факса, отворете диалоговия прозорец  Print (Отпечатване) . Изберете принтера, след което кликнете върху  Properties  (Свойства),  Preferences  (Предпочитания),  Options  (Опции) или  Setup  (Конфигуриране). Кликнете върху  Fax (Факс) , след което изчистете настройката  Always display settings prior to faxing (Винаги показвай настройките преди изпращане по факс) . Изпратете факса. Можете ли да изпратите заглавната страница за факс? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при работа с факс не може да се изпраща заглавната страница за факс от компютъра отстраняване на неизправности, факс не може да се изпраща заглавната страница за факс от компютъра не може да се изпраща заглавната страница за факс от компютъра"},{"UUID":"b50a22b5-eaf0-4225-84ba-78e24cfe4ad6","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Не може да се извърши","descFull":"Не може да се извърши сканиране към компютър Стъпки за решаване на проблема Действие Да Не Изпълнете задание за копиране. Успешно ли е заданието за копиране? Отидете на стъпка 3. Изключете принтера, изчакайте около 10 секунди и след това го включете отново. Сканирайте документа. Можете ли да изпълните сканиране на документа към компютър? Проблемът е решен. Проверете връзката на принтера. Печат на  Network Setup Page (Страница за настройка на мрежа) . От началния екран докоснете  Settings (Настройки) Reports (Отчети) Network (Мрежа) Network Setup Page (Страница за настройка на мрежа) . Проверете състоянието на мрежата. Принтерът свързан ли е към мрежата? Отидете на стъпка 5. Свържете принтера към мрежата. Сканирайте документа. Можете ли да изпълните сканиране на документа към компютър? Проблемът е решен. Уверете се, че принтерът и компютърът са свързани към една и съща мрежа. Сканирайте документа. Можете ли да изпълните сканиране на документа към компютър? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . отстраняване на неизправности при сканиране не може да се извърши сканиране към компютър отстраняваме на неизправности, сканиране не може да се извърши сканиране към компютър не може да се извърши сканиране към компютър"},{"UUID":"f6607c34-9dc6-4432-97b9-a103ca105aac","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Не може да се извърши","descFull":"Не може да се извърши сканиране към мрежова папка Стъпки за решаване на проблема Действие Да Не Създайте бърза команда за мрежова папка. Сканирайте документ, като използвате бързата команда. За повече информация вижте  . Можете ли да сканирате документ и да го запазите в мрежова папка? Проблемът е решен. Уверете се, че пътят и форматът до мрежовата папка са правилни. Например,  // server_hostname /foldername/path , където  server_hostname  е потребителски домейн в пълен вид (FQDN) или IP адрес. Правилен ли е пътят и форматът до мрежовата папка? Отидете на стъпка 4. Уверете се, че имате разрешение за достъп за записване в мрежовата папка. Можете ли да сканирате документ и да го запазите в мрежова папка? Проблемът е решен. Актуализирайте бързата команда за мрежовата папка. Отворете уеб браузър и въведете IP адреса на принтера в полето за адрес. Вижте IP адреса на принтера на началния екран. IP адресът се появява като четири поредици от цифри, разделени с точки, напр. 123.123.123.123. В случай че използвате прокси сървър, временно го изключете, за да заредите уеб страницата правилно. Кликнете върху  Shortcuts (Бързи команди) , след което изберете бърза команда. Ако имате няколко типа бързи команди, тогава изберете  Network Folder (Мрежова папка) . В полето  Share Path (Път за споделяне)  въведете пътя до мрежовата папка. Ако Вашият път за споделяне е  \\\\server_hostname\\foldername\\path , тогава въведете  //server_hostname/foldername/path . Уверете се, че използвате наклонени напред черти, когато въвеждате пътя за споделяне. От менюто  Authentication (Удостоверяване)  изберете Вашия метод за удостоверяване. Ако  Authentication (Удостоверяване)  е зададено на „ Use assigned username and password (Използване на присвоено потребителско име и парола) “, тогава въведете Вашите идентификационни данни в полетата  User Name (Потребителско име)  и  Password (Парола) . Кликнете върху  Save (Записване) . Можете ли да сканирате документ и да го запазите в мрежова папка? Проблемът е решен. Уверете се, че принтерът и мрежовата папка са свързани към една и съща мрежа. Можете ли да сканирате документ и да го запазите в мрежова папка? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . не може да се извърши сканиране към мрежова папка отстраняваме на неизправности, сканиране не може да се извърши сканиране към мрежова папка отстраняване на неизправности при сканиране не може да се извърши сканиране към мрежова папка"},{"UUID":"a1b48400-aedf-4c6c-94d7-ab403e23cf02","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Частични копия на документ или","descFull":"Частични копия на документ или снимка Стъпки за решаване на проблема Действие Да Не Уверете се, че документът или снимката е поставен в горния ляв ъгъл на стъклото на скенера с лицевата част надолу. Копирайте документа или снимката. Копиран ли е правилно документът или снимката? Проблемът е решен. Настройката за размер на хартията трябва да отговаря на хартията, заредена в тавата. Копирайте документа или снимката. Копиран ли е правилно документът или снимката? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с качеството на копиране частични копия на документи проблем с качеството на копиране частични копия на снимки проблем с качеството на сканиране частични копия на документи проблем с качеството на сканиране частични копия на снимки частични копия на документи частични копия на снимки"},{"UUID":"bed22c38-70c8-48cb-a82e-1c01649a34ae","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Лошо качество на копиране Стъпки","descFull":"Лошо качество на копиране Стъпки за решаване на проблема Действие Да Не Почистване на стъклото на скенера и стъклото на АПУ с влажна мека кърпа без влакна. Ако принтерът Ви има второ стъкло на АПУ вътре в АПУ, почистете също и това стъкло. За повече информация вижте  . Уверете се, че документът или снимката е поставен в горния ляв ъгъл на стъклото на скенера с лицевата част надолу. Копирайте документа или снимката. Задоволително ли е качеството на копиране? Проблемът е решен. Проверете качеството на оригиналния документ или снимка. Регулирайте настройките за качество на сканиране. Копирайте документа или снимката. Задоволително ли е качеството на копиране? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с качеството на копиране лошо качество на копиране проблем с качеството на сканиране лошо качество на копиране лошо качество на копиране"},{"UUID":"fcc4b3d5-1881-4bfe-9b38-5747ed8cc605","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Тъмни вертикални черти по изходящия","descFull":"Тъмни вертикални черти по изходящия документ при сканиране от АПУ Тъмни вертикални черти по изходящия документ при сканиране от АПУ Стъпки за решаване на проблема Действие Да Не Отворете капака на скенера. С помощта на влажна, мека кърпа без власинки избършете стъклото на АПУ и стъклената подложка на АПУ. Затворете капака на скенера. Сканирайте документа. Появяват ли се вертикални черти по сканираните документи? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на сканиране вертикални тъмни черти проблем с качеството на копиране вертикални тъмни черти вертикални тъмни черти при сканиране от АПУ сканиране от АПУ вертикални тъмни черти"},{"UUID":"2a46baaf-70a1-4cb5-87f2-ba7e977dca56","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Назъбено изображение или текст при","descFull":"Назъбено изображение или текст при сканиране от АПУ Стъпки за решаване на проблема Действие Да Не Заредете 50 страници чиста обикновена хартия в АПУ. Обикновената хартия помага да се почисти или отстрани прахът и другото покритие от подаващите ролки на АПУ. От началния екран докоснете  . Заредете оригинален документ в АПУ. Сканирайте документа. Появяват ли се назъбени изображения или текстове върху разпечатките? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем с качеството на сканиране назъбено изображение проблем с качеството на сканиране назъбен текст назъбено изображение сканиране от АПУ назъбен текст сканиране от АПУ"},{"UUID":"140372a5-5f7a-45cd-a0a6-8a63d5c6a714","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Заданието за сканиране е неуспешно","descFull":"Заданието за сканиране е неуспешно Стъпки за решаване на проблема Действие Да Не Проверете кабелните връзки. Уверете се, че Ethernet или USB кабелът е свързан безопасно към компютъра и принтера. Сканирайте документа. Успешна ли е задачата за сканиране? Проблемът е решен. Проверете файла, който желаете да сканирате. Уверете се, че името на файла вече не се използва в папката на местоназначението. Уверете се, че документът или снимката, които желаете да сканирате, не са отворени в друго приложение. Сканирайте документа. Успешна ли е задачата за сканиране? Проблемът е решен. Уверете се, че отметките Append time stamp (Добавяне на времево клеймо) или Overwrite existing file (Записване върху съществуващ файл) са избрани в конфигурационните настройки на местоназначението. Сканирайте документа. Успешна ли е задачата за сканиране? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . заданието за сканиране е неуспешно проблем със сканирането заданието за сканиране е неуспешно"},{"UUID":"e1da62c8-acda-4050-8171-04f8d2a732d5","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Скенерът не се затваря Стъпка","descFull":"Скенерът не се затваря Стъпка за решаване на проблема Действие Да Не Отстранете препятствията, които задържат капака на скенера отворен. Затвори ли се правилно капакът на скенера? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с копирането скенерът не се затваря проблем със сканирането скенерът не се затваря скенерът не се затваря"},{"UUID":"cc0d32a3-2a59-40a2-8654-4e4a89a91913","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Сканирането е много бавно или","descFull":"Сканирането е много бавно или блокира компютъра Стъпки за решаване на проблема Действие Да Не Затворете всички приложения, които пречат на сканирането. Продължава ли сканирането да е много бавно или да блокира компютъра? Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . Проблемът е решен. проблем със сканирането сканирането отнема твърде дълго проблем със сканирането при сканиране компютърът \"замръзва\""},{"UUID":"df355be4-9558-4120-b567-df5f303b127c","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Скенерът не реагира Стъпки за","descFull":"Скенерът не реагира Стъпки за решаване на проблема Действие Да Не Проверете дали захранващият кабел е правилно свързан към принтера и електрическия контакт. За да избегнете риска от пожар или токов удар, свържете захранващия кабел към подходящ и правилно заземен електрически контакт, който е в близост до продукта и е леснодостъпен. Копиране или сканиране на документ. Реагира ли скенерът? Проблемът е решен. Проверете дали принтерът е включен. Разрешете всички съобщения за грешка, които се появяват на дисплея. Копиране или сканиране на документ. Реагира ли скенерът? Проблемът е решен. Изключете принтера, изчакайте около 10 секунди и след това го включете отново. Копиране или сканиране на документ. Реагира ли скенерът? Проблемът е решен. Свържете се с  поддръжка на клиенти . Свържете се с  техническа поддръжка . Свържете се с Вашия  дилър . проблем с копирането скенерът не отговаря проблем със сканирането скенерът не отговаря скенерът не отговаря"},{"UUID":"95abf5db-3e8b-491e-98fc-bcd8878c9bb0","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Коригиране на регистрацията на скенера","descFull":"Коригиране на регистрацията на скенера От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Scanner Configuration (Конфигуриране на скенера) Scanner Manual Registration (Ръчна регистрация на скенера) . В менюто Print Quick Test (Бърз тест за отпечатване) докоснете  Start (Старт) . Поставете страницата Print Quick Test (Бърз тест за отпечатване) върху стъклото на скенера и докоснете  Flatbed Registration (Регистрация на хориз. скенер) . В менюто Copy Quick Test (Бърз тест за копиране) докоснете  Start (Старт) . Сравнете страницата Copy Quick Test (Бърз тест за копиране) с оригиналния документ. Ако границите на тестовата страница се различават от оригиналния документ, то коригирайте Left Margin (Лява граница) и Top Margin (Горна граница). Повторете   и  , докато полетата на страницата Copy Quick Test (Бърз тест за копиране) съвпаднат с оригиналния документ. регулиране регистриране на скенер"},{"UUID":"48666cf1-b6ff-4975-b127-75978ae35226","title":"Проблеми със сканирането","link":"trb-cannot-scan-to-computer-topic.html","desc":"Коригиране на регистрацията на АПУ","descFull":"Коригиране на регистрацията на АПУ От началния екран докоснете  Settings (Настройки) Device (Устройство) Maintenance (Поддръжка) Configuration Menu (Меню за конфигуриране) Scanner Configuration (Конфигуриране на скенера) Scanner Manual Registration (Ръчна регистрация на скенера) . В менюто Print Quick Test (Бърз тест за отпечатване) докоснете  Start (Старт) . Поставете страницата от Print Quick Test (Бърз тест за отпечатване) върху тавата на АПУ. Докоснете  Front ADF Registration (Предна регистрация на АПУ)  или  Rear ADF Registration (Задна регистрация на АПУ) . За да подравните Front ADF Registration (Предна регистрация на АПУ), поставете тестовата страница с лицето нагоре, с късата страна първо в АПУ. За да подравните Rear ADF Registration (Задна регистрация на АПУ), поставете тестовата страница с лицето надолу, с късата страна първо в АПУ. В менюто Copy Quick Test (Бърз тест за копиране) докоснете  Start (Старт) . Сравнете страницата Copy Quick Test (Бърз тест за копиране) с оригиналния документ. Ако границите на тестовата страница се различават от оригиналния документ, то коригирайте Horizontal Adjust (Хоризонтална корекция) и Top Margin (Горна граница). Повторете   и  , докато полетата на страницата Copy Quick Test (Бърз тест за копиране) съвпаднат с оригиналния документ. регистриране на АПУ регулиране коригиране на регистрацията на АПУ"},{"UUID":"017c1972-f0b2-459b-846e-5b2b94ae8a02","title":"Отстраняване на проблем","link":"trb-contacting-customer-support-topic.html","desc":"Свързване с поддръжка на клиенти","descFull":"Свързване с поддръжка на клиенти Преди да се свържете с поддръжка на клиенти, се уверете, че разполагате със следната информация: Проблеми с принтера Съобщение за грешка Тип на модела на принтера и сериен номер Отидете на  http://support.lexmark.com , за да получавате поддръжка по имейл или чат или прегледайте библиотеката от ръководства, документация за поддръжка, драйвери и други изтегляния. Техническа поддръжка през телефона също е достъпна. За САЩ или Канада използвайте 1-800-539-6275. За други държави или региони отидете в  директорията за контакти за международна поддръжка . Посетете мястото, откъдето сте закупили принтера. свързване с поддръжката на клиенти поддръжката на клиенти осъществяване на контакт"},{"UUID":"570874f3-e072-41f0-aa2e-561ec27256a2","title":"Отстраняване на проблем","link":"troubleshooting-chapter.html","desc":"Свързване с техническата поддръжка Когато","descFull":"Свързване с техническата поддръжка Когато се обадите за техническа поддръжка, трябва да опишете проблема, съобщението на дисплея на принтера и стъпките за отстраняване на проблеми, които вече сте предприели. Вижте етикета от вътрешната страна на горния преден капак или от задната страна на принтера и си запишете следното: Модела на принтера Номера на сервизния етикет или кода за експресно обслужване За повече информация отидете на  www.dell.com/support . отстраняване на неизправности свързване с техническата поддръжка свързване с техническата поддръжка"},{"UUID":"93f61235-34a8-419d-b54a-4af03c42cce6","title":"Отстраняване на проблем","link":"troubleshooting-chapter.html","desc":"Свързване с Вашия дилър Преди","descFull":"Свързване с Вашия дилър Преди да се свържете с Вашия дилър, се уверете, че разполагате със следната информация: Проблеми с принтера Съобщение за грешка Тип на модела на принтера и сериен номер свързване с Вашия дилър дилър на принтери"},{"UUID":"b0aab9c4-fdff-40d2-ba05-e0a665f3663b","title":"Преработване и изхвърляне","link":"recycling-lexmark-products-topic.html","desc":"Рециклиране на продукти на Lexmark","descFull":"Рециклиране на продукти на Lexmark За да върнете продукти на Lexmark за рециклиране: Отидете на  www.lexmark.com/recycle . Изберете вашата страна или регион. Изберете програма за рециклиране. Следвайте инструкциите на екрана. рециклиране на продукти на Lexmark"},{"UUID":"1ded675e-e1cd-4bdd-be13-47164e991eb7","title":"Преработване и изхвърляне","link":"recycling-lexmark-packaging-topic.html","desc":"Рециклиране на опаковки на Lexmark","descFull":"Рециклиране на опаковки на Lexmark Lexmark се стреми непрекъснато към свеждане на опаковките до минимум. По-малкият брой опаковки помага да се гарантира, че принтерите на Lexmark се транспортират по най-ефективния и предпазващ околната среда начин и че има по-малък брой опаковки за изхвърляне. Тези ефективни мерки водят до по-малко емисии на парникови газове, пестят се енергия и природни ресурси. Lexmark също предлага рециклиране на компоненти на опаковки в някои страни или региони. За повече информация отидете на  www.lexmark.com/recycle  и после изберете вашата страна или регион. Информация относно наличните програми за рециклиране на опаковки е включена в информацията за рециклиране на продукта. Картонените опаковки на Lexmark са 100% годни за рециклиране, където съществуват съоръжения за рециклиране на велпапе. Може да не съществуват подобни съоръжения във вашия район. Пяната, която се използва при опаковките на Lexmark, може да се рециклира, където съществуват съоръжения за рециклиране на пяна. Може да не съществуват подобни съоръжения във вашия район.  Когато върнете касета на Lexmark, можете да използвате повторно кутията, в която сте получили касетата. Lexmark рециклира кутията. рециклиране опаковки на Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Многофункционални продукти MX532, MX632, XM3350"}},[_vm._v("\n    Многофункционални продукти MX532, MX632, XM3350\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_bg","title":"Информация за безопасност"}},[_vm._v("\n    Информация за безопасност\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Правила"}},[_vm._v("\n     Правила\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Извлечения за продукта"}},[_vm._v("\n     Извлечения за продукта\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_bg","title":"Научете повече за принтера"}},[_vm._v("\n    Научете повече за принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e175"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_bg","title":"Откриване на информация за принтера"}},[_vm._v("\n     Откриване на информация за принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_bg","title":"Намиране на серийния номер на принтера"}},[_vm._v("\n     Намиране на серийния номер на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_bg","title":"Конфигурации на принтера"}},[_vm._v("\n     Конфигурации на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_bg","title":"Използване на контролния панел"}},[_vm._v("\n     Използване на контролния панел\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_bg","title":"Запознаване със състоянията на индикаторната светлина"}},[_vm._v("\n     Запознаване със състоянията на индикаторната светлина\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e500","title":"Избор на хартия"}},[_vm._v("\n     Избор на хартия\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_bg","title":"Настройване, инсталиране и конфигуриране"}},[_vm._v("\n    Настройване, инсталиране и конфигуриране\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1569"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_bg","title":"Избор на място за принтера"}},[_vm._v("\n     Избор на място за принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_bg","title":"Свързване на кабели"}},[_vm._v("\n     Свързване на кабели\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e1764","title":"Настройване и използване на приложенията на началния екран"}},[_vm._v("\n     Настройване и използване на приложенията на началния екран\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e2411","title":"Настройване и използване на функциите за достъпност"}},[_vm._v("\n     Настройване и използване на функциите за достъпност\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e2717","title":"Настройване на принтера за изпращане на факс"}},[_vm._v("\n     Настройване на принтера за изпращане на факс\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_bg","title":"Конфигуриране на SMTP настройките за имейл"}},[_vm._v("\n     Конфигуриране на SMTP настройките за имейл\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-paper-size-and-type-topic.html#d0e4576","title":"Зареждане на хартия и специални носители"}},[_vm._v("\n     Зареждане на хартия и специални носители\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e4744","title":"Инсталиране и актуализация на софтуер, драйвери и фърмуер"}},[_vm._v("\n     Инсталиране и актуализация на софтуер, драйвери и фърмуер\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"available-internal-options-topic.html#d0e5025","title":"Инсталиране на допълнителен хардуер"}},[_vm._v("\n     Инсталиране на допълнителен хардуер\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"wireless-support-topic.html#d0e5334","title":"Работа в мрежа"}},[_vm._v("\n     Работа в мрежа\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_bg","title":"Защита на принтера"}},[_vm._v("\n    Защита на принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5759"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_bg","title":"Намиране на слота за защита"}},[_vm._v("\n     Намиране на слота за защита\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_bg","title":"Изтриване на паметта на принтера"}},[_vm._v("\n     Изтриване на паметта на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_bg","title":"Изтриване на запаметяващо устройство на принтера"}},[_vm._v("\n     Изтриване на запаметяващо устройство на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_bg","title":"Възстановяване на фабричните настройки по подразбиране"}},[_vm._v("\n     Възстановяване на фабричните настройки по подразбиране\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_bg","title":"Изявление за енергозависимост"}},[_vm._v("\n     Изявление за енергозависимост\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_bg","title":"Печат"}},[_vm._v("\n    Печат\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5952"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_bg","title":"Отпечатване от компютър"}},[_vm._v("\n     Отпечатване от компютър\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e5978","title":"Отпечатване от мобилно устройство"}},[_vm._v("\n     Отпечатване от мобилно устройство\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_bg","title":"Отпечатване от флаш устройство"}},[_vm._v("\n     Отпечатване от флаш устройство\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_bg","title":"Поддържани флаш устройства и типове файлове"}},[_vm._v("\n     Поддържани флаш устройства и типове файлове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_bg","title":"Конфигуриране на поверителни задания"}},[_vm._v("\n     Конфигуриране на поверителни задания\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_bg","title":"Отпечатване на конфиденциални и други изчакващи задания за печат"}},[_vm._v("\n     Отпечатване на конфиденциални и други изчакващи задания за печат\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_bg","title":"Отпечатване на списък с примери на шрифтове"}},[_vm._v("\n     Отпечатване на списък с примери на шрифтове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_bg","title":"Отпечатване на списък на директории"}},[_vm._v("\n     Отпечатване на списък на директории\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_bg","title":"Поставяне на разделителни листове между копията"}},[_vm._v("\n     Поставяне на разделителни листове между копията\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_bg","title":"Отмяна на задание за печат"}},[_vm._v("\n     Отмяна на задание за печат\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_bg","title":"Регулиране на тъмнотата на тонера"}},[_vm._v("\n     Регулиране на тъмнотата на тонера\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_bg","title":"Копиране"}},[_vm._v("\n    Копиране\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6568"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_bg","title":"С помощта на автоматичното подаващо устройство и стъклото на скенера"}},[_vm._v("\n     С помощта на автоматичното подаващо устройство и стъклото на скенера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_bg","title":"Правене на копия"}},[_vm._v("\n     Правене на копия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_bg","title":"Копиране на снимки"}},[_vm._v("\n     Копиране на снимки\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_bg","title":"Копиране върху бланка"}},[_vm._v("\n     Копиране върху бланка\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_bg","title":"Копирайте от двете страни на хартията"}},[_vm._v("\n     Копирайте от двете страни на хартията\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_bg","title":"Намаляване или увеличаване на копията"}},[_vm._v("\n     Намаляване или увеличаване на копията\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_bg","title":"Сортиране на копия"}},[_vm._v("\n     Сортиране на копия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_bg","title":"Поставяне на разделителни листове между копията"}},[_vm._v("\n     Поставяне на разделителни листове между копията\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_bg","title":"Копиране на няколко страници върху един лист"}},[_vm._v("\n     Копиране на няколко страници върху един лист\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_bg","title":"Копиране на карти"}},[_vm._v("\n     Копиране на карти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_bg","title":"Създаване на бърза команда за копиране"}},[_vm._v("\n     Създаване на бърза команда за копиране\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_bg","title":"Имейл"}},[_vm._v("\n    Имейл\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6879"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_bg","title":"С помощта на автоматичното подаващо устройство и стъклото на скенера"}},[_vm._v("\n     С помощта на автоматичното подаващо устройство и стъклото на скенера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_bg","title":"Изпращане на имейл"}},[_vm._v("\n     Изпращане на имейл\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_bg","title":"Създаване на бърза команда за имейл"}},[_vm._v("\n     Създаване на бърза команда за имейл\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_bg","title":"Факс"}},[_vm._v("\n    Факс\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6973"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_bg","title":"С помощта на автоматичното подаващо устройство и стъклото на скенера"}},[_vm._v("\n     С помощта на автоматичното подаващо устройство и стъклото на скенера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_bg","title":"Изпращане на факс"}},[_vm._v("\n     Изпращане на факс\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_bg","title":"Насрочване на факс"}},[_vm._v("\n     Насрочване на факс\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_bg","title":"Създаване на бърза команда за факсово местоназначение"}},[_vm._v("\n     Създаване на бърза команда за факсово местоназначение\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_bg","title":"Намаляване на разделителната способност на факса"}},[_vm._v("\n     Намаляване на разделителната способност на факса\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_bg","title":"Регулиране на тъмнината на факса"}},[_vm._v("\n     Регулиране на тъмнината на факса\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_bg","title":"Печат на дневник на факсове"}},[_vm._v("\n     Печат на дневник на факсове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_bg","title":"Блокиране на нежелани факсове"}},[_vm._v("\n     Блокиране на нежелани факсове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_bg","title":"Задържане на факсове"}},[_vm._v("\n     Задържане на факсове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_bg","title":"Препращане на факс"}},[_vm._v("\n     Препращане на факс\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_bg","title":"Сканиране"}},[_vm._v("\n    Сканиране\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7338"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_bg","title":"С помощта на автоматичното подаващо устройство и стъклото на скенера"}},[_vm._v("\n     С помощта на автоматичното подаващо устройство и стъклото на скенера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_bg","title":"Сканиране към компютър"}},[_vm._v("\n     Сканиране към компютър\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_bg","title":"Сканиране към FTP сървър"}},[_vm._v("\n     Сканиране към FTP сървър\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_bg","title":"Създаване на бърза команда за FTP"}},[_vm._v("\n     Създаване на бърза команда за FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_bg","title":"Сканиране към мрежова папка"}},[_vm._v("\n     Сканиране към мрежова папка\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_bg","title":"Създаване на бърза команда за мрежова папка"}},[_vm._v("\n     Създаване на бърза команда за мрежова папка\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_bg","title":"Сканиране към флаш устройство"}},[_vm._v("\n     Сканиране към флаш устройство\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_bg","title":"Използване на менютата на принтера"}},[_vm._v("\n    Използване на менютата на принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7640"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menu-map-mfp_bg","title":"Карта на менюто"}},[_vm._v("\n     Карта на менюто\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e8021","title":"Устройство"}},[_vm._v("\n     Устройство\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e10356","title":"Печат"}},[_vm._v("\n     Печат\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e11519","title":"Хартия"}},[_vm._v("\n     Хартия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e11879","title":"Копиране"}},[_vm._v("\n     Копиране\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e12451","title":"Факс"}},[_vm._v("\n     Факс\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e14879","title":"Имейл"}},[_vm._v("\n     Имейл\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e15895","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e16541","title":"USB у-во"}},[_vm._v("\n     USB у-во\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e17342","title":"Мрежа/портове"}},[_vm._v("\n     Мрежа/портове\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e19486","title":"Защита"}},[_vm._v("\n     Защита\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e20636","title":"Услуги в облака"}},[_vm._v("\n     Услуги в облака\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e20693","title":"Отчети"}},[_vm._v("\n     Отчети\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_bg","title":"Откриване и отстраняване на неизправности"}},[_vm._v("\n     Откриване и отстраняване на неизправности\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_bg","title":"Forms Merge (Обединяване на формуляри)"}},[_vm._v("\n     Forms Merge (Обединяване на формуляри)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_bg","title":"Отпечатване на страница с настройки на менюто"}},[_vm._v("\n     Отпечатване на страница с настройки на менюто\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_bg","title":"Поддръжка на принтера"}},[_vm._v("\n    Поддръжка на принтера\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e21237"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_bg","title":"Проверка на състоянието на части и консумативи"}},[_vm._v("\n     Проверка на състоянието на части и консумативи\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_bg","title":"Конфигуриране на известия за консумативи"}},[_vm._v("\n     Конфигуриране на известия за консумативи\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_bg","title":"Конфигуриране на уведомления с имейл"}},[_vm._v("\n     Конфигуриране на уведомления с имейл\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_bg","title":"Преглед на отчетите"}},[_vm._v("\n     Преглед на отчетите\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-supplies-group.html#ordering-supplies-group_bg","title":"Поръчване на части и консумативи"}},[_vm._v("\n     Поръчване на части и консумативи\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e21570","title":"Замяна на части и консумативи"}},[_vm._v("\n     Замяна на части и консумативи\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e21913","title":"Почистване на частите на принтера"}},[_vm._v("\n     Почистване на частите на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e22060","title":"Пестене на енергия и хартия"}},[_vm._v("\n     Пестене на енергия и хартия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_bg","title":"Преместване на принтера в друго местоположение"}},[_vm._v("\n     Преместване на принтера в друго местоположение\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_bg","title":"Транспортиране на принтера"}},[_vm._v("\n     Транспортиране на принтера\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_bg","title":"Отстраняване на проблем"}},[_vm._v("\n    Отстраняване на проблем\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e22214"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-picker-topic.html#print-quality-problems-picker_bg","title":"Проблеми с качеството на печата"}},[_vm._v("\n     Проблеми с качеството на печата\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_bg","title":"Кодове за грешки на принтера"}},[_vm._v("\n     Кодове за грешки на принтера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_bg","title":"Проблеми с печата"}},[_vm._v("\n     Проблеми с печата\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_bg","title":"Принтерът не отговаря"}},[_vm._v("\n     Принтерът не отговаря\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_bg","title":"Не може да разчете флаш устройството"}},[_vm._v("\n     Не може да разчете флаш устройството\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_bg","title":"Разрешаване на USB порт"}},[_vm._v("\n     Разрешаване на USB порт\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_bg","title":"Отстраняване на заседнала хартия"}},[_vm._v("\n     Отстраняване на заседнала хартия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e25885","title":"Проблеми с мрежовата връзка"}},[_vm._v("\n     Проблеми с мрежовата връзка\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e26113","title":"Проблеми с хардуерните опции"}},[_vm._v("\n     Проблеми с хардуерните опции\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e26261","title":"Проблеми с консумативите"}},[_vm._v("\n     Проблеми с консумативите\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e26384","title":"Проблеми с подаването на хартия"}},[_vm._v("\n     Проблеми с подаването на хартия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e26750","title":"Проблеми с изпращането на имейли"}},[_vm._v("\n     Проблеми с изпращането на имейли\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e26844","title":"Проблеми с работата на факса"}},[_vm._v("\n     Проблеми с работата на факса\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e27489","title":"Проблеми със сканирането"}},[_vm._v("\n     Проблеми със сканирането\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_bg","title":"Свързване с поддръжка на клиенти"}},[_vm._v("\n     Свързване с поддръжка на клиенти\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_bg","title":"Преработване и изхвърляне"}},[_vm._v("\n    Преработване и изхвърляне\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28269"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_bg","title":"Рециклиране на продукти на Lexmark"}},[_vm._v("\n     Рециклиране на продукти на Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_bg","title":"Рециклиране на опаковки на Lexmark"}},[_vm._v("\n     Рециклиране на опаковки на Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_bg","title":"Известия"}},[_vm._v("\n    Известия\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28306"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28309","title":"Информация за продукта"}},[_vm._v("\n     Информация за продукта\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28326","title":"Известие за нова версия"}},[_vm._v("\n     Известие за нова версия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_bg","title":"Търговски марки"}},[_vm._v("\n     Търговски марки\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_bg","title":"Известия за лицензиране"}},[_vm._v("\n     Известия за лицензиране\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_bg","title":"Нива на емисии на шум"}},[_vm._v("\n     Нива на емисии на шум\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_bg","title":"Директива относно отпадъци от електрическо и електронно оборудване (WEEE)"}},[_vm._v("\n     Директива относно отпадъци от електрическо и електронно оборудване (WEEE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28432","title":"Литиевойонна презареждаема батерия"}},[_vm._v("\n     Литиевойонна презареждаема батерия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_bg","title":"Регламент (ЕС) 2023/1542"}},[_vm._v("\n     Регламент (ЕС) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28470","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_bg","title":"Изхвърляне на продукта"}},[_vm._v("\n     Изхвърляне на продукта\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_bg","title":"Връщане на касетите на Lexmark за повторна употреба или рециклиране"}},[_vm._v("\n     Връщане на касетите на Lexmark за повторна употреба или рециклиране\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_bg","title":"Известие за чувствителност към статично електричество"}},[_vm._v("\n     Известие за чувствителност към статично електричество\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_bg","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_bg","title":"Информация за температурата"}},[_vm._v("\n     Информация за температурата\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_bg","title":"Известие за лазера"}},[_vm._v("\n     Известие за лазера\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_bg","title":"Потребление на енергия"}},[_vm._v("\n     Потребление на енергия\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_bg","title":"Нормативни разпоредби, касаещи оборудване за телекомуникационни терминали"}},[_vm._v("\n     Нормативни разпоредби, касаещи оборудване за телекомуникационни терминали\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28734","title":"Нормативни разпоредби за безжични продукти"}},[_vm._v("\n     Нормативни разпоредби за безжични продукти\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_bg","title":"Известие за модулен компонент"}},[_vm._v("\n     Известие за модулен компонент\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_bg","title":"Излагане на радиочестотно лъчение"}},[_vm._v("\n     Излагане на радиочестотно лъчение\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28759","title":"Съответствие с директиви на Европейската общност (ЕО)"}},[_vm._v("\n     Съответствие с директиви на Европейската общност (ЕО)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_bg","title":"Съответствие с директиви на Европейската общност (ЕО)"}},[_vm._v("\n     Съответствие с директиви на Европейската общност (ЕО)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_bg","title":"Бележка за радиосмущения"}},[_vm._v("\n     Бележка за радиосмущения\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js